import React from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Box from "@mui/material/Box";
import VisibilityIcon from "@mui/icons-material/Visibility";
import avtar from "../../img/avtarImg.jpg";
import omcaFoundationLetterhead from "../../img/omca-foundation-letterhead.png";
import omcaPrivateLetterhead from "../../img/omca-private-letterhead.jpeg";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate } from "react-router-dom";
import { GetPatientTreatments } from "../../reducer/PatientTreatmentSlice";
import { AddHospitalForPatient } from "../../reducer/PatientTreatmentSlice";
import { GetAllHositalData } from "../../reducer/HospitalSlice";
import { GetAllCountries, GetAllCountries2 } from "../../reducer/Countries";
import { AppointmentForPatient } from "../../reducer/PatientTreatmentSlice";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
import {
  formatTime12Hour,
  formatDisplayDateTime,
  getTimeInputValue,
} from "../../utils/appointmentHelpers";

import {
  AdminBaseUrl,
  baseu11,
  baseurl,
  image,
  imageUrl,
  resolveCrmImageUrl,
} from "../../Basurl/Baseurl";
import { GetAllTreatment } from "../../reducer/TreatmentSlice";
import { ExtraServices } from "../../reducer/PatientTreatmentSlice";
import { AddNewTretmentPayment } from "../../reducer/PatientTreatmentSlice";
import { FaPen } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import {
  Checkbox,
  FormControl,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import html2pdf from "html2pdf.js";
import { useRef } from "react";
import { EnquiryStatus } from "../../reducer/EnquirySlice";
import { Pagination, Stack } from "@mui/material";
import { getDiscountValidationError } from "../../utils/discountHelpers";
import { canStaffDelete, canStaffExport } from "../../utils/staffActions";
import PreIntimationModal from "./components/PreIntimationModal";
import UploadVilModal from "./components/UploadVilModal";
import PreIntimationViewModal from "./components/PreIntimationViewModal";
import VilWorkflowSection from "./components/VilWorkflowSection";
import PatientOrdersTab from "./components/PatientOrdersTab";
import PatientPhysiotherapySection from "./components/PatientPhysiotherapySection";
import SubmitButton from "../../components/Common/SubmitButton";
const signatureImg = "/assets/img/signature.png";
const ALLOWED_PDF_TYPES = ["Foundation", "Private"];
const DEFAULT_PDF_SIGNATORY = "Zaheerah Peerbacus";
const normalizePdfType = (type) =>
  ALLOWED_PDF_TYPES.includes(type) ? type : "Foundation";
const getPdfTreatmentPlanId = (info, hospitalItem) =>
  info?.treatment_plan_id ||
  info?._id ||
  info?.id ||
  info?.treatmentPlanId ||
  hospitalItem?.treatment_plan_id ||
  hospitalItem?._id ||
  "";
const isMongoObjectId = (value) =>
  /^[a-fA-F0-9]{24}$/.test(String(value || "").trim());
const getPdfPatientId = (patient, locationState) => {
  const candidates = [
    locationState?.testid,
    locationState?._id,
    patient?._id,
    patient?.id,
    patient?.patientObjectId,
    patient?.patient_object_id,
    patient?.patient_id,
  ];
  return (
    candidates.find((value) => isMongoObjectId(value)) ||
    ""
  );
};
const getPatientHonorific = (gender) => {
  const g = String(gender || "").trim().toLowerCase();
  if (["male", "m", "mr", "man", "boy"].includes(g)) return "Mr. ";
  if (["female", "f", "woman", "girl", "mrs"].includes(g)) return "Mrs. ";
  if (["ms", "miss"].includes(g)) return "Ms. ";
  return "";
};
const normalizeEstimateCostDetails = (value) => {
  let details = value;
  if (typeof details === "string") {
    try {
      details = JSON.parse(details);
    } catch (e) {
      return [];
    }
  }
  if (!Array.isArray(details)) return [];
  return details
    .map((item) => {
      if (typeof item === "string") return { description: item };
      if (item && typeof item === "object") {
        return { description: item.description || "" };
      }
      return null;
    })
    .filter(Boolean);
};
const calculateTotalCost = (formData, pdfType) => {
  if (!formData) return "";
  let fieldsToSum = [];
  if (pdfType === "Foundation") {
    fieldsToSum = [
      formData.treatment_cost,
      formData.evaluation_cost,
      formData.surgery_cost,
      formData.accommodation_cost,
      formData.air_ticket_cost,
      formData.other_additional_costs,
      formData.medical_escort_cost
    ];
  } else {
    fieldsToSum = [
      formData.treatment_cost,
      formData.evaluation_cost,
      formData.sim_card_cost,
      formData.accommodation_cost,
      formData.guesthouse_cost,
      formData.air_ticket_cost,
      formData.medif_cost,
      formData.medical_cost,
      formData.physiotherapy_cost,
      formData.medical_escort_cost,
      formData.transport_cost,
      formData.other_additional_costs,
      formData.surgery_cost,
    ];
  }

  let sum = 0;
  let currency = "";

  fieldsToSum.forEach((field) => {
    if (!field) return;
    const str = String(field).trim();
    if (!currency) {
      if (str.toUpperCase().includes("USD")) {
        currency = "USD";
      } else if (str.toUpperCase().includes("MUR")) {
        currency = "MUR";
      } else if (str.includes("$")) {
        currency = "$";
      }
    }

    const clean = str.replace(/,/g, '');
    const match = clean.match(/(\d+(?:\.\d+)?)/);
    if (match) {
      sum += parseFloat(match[1]);
    }
  });

  if (sum === 0) return "";

  const formattedSum = sum.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  if (currency === "USD") {
    return `${formattedSum} USD`;
  } else if (currency === "MUR") {
    return `MUR ${formattedSum} approx.`;
  } else if (currency === "$") {
    return `$${formattedSum}`;
  } else {
    return pdfType === "Foundation" ? `MUR ${formattedSum}` : `${formattedSum} USD`;
  }
};
const rowsPerPage = 10;
const isValidPaidAmount = (amount) => {
  if (amount === "" || amount == null || amount === undefined) return false;
  const num = Number(amount);
  return !isNaN(num) && num >= 0;
};
const formatPaidAmountForApi = (amount) => String(Number(amount));
const getPaidAmountInputValue = (amount) =>
  amount === 0 || amount ? amount : "";
const isGopPayment = (item) => {
  if (!item) return false;
  const method = (item.paymentMethod || item.method || item.mode || "").toLowerCase().trim();
  return method === "gop" || method === "guarantee of payment";
};
const getPaymentStatus = (item) => {
  if (!item) return "Approved";
  const st = (item.status || "").trim();
  if (st) {
    const lower = st.toLowerCase();
    if (lower === "approved") return "Approved";
    if (lower === "pending") return "Pending";
    if (lower === "rejected") return "Rejected";
    return st.charAt(0).toUpperCase() + st.slice(1);
  }
  return isGopPayment(item) ? "Pending" : "Approved";
};
const renderPaymentStatusBadge = (item) => {
  const status = getPaymentStatus(item);
  if (status === "Approved") {
    return (
      <span
        className="badge bg-success"
        style={{ fontSize: "11px", fontWeight: 500, padding: "4px 8px" }}
      >
        <i className="fa-solid fa-check me-1"></i>Approved
      </span>
    );
  }
  if (status === "Pending") {
    return (
      <span
        className="badge bg-warning text-dark"
        title="Pending Approval - Excluded from paid totals"
        style={{ fontSize: "11px", fontWeight: 500, padding: "4px 8px" }}
      >
        <i className="fa-solid fa-clock me-1"></i>Pending
      </span>
    );
  }
  if (status === "Rejected") {
    return (
      <span
        className="badge bg-danger"
        title={item?.notes ? `Rejection reason: ${item.notes}` : "Rejected"}
        style={{
          fontSize: "11px",
          fontWeight: 500,
          padding: "4px 8px",
          cursor: item?.notes ? "help" : "default",
        }}
      >
        <i className="fa-solid fa-ban me-1"></i>Rejected
      </span>
    );
  }
  return <span className="badge bg-secondary">{status}</span>;
};
const getCategoryPaymentTotals = (payments = [], defaultPaid = 0, totalAmount = 0) => {
  if (!Array.isArray(payments) || payments.length === 0) {
    const paid = Number(defaultPaid) || 0;
    const total = Number(totalAmount) || 0;
    return {
      approvedPaid: paid,
      pendingAmount: 0,
      dueAmount: Math.max(0, total - paid),
    };
  }
  let approved = 0;
  let pending = 0;
  payments.forEach((p) => {
    const amt = Number(p?.paid_amount ?? p?.amount ?? p?.payment ?? 0) || 0;
    const st = getPaymentStatus(p);
    if (st === "Approved") {
      approved += amt;
    } else if (st === "Pending") {
      pending += amt;
    }
  });
  const total = Number(totalAmount) || 0;
  return {
    approvedPaid: approved,
    pendingAmount: pending,
    dueAmount: Math.max(0, total - approved),
  };
};
const getPriceDisplayValue = (price) => (price === 0 || price ? price : "-");
const getMoneyDisplayValue = (amount) => {
  const value = getPriceDisplayValue(amount);
  return value === "-" ? "-" : `$${value}`;
};
const getDiscountPercentageDisplay = (discount) => {
  if (discount === 0 || discount) return `${discount}%`;
  return "-";
};
const getFinalChargeDisplay = (item, finalKey, baseKey) => {
  if (item?.[finalKey] === 0 || item?.[finalKey]) {
    return getMoneyDisplayValue(item[finalKey]);
  }
  return getMoneyDisplayValue(item?.[baseKey]);
};
const getDiscountedChargeDisplay = (item, baseKey, finalKey) => {
  const finalValue = item?.[finalKey];
  const baseValue = item?.[baseKey];
  const discount = item?.discount_percentage;
  if (finalValue === 0 || finalValue) {
    if (discount === 0 || discount) {
      return `$${finalValue} (${discount}% off from $${baseValue})`;
    }
    return `$${finalValue}`;
  }
  const baseDisplay = getPriceDisplayValue(baseValue);
  return baseDisplay === "-" ? "-" : `$${baseDisplay}`;
};
const calculateFinalFromDiscount = (baseAmount, discountPercentage) => {
  const base = Number(baseAmount);
  const discount = Number(discountPercentage);
  if (!isValidPaidAmount(base) || discountPercentage === "" || discountPercentage == null) {
    return "";
  }
  const final = base - (base * discount) / 100;
  return String(Math.round(final * 100) / 100);
};
const calculateDiscountFromFinal = (baseAmount, finalAmount) => {
  const base = Number(baseAmount);
  const final = Number(finalAmount);
  if (!isValidPaidAmount(base) || !isValidPaidAmount(finalAmount) || base === 0) {
    return "";
  }
  const discount = ((base - final) / base) * 100;
  return String(Math.round(discount * 100) / 100);
};
const updateDiscountedFields = (
  currentValue,
  name,
  value,
  baseField,
  finalField,
) => {
  const next = {
    ...(currentValue && typeof currentValue === "object" ? currentValue : {}),
    [name]: value,
  };

  if (name === baseField) {
    if (next.discount_percentage !== "") {
      next[finalField] = calculateFinalFromDiscount(
        value,
        next.discount_percentage,
      );
    } else if (next[finalField] !== "") {
      next.discount_percentage = calculateDiscountFromFinal(
        value,
        next[finalField],
      );
    }
  } else if (name === "discount_percentage" && value !== "") {
    next[finalField] = calculateFinalFromDiscount(next[baseField], value);
  } else if (name === finalField && value !== "") {
    next.discount_percentage = calculateDiscountFromFinal(
      next[baseField],
      value,
    );
  }

  return next;
};
const isApiSuccess = (success) => success === true || success === "true";
const getDoctorReviewFullLabel = (option) => {
  if (!option || typeof option !== "object") return "";
  return `${option?.title || option?.review_notes || "Review"} (${option?.enquiryId || ""})`.trim();
};
const getDoctorReviewLabel = (option, maxLength = 50) => {
  const label = getDoctorReviewFullLabel(option);
  return label.length > maxLength
    ? `${label.substring(0, maxLength)}...`
    : label;
};
const isLikelyId = (str) => {
  if (typeof str !== "string") return false;
  const trimmed = str.trim();
  return /^[0-9a-fA-F]{24}$/.test(trimmed) || (/^\d+$/.test(trimmed) && trimmed.length > 5);
};

const getAddedByPlatformLabel = (platform) => {
  if (platform === null || platform === undefined || platform === "") return "";
  if (typeof platform === "string") {
    const trimmed = platform.trim();
    if (trimmed.toLowerCase() === "crm") return "CRM";
    if (trimmed.toLowerCase() === "hospital") return "Hospital";
    if (trimmed.toLowerCase() === "patient") return "Patient";
  }
  const normalizedPlatform =
    platform === 0 || platform === 1 || platform === 2 || platform === 3
      ? platform
      : Number(platform);
  if (normalizedPlatform === 1 || platform === "1") return "CRM";
  if (normalizedPlatform === 0 || platform === "0" || normalizedPlatform === 2 || platform === "2") return "Hospital";
  if (normalizedPlatform === 3 || platform === "3") return "Patient";
  return platform ? String(platform) : "";
};

const getAddedByStaffName = (item) => {
  if (!item || typeof item !== "object") return "";

  const extractFromObj = (obj) => {
    if (!obj || typeof obj !== "object") return "";
    const combinedFirstLast =
      obj.first_name || obj.firstName
        ? `${obj.first_name || obj.firstName} ${obj.last_name || obj.lastName || ""}`.trim()
        : "";
    const fullName =
      obj.full_name ||
      obj.fullName ||
      combinedFirstLast ||
      obj.name ||
      obj.staff_name ||
      obj.staffName ||
      obj.userName ||
      obj.username ||
      obj.user_name ||
      obj.hospital_Name ||
      obj.hospital_name ||
      obj.hospitalName ||
      obj.email ||
      "";
    if (typeof fullName === "string" && fullName.trim() && !isLikelyId(fullName)) {
      return fullName.trim();
    }
    return "";
  };

  // 1. Direct name fields on item
  const candidates = [
    item.staff_name,
    item.staffName,
    item.userName,
    item.username,
    item.user_name,
    item.created_by_name,
    item.added_by_name,
    item.addedByName,
    item.admin_name,
    item.adminName,
    item.addedByStaff,
    item.added_by_staff,
    item.addedByUser,
    item.added_by_user,
    item.creator_name,
    item.creator,
    item.author,
    item.hospital_name,
    item.hospitalName,
    item.hospital_Name,
  ];

  for (const c of candidates) {
    if (typeof c === "string" && c.trim() && !isLikelyId(c)) {
      return c.trim();
    }
    if (typeof c === "object" && c !== null) {
      const name = extractFromObj(c);
      if (name) return name;
    }
  }

  // 2. Nested objects on item
  const objCandidates = [
    item.added_by,
    item.addedBy,
    item.staff,
    item.staff_id,
    item.staffId,
    item.staff_details,
    item.user,
    item.user_id,
    item.userId,
    item.user_details,
    item.createdBy,
    item.created_by,
    item.created_by_details,
    item.admin,
    item.hospital,
    item.hospital_details,
  ];

  for (const obj of objCandidates) {
    if (typeof obj === "string" && obj.trim() && !isLikelyId(obj)) {
      return obj.trim();
    }
    if (typeof obj === "object" && obj !== null) {
      const name = extractFromObj(obj);
      if (name) return name;
    }
  }

  // 3. Direct item.name if present and not an ID
  if (item.name && typeof item.name === "string" && item.name.trim() && !isLikelyId(item.name)) {
    return item.name.trim();
  }

  return "";
};

const formatAddedBy = (item) => {
  if (item === null || item === undefined || item === "") return "-";
  if (typeof item !== "object") {
    const platformLabel = getAddedByPlatformLabel(item);
    return platformLabel || (item !== undefined && item !== null ? String(item) : "-");
  }
  const platformVal =
    item.platform ??
    item.plateform ??
    item.createdPlatform ??
    item.created_platform ??
    item.source ??
    item.initiatedFrom;
  const platformLabel = getAddedByPlatformLabel(platformVal);
  const staffName = getAddedByStaffName(item);

  if (platformLabel && staffName) {
    return `${platformLabel} (${staffName})`;
  }
  if (platformLabel) return platformLabel;
  if (staffName) return staffName;
  return "-";
};
function PatientDetail() {
  const navigate = useNavigate();
  const pharmacyRefs = useRef([]);
  const componentRef = useRef();
  const [openGuesthouse, setOpenGuesthouse] = useState(false);
  const [openPaymentmodal, setOpenPaymentmodal] = useState(false);
  const [isEditGuesthouse, setIsEditGuesthouse] = useState(false);
  const [seekerStatus, setSeekerStatus] = React.useState({});
  const [treatmentData, setTreatmentData] = useState([]);
  const [recommend, setRecommend] = useState("");
  const [treatmentInfo, setTreatmentInfo] = useState({});
  const [Title, setTitle] = useState("");
  const [pickuptime, setPickuptime] = useState("");
  const [appointmentTime, setAppointmentTime] = useState("");
  const [treatmentIds1, setTreatmentIds1] = useState("");
  const [vehicalnumber, setVehicalnumber] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [treatmentPage, setTreatmentPage] = useState(0);
  const [images, setImages] = useState([]);
  const [openIndex, setOpenIndex] = useState(0);
  const [openPlanIndex, setOpenPlanIndex] = useState(0);
  const [airAmbulanceData, setAirAmbulanceData] = useState([]);
  const [ambulanceData, setAmbulanceData] = useState([]);
  const [treatmentData1, setTreatmentData1] = useState([]);
  const [accessCountries, setAccessCountries] = useState([]);
  const [roleStatuses, setRoleStatuses] = useState([]);
  const [selectedAttendants, setSelectedAttendants] = useState([]);
  const [treatemntData1, setTreatemntData1] = useState([]);
  const [isTreatmentPlanLoading, setIsTreatmentPlanLoading] = useState(true);
  const [preIntimationModalOpen, setPreIntimationModalOpen] = useState(false);
  const [uploadVilModalOpen, setUploadVilModalOpen] = useState(false);
  const [isVilResubmit, setIsVilResubmit] = useState(false);
  const [preIntimationViewModalOpen, setPreIntimationViewModalOpen] = useState(false);
  const [activeVilPlan, setActiveVilPlan] = useState(null);
  const [activeVilHospital, setActiveVilHospital] = useState(null);
  const [selectedViewPreIntimation, setSelectedViewPreIntimation] = useState(null);
  const [standalonePreIntimations, setStandalonePreIntimations] = useState([]);
  const [open4, setOpen4] = React.useState(false);
  const [doctorReviewData1, setDoctorReviewData1] = useState([]);
  const [datagetapiPaidto, setDatagetapiPaidto] = useState([]);
  const [getAttendeDetails, setGetAttendeDetails] = useState([]);
  const [attandantnew, setAttandantnew] = useState([]);
  const [guestHouseBooking, setGuestHouseBooking] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [openAppointment, setOpenAppointment] = useState(false);
  const [ambulancePage, setAmbulancePage] = useState(0);
  const [appointmentData, setAppointmentData] = useState({
    hospital_id: "",
    hospitalName: "",
    health_issue: "",
    Notes: "",
    appointment_Date: "",
    appointment_Time: "",
    enq_userName: "",
    user_id: "",
    enq_phoneNumber: "",
    enq_email: "",
    enquiryId: "",
  });
  const hospitalRef = useRef([]);
  const omcaRef = useRef();
  const [guestHouseBookingobj, setGuestHouseBookingobj] = useState({});
  const [hospitalDetails, setHospitalDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [valueofappointmentpaidto, setValueofappointmentpaidto] = useState("");
  const [drivername, setDrivername] = useState("");
  const [pharmacyadd, setPharmacyadd] = useState(false);
  const [attendedeaisledit, setAttendedeaisledit] = useState(false);
  const [popupopenattande, setPopupopenattande] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [notesID, setNotesID] = useState("");
  const [drivercontact, setDrivercontact] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const [treatmentNamePassport, setTreatmentNamePassport] = useState("");
  const [treatmentIdFilter, setTreatmentIdFilter] = useState("");
  const [value1, setValue1] = useState("");
  const [treatmntidPharmacy, setTreatmntidPharmacy] = useState("");
  const [passportDetails, setPassportDetails] = useState({});
  const [editData, setEditData] = useState(null);
  const [dataPerforma, setDataPerforma] = useState(null);
  const [edited, setEdited] = useState(false);
  const [treatMentNAem, setTreatMentNAem] = useState("");
  const [filesData, setFilesData] = useState({
    attendant_fullname: "",
    attendant_relation: "",
    attendant_contact: "",
    Attende_passport: null,
    Attende_photo: null,
  });
  const [treatmentNameHeading, setTreatmentNameHeading] = useState("");
  const [attendId, setAttendId] = useState("");
  const [dataC, setDataC] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const { Countries } = useSelector((state) => state.Countries);
  const { PatientTreatments, loading, error } = useSelector(
    (state) => state.PatientTreatments,
  );
  const patientFromStore = useSelector((state) => state.patient?.patient);
  const [patientRegistrationDate, setPatientRegistrationDate] = useState(
    location?.state?.createdAt ||
      location?.state?.created_at ||
      location?.state?.registrationDate ||
      location?.state?.registration_date ||
      "",
  );
  const [ispatient, setIspatient] = useState("");
  const [datedata, setDatedata] = useState("");
  const [appointmentid, setAppointmentid] = useState("");
  const [tretment, setTretment] = useState([]);
  const [undadedservice, setUndadedservice] = useState([]);
  const [Service, setService] = useState([]);
  const [statuddropdown, setStatuddropdown] = useState("offline");
  const [reportdataget, setReportdataget] = useState([]);
  const [iniData, setIniData] = useState({});
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [openEnquiryNotes, setOpenEnquiryNotes] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [hospitalList, setHospitalList] = useState([]);
  const [tratmentenqId, setTratmentenqId] = useState("");
  const [notesModal, setNotesModal] = useState(false);
  const [openmodalCharge, setOpenmodalCharge] = useState(false);
  const [hospitalCharge, setHospitalCharge] = useState("");
  const [treatmentIdCharge, setTreatmentIdCharge] = useState("");
  const [dataImperial, setDataImperial] = useState(false);
  const [open32, setOpen32] = useState(false);
  const [editModalNotes, setEditModalNotes] = useState(false);
  const [modalEditServiceOpen, setModalEditServiceOpen] = useState(false);
  const [treatmentIDservice, setTreatmentIDservice] = useState(null);
  const [open10, setOpen10] = React.useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [noteHospital2, setNoteHospital2] = useState("");
  const [hospitalLumpDiscount, setHospitalLumpDiscount] = useState("");
  const [hospitalLumpFinalAmount, setHospitalLumpFinalAmount] = useState("");
  const [treatmentPlanPopup, setTreatmentPlanPopup] = useState(false);
  // Add Hospitals to Treatment Plan modal state
  const [addHospToPlanModalOpen, setAddHospToPlanModalOpen] = useState(false);
  const [targetPlanForAddHosp, setTargetPlanForAddHosp] = useState(null);
  const [selectedHospitalsForPlan, setSelectedHospitalsForPlan] = useState([]);
  const [addHospPlanNotes, setAddHospPlanNotes] = useState("");
  const [availableHospitalsForPlan, setAvailableHospitalsForPlan] = useState([]);
  const [isAddingHospToPlan, setIsAddingHospToPlan] = useState(false);
  const [addHospPlanError, setAddHospPlanError] = useState("");
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [pdfType, setPdfType] = useState("Foundation");
  const [pdfTreatmentPlanId, setPdfTreatmentPlanId] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [savingPdf, setSavingPdf] = useState(false);
  const [pdfActiveTab, setPdfActiveTab] = useState("form");
  const pdfTemplateRef = useRef(null);

  const initialPdfFormData = {
    date: "",
    patient_name: "",
    patient_age: "",
    hospital_name: "",
    hospital_location: "",
    diagnosis: "",
    treatment_surgery: "",
    treating_doctor: "",
    evaluation_cost: "",
    surgery_cost: "",
    hospital_stay_duration: "",
    india_stay_duration: "",
    accommodation_cost: "",
    guesthouse_cost: "",
    air_ticket_cost: "",
    medical_cost: "",
    physiotherapy_cost: "",
    other_additional_costs: "",
    treatment_cost: "",
    medical_escort_cost: "",
    sim_card_cost: "",
    medif_cost: "",
    transport_cost: "",
    remark: "",
    paragraph_1: "",
    paragraph_2: "",
    paragraph_3: "",
    paragraph_4: "",
    paragraph_5: "",
    signatory_name: DEFAULT_PDF_SIGNATORY,
    designation: "",
    signature: "",
    gender: "",
    estimate_cost_details: [],
    qr_code: "",
    pdf_file: "",
    pdf: "",
    file: "",
  };
  const [pdfFormData, setPdfFormData] = useState(initialPdfFormData);

  const getQrCodeSrc = () => {
    if (!pdfFormData.qr_code) {
      return `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent("https://www.omcafoundation.org")}&size=120x120`;
    }
    if (pdfFormData.qr_code instanceof File) {
      return URL.createObjectURL(pdfFormData.qr_code);
    }
    if (typeof pdfFormData.qr_code === "string") {
      if (pdfFormData.qr_code.startsWith("http") || pdfFormData.qr_code.startsWith("data:")) {
        return pdfFormData.qr_code;
      }
      const cleanPath = pdfFormData.qr_code.startsWith("/") ? pdfFormData.qr_code : `/${pdfFormData.qr_code}`;
      return `https://sisccltd.com/omca_crm${cleanPath}`;
    }
  };

  const [base64FoundationLetterhead, setBase64FoundationLetterhead] = useState("");
  const [base64PrivateLetterhead, setBase64PrivateLetterhead] = useState("");
  const [base64Signature, setBase64Signature] = useState("");
  const [base64Stamp, setBase64Stamp] = useState("");
  const [base64QrCode, setBase64QrCode] = useState("");

  const urlToBase64 = async (url) => {
    if (!url) return "";
    if (url.startsWith("data:")) return url;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => resolve(url);
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.error("Failed to convert image to base64:", url, err);
      return url;
    }
  };

  const loadPdfImagesAsBase64 = async () => {
    try {
      const base64Foundation = await urlToBase64(omcaFoundationLetterhead);
      setBase64FoundationLetterhead(base64Foundation);

      const base64Private = await urlToBase64(omcaPrivateLetterhead);
      setBase64PrivateLetterhead(base64Private);

      const base64Sig = await urlToBase64(signatureImg);
      setBase64Signature(base64Sig);

      const base64St = await urlToBase64("/assets/img/omca_stamp.png");
      setBase64Stamp(base64St);

      const qrSrc = getQrCodeSrc();
      if (qrSrc) {
        const base64Qr = await urlToBase64(qrSrc);
        setBase64QrCode(base64Qr);
      }
    } catch (err) {
      console.error("Error loading PDF images as base64", err);
    }
  };

  useEffect(() => {
    if (pdfModalOpen) {
      loadPdfImagesAsBase64();
    }
  }, [pdfModalOpen, pdfFormData.qr_code]);

  const [open5, setOpen5] = React.useState(false);
  const [note, setNote] = useState("");
  const [drreviewnotes, setDrreviewnotes] = useState("");
  const [date, setDate] = useState();
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [hospitalId, setHospitalId] = useState("");
  const [doctorReviewNotes, setDoctorReviewNotes] = useState("");
  const [notesTable, setNotesTable] = useState([]);
  const [viewNoteOpen, setViewNoteOpen] = useState(false);
  const [viewNoteText, setViewNoteText] = useState("");
  const [valuedata, setValuedata] = useState("");
  const [hospitalData, setHospitalData] = useState({
    hospital_id: "",
    hospital_Name: "",
    hospital_email: "",
  });
  const [treatmentId, setTreatmentId] = useState("");
  const [hospitalcharge, sethospitalharge] = useState("");
  const [hospitlID, setHospitlID] = useState([]);
  const [ishospitalArray, setIShospitalArray] = useState([]);
  const [dataForConfirmedEnq, setDataForConfirmedEnq] = useState([]);
  const [note2, setNote2] = useState("");
  const [activeSubTab, setActiveSubTab] = useState("details");
  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [mainTab, setMainTab] = useState(() => {
    return (
      location?.state?.mainTab ||
      location?.state?.tab ||
      localStorage.getItem("patientMainTab") ||
      "treatment-plans"
    );
  });

  useEffect(() => {
    if (location?.state?.mainTab || location?.state?.tab) {
      const targetTab = location?.state?.mainTab || location?.state?.tab;
      setMainTab(targetTab);
      localStorage.setItem("patientMainTab", targetTab);
    }
  }, [location?.state?.mainTab, location?.state?.tab]);
  const omcaRefs = useRef([]);
  const pharmacyreRefs = useRef([]);
  const [date2, setDate2] = useState();
  const [appHospital, setAppHospital] = useState("");
  const [kys, setKyc] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isServiceSubmitting, setIsServiceSubmitting] = useState(false);
  const paymentSubmitLockRef = useRef(false);
  const [notes, setNotes] = useState([]);
  const [dataHospital, setDataHospital] = useState([]);
  const [imagefile, setImagefile] = useState(null);
  const [treatmentIDa, setTreatmentIDa] = useState(null);
  const [enqId, setEnqId] = useState("");
  const [nodaestInput, setNodaestInput] = useState("");
  const [treatmentChargeid, setTreatmentChargeid] = useState("");
  const [gettreatmentserID, setGettreatmentserID] = useState("");
  const [dropdaowbreviwnotes, setDropdaowbreviwnotes] = useState("");
  const [pharmacyvalue, setPharmacyvalue] = useState("");
  const [serviceData, setServiceData] = useState([]);
  const [payment_details, setPayment_details] = useState([]);
  const [reportsFilered1, setReportsFilered1] = useState([]);
  const [paidTo, setPaidTo] = useState([]);
  const [airAmbulancePage, setAirAmbulancePage] = useState(0);
  const [paymentsFilered, setPaymentsFilered] = useState([]);
  const [attandantFilered, setAttandantFilered] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [appointmentTabel, setAppointmentTabel] = useState([]);
  const [chkservice, setChkservice] = useState([]);
  const [blogErr, setBlogErr] = useState(false);
  const [formDataGuestHouse, setFormDataGuestHouse] = useState({
    guestHouseName: "",
    dateRangeFrom: "",
    dateRangeTo: "",
    numberOfRooms: "",
    paymentAmount: "",
    discount_percentage: "",
    final_amount: "",
    paymentDate: "",
    notes: "",
    invoiceFile: null,
  });
  const [page, setPage] = useState(0);
  const [editPatientProfile, setEditPatientProfile] = useState(false);
  const [hAndleReport, setHAndleReport] = useState(false);
  const [appointErr, setAppointErr] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);
  const [oeditappp, setOeditappp] = useState(false);
  const [openPharmacyModal, setOpenPharmacyModal] = useState(false);
  const [isEditT, setIsEditT] = useState(false);
  const [treatmentuser, setTreatmentuser] = useState([]);
  const [noteErr, setNoteErr] = useState(false);
  const [data, setData] = useState({
    paid_amount: "",
    paymentMethod: "",
    payment_Date: "",
    notes: "",
  });
  const usrRole = localStorage.getItem("Role");
  const isAdmin = (usrRole || "").trim().toLowerCase() === "admin";
  const canDeleteAction = canStaffDelete();
  const canExportAction = canStaffExport();
  const usrFount = localStorage.getItem("_id");
  useEffect(() => {
    gtdatareportsdata();
    getextraservice();
  }, []);
  useEffect(() => {
    getAttemdeData();
  }, []);
  useEffect(() => {
    getTreatmentPlan();
  }, []);

  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: false,
      Toolbar: {
        display: ["zoom", "slideshow", "fullscreen", "close"],
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);
  const getextraservice = async () => {
    try {
      const response = await axios.get(`${baseurl}paid_service`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      const extraServices = response.data; // 👈 cleaner
    } catch (error) {
      console.error("Error fetching extra services:", error);
      throw error;
    }
  };

  const handleAttachFile11 = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
    setIniData((prev) => ({
      ...prev,
      attachFile: files,
    }));
  };

  const hadnlcecEdopenmodalGuestHouse = (item, info) => {
    console.log(item, info);
    setTreatmentIds1(item.treatment_id || info?.treatment_id);
    setFormDataGuestHouse({
      ...item,
      discount_percentage:
        item.discount_percentage === 0 || item.discount_percentage
          ? item.discount_percentage
          : "",
      final_amount:
        item.final_amount === 0 || item.final_amount ? item.final_amount : "",
    });
    setIsEditGuesthouse(true);
    setOpenGuesthouse(true);
  };
  const handleclickGuestHouse = (info) => {
    setTreatmentIds1(info.treatment_id);
    setFormDataGuestHouse({
      guestHouseName: "",
      dateRangeFrom: "",
      dateRangeTo: "",
      numberOfRooms: "",
      paymentAmount: "",
      discount_percentage: "",
      final_amount: "",
      paymentDate: "",
      notes: "",
      invoiceFile: null,
    });
    setOpenGuesthouse(true);
  };
  const handleCloseguesthouse = () => {
    setOpenGuesthouse(false);
    setTreatmentIds1();
    setIsEditGuesthouse(false);
    setFormDataGuestHouse({
      guestHouseName: "",
      dateRangeFrom: "",
      dateRangeTo: "",
      numberOfRooms: "",
      paymentAmount: "",
      discount_percentage: "",
      final_amount: "",
      paymentDate: "",
      notes: "",
      invoiceFile: null,
    });
    setOpenGuesthouse(false);
  };
  const AddpaymentOnchnage = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleAppointmentChange = (e) => {
    const { name, value } = e.target;
    setAppointmentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const ServiceData2 = useSelector((state) => state.Service.Service);
  const { hospital } = useSelector((state) => state.hospital);
  const { Treatment } = useSelector((state) => state.Treatment);
  useEffect(() => {
    dispatch(GetAllTreatment());
  }, [dispatch]);
  useEffect(() => {
    dispatch(GetAllHositalData());
    // console.log(error, hospital);
  }, [dispatch]);
  const effectivePatientDetailId =
    location?.state?.patientId ||
    new URLSearchParams(location?.search || "").get("patient_id") ||
    new URLSearchParams(location?.search || "").get("patientId") ||
    sessionStorage.getItem("patient_detail_patientId") ||
    "";

  useEffect(() => {
    if (location?.state?.patientId) {
      sessionStorage.setItem(
        "patient_detail_patientId",
        (location?.state?.patientId || effectivePatientDetailId),
      );
    }
  }, [location?.state?.patientId]);

  const effectiveUserId =
    location?.state?.user_id ||
    location?.state?.userId ||
    new URLSearchParams(location?.search || "").get("user_id") ||
    new URLSearchParams(location?.search || "").get("userId") ||
    sessionStorage.getItem("patient_detail_userId") ||
    "";

  useEffect(() => {
    const uid = location?.state?.user_id || location?.state?.userId;
    if (uid) {
      sessionStorage.setItem("patient_detail_userId", String(uid));
    }
  }, [location?.state?.user_id, location?.state?.userId]);

  useEffect(() => {
    dispatch(GetAllCountries2());
    if (effectivePatientDetailId) {
      dispatch(GetPatientTreatments({ id: effectivePatientDetailId }));
    }
  }, [dispatch, effectivePatientDetailId]);
  useEffect(() => {
    if (PatientTreatments) {
      console.log(PatientTreatments);
      setIspatient(PatientTreatments);
      console.log(PatientTreatments);
      setTretment(PatientTreatments.treatments || []);
      setKyc(PatientTreatments.Kyc_details);
      setNotes(PatientTreatments.discussionNotes);
      setPayment_details(PatientTreatments.payment_details);
      const treatmentId = PatientTreatments?.treatments?.[0]?.treatment_id;
      console.log(treatmentId);
      if (treatmentId) {
        patient_guesthouse(treatmentId); // 👈 pass karo
      }
      setChkservice(PatientTreatments.services);
    }
  }, [PatientTreatments]);

  useEffect(() => {
    // 1. Direct from location.state
    const stateDate =
      location?.state?.createdAt ||
      location?.state?.created_at ||
      location?.state?.registrationDate ||
      location?.state?.registration_date;
    if (stateDate) {
      setPatientRegistrationDate(stateDate);
      return;
    }

    // 2. Direct from ispatient / PatientTreatments
    const directDate =
      ispatient?.createdAt ||
      ispatient?.created_at ||
      ispatient?.registrationDate ||
      ispatient?.registration_date ||
      ispatient?.registerDate ||
      ispatient?.date ||
      PatientTreatments?.createdAt ||
      PatientTreatments?.created_at;
    if (directDate) {
      setPatientRegistrationDate(directDate);
      return;
    }

    // 3. Search target identifier
    const targetId =
      ispatient?.patientNumber ||
      ispatient?.patientId ||
      PatientTreatments?.patientNumber ||
      PatientTreatments?.patientId ||
      location?.state?.patientNumber ||
      (typeof location?.state?.patientId === "string" &&
      location?.state?.patientId.startsWith("OMCA")
        ? location?.state?.patientId
        : "");

    // Check redux store list first
    const list = Array.isArray(patientFromStore)
      ? patientFromStore
      : patientFromStore?.details || [];
    if (targetId && list.length > 0) {
      const match = list.find(
        (p) =>
          p?.patientNumber === targetId ||
          p?.patientId === targetId ||
          p?._id === targetId ||
          p?.id === targetId,
      );
      if (match?.createdAt || match?.created_at) {
        setPatientRegistrationDate(match.createdAt || match.created_at);
        return;
      }
    }

    // 4. Fetch from all_patients API if targetId available
    if (!targetId) return;
    let isCancelled = false;
    const fetchRegDate = async () => {
      try {
        const response = await axios.get(
          `${baseurl}all_patients?search=${encodeURIComponent(targetId)}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        const records =
          response?.data?.details ||
          response?.data?.data?.details ||
          response?.data?.patients ||
          response?.data?.data ||
          response?.data;
        if (Array.isArray(records) && records.length > 0) {
          const match =
            records.find(
              (p) =>
                p?.patientNumber === targetId ||
                p?.patientId === targetId ||
                p?._id === targetId ||
                p?.id === targetId,
            ) || records[0];
          if (!isCancelled && (match?.createdAt || match?.created_at)) {
            setPatientRegistrationDate(match.createdAt || match.created_at);
          }
        }
      } catch (err) {
        console.warn("Could not load patient registration date:", err);
      }
    };
    fetchRegDate();

    return () => {
      isCancelled = true;
    };
  }, [
    location?.state,
    ispatient?.patientNumber,
    ispatient?.patientId,
    ispatient?.createdAt,
    PatientTreatments,
    patientFromStore,
  ]);
  const handleClose = () => {
    sethospitalharge("");
    setOpen(false);
  };
  const handleClickOpen = (e, tretmentId) => {
    setOpen(true);
    setTreatmentId(tretmentId);
  };
  const handleClose5 = () => {
    setOpen5(false);
  };
  const handleClickOpen1 = (e, tretmentId, listhospital) => {
    console.log(e, tretmentId, listhospital);
    setEdited(false);
    setOpen1(true);
    setTreatmentId(selectedTreatmentId);
    setIShospitalArray(hospitalDetails);
    setHospitalFunction1();
  };
  const statusMap = {
    0: "Pending",
    1: "Confirmed",
    2: "Hold",
    3: "Follow-Up",
    4: "Dead",
  };
  const handleClickOpenNotes = (e, tretmentId, listhospital) => {
    setOpen5(true);
    setOpenNotes(true);
    setTreatmentId(tretmentId);
    setIShospitalArray(listhospital);
  };
  const handleClickOpen2 = (e, tretmentId, listhospital) => {
    setOpen2(true);
  };
  useEffect(() => {
    if (dataC?.treatment_id) {
      getDataapi3(dataC);
    }
  }, [dataC]);
  const handleClickOpen3 = (e, tretmentId) => {
    setOpen3(true);
    setTreatmentId(tretmentId);
  };
  const handleClickOpenPerforma = (e, tretmentId) => {
    setOpen32(true);
    setTreatmentId(tretmentId);
  };
  useEffect(() => {
    const treatmentId = tretment?.treatment?.[0]?.treatment_id;

    if (treatmentId) {
      patient_guesthouse();
      getallPayments();
    }
  }, [location?.state?.patientId, tretment]);
  const handleclosePerforma = () => {
    setOpen32(false);
  };
  const handleEditreport = (id, info) => {
    setTreatmentId(id, info.treatmentId);
    setIniData(id);
    setHAndleReport(true);
    setOpen10(true);
  };
  const handleClickOpen10 = (e, tretmentId) => {
    setTreatmentId(tretmentId);
    setOpen10(true);
  };
  const handleClose1 = () => {
    setOpen1(false);
    setDrivername("");
    setPickuptime("");
    setAppointmentTime("");
    setNote("");
    setVehicalnumber("");
    setDate("");
  };
  const statusRole = localStorage.getItem("Role");
  const handleClose2 = () => {
    setOpen2(false);
    setFilesData("");
    setAttendedeaisledit(false);
  };
  const setHospitalFunction1 = async () => {
    try {
      const response = await axios.post(`${AdminBaseUrl}hospital_list`);
      if (response.data.success) {
        console.log(response.data.data);
        setHospitalList(response.data.data);
      }
    } catch (error) { }
  };
  const ViewDetail = (e, type, info) => {
    console.log(e, type, info);
    const routeMap = {
      0: "/Admin/Enquiry-Detail",
      1: "/Admin/Enquiry-DetailAmbulance",
      2: "/Admin/airambulanceview",
      3: "/Admin/medicalescortservice",
    };
    const path = routeMap[type];
    if (!path) return;
    console.log(type);
    localStorage.setItem("tabenquiry", type);
    navigate(path, {
      state: {
        id: type === 0 ? info.enquiryId : info.id, // ✅ FIX
        enquiryId: info.enquiryId, // optional
        type: type,
      },
    });
  };
  const handleNotesdataqw = async (e) => {
    e.preventDefault();
    if (!Title || !note || !recommend) {
      return Swal.fire("Error", "All fields are required", "error");
    }
    try {
      let response;
      if (tabValue === 0) {
        const enquiryPayload = new FormData();
        enquiryPayload.append("review_notes", note);
        enquiryPayload.append("Recommendations", recommend); // ⚠️ old API key
        enquiryPayload.append("enquiryId", enqId);
        enquiryPayload.append("title", Title);
        enquiryPayload.append("user_type", statusRole);
        images.forEach((img) => {
          enquiryPayload.append("images", img);
        });
        console.log("OLD API PAYLOAD →", [...enquiryPayload.entries()]);
        response = await axios.post(
          `${baseurl}addDoctorReview`,
          enquiryPayload,
        );
      } else {
        const newPayload = new FormData();
        const typeMap = {
          1: "AmbulanceRequest",
          2: "AirAmbulance",
          3: "PatientQuery",
        };
        newPayload.append("review_notes", note);
        newPayload.append("enquiry_id", tratmentenqId);
        newPayload.append("recommendations", recommend);
        newPayload.append("title", Title);
        newPayload.append("user_type", statusRole);
        newPayload.append("reference_id", enqId);
        newPayload.append("model_type", typeMap[tabValue]);
        images.forEach((img) => {
          newPayload.append("images[]", img);
        });
        console.log("NEW API PAYLOAD →", [...newPayload.entries()]);
        response = await axios.post(`${AdminBaseUrl}review/store`, newPayload);
      }
      if (response?.data?.success) {
        handleClose4();
        Swal.fire("Success", "Doctor Review Added Successfully", "success");
        setNote("");
        setRecommend("");
        setImages([]);
      }
    } catch (error) {
      console.log(error);
      let message = "Something went wrong";
      if (error.response) {
        message = error.response.data?.message || message;
      } else if (error.request) {
        message = "No response from server";
      } else {
        message = error.message;
      }
      Swal.fire("Error", message, "error");
    }
  };
  const handleSubmitAppointment = async () => {
    const { appointment_Date, appointment_Time, Notes } = appointmentData;
    if (!appointment_Date) {
      return Swal.fire("Error", "Please select appointment date", "error");
    }
    if (!appointment_Time) {
      return Swal.fire("Error", "Please select appointment time", "error");
    }
    if (!Notes) {
      return Swal.fire("Error", "Please enter notes", "error");
    }
    if (images.length === 0) {
      return Swal.fire("Error", "Please upload at least one report", "error");
    }
    console.log(appointmentData);
    try {
      const formData = new FormData();
      formData.append("enquiryId", appointmentData.enquiry_id);
      formData.append("hospital_id", appointmentData.hospital_id);
      formData.append("hospitalName", appointmentData.hospitalName);
      formData.append("hospital_email", appointmentData.hospital_email);
      formData.append("health_issue", appointmentData.health_issue);
      formData.append("Notes", appointmentData.Notes);
      formData.append("appointment_Date", appointmentData.appointment_Date);
      formData.append("appointment_Time", formatTime12Hour(appointmentData.appointment_Time));
      formData.append("enq_userName", appointmentData.enq_userName);
      formData.append("enq_phoneNumber", appointmentData?.enq_phoneNumber);
      formData.append("user_id", appointmentData?.user_id);
      // formData.append("enq_country_code", appointmentData.enq_country_code);
      formData.append("enq_email", appointmentData.enq_email);
      images.forEach((file) => {
        formData.append("reports", file);
      });
      const res = await axios.post(
        `${baseurl}create_enquiry_appointment/${usrFount}`,
        formData,
      );
      if (res.data.success) {
        Swal.fire("Success", "Appointment Created", "success");
        handleCloseAppointment();
      }
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  const handleClose10 = () => {
    setOpen10(false);
    setHAndleReport(false);
    setIniData("");
  };
  const PatientDetailButton = (e, id) => {
    navigate("/Admin/add-patient-treatment", {
      state: {
        patient: (location?.state?.patientId || effectivePatientDetailId),
      },
    });
  };
  const GetActiveService = () => {
    axios
      .get(`${baseurl}get_activeServices`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setService(response.data.services);
        } else {
          console.error("Failed to fetch job titles:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching job titles:", error);
      });
  };
  useEffect(() => {
    GetActiveService();
    setHospitalFunction1();
    getDataforconfirmedenq();
  }, []);
  const getDataforconfirmedenq = async () => {
    try {
      const patientId = location?.state?.patientId || effectivePatientDetailId;
      if (!patientId) return;
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${baseurl}enquiries/by-patient/${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const enqData = response.data?.data || response.data?.enquiries || (Array.isArray(response.data) ? response.data : []);
      if (enqData) {
        setDataForConfirmedEnq(enqData);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleClose4 = () => {
    setOpen4(false);
  };
  const get3tabdata = async (getcountry, rolestatus) => {
    const payload = {
      user_id: location?.state?.user_id,
      accessCountries: getcountry,
      roleStatuses: rolestatus,
      is_admin: statusRole === "Admin" ? 1 : 0,
    };
    try {
      const response = await axios.post(
        `${AdminBaseUrl}other_enquiry_requests`,
        payload,
      );
      console.log(response.data.data);
      setAirAmbulanceData(response.data?.data?.air_ambulance || []);
      setAmbulanceData(response?.data?.data?.ambulance_requests || []);
      setTreatmentData1(response?.data?.data?.get_treatment_estimate || []);
    } catch (error) {
      console.log(error);
    }
  };
  const getUserAccessDetails = async () => {
    try {
      const response = await axios.get(
        `${baseurl}get_details/${localStorage.getItem("_id")}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      const countries =
        response.data.accessCountries ||
        response.data.Details?.accessCountries ||
        [];
      const roles =
        response.data.roleStatuses ||
        response.data.Details?.roleStatuses ||
        [];
      setAccessCountries(countries);
      setRoleStatuses(roles);
      await get3tabdata(countries, roles);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUserAccessDetails();
  }, []);
  const handlesubmitdata = async () => {
    const priceValue = Number(data.price);
    if (!isValidPaidAmount(data?.price)) {
      Swal.fire({
        title: "Error",
        text: "Please enter a valid price",
        icon: "error",
      });
      return;
    }
    const discountError = getDiscountValidationError(
      data.price,
      data.discount_percentage,
      data.final_price,
    );
    if (discountError) {
      Swal.fire({
        title: "Validation Error",
        text: discountError,
        icon: "error",
      });
      return;
    }
    const startDate = new Date(datedata.start_date);
    const endDate = new Date(datedata.end_date);
    if (!datedata.start_date || !datedata.end_date) {
      Swal.fire({
        title: "Error",
        text: "Please select both start date and end date",
        icon: "error",
      });
      return;
    }
    if (startDate >= endDate) {
      Swal.fire({
        title: "Error",
        text: "Start date must be smaller than end date",
        icon: "error",
      });
      return;
    }
    if (isServiceSubmitting) return;
    setIsServiceSubmitting(true);

    const servipostdata = {
      services: {
        serviceId: valuedata,
        price: priceValue,
        ...(data.discount_percentage !== "" &&
          data.discount_percentage !== null &&
          data.discount_percentage !== undefined
          ? { discount_percentage: Number(data.discount_percentage) }
          : {}),
        ...(data.final_price !== "" &&
          data.final_price !== null &&
          data.final_price !== undefined
          ? { final_price: Number(data.final_price) }
          : {}),
        startTime: datedata.start_date,
        endTime: datedata.end_date,
      },
    };
    try {
      const response = await axios.post(
        `${baseurl}patient_extra_service/${gettreatmentserID}`,
        servipostdata,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data.success === true) {
        setOpenModal(false);
        dispatch(
          GetPatientTreatments({
            id: (location?.state?.patientId || effectivePatientDetailId),
          }),
        );
        Swal.fire("Service Added successfully!", "", "success");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Something went wrong!";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
      });
    } finally {
      setIsServiceSubmitting(false);
    }
  };
  useEffect(() => {
    gettreatment11();
  }, []);
  const hadnlcecEditModal = (item, treatmentId) => {
    setTreatmentIDservice(treatmentId.treatment_id);
    setModalEditServiceOpen(true);
    setData(item);
  };
  const hadnlcecEcloseeModal = () => {
    setModalEditServiceOpen(false);
    setIsServiceSubmitting(false);
  };
  const gettreatment11 = async () => {
    try {
      const response = await axios.post(`${baseurl}treatment_list`);
    } catch (error) { }
  };
  useEffect(() => {
    getDrreview();
  }, []);
  useEffect(() => {
    gettreatment();
  }, [ispatient?.patientId]);
  const gettreatment = async () => {
    try {
      const response = await axios.get(
        `${baseurl}get_patient_treatment/${ispatient?.patientId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      setTreatmentuser(response.data.patient_treatments, "treatment data");
    } catch (error) {
      console.error("Error fetching treatment data", error);
    }
  };
  useEffect(() => {
    getAllPaidTo();
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setBlogErr({ hospitalcharge: false });
    const result = await dispatch(
      AddHospitalForPatient({
        id: (location?.state?.patientId || effectivePatientDetailId),
        hospitalId: hospitalId,
        treatmentId: treatmentId,
      }),
    );
    if (AddHospitalForPatient.rejected.match(result)) {
      const allErrors = result.payload; // array of backend errors
      setOpen(false);
      Swal.fire({
        title: "Error Occurred",
        html: allErrors.join("<br>"),
        icon: "error",
      }).then(() => {
        setOpen(true);
      });
      setIsSubmitting(false);
      return;
    }
    try {
      setOpen(false);
      Swal.fire("Patient assigned to Hospital successfully!", "", "success");
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      setTreatmentId("");
      setNote("");
      setDate("");
      setHospitalId("");
      setBlogErr(false);
    } catch (err) {
      Swal.fire("Error!", err?.message || "An error occurred", "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  const deletePaymentInvoice = async (item) => {
    console.log(item);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    const result = await swalWithBootstrapButtons.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${baseurl}delete_payment/${item._id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (response.data?.success) {
          getDataapi3(selectedTreatmentId);
          dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
          Swal.fire("Deleted!", "Payment has been deleted.", "success");
        } else {
          toast.error("Failed to delete Payment");
        }
      } catch (error) {
        console.error("Delete Payment error:", error);
        toast.error("Something went wrong");
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      swalWithBootstrapButtons.fire({
        title: "Cancelled",
        icon: "error",
      });
    }
  };
  const handleDelete212 = async (item) => {
    console.log(item);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-secondary",
      },
      buttonsStyling: false,
    });
    const result = await swalWithBootstrapButtons.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${baseurl}deleteTreatmentAttendee/${item}`,
        );
        if (response.data?.success) {
          Swal.fire("Deleted!", "Report has been deleted.", "success");
          getDataapi3(selectedTreatmentId);
        } else {
          toast.error("Failed to delete report");
        }
      } catch (error) {
        console.error("Delete report error:", error);
        toast.error("Something went wrong");
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      swalWithBootstrapButtons.fire({
        title: "Cancelled",
        icon: "error",
      });
    }
  };
  const handledeleteReport = async (item) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    const result = await swalWithBootstrapButtons.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${baseurl}deleteReport/${item._id}`,
        );
        if (response.data?.success) {
          Swal.fire("Deleted!", "Report has been deleted.", "success");
          getDataapi3(selectedTreatmentId);
        } else {
          toast.error("Failed to delete report");
        }
      } catch (error) {
        console.error("Delete report error:", error);
        toast.error("Something went wrong");
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      swalWithBootstrapButtons.fire({
        title: "Cancelled",
        icon: "error",
      });
    }
  };
  const handlesubmitAppoint = async (e) => {
    e.preventDefault();
    setAppointErr({
      note: false,
      date: false,
      appointmentTime: false,
      drivername: false,
      vehicalnumber: false,
      drivercontact: false,
      pickuptime: false,
      hospitalcharge: false,
    });
    let hasError = false;
    if (!note) {
      setAppointErr((prev) => ({ ...prev, note: true }));
      hasError = true;
    }
    if (!date) {
      setAppointErr((prev) => ({ ...prev, date: true }));
      hasError = true;
    }
    if (!appointmentTime) {
      setAppointErr((prev) => ({ ...prev, appointmentTime: true }));
      hasError = true;
    }
    if (hasError) {
      return;
    }
    try {
      const result = await dispatch(
        AppointmentForPatient({
          patientId: (location?.state?.patientId || effectivePatientDetailId),
          hospitalId: hospitalData.hospital_id,
          hospital_Name: hospitalData.hospital_Name,
          hospital_email: hospitalData.hospital_email,
          treatment_id: treatmentId,
          note: note,
          mode: statuddropdown,
          appointment_Date: date,
          appointment_Time: formatTime12Hour(appointmentTime),
          pickup_time: pickuptime,
          vehicle_no: vehicalnumber,
          driver_name: drivername,
          driver_contact: drivercontact,
        }),
      ).unwrap();
      getDataapi3(treatmentId);
      setOpen1(false);
      Swal.fire("Patient assigned to Appointment successfully!", "", "success");
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      setTreatmentId("");
      sethospitalharge("");
      setHospitalId("");
      setNote("");
      setDate("");
      setAppointmentTime("");
      setDrivercontact("");
      setPickuptime("");
      setDrivername("");
      setVehicalnumber("");
      setAppointErr(false);
    } catch (err) {
      Swal.fire("Error!", err?.message || "An error occurred", "error");
    }
  };
  const handlesubmitAppoint111 = async (e) => {
    e.preventDefault();
    setAppointErr({
      note: false,
      date: false,
      appointmentTime: false,
    });
    let hasError = false;
    if (!note) {
      setAppointErr((prev) => ({ ...prev, note: true }));
      hasError = true;
    }
    if (!date) {
      setAppointErr((prev) => ({ ...prev, date: true }));
      hasError = true;
    }
    if (!appointmentTime) {
      setAppointErr((prev) => ({ ...prev, appointmentTime: true }));
      hasError = true;
    }
    if (hasError) {
      return;
    }
    try {
      const result = await dispatch(
        AppointmentForPatient({
          patientId: (location?.state?.patientId || effectivePatientDetailId),
          hospitalId: hospitalData.hospital_id,
          hospital_Name: hospitalData.hospital_Name,
          hospital_email: hospitalData.hospital_email,
          treatment_id: treatmentId,
          note: note,
          mode: statuddropdown,
          appointment_Date: date,
          appointment_Time: formatTime12Hour(appointmentTime),
        }),
      ).unwrap();
      getDataapi3(treatmentId);
      setOpen1(false);
      Swal.fire("Patient assigned to Appointment successfully!", "", "success");
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      setTreatmentId("");
      sethospitalharge("");
      setHospitalId("");
      setNote("");
      setDate("");
      setAppointmentTime("");
      setDrivercontact("");
      setPickuptime("");
      setDrivername("");
      setVehicalnumber("");
      setAppointErr(false);
    } catch (err) {
      Swal.fire("Error!", err?.message || "An error occurred", "error");
    }
  };
  const getdataApi = async () => {
    try {
      const rresponse = await axios.post(`${AdminBaseUrl}hospital_list`);
      if (rresponse.data.success === "true") {
        setDataHospital(rresponse.data.data);
      }
    } catch (error) { }
  };
  useEffect(() => {
    getdataApi();
  }, []);
  const allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "application/pdf",
  ];
  const handleKysDetail = async (e) => {
    e.preventDefault();
    const {
      attendant_fullname,
      attendant_relation,
      attendant_contact,
      Attende_passport,
      country,
      attendant_address,
    } = filesData;
    if (
      !attendant_fullname?.trim() ||
      !attendant_relation?.trim() ||
      !attendant_contact?.trim() ||
      !country?.trim() ||
      !Attende_passport ||
      !attendant_address
    ) {
      Swal.fire("All fields are mandatory!", "", "warning");
      return;
    }
    const formData = new FormData();
    formData.append("attendant_fullname", attendant_fullname);
    formData.append("attendant_relation", attendant_relation);
    formData.append("attendant_contact", attendant_contact);
    formData.append("country", filesData.country);
    formData.append("attendant_address", attendant_address);
    filesData.Attende_passport.forEach((file) => {
      formData.append("attendant_passport", file);
    });
    console.log(filesData);
    try {
      const response = await axios.post(
        `${baseurl}addAttendeeDetails/${(location?.state?.patientId || effectivePatientDetailId)}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.data.success) {
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        setOpen2(false);
        getattendantnewai();
        Swal.fire("Attendant  Details Added Successfully!", "", "success");
        setFilesData({
          attendant_fullname: "",
          attendant_relation: "",
          attendant_contact: "",
          Attende_passport: null,
          Attende_photo: null,
        });
      }
    } catch (error) {
      Swal.fire(
        "Error!",
        error?.response?.data?.message || error.message,
        "error",
      );
    }
  };
  const hospitalStatuses = [
    "Admitted",
    "Under Review",
    "Under Surgery",
    "Under Recovery",
    "Discharged",
  ];
  const editatednde = async (e) => {
    e.preventDefault();
    const {
      attendant_fullname,
      attendant_relation,
      attendant_contact,
      country,
      attendant_address,
    } = filesData;
    if (!attendant_fullname?.trim()) {
      return Swal.fire("Error!", "Attendant fullname is required", "error");
    }
    if (!attendant_relation?.trim()) {
      return Swal.fire("Error!", "Attendant relation is required", "error");
    }
    if (!attendant_contact?.toString().trim()) {
      return Swal.fire("Error!", "Attendant contact is required", "error");
    }
    if (!country?.trim()) {
      return Swal.fire("Error!", "Country is required", "error");
    }
    if (!attendant_address?.trim()) {
      return Swal.fire("Error!", "Attendant address is required", "error");
    }
    const formData = new FormData();
    formData.append("attendant_fullname", attendant_fullname);
    formData.append("attendant_relation", attendant_relation);
    formData.append("attendant_contact", attendant_contact);
    formData.append("country", country);
    formData.append("attendant_address", attendant_address);
    if (filesData?.Attende_passport && filesData.Attende_passport.length > 0) {
      filesData.Attende_passport.forEach((file) => {
        formData.append("attendant_passport", file);
      });
    }
    try {
      const response = await axios.put(
        `${baseurl}updateAttendeeDetails/${filesData._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.data.success) {
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        getattendantnewai();
        setOpen2(false);
        Swal.fire(
          "Success!",
          "Attendant Details Updated Successfully!",
          "success",
        );
        setFilesData({
          attendant_fullname: "",
          attendant_relation: "",
          attendant_contact: "",
          country: "",
          attendant_address: "",
          Attende_passport: null,
          Attende_photo: null,
        });
      }
    } catch (error) {
      Swal.fire(
        "Error!",
        error?.response?.data?.message || error.message,
        "error",
      );
    }
  };
  useEffect(() => {
    getattendantnewai();
  }, []);
  const getattendantnewai = async () => {
    try {
      const response = await axios.get(
        `${baseurl}getAttendeeDetails/${(location?.state?.patientId || effectivePatientDetailId)}`,
      );
      setAttandantnew(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilesData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleFileChange = (e, fieldName) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    if (fieldName === "Attende_photo") {
      const file = files[0];
      if (!file.type.startsWith("image/")) {
        Swal.fire("Only image file allowed for Photo!", "", "warning");
        return;
      }
      setFilesData((prev) => ({
        ...prev,
        [fieldName]: file,
      }));
    } else if (fieldName === "Attende_passport") {
      const fileArray = Array.from(files);
      const validFiles = fileArray.filter(
        (file) =>
          file.type.startsWith("image/") || file.type === "application/pdf",
      );
      if (validFiles.length !== fileArray.length) {
        Swal.fire("Only images and PDF files are allowed!", "", "warning");
        return;
      }
      setFilesData((prev) => ({
        ...prev,
        [fieldName]: validFiles,
      }));
    }
  };
  const handleOnChangeCheckbox = (event, id) => {
    const selectedService = Service.find((info) => info.serviceId === id);
    if (selectedService) {
      if (event.target.checked) {
        if (!selectedServices.some((service) => service.serviceId === id)) {
          setSelectedServices((prev) => [
            ...prev,
            {
              serviceId: selectedService.serviceId,
              price: selectedService.price,
            },
          ]);
        }
        setChkservice((prev) => [...prev, selectedService]);
      } else {
        setSelectedServices((prev) =>
          prev.filter((service) => service.serviceId !== id),
        );
        setChkservice((prev) =>
          prev.filter((service) => service.serviceId !== id),
        );
      }
    }
  };
  const handleExtraService = async () => {
    const allServices = [...chkservice, ...selectedServices];
    try {
      const result = await dispatch(
        ExtraServices({ id: (location?.state?.patientId || effectivePatientDetailId), services: allServices }),
      ).unwrap();
      Swal.fire("New Services Added!", "", "success");
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
    } catch (err) {
      Swal.fire("Error!", err?.message || "An error occurred", "error");
    }
  };
  const handleNotesdata = (e) => {
    e.preventDefault();
    setNoteErr({
      note2: false,
    });
    let hasError = false;
    if (!note2) {
      setNoteErr((prev) => ({ ...prev, note2: true }));
      hasError = true;
    }
    if (hasError) return;
    const formData = new FormData();
    formData.append("note", note2);
    if (images && images.length > 0) {
      images.forEach((img) => {
        formData.append("treatmentNoteImages", img); // backend should use upload.array("images")
      });
    }
    axios
      .post(`${baseurl}add_treatment_notes/${treatmentId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setOpen5(false);
          getDataapi3(treatmentId);
          Swal.fire("Success", "Notes added successfully!", "success");
          dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        }
        setNote2("");
        setImages([]);
        setNoteErr({
          note2: false,
        });
      })
      .catch((error) => {
        setOpen5(false);
        Swal.fire("Error", `${error?.response?.data?.message}`, "error");
      });
  };
  const handleAddTritmentPayment = async () => {
    if (paymentSubmitLockRef.current) return;
    console.log(treatmentId, selectedTreatmentId);
    if (!valueofappointmentpaidto) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select Paid To",
      });
      return;
    }
    if (!iniData?.paid_for) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select Paid For",
      });
      return;
    }
    if (!data?.notes) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select Notes",
      });
      return;
    }
    if (!data?.paymentMethod) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select Payment Method",
      });
      return;
    }
    if (!isValidPaidAmount(data?.paid_amount)) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please enter a valid Paid Amount",
      });
      return;
    }
    if (!data?.payment_Date) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select Payment Date",
      });
      return;
    }
    paymentSubmitLockRef.current = true;
    try {
      const formData = new FormData();
      formData.append("id", treatmentId || selectedTreatmentId);
      formData.append("paid_amount", formatPaidAmountForApi(data?.paid_amount));
      formData.append("notes", data?.notes);
      formData.append("paymentMethod", data?.paymentMethod);
      formData.append("status", isGopPayment(data) ? "Pending" : "Approved");
      formData.append("payment_Date", data?.payment_Date);
      formData.append("paid_to", valueofappointmentpaidto);
      formData.append("paid_for", iniData?.paid_for);
      formData.append("platform", 1);
      const filesToAttach =
        (iniData?.attachFile?.length ? iniData.attachFile : null) ||
        (selectedFiles?.length ? selectedFiles : []);
      if (filesToAttach?.length > 0) {
        filesToAttach.forEach((file) => {
          formData.append("attachFile", file);
        });
      }
      await dispatch(AddNewTretmentPayment(formData)).unwrap();
      getDataapi3(selectedTreatmentId);
      setOpen3(false);
      const isPendingGop = isGopPayment(data);
      Swal.fire(
        "Success!",
        isPendingGop
          ? "GOP Payment added with 'Pending' status. It will reflect in Paid/Due totals once approved."
          : "Payment Details Added Successfully!",
        "success"
      );
      if (location.state?.patientId) {
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      }
      setTreatmentId("");
      setData({
        paid_amount: "",
        paymentMethod: "",
        payment_Date: "",
      });
    } catch (err) {
      const errorMessage =
        typeof err === "string" ? err : err?.message || "Something went wrong";
      setOpen3(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      }).then(() => {
        setOpen3(true);
      });
    } finally {
      paymentSubmitLockRef.current = false;
    }
  };
  const handleChange = async (event, id) => {
    const { value } = event.target;
    setSeekerStatus((prev) => ({
      ...prev,
      [id]: value,
    }));
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("Authorization token is missing");
    }
    const response = await axios.post(
      `${baseurl}update_treatment_status/${id}`,
      { status: event.target.value },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    try {
      Swal.fire("Success!", "Status updated successfully!", "success");
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      return response.data;
    } catch (err) { }
  };
  const handleChangeStatusEnquiry = async (event, id, tabValue, data) => {
    console.log(event, id, tabValue, data);

    const { value } = event.target;
    const status = Number(value);

    try {
      // TAB 0
      if (tabValue === 0) {
        const res = await dispatch(
          EnquiryStatus({
            id,
            status,
            user_id: ispatient?.user_id,
            enquiry_type: "OMCA Enquiry",
          }),
        ).unwrap();

        if (res?.isDuplicatePhone) {
          const confirmDup = await Swal.fire({
            title: "Duplicate Phone Number Detected",
            text: res.message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });

          if (confirmDup.isConfirmed) {
            const forcedRes = await dispatch(
              EnquiryStatus({
                id,
                status,
                user_id: ispatient?.user_id,
                enquiry_type: "OMCA Enquiry",
                forceCreate: true,
              }),
            ).unwrap();

            if (forcedRes?.success === false) {
              Swal.fire("Error!", forcedRes?.message || "Failed to update status", "error");
            } else {
              Swal.fire("Success!", forcedRes?.message || "Status Changed Successfully!", "success");
            }
            getDataforconfirmedenq();
          } else {
            Swal.fire({
              icon: "info",
              title: "New Phone Number Required",
              text: "Please use a different phone number before confirming this enquiry.",
            });
            getDataforconfirmedenq();
          }
          return;
        }

        if (res?.success === false) {
          Swal.fire("Error!", res?.message || "Failed to update status", "error");
          return;
        }

        Swal.fire("Success!", "Status Changed Successfully!", "success");
        getDataforconfirmedenq();
      } else {
        await handleChangtype({ value }, data.raw);
        Swal.fire("Success!", "Status Changed Successfully!", "success");

        get3tabdata(accessCountries, roleStatuses);
      }
    } catch (err) {
      if (err?.isDuplicatePhone) {
        const confirmDup = await Swal.fire({
          title: "Duplicate Phone Number Detected",
          text: err.message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        });

        if (confirmDup.isConfirmed) {
          try {
            const forcedRes = await dispatch(
              EnquiryStatus({
                id,
                status,
                user_id: ispatient?.user_id,
                enquiry_type: "OMCA Enquiry",
                forceCreate: true,
              }),
            ).unwrap();

            if (forcedRes?.success === false) {
              Swal.fire("Error!", forcedRes?.message || "Failed to update status", "error");
            } else {
              Swal.fire("Success!", forcedRes?.message || "Status Changed Successfully!", "success");
            }
          } catch (forcedErr) {
            Swal.fire("Error!", forcedErr?.message || "Something went wrong", "error");
          }
          getDataforconfirmedenq();
        } else {
          Swal.fire({
            icon: "info",
            title: "New Phone Number Required",
            text: "Please use a different phone number before confirming this enquiry.",
          });
          getDataforconfirmedenq();
        }
        return;
      }

      Swal.fire("Error!", err?.message || "Something went wrong", "error");
    }
  };
  const handleChangtype = async (e, b) => {
    const value = e?.value || e?.target?.value;
    console.log(b);
    const payload = {
      id: b.id,
      status: statusMap[Number(value)],
      model:
        tabValue === 1
          ? "AmbulanceRequest"
          : tabValue === 2
            ? "AirAmbulance"
            : tabValue === 3
              ? "PatientQuery"
              : "",
    };
    console.log("Payload:", payload);
    try {
      const response = await axios.post(
        `${AdminBaseUrl}update_user_request_status`,
        payload,
      );
      Swal.fire("Success!", "Status Changed Successfully!", "success");
      await get3tabdata(accessCountries, roleStatuses);
      if (response?.data?.success) {
        console.log("Updated Successfully");
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };
  const handleChangeDetails = async (event, id) => {
    try {
      const { value } = event.target;
      setSeekerStatus((prev) => ({
        ...prev,
        [id]: value,
      }));
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authorization token is missing");
      }
      const response = await axios.post(
        `${baseurl}update_appointment_status/${id}`,
        { status: parseInt(value) },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      Swal.fire("Success!", "Status updated successfully!", "success");
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      return response.data;
    } catch (err) {
      console.error(err.response || err.message);
      if (err.response && err.response.data && err.response.data.message) {
        Swal.fire("Error", err.response.data.message, "error");
      } else {
        toast.error("Something went wrong. Please try again!");
      }
    }
  };
  const groupedPayments = payment_details?.reduce((acc, info) => {
    if (!acc[info.treatment_id]) {
      acc[info.treatment_id] = [];
    }
    acc[info.treatment_id].push(info);
    return acc;
  }, {});
  const getMappedStatus = (status) => status || "";
  const penModal = (a, b) => {
    getapicall(b);
    setGettreatmentserID(b);
    setValuedata("");
    setData((prev) => ({
      ...(prev && typeof prev === "object" ? prev : {}),
      serviceId: "",
      price: "",
      discount_percentage: "",
      final_price: "",
    }));
    setDatedata({
      start_date: "",
      end_date: "",
    });
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
    setIsServiceSubmitting(false);
  };
  useEffect(() => {
    getallservice();
  }, []);

  useEffect(() => {
    try {
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("pre_intimations_")) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((k) => localStorage.removeItem(k));
    } catch (e) {}
  }, []);
  const getallservice = async () => {
    try {
      const response = await axios.get(`${baseurl}get_activeServices`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      setServiceData(response.data.services);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  if (loading && !PatientTreatments) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="card p-5 text-center mt-3 shadow-sm border-0">
            <div className="py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <h5 className="mt-3 text-secondary">Loading patient details...</h5>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (error && !PatientTreatments) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="card p-5 text-center mt-3 shadow-sm border-0">
            <div className="py-4">
              <i className="fa fa-exclamation-circle fa-3x text-danger mb-3" />
              <h5 className="text-secondary">Failed to Load Patient</h5>
              <p className="text-muted">
                {typeof error === "object" ? error.message || "An error occurred" : String(error)}
              </p>
              <button
                type="button"
                className="btn btn-primary mt-2 px-4"
                style={{ backgroundColor: "#0ba6df", borderColor: "#0ba6df" }}
                onClick={() => navigate("/Admin/patients")}
              >
                <i className="fa fa-arrow-left me-2" /> Back to Manage Patients
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const andlechange = (e) => {
    const { name, value } = e.target;
    if (name === "serviceId") {
      getapicall(value);
      const selectedService = serviceData.find(
        (info) => String(info.serviceId) === String(value),
      );
      setValuedata(value);
      setData((prev) => ({
        ...(prev && typeof prev === "object" ? prev : {}),
        serviceId: value,
        price:
          selectedService?.price === 0 || selectedService?.price
            ? selectedService.price
            : "",
        discount_percentage: "",
        final_price: "",
      }));
      return;
    }
    setData((prev) =>
      updateDiscountedFields(prev, name, value, "price", "final_price"),
    );
  };
  const andlechangedate = (e) => {
    const { name, value } = e.target;
    setDatedata({ ...datedata, [name]: value });
  };
  const handleClickOpen4 = (e, enq, info) => {
    console.log(info);
    setOpen4(true);
    setEnqId(enq);
    setTratmentenqId(info.id);
  };
  const handleOpenEnquiryNotes = (e, enq) => {
    e?.preventDefault?.();
    setEnqId(enq);
    setNote("");
    setDate("");
    setBlogErr(false);
    setOpenEnquiryNotes(true);
  };
  const handleCloseEnquiryNotes = () => {
    setOpenEnquiryNotes(false);
    setNote("");
    setDate("");
    setBlogErr(false);
  };
  const handleEnquiryNotesSubmit = async (e) => {
    e.preventDefault();
    setBlogErr({
      note: false,
      date: false,
    });
    if (!note) {
      setBlogErr((prevState) => ({ ...prevState, note: true }));
    }
    if (!date) {
      setBlogErr((prevState) => ({ ...prevState, date: true }));
    }
    if (!note || !date) {
      return;
    }
    try {
      const response = await axios.post(`${baseurl}add_notes/${enqId}`, {
        note: note,
        date: date,
      });
      if (response.status === 200) {
        handleCloseEnquiryNotes();
        Swal.fire("Success", "Notes added successfully!", "success");
      }
    } catch (error) {
      handleCloseEnquiryNotes();
      Swal.fire(
        "Error",
        `${error?.response?.data?.message || "Failed to add notes"}`,
        "error",
      );
    }
  };
  const handleCloseAppointment = () => {
    setOpenAppointment(false);
    setImages([]);
    setAppointmentData({
      patient_name: "",
      doctor_name: "",
      date: "",
      time: "",
      notes: "",
      user_id: "",
      enq_userName: "",
      enq_phoneNumber: "",
      enq_email: "",
    });
  };
  const handleOpenAppointment = (info) => {
    console.log(info);
    setAppointmentData({
      hospital_id: "",
      hospitalName: "",
      health_issue: "",
      Notes: "",
      appointment_Date: "",
      appointment_Time: "",
      enq_userName: info.name,
      enq_phoneNumber: info.emergency_contact_no,
      user_id: info._id,
      enq_email: info.email,
      enquiry_id: info.enquiryId,
    });
    setOpenAppointment(true);
  };
  const getapicall = (getapicall) => {
    axios
      .get(`${baseurl}get_unadded_services_for_treatment/${getapicall}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setUndadedservice(response.data.availableServices);
      })
      .catch((error) => {
        console.error("Error fetching unadded services:", error);
      });
  };
  const handlefilechange = (e) => {
    const { name, value } = e.target;
    setIniData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handlefilechangechangeinput = async (e) => {
    const paidToId = e.target.value;

    try {
      // state update
      setData((prev) => ({
        ...prev,
        paid_to: paidToId,
        paid_for: "", // reset paid_for when paid_to changes
      }));

      setValueofappointmentpaidto(paidToId);

      // get paid for list
      const response = await axios.get(
        `${baseurl}/getPaidForByPaidTo/${paidToId}`,
      );

      setDatagetapiPaidto(response.data.data || []);
    } catch (error) {
      console.log("Paid For API Error:", error);
    }
  };
  const handleFileChange12 = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      Swal.fire("Only JPG, PNG, files are allowed.");
      return;
    }
    setImagefile(file); // store in state
  };
  const handleFileChange1 = (e) => {
    const files = Array.from(e.target.files);
    setImagefile(files);
  };
  const handleAttachFile = (e) => {
    const files = Array.from(e.target.files);

    setIniData((prev) => ({
      ...prev,
      attachFile: files,
    }));
  };
  const handleViewImages = (images) => {
    if (!images || images.length === 0) return;
    images.forEach((img) => {
      const url = image + img;
      window.open(url, "_blank");
    });
  };
  const handleClickEditReport = async () => {
    console.log("a", treatmentId);
    if (!iniData?.reportTitle?.trim()) {
      return Swal.fire("Error", "Report Title is required", "error");
    }
    if (!iniData?.treatment_report_date) {
      return Swal.fire("Error", "Report Date is required", "error");
    }
    try {
      Swal.fire({
        title: "Updating...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const formData = new FormData();
      formData.append("reportTitle", iniData.reportTitle);
      formData.append(
        "treatment_report_date",
        new Date(iniData.treatment_report_date).toISOString().split("T")[0],
      );
      formData.append("platform", 1);
      if (iniData?.attachFile) {
        formData.append("attachFile", iniData.attachFile);
      }
      if (Array.isArray(imagefile)) {
        imagefile.forEach((file) => {
          formData.append("treatmentReport", file);
        });
      }
      const response = await axios.put(
        `${baseurl}editReport/${iniData._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Report Updated Successfully ✅",
          timer: 1500,
          showConfirmButton: false,
        });
        handleClose10();
        getDataapi3(treatmentId.treatmentId);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "Failed to update report",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    }
  };
  const handleClickSubmit = async () => {
    if (!iniData.reportTitle) {
      return Swal.fire("Error", "Report Title is required", "error");
    }
    if (!iniData.treatment_report_date) {
      return Swal.fire("Error", "Report Date is required", "error");
    }
    if (!imagefile || imagefile.length === 0) {
      return Swal.fire(
        "Error",
        "At least one Treatment Report file is required",
        "error",
      );
    }
    try {
      const formData = new FormData();
      formData.append("reportTitle", iniData.reportTitle);
      formData.append("treatment_report_date", iniData.treatment_report_date);
      formData.append("platform", 1);
      formData.append("attachFile", iniData.attachFile);
      imagefile.forEach((file) => {
        formData.append("treatmentReport", file);
      });
      const response = await axios.post(
        `${baseurl}addReports/${treatmentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Report Added Successfully!",
        });
        handleClose10();
        getDataapi3(treatmentId);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "Failed to add report",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    }
  };
  const handleopenNotesModal = (id) => {
    const response = notes.filter((item) => {
      return item.id === id;
    });
    setNodaestInput(response[0]);
    setNotesModal(true);
  };
  const handleCloseNotesmodal = () => {
    setNotesModal(false);
  };
  const handlechangenotesdata = (e) => {
    const { name, value } = e.target;
    setNodaestInput({ ...nodaestInput, [name]: value });
  };
  const handleKysDetailnotes = async (e) => {
    e.preventDefault();
    try {
      const postdata = {
        id: nodaestInput.id,
        note: nodaestInput.note,
        date: nodaestInput.date,
      };
      const response = await axios.post(
        `${baseurl}update_notes/${(location?.state?.patientId || effectivePatientDetailId)}`,
        postdata,
      );
      if (response.data.success === true) {
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        handleCloseNotesmodal();
        Swal.fire("Notes Updates Successfully!", "", "success");
      } else {
        toast.error("somethign went wornh");
      }
    } catch (error) { }
  };
  const gtdatareportsdata = async () => {
    try {
      const response = await axios.get(
        `${baseurl}getReports/${(location?.state?.patientId || effectivePatientDetailId)}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data.success === true) {
        setTreatmentData(response.data.data);
        setReportdataget(response.data.data);
      } else {
      }
    } catch (error) { }
  };
  const handledelete = async (info) => {
    console.log(info);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This hospital will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6e7881",
      confirmButtonText: "Yes, delete it!",
    });
    if (!result.isConfirmed) return;
    try {
      const response = await axios.delete(
        `${baseurl}deleteTreatmentHospital/${info.treatment_id}/${info.hospital.details.hospital_id}`,
      );
      if (response.data.success === true) {
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Hospital deleted successfully",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Server error occurred", "error");
    }
  };
  const editServiceandlechange = (e) => {
    const { name, value } = e.target;
    setData((prev) =>
      updateDiscountedFields(prev, name, value, "price", "final_price"),
    );
  };
  // const handlesubmitdataserviceEdit = async () => {
  //   const payload = {
  //     _id: data._id,
  //     duration: data.duration,
  //     endTime: data.endTime,
  //     price: Number(data.price),
  //     service_type: data.service_type,
  //     serviceId: data.serviceId,
  //     serviceName: data.serviceName,
  //     startTime: data.startTime,
  //   };
  //   try {
  //     const response = await axios.put(
  //       `${baseurl}edit_patient_extra_service/${treatmentIDservice}/${data.serviceId}`,
  //       payload, // (agar body bhejni hai)
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           "Content-Type": "application/json",
  //         },
  //       },
  //     );
  //     if (response.data?.success) {
  //       hadnlcecEcloseeModal();
  //       dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
  //       Swal.fire({
  //         icon: "success",
  //         title: "Updated!",
  //         text: response.data.message || "Service updated successfully",
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Warning",
  //         text: response.data?.message || "Update failed",
  //       });
  //     }
  //   } catch (error) {
  //     const errorMessage =
  //       error?.response?.data?.message ||
  //       error?.message ||
  //       "Something went wrong!";
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: errorMessage,
  //       didOpen: () => {
  //         const swalContainer = document.querySelector(".swal2-container");
  //         if (swalContainer) {
  //           swalContainer.style.zIndex = "1500"; // MUI Dialog se zyada
  //         }
  //       },
  //     });
  //   }
  // };
  const handlesubmitdataserviceEdit = async () => {
    // Convert price to number
    const priceValue = Number(data.price);
    if (!isValidPaidAmount(data?.price)) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please enter a valid price",
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) {
            swalContainer.style.zIndex = "1500";
          }
        },
      });
      return;
    }
    const discountError = getDiscountValidationError(
      data.price,
      data.discount_percentage,
      data.final_price,
    );
    if (discountError) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: discountError,
      });
      return;
    }
    // Date Mandatory Validation
    if (!data.startTime || !data.endTime) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Both start date and end date are mandatory",
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) {
            swalContainer.style.zIndex = "1500";
          }
        },
      });
      return;
    }
    // Date Comparison Validation
    const startDate = new Date(data.startTime);
    const endDate = new Date(data.endTime);
    if (startDate >= endDate) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Start date must be smaller than end date",
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) {
            swalContainer.style.zIndex = "1500";
          }
        },
      });
      return;
    }
    if (isServiceSubmitting) return;
    setIsServiceSubmitting(true);

    const payload = {
      _id: data._id,
      duration: data.duration,
      endTime: data.endTime,
      price: priceValue,
      ...(data.discount_percentage !== "" &&
        data.discount_percentage !== null &&
        data.discount_percentage !== undefined
        ? { discount_percentage: Number(data.discount_percentage) }
        : {}),
      ...(data.final_price !== "" &&
        data.final_price !== null &&
        data.final_price !== undefined
        ? { final_price: Number(data.final_price) }
        : {}),
      service_type: data.service_type,
      serviceId: data.serviceId,
      serviceName: data.serviceName,
      startTime: data.startTime,
    };
    try {
      const response = await axios.put(
        `${baseurl}edit_patient_extra_service/${treatmentIDservice}/${data.serviceId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data?.success) {
        hadnlcecEcloseeModal();
        dispatch(
          GetPatientTreatments({
            id: (location?.state?.patientId || effectivePatientDetailId),
          }),
        );
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: response.data.message || "Service updated successfully",
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: response.data?.message || "Update failed",
        });
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!";

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");

          if (swalContainer) {
            swalContainer.style.zIndex = "1500";
          }
        },
      });
    } finally {
      setIsServiceSubmitting(false);
    }
  };
  const handledeltePatientserveice = async (a, b, index) => {
    console.log(a, b);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this service?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6e7881",
    });
    if (!result.isConfirmed) return;
    try {
      const response = await axios.delete(
        `${baseurl}delete_patient_extra_service/${b.treatment_id}/${a.serviceId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data?.success) {
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        Swal.fire("Deleted!", "Service Deleted Successfully", "success");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Unable to delete service",
        "error",
      );
    }
  };
  const handleclickeditfunc = (item) => {
    setAppointmentid(item.appointmentId);
    setEdited(true);
    setOpen1(true);
    setEditData(item);
    setStatuddropdown(item.mode);
    setNote(item.note || "");
    setDate(item.appointment_Date || "");
    setAppointmentTime(
      getTimeInputValue(item.appointment_Date, item.appointment_Time),
    );
    setAppHospital({
      hospital_id: item.hospital_id,
      hospital_Name: item.hospital_Name,
    });
    if (item.mode === "offline") {
      setPickuptime(item.pickup_time || "");
      setDrivername(item.driver_name || "");
      setDrivercontact(item.driver_contact || "");
      setVehicalnumber(item.vehicle_no || "");
    } else {
      setPickuptime("");
      setDrivername("");
      setDrivercontact("");
      setVehicalnumber("");
    }
  };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };
  const handleRecommendChange = (e) => {
    setRecommend(e.target.value);
  };
  const handleRecommendTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };
  const handleClose1editapp = () => {
    setOeditappp(false);
  };
  const handleclickeditdelete = async (item) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this appointment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6e7881",
    });
    if (!result.isConfirmed) return;
    try {
      const response = await axios.delete(
        `${baseurl}delete_appointment/${item.appointmentId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data?.success) {
        getDataapi3(selectedTreatmentId);
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        Swal.fire(
          "Deleted!",
          response.data.message || "Appointment deleted successfully",
          "success",
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Unable to delete appointment",
        "error",
      );
    }
  };
  const handleExtraButton = async () => {
    try {
      const formattedDate = date
        ? new Date(date).toISOString().split("T")[0]
        : "";
      // 🔥 COMMON VALIDATION (for both)
      if (!hospitalData?.hospital_id) {
        return Swal.fire("Please select hospital", "", "warning");
      }
      if (!note) {
        return Swal.fire("Note is required", "", "warning");
      }
      if (!formattedDate) {
        return Swal.fire("Date is required", "", "warning");
      }
      if (!appointmentTime) {
        return Swal.fire("Appointment time is required", "", "warning");
      }
      if (!statuddropdown) {
        return Swal.fire("Mode is required", "", "warning");
      }
      const payload = {
        hospitalId: hospitalData.hospital_id,
        note: note,
        appointment_Date: formattedDate,
        appointment_Time: formatTime12Hour(appointmentTime),
        mode: statuddropdown,
        ...(statuddropdown === "offline" && {
          pickup_time: pickuptime,
          driver_name: drivername,
          driver_contact: drivercontact,
          vehicle_no: vehicalnumber,
        }),
      };
      console.log(payload);
      const response = await axios.put(
        `${baseurl}edit_appointment/${appointmentid}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        Swal.fire("Appointment updated successfully!", "", "success");
        setOpen1(false);
        getDataapi3(selectedTreatmentId);
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        // reset
        setNote("");
        setDate("");
        setAppointmentTime("");
        setPickuptime("");
        setDrivername("");
        setDrivercontact("");
        setVehicalnumber("");
        setAppHospital(null);
        setEdited(false);
        setAppointErr(false);
      } else {
        Swal.fire("Update failed!", "", "error");
      }
    } catch (err) {
      Swal.fire(
        "Error!",
        err?.response?.data?.message || err?.message || "Something went wrong",
        "error",
      );
    }
  };
  const handleClicexportPayment = async (a, b) => {
    try {
      const response = await axios.get(`${baseurl}exportTreatmentExcel/${b}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "treatment-payments.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      Swal.fire("Success", "Excel downloaded successfully!", "success");
    } catch (error) {
      Swal.fire("Error", "Failed to download excel file", "error");
    }
  };
  const handleExportReportsExcel = () => {
    const list = reportsFilered1 || [];
    if (!list || list.length === 0) {
      Swal.fire("Info", "No reports available to export", "info");
      return;
    }
    const headers = [
      "Sr.No.",
      "Treatment Name",
      "Report Title",
      "Report Date",
      "Added By",
      "Reports Count",
    ];
    const escapeHtml = (val) => {
      const text = val == null ? "" : String(val);
      return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    };

    const headerRow = headers
      .map(
        (h) =>
          `<th style="background-color:#0ba6df;color:#ffffff;font-weight:bold;padding:8px;border:1px solid #ddd;">${escapeHtml(
            h,
          )}</th>`,
      )
      .join("");

    const bodyRows = list
      .map((item, idx) => {
        const tName =
          item?.treatment_course_name || treatmentInfo?.treatment_name || "-";
        const title = item?.reportTitle || "-";
        const date = item?.treatment_report_date
          ? new Date(item.treatment_report_date).toLocaleDateString("en-GB")
          : "-";
        const addedBy = formatAddedBy(item) || "-";
        const reportFiles = Array.isArray(item?.treatmentReport)
          ? item.treatmentReport
          : item?.treatmentReport
            ? [item.treatmentReport]
            : Array.isArray(item?.documents)
              ? item.documents
              : [];
        const count = reportFiles.length;

        const cells = [idx + 1, tName, title, date, addedBy, count]
          .map(
            (c) =>
              `<td style="padding:6px;border:1px solid #ddd;">${escapeHtml(
                c,
              )}</td>`,
          )
          .join("");
        return `<tr>${cells}</tr>`;
      })
      .join("");

    const excelHtml = `\uFEFF<!DOCTYPE html>
<html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:x="urn:schemas-microsoft-com:office:excel"
      xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta charset="UTF-8">
<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
<x:Name>Patient Reports</x:Name>
<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
</x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
</head>
<body>
<h3 style="color:#0ba6df;font-family:sans-serif;">Patient Reports List</h3>
<table border="1" style="border-collapse:collapse;font-family:sans-serif;font-size:12px;">
<thead><tr>${headerRow}</tr></thead>
<tbody>${bodyRows}</tbody>
</table>
</body>
</html>`;

    // Export to Excel sheet
    const blob = new Blob([excelHtml], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const stamp = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.setAttribute("download", `patient-reports-${stamp}.xls`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    Swal.fire("Success", "Reports exported to Excel successfully!", "success");
  };
  const EditButton = (a, b) => {
    setTreatmentIDservice(b.treatment_id);
    setEditModalNotes(true);
    setNotesID(a._id);
    setNote2(a.note);
    setDate2(new Date(a.date).toISOString().split("T")[0]);
  };
  const handleCloseEditModal = () => {
    setEditModalNotes(false);
  };
  const editNotes = async () => {
    if (!note2) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please enter note",
      });
      return;
    }
    const formData = new FormData();
    formData.append("note", note2);

    // 👉 append multiple images
    images.forEach((img) => {
      formData.append("treatmentNoteImages", img);
    });
    try {
      const response = await axios.put(
        `${baseurl}edit_treatment_note/${treatmentIDservice}/${notesID}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        getDataapi3(treatmentIDservice);
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Note updated successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        handleCloseEditModal();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.message || "Update failed",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again",
      });
    }
  };

  const handleDownloadPDF2 = (refs, index, fileName) => {
    const element = refs.current[index];

    if (!element) {
      console.log("PDF element not found");
      return;
    }

    const options = {
      margin: 0.3,
      filename: fileName,

      image: {
        type: "jpeg",
        quality: 1,
      },

      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
        scrollX: 0,
        scrollY: 0,
      },

      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf().set(options).from(element).save();
  };
  const handleDownloadPDF1 = (refs, index, fileName) => {
    const element = refs.current[index];

    if (!element) return;

    const options = {
      margin: 0.3,
      filename: fileName,
      image: {
        type: "jpeg",
        quality: 1,
      },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf().set(options).from(element).save();
  };
  const EditDelete = async (a, b) => {
    const confirm = await Swal.fire({
      title: "Delete Note?",
      text: "Are You sure to delete this notes!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6e7881",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    });
    if (!confirm.isConfirmed) return;
    try {
      const response = await axios.delete(
        `${baseurl}delete_treatment_note/${b.treatment_id}/${a._id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Note deleted successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        getDataapi3(b.treatment_id);
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        handleCloseEditModal(); // or close delete modal if you have one
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.message || "Delete failed",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again",
      });
    }
  };
  const handleKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };
  const EditFreeDelete = async (a, b, c) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "This extra service will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6e7881",
      confirmButtonText: "Yes, delete it",
    });
    if (!confirmResult.isConfirmed) return;
    try {
      const response = await axios.delete(
        `${baseurl}delete_patient_extra_service/${b.treatment_id}/${c}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Extra service deleted successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      } else {
        Swal.fire("Error", response.data.message || "Delete failed", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  // ///////////////////////////////////////////////PlanTreatmentPopUp
  const PlanTreatmentPopUp = () => {
    setTreatmentPlanPopup(true);
  };
  const PlanTreatmentPopupClose = () => {
    setTreatmentPlanPopup(false);
    setDrreviewnotes("");
  };
  const handleChangeDetails123 = (selectedCourse) => {
    if (!selectedCourse) return;
    const dataStore = selectedCourse.id;
    setHospitalFunction(dataStore);
  };
  const setHospitalFunction = async (dataStore) => {
    const payload = {
      treatment_id: dataStore,
    };
    try {
      const response = await axios.post(
        `${AdminBaseUrl}treatment_hospital_list`,
        payload,
      );
      if (response.data.success) {
        const hospitalData = response.data.data;
        const updatedList = [
          { _id: "all", name: "Select All" }, // 👈 YEH LINE ADD
          ...hospitalData,
        ];
        setHospitlID(updatedList);
      }
    } catch (error) { }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!fieldValue) {
      newErrors.treatment = "Treatment is required";
    }
    if (!hospitalId || hospitalId.length === 0) {
      newErrors.hospitals = "Please select at least one hospital";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const uploadmultipleRecord = async () => {
    if (!validateForm()) return;
    const swalOnTop = Swal.mixin({
      customClass: {
        popup: "swal-on-top",
      },
      buttonsStyling: true,
    });
    const formData = new FormData();
    formData.append("patientObjectId", location?.state?.testid);
    formData.append("patientId", (location?.state?.patientId || effectivePatientDetailId));
    formData.append("treatment", JSON.stringify(fieldValue));
    formData.append("hospitals", JSON.stringify(hospitalId));
    formData.append("doctorReviewId", drreviewnotes);
    formData.append("platform", 1);
    formData.append("notes", value1 || "");
    if (images && images.length > 0) {
      images.forEach((file) => {
        formData.append("reports", file);
      });
    }
    try {
      const response = await axios.post(
        `${baseurl}addTreatmentPlan`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        getTreatmentPlan();
        setTreatmentPlanPopup(false);
        await swalOnTop.fire({
          icon: "success",
          title: "Success",
          text: response.data.message || "Treatment plan added successfully",
          confirmButtonText: "OK",
        });
        PlanTreatmentPopupClose();
        setFieldValue(null);
        setHospitalId([]);
        setDrreviewnotes("");
        setValue1("");
        setImages([]);
      } else {
        await swalOnTop.fire(
          "Error",
          response?.data?.message || "Something went wrong",
          "error",
        );
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Server error occurred";
      await swalOnTop.fire("Error", errorMsg, "error");
    }
  };

  // Open modal to add hospitals to an existing treatment plan
  const handleOpenAddHospitalToPlan = async (plan) => {
    if (!plan) return;
    setTargetPlanForAddHosp(plan);
    setSelectedHospitalsForPlan([]);
    setAddHospPlanNotes("");
    setAddHospPlanError("");
    setAddHospToPlanModalOpen(true);

    // Fetch hospital options for this treatment plan
    const treatmentId =
      plan?.treatment?._id ||
      plan?.treatment?.id ||
      plan?.treatmentId ||
      plan?.treatment_id;

    let hospList = [];
    if (treatmentId) {
      try {
        const res = await axios.post(`${AdminBaseUrl}treatment_hospital_list`, {
          treatment_id: treatmentId,
        });
        if (res?.data?.success && Array.isArray(res?.data?.data) && res.data.data.length > 0) {
          hospList = res.data.data;
        }
      } catch (err) {
        console.warn("Could not fetch treatment_hospital_list, falling back to hospital_list:", err);
      }
    }

    if (hospList.length === 0) {
      if (dataHospital && dataHospital.length > 0) {
        hospList = dataHospital;
      } else {
        try {
          const res = await axios.post(`${AdminBaseUrl}hospital_list`);
          if (res?.data?.data) {
            hospList = res.data.data;
          }
        } catch (err) {
          console.error("Failed to load hospital_list:", err);
        }
      }
    }

    // Filter out hospitals already added to this treatment plan
    const existingHospitalIds = new Set(
      (plan?.hospitals || []).map((h) => String(h.id || h._id || h.hospitalId || "").trim())
    );
    const existingHospitalNames = new Set(
      (plan?.hospitals || []).map((h) => String(h.name || h.hospitalName || "").toLowerCase().trim())
    );

    const filtered = (hospList || []).filter((h) => {
      if (h._id === "all" || h.id === "all") return false;
      const hid = String(h.id || h._id || "").trim();
      const hname = String(h.name || h.hospital_name || "").toLowerCase().trim();
      if (hid && existingHospitalIds.has(hid)) return false;
      if (hname && existingHospitalNames.has(hname)) return false;
      return true;
    });

    setAvailableHospitalsForPlan(filtered);
  };

  // Submit adding hospitals to the existing treatment plan
  const handleSubmitAddHospitalsToPlan = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!selectedHospitalsForPlan || selectedHospitalsForPlan.length === 0) {
      setAddHospPlanError("Please select at least one hospital.");
      return;
    }

    setIsAddingHospToPlan(true);
    setAddHospPlanError("");

    const planId =
      targetPlanForAddHosp?._id ||
      targetPlanForAddHosp?.id ||
      targetPlanForAddHosp?.treatmentPlanId;

    const hospitalsPayload = selectedHospitalsForPlan.map((h) => ({
      id: h.id || h._id,
      name: h.name || h.hospital_name || "",
      email: h.email || h.hospital_email || "",
    }));

    const payload = {
      hospitals: hospitalsPayload,
      notes: addHospPlanNotes.trim(),
    };

    try {
      let response;
      try {
        // Dedicated primary endpoint: POST /api/addHospitalToTreatmentPlan/:treatmentPlanId
        response = await axios.post(
          `${baseurl}addHospitalToTreatmentPlan/${planId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
      } catch (primaryErr) {
        console.warn("Primary endpoint failed, attempting fallback endpoints:", primaryErr);
        if (
          primaryErr?.response?.status === 404 ||
          primaryErr?.response?.status === 405 ||
          primaryErr?.response?.status === 500
        ) {
          try {
            // Fallback A: PUT /api/addHospitalToTreatmentPlan/:treatmentPlanId
            response = await axios.put(
              `${baseurl}addHospitalToTreatmentPlan/${planId}`,
              payload,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              }
            );
          } catch (putErr) {
            // Fallback B: POST /api/assignHospitalsToTreatmentPlan/:treatmentPlanId
            response = await axios.post(
              `${baseurl}assignHospitalsToTreatmentPlan/${planId}`,
              payload,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              }
            );
          }
        } else {
          throw primaryErr;
        }
      }

      if (response?.data?.success !== false) {
        setAddHospToPlanModalOpen(false);
        await Swal.fire({
          icon: "success",
          title: "Hospitals Added!",
          text:
            response?.data?.message ||
            "Hospitals successfully added to the treatment plan.",
          timer: 2000,
          showConfirmButton: false,
        });

        // Refresh treatment plans
        getTreatmentPlan();
        if (dispatch && typeof GetPatientTreatments === "function") {
          dispatch(
            GetPatientTreatments({
              id: location?.state?.patientId || effectivePatientDetailId,
            })
          );
        }
      } else {
        throw new Error(
          response?.data?.message || "Failed to add hospitals to treatment plan."
        );
      }
    } catch (err) {
      console.error("Error adding hospitals to treatment plan:", err);
      const errorMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Failed to add hospitals to treatment plan.";
      setAddHospPlanError(errorMsg);
      Swal.fire("Error", errorMsg, "error");
    } finally {
      setIsAddingHospToPlan(false);
    }
  };

  const handleAddTritmentPaymenttestsubmit = async () => {
    try {
      if (!dataPerforma) {
        Swal.fire({
          icon: "warning",
          title: "No File Selected",
          text: "Please select a Performa Invoice file first.",
        });
        return;
      }
      const formData = new FormData();
      formData.append("perfomainvoice", dataPerforma);
      const response = await axios.post(`${baseurl}performainvoice`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response.data.success) {
        setOpen32(false);
        Swal.fire({
          icon: "success",
          title: "Uploaded Successfully!",
          text: response?.data?.message || "Performa Invoice uploaded.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed!",
        text:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    }
  };
  const handledelteguestHouse = async (item, info, index) => {
    console.log(item, info, index);
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `${baseurl}deleteGuestHouseCharge/${item.id}`,
        );
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: response.data.message || "Record deleted successfully",
          });
          patient_guesthouse(item.treatment_id); // ya jo bhi API tum use kar rahe ho refresh ke liye
          dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.data?.message || "Something went wrong",
          });
        }
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.message || "Server error, please try again",
        });
      }
    }
  };
  const AddpaymentOnchnage123 = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/webp",
    ];
    if (!allowedTypes.includes(file.type)) {
      Swal.fire("Only PDF or Image files are allowed!");
      e.target.value = null;
      return;
    }
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      Swal.fire("File size must be less than 5MB");
      e.target.value = null;
      return;
    }
    setDataPerforma((prev) => ({
      ...prev,
      perfomainvoice: file,
    }));
  };
  const getDrreview = async () => {
    const payload = {
      patientId: (location?.state?.patientId || effectivePatientDetailId),
    };
    try {
      const response = await axios.get(
        `${baseurl}get_doctor_review/${(location?.state?.patientId || effectivePatientDetailId)}`,
      );
      if (response.data.success) {
        console.log(response.data);
        setDoctorReviewData1(response.data.data);
      }
    } catch (error) { }
  };
  const getTreatmentPlan = async () => {
    setIsTreatmentPlanLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}getTreatmentPlans?patientId=${(location?.state?.patientId || effectivePatientDetailId)}&version=v2`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        setTreatemntData1(response.data.data);
      }
    } catch (error) { }
    finally {
      setIsTreatmentPlanLoading(false);
    }
  };

  const handleClosepayment3 = () => {
    setOpenPaymentmodal(false);
  };

  const formatTodayDateString = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[today.getMonth()];
    const year = today.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleOpenPdfModal = async (hospitalItem, info, type) => {
    const resolvedType = normalizePdfType(type);
    const treatmentPlanId = getPdfTreatmentPlanId(info, hospitalItem);
    setPdfType(resolvedType);
    setPdfTreatmentPlanId(treatmentPlanId);
    setPdfActiveTab("form");
    setPdfModalOpen(true);
    setPdfLoading(true);

    const patientId = getPdfPatientId(ispatient, location?.state);

    const defaultData = {
      date: formatTodayDateString(),
      patient_name:
        ispatient?.patient_name ||
        ispatient?.name ||
        ispatient?.fullname ||
        ispatient?.enq_userName ||
        "",
      patient_age:
        ispatient?.age || ispatient?.patient_age || ispatient?.enq_userAge || "",
      hospital_name: hospitalItem?.name || hospitalItem?.hospitalName || "",
      hospital_location:
        hospitalItem?.location ||
        ispatient?.hospital_location ||
        "New Delhi, India",
      diagnosis: ispatient?.diagnosis || ispatient?.health_issue || "",
      treatment_surgery:
        info?.treatmentName ||
        ispatient?.treatment_name ||
        ispatient?.treatment ||
        "",
      treating_doctor:
        ispatient?.treating_doctor || ispatient?.doctor_name || "",
      evaluation_cost: "10 USD",
      surgery_cost: "4500 USD",
      hospital_stay_duration: "5 Days",
      india_stay_duration: "15 Days",
      accommodation_cost: "10 USD",
      guesthouse_cost: "10 USD",
      air_ticket_cost: "2500 USD",
      medical_cost: "2500 USD",
      physiotherapy_cost: "3200 USD",
      other_additional_costs: "1500 USD",
      treatment_cost: "10 USD",
      medical_escort_cost: "3500 USD",
      sim_card_cost: "100 USD",
      medif_cost: "500 USD",
      transport_cost: "350 USD",
      remark: "",
      paragraph_1:
        resolvedType === "Foundation"
          ? "All contributions in support of this treatment can be made securely by scanning the QR Code provided:"
          : "Overseas Medical Care Assistance Ltd is facilitating all necessary arrangements as the medical service provider in Mauritius and India, including visa processing, accommodation arrangements, and flight bookings.",
      paragraph_2:
        resolvedType === "Foundation"
          ? `We humbly seek your prayers & support to enable ${ispatient?.patient_name || ispatient?.name || ispatient?.fullname || ispatient?.enq_userName || "Pravesh"} to undergo the necessary medical treatment. Your generosity can truly make a difference and help save a life.`
          : "Below is a breakdown of the estimated costs associated with the medical travel:",
      paragraph_3:
        resolvedType === "Foundation"
          ? ""
          : "These estimates are subject to change based on further evaluation and the price for the ticket is subjected to availability of seats and rate of exchange.",
      paragraph_4:
        resolvedType === "Foundation"
          ? ""
          : "Please be advised that this letter is not intended for the collection of funds.",
      paragraph_5:
        resolvedType === "Foundation"
          ? ""
          : "For any further inquiries, please feel free to contact our office at +230 660 0210.",
      signatory_name: DEFAULT_PDF_SIGNATORY,
      designation: "Medical Coordinator",
      signature: signatureImg,
      gender: ispatient?.gender || "",
      estimate_cost_details: [],
      qr_code: "",
    };

    setPdfFormData(defaultData);

    try {
      if (patientId && treatmentPlanId) {
        const response = await axios.get(`${baseurl}get_pdf_details`, {
          params: {
            patient_id: patientId,
            treatment_plan_id: treatmentPlanId,
            pdf_type: resolvedType,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const fetchedData =
          response.data?.data ||
          response.data?.detail ||
          response.data?.details ||
          (response.data && typeof response.data === "object"
            ? response.data
            : null);

        if (fetchedData && typeof fetchedData === "object") {
          setPdfFormData((prev) => {
            const updated = { ...prev };
            Object.keys(initialPdfFormData).forEach((key) => {
              if (resolvedType === "Foundation" && ["paragraph_3", "paragraph_4", "paragraph_5"].includes(key)) {
                updated[key] = "";
                return;
              }
              if (fetchedData[key] !== undefined && fetchedData[key] !== null) {
                if (key === "estimate_cost_details") {
                  updated[key] = normalizeEstimateCostDetails(fetchedData[key]);
                } else {
                  updated[key] = fetchedData[key];
                }
              }
            });
            return updated;
          });
        }
      }
    } catch (err) {
      console.log("get_pdf_details fetch notice:", err);
    } finally {
      setPdfLoading(false);
    }
  };

  const handlePdfInputChange = (e) => {
    const { name, value } = e.target;
    setPdfFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSavePdfDetails = async (showNotification = true) => {
    setSavingPdf(true);
    const patientId = getPdfPatientId(ispatient, location?.state);

    try {
      const resolvedType = normalizePdfType(pdfType);
      if (!ALLOWED_PDF_TYPES.includes(resolvedType)) {
        if (showNotification) {
          Swal.fire(
            "Error",
            "pdf_type must be Foundation or Private",
            "error",
          );
        }
        return false;
      }

      if (!patientId || !pdfTreatmentPlanId || !resolvedType) {
        if (showNotification) {
          Swal.fire(
            "Error",
            "patient_id, treatment_plan_id, and pdf_type are required",
            "error",
          );
        }
        return false;
      }

      const formData = new FormData();
      formData.append("patient_id", patientId);
      formData.append("treatment_plan_id", pdfTreatmentPlanId);
      formData.append("pdf_type", resolvedType);

      Object.keys(pdfFormData).forEach((key) => {
        if (resolvedType === "Foundation" && ["paragraph_3", "paragraph_4", "paragraph_5"].includes(key)) {
          return; // only pass paragraph_1 and paragraph_2 for Foundation
        }
        if (key === "estimate_cost_details") {
          formData.append(
            key,
            JSON.stringify(normalizeEstimateCostDetails(pdfFormData[key])),
          );
        } else if (key === "qr_code") {
          if (pdfFormData[key] instanceof File) {
            formData.append(key, pdfFormData[key]);
          } else if (pdfFormData[key]) {
            formData.append(key, pdfFormData[key]);
          }
        } else {
          formData.append(key, pdfFormData[key] !== null && pdfFormData[key] !== undefined ? pdfFormData[key] : "");
        }
      });

      const saveQuery = new URLSearchParams({
        patient_id: patientId,
        treatment_plan_id: pdfTreatmentPlanId,
        pdf_type: resolvedType,
      });

      const response = await axios.post(
        `${baseurl}save_pdf_details?${saveQuery.toString()}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (showNotification) {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          text: response.data?.message || "PDF details saved successfully.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
      return true;
    } catch (error) {
      console.error("Error saving PDF details:", error);
      if (showNotification) {
        Swal.fire(
          "Error",
          error.response?.data?.message || "Failed to save PDF details",
          "error",
        );
      }
      return false;
    } finally {
      setSavingPdf(false);
    }
  };

  const handleGeneratePdfDownload = async () => {
    setPdfLoading(true);
    try {
      await handleSavePdfDetails(false);
      await loadPdfImagesAsBase64();

      // Delay to let React re-render DOM with loaded base64 images
      await new Promise((resolve) => setTimeout(resolve, 600));

      const element = pdfTemplateRef.current;
      if (!element) {
        Swal.fire("Error", "PDF template element not found", "error");
        return;
      }

      const fileName = `${pdfType.replace(/\s+/g, "_")}_${(
        pdfTreatmentPlanId || pdfFormData.patient_name || "Patient"
      ).replace(/\s+/g, "_")}.pdf`;

      const images = Array.from(element.querySelectorAll("img"));
      await Promise.all(
        images.map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve;
            }),
        ),
      );

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        width: 794,
        height: 1123,
        windowWidth: 794,
        windowHeight: 1123,
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      pdf.addImage(imgData, "JPEG", 0, 0, 210, 297, undefined, "FAST");
      pdf.save(fileName);

      // Convert generated PDF to blob and upload to backend
      const pdfBlob = pdf.output("blob");
      const resolvedType = normalizePdfType(pdfType);
      const patientId = getPdfPatientId(ispatient, location?.state);

      if (patientId && pdfTreatmentPlanId && resolvedType) {
        const uploadFormData = new FormData();
        uploadFormData.append("patient_id", patientId);
        uploadFormData.append("treatment_plan_id", pdfTreatmentPlanId);
        uploadFormData.append("pdf_type", resolvedType);
        uploadFormData.append("pdf_file", pdfBlob, fileName);
        uploadFormData.append("pdf", pdfBlob, fileName);
        uploadFormData.append("file", pdfBlob, fileName);

        try {
          const saveQuery = new URLSearchParams({
            patient_id: patientId,
            treatment_plan_id: pdfTreatmentPlanId,
            pdf_type: resolvedType,
          });

          await axios.post(
            `${baseurl}save_pdf_details?${saveQuery.toString()}`,
            uploadFormData,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log("PDF uploaded to save_pdf_details successfully");
        } catch (uploadErr) {
          console.error("Failed to upload generated PDF to save_pdf_details:", uploadErr);
        }

        // Also add the PDF to patient reports as fallback so it shows on patient side
        const activeTreatmentId = treatmentId || pdfTreatmentPlanId || ispatient?._id;
        if (activeTreatmentId) {
          const reportFormData = new FormData();
          reportFormData.append("reportTitle", `${resolvedType} Treatment Plan PDF`);
          reportFormData.append("treatment_report_date", new Date().toISOString().split("T")[0]);
          reportFormData.append("platform", 1);
          reportFormData.append("treatmentReport", pdfBlob, fileName);

          try {
            await axios.post(
              `${baseurl}addReports/${activeTreatmentId}`,
              reportFormData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            console.log("PDF uploaded to reports successfully");
            gtdatareportsdata();
          } catch (reportErr) {
            console.error("Failed to upload PDF to reports:", reportErr);
          }
        }
      }

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "PDF generated, downloaded, and shared with patient successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("PDF generation error:", err);
      Swal.fire("Error", "Failed to generate PDF document", "error");
    } finally {
      setPdfLoading(false);
    }
  };

  // CRM Side Treatment Plan statuses (from workflow sheet)
  const CRM_TP_STATUS = {
    AWAITING: "Awaiting for Treatment Plan",
    RECEIVED: "Treatment Plan Received",
    APPROVED: "Treatment Plan Approved",
    REJECTED: "Treatment Plan Rejected",
  };

  const getHospitalStatusBadgeClass = (status) => {
    const normalized = (status || "").trim();
    if (
      normalized === "Approved" ||
      normalized === CRM_TP_STATUS.APPROVED
    ) {
      return "approved";
    }
    if (
      normalized === "Rejected" ||
      normalized === CRM_TP_STATUS.REJECTED
    ) {
      return "rejected";
    }
    if (
      normalized === CRM_TP_STATUS.AWAITING ||
      /awaiting/i.test(normalized)
    ) {
      return "awaiting";
    }
    if (
      normalized === CRM_TP_STATUS.RECEIVED ||
      /received/i.test(normalized)
    ) {
      return "received";
    }
    if (/pre-intimation|letter/i.test(normalized)) {
      return "pre-intimation";
    }
    if (/vil approved/i.test(normalized)) {
      return "vil-approved";
    }
    if (/vil rejected/i.test(normalized)) {
      return "vil-rejected";
    }
    if (/vil (pending|upload|uploaded|resubmit)/i.test(normalized)) {
      return "vil-pending";
    }
    if (/treatment created/i.test(normalized)) {
      return "treatment-created";
    }
    return "pending";
  };

  const getHospitalPlanDocs = (hospital) => {
    const docs =
      hospital?.treatmentPlanDocuments ||
      hospital?.estimationDocuments ||
      hospital?.estimationDocs ||
      [];
    return Array.isArray(docs) ? docs : [];
  };

  const isHospitalPending = (hospital) =>
    !hospital?.status || hospital.status === "Pending";

  const hasHospitalUploadedPlanDocument = (hospital) =>
    getHospitalPlanDocs(hospital).some(
      (doc) => doc?.file || doc?.fileName || doc?.url,
    );

  const showAwaitingHospitalPlan = (hospital) =>
    isHospitalPending(hospital) && !hasHospitalUploadedPlanDocument(hospital);

  const canReviewHospital = (info, hospital) =>
    info?.isAnyHospitalApproved !== true &&
    isHospitalPending(hospital) &&
    hasHospitalUploadedPlanDocument(hospital);

  /** Map hospital raw status → CRM Side display status */
  const getCrmHospitalStatusLabel = (hospital) => {
    const rawStatus = (hospital?.status || "").trim();
    if (rawStatus === "Approved") return CRM_TP_STATUS.APPROVED;
    if (rawStatus === "Rejected") return CRM_TP_STATUS.REJECTED;
    if (showAwaitingHospitalPlan(hospital)) return CRM_TP_STATUS.AWAITING;
    if (isHospitalPending(hospital) && hasHospitalUploadedPlanDocument(hospital)) {
      return CRM_TP_STATUS.RECEIVED;
    }
    if (isHospitalPending(hospital)) return CRM_TP_STATUS.AWAITING;
    return rawStatus || CRM_TP_STATUS.AWAITING;
  };

  /** Check if a Treatment Plan is Approved (either whole plan or any hospital under it is approved) */
  const isTreatmentPlanApproved = (plan) => {
    if (!plan) return false;
    if (plan.isAnyHospitalApproved === true || plan.is_any_hospital_approved === true) {
      return true;
    }
    const s = String(plan.status || plan.crmStatus || "").toLowerCase().trim();
    if (s === "approved" || s.includes("approved")) return true;
    if (Array.isArray(plan.hospitals)) {
      return plan.hospitals.some((h) => {
        const hs = String(h?.status || "").toLowerCase().trim();
        const crmLabel = String(getCrmHospitalStatusLabel(h) || "").toLowerCase().trim();
        return hs === "approved" || hs.includes("approved") || crmLabel.includes("approved");
      });
    }
    return false;
  };

  /** Map status-history entry → CRM Side label */
  const getCrmStatusHistoryLabel = (entry) => {
    if (!entry) return "-";
    const raw = (entry.status || entry.crmStatus || "").trim();
    const notes = (entry.notes || entry.note || "").trim();
    const allText = `${raw} ${notes} ${entry.uploadType || ""} ${entry.type || ""} ${entry.action || ""}`;

    // 1. Pre-Intimation Letter Sent entries (check FIRST to avoid false /sent/i matches)
    if (
      /pre-intimation|intimation/i.test(raw) ||
      /pre-intimation/i.test(notes) ||
      (/letter/i.test(raw) && !/treatment/i.test(raw)) ||
      /pre-intimation email sent/i.test(notes) ||
      (/email sent/i.test(allText) && /pre-intimation/i.test(allText))
    ) {
      return "Pre-Intimation Sent";
    }

    // 2. VIL specific statuses (check before generic resubmit/submit)
    if (/vil approved/i.test(raw)) return "VIL Approved";
    if (/vil rejected/i.test(raw)) return "VIL Rejected";
    if (/vil resubmit/i.test(raw)) return "VIL Resubmitted";
    if (/vil upload/i.test(raw)) return "VIL Uploaded";
    if (/treatment created/i.test(raw)) return "Treatment Created";

    // 3. Exact CRM TP Statuses
    if (
      raw === CRM_TP_STATUS.AWAITING ||
      raw === CRM_TP_STATUS.RECEIVED ||
      raw === CRM_TP_STATUS.APPROVED ||
      raw === CRM_TP_STATUS.REJECTED
    ) {
      return raw;
    }

    if (raw === "Approved") return CRM_TP_STATUS.APPROVED;
    if (raw === "Rejected") return CRM_TP_STATUS.REJECTED;

    // 4. Treatment plan pending / awaiting / requested
    if (raw === "Pending" || raw === "Requested" || /awaiting|requested/i.test(raw)) {
      const docs = getStatusHistoryDocuments(entry);
      const hasDocs =
        (Array.isArray(entry.documents) && entry.documents.length > 0) ||
        docs.length > 0 ||
        /submitted|received|resubmit|re-submitted/i.test(
          `${entry.notes || ""} ${entry.uploadType || ""} ${entry.type || ""} ${entry.action || ""}`,
        );
      // After hospital submit/resubmit → Received; otherwise Awaiting
      if (hasDocs || /resubmit|submitted|received/i.test(raw)) {
        return CRM_TP_STATUS.RECEIVED;
      }
      return CRM_TP_STATUS.AWAITING;
    }

    if (/submitted|received|resubmit/i.test(raw)) {
      return CRM_TP_STATUS.RECEIVED;
    }

    return raw || "-";
  };

  const getDocFileUrl = (doc) => {
    if (!doc) return "";
    let target = doc;

    while (Array.isArray(target) && target.length > 0) {
      target = target.find(Boolean);
    }
    if (!target) return "";

    if (typeof target === "string" && (target.trim().startsWith("[") || target.trim().startsWith("{"))) {
      try {
        const parsed = JSON.parse(target.trim());
        if (Array.isArray(parsed)) {
          target = parsed.find(Boolean);
        } else if (parsed && typeof parsed === "object") {
          target = parsed;
        }
      } catch (e) {}
    }
    if (!target) return "";

    const rawPath =
      typeof target === "string"
        ? target.trim()
        : (target?.file ||
           target?.fileName ||
           target?.filename ||
           target?.filePath ||
           target?.filepath ||
           target?.fileUrl ||
           target?.file_url ||
           target?.path ||
           target?.url ||
           target?.attachment ||
           target?.document ||
           target?.location ||
           (target?.name && /\.(pdf|jpg|jpeg|png|webp|gif|docx?|xlsx?)$/i.test(target.name) ? target.name : "") ||
           "");

    if (!rawPath || typeof rawPath !== "string") return "";
    const filePath = rawPath.trim();
    if (!filePath || filePath === "null" || filePath === "undefined") return "";

    if (
      filePath.startsWith("http://") ||
      filePath.startsWith("https://") ||
      filePath.startsWith("blob:") ||
      filePath.startsWith("data:")
    ) {
      return filePath;
    }

    const cleanPath = filePath.replace(/^\/+/, "");
    const base = (imageUrl || "").endsWith("/") ? imageUrl : `${imageUrl || ""}/`;
    return `${base}${cleanPath}`;
  };

  const handleOpenDocFile = (doc) => {
    const fileUrl = getDocFileUrl(doc);
    if (fileUrl) {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    } else {
      Swal.fire({
        icon: "warning",
        title: "Document Unavailable",
        text: "The document file URL could not be found or is invalid.",
      });
    }
  };

  const getDocFilesList = (files) => {
    if (!files) return [];
    if (Array.isArray(files)) {
      return files.flat().filter(Boolean);
    }
    if (typeof files === "string") {
      const trimmed = files.trim();
      if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) return parsed.filter(Boolean);
        } catch (e) {}
      }
      if (trimmed.includes(",") && !trimmed.startsWith("http")) {
        return trimmed.split(",").map((s) => s.trim()).filter(Boolean);
      }
      return [trimmed];
    }
    if (typeof files === "object") {
      return [files];
    }
    return [];
  };

  const getStatusHistoryDocuments = (entry) => {
    if (!entry) return [];
    const sources = [
      entry.documents,
      entry.treatmentPlanDocuments,
      entry.files,
      entry.document ? [entry.document] : null,
    ].filter(Array.isArray);
    const docs = sources.flat().filter(Boolean);
    if (docs.length > 0) {
      return docs.filter((doc) => doc?.file || doc?.fileName || doc?.url);
    }
    if (entry?.file || entry?.fileName || entry?.url) {
      return [entry];
    }
    return [];
  };

  const getPreIntimationDocs = (hospital, entry) => {
    const fromEntry = getStatusHistoryDocuments(entry);
    if (fromEntry.length > 0) return fromEntry;

    const pi = hospital?.preIntimation;
    if (!pi) return [];

    const docs = [];
    if (pi.patientPassportFile) {
      docs.push({
        fileName: "Patient Passport Copy",
        file: pi.patientPassportFile,
      });
    }
    if (Array.isArray(pi.passportAttachments)) {
      pi.passportAttachments.forEach((att, i) => {
        const f = typeof att === "string" ? att : att?.file || att?.url;
        if (f) {
          docs.push({
            fileName: `Passport Attachment ${i + 1}`,
            file: f,
          });
        }
      });
    }
    if (Array.isArray(pi.attachments)) {
      pi.attachments.forEach((att, i) => {
        const f = typeof att === "string" ? att : att?.file || att?.url;
        if (f) {
          docs.push({
            fileName: `Attachment ${i + 1}`,
            file: f,
          });
        }
      });
    }
    if (pi.preIntimationLetter || pi.letterFile || pi.letter) {
      docs.push({
        fileName: "Pre-Intimation Letter",
        file: pi.preIntimationLetter || pi.letterFile || pi.letter,
      });
    }
    return docs.filter((d) => Boolean(d.file));
  };

  const getVilHistoryDocs = (hospital, entry) => {
    const fromEntry = getStatusHistoryDocuments(entry);
    if (fromEntry.length > 0) return fromEntry;

    const vilDocs = [
      ...(Array.isArray(hospital?.vilDocuments) ? hospital.vilDocuments : []),
      ...(hospital?.vilDocument ? [hospital.vilDocument] : []),
    ].filter(Boolean);

    return vilDocs.map((doc) =>
      typeof doc === "string" ? { file: doc, fileName: "VIL Document" } : doc,
    );
  };

  const attachDocumentsToStatusEntry = (entry, hospital) => {
    if (!entry) return [];
    const entryDocuments = getStatusHistoryDocuments(entry);
    if (entryDocuments.length > 0) return entryDocuments;

    const statusText = `${entry?.status || ""} ${entry?.crmStatus || ""} ${entry?.notes || ""}`;

    // Pre-Intimation entries: attach Pre-Intimation / passport documents
    if (/pre-intimation|intimation/i.test(statusText)) {
      return getPreIntimationDocs(hospital, entry);
    }

    // VIL entries: attach VIL documents
    if (/vil/i.test(statusText)) {
      return getVilHistoryDocs(hospital, entry);
    }

    // Treatment Created: no document
    if (/treatment created/i.test(statusText)) {
      return [];
    }

    // Only genuine Treatment Plan entries should attach treatmentPlanUploadHistory
    const uploadHistory = hospital?.treatmentPlanUploadHistory || [];
    if (!Array.isArray(uploadHistory) || uploadHistory.length === 0) {
      return [];
    }

    const entryTime = new Date(
      entry?.changedAt || entry?.createdAt || entry?.updatedAt || 0,
    ).getTime();

    const matchedByDate = uploadHistory.find((upload) => {
      const uploadTime = new Date(
        upload?.uploadedAt || upload?.createdAt || upload?.changedAt || 0,
      ).getTime();
      return uploadTime && entryTime && Math.abs(uploadTime - entryTime) < 86400000;
    });
    if (matchedByDate) {
      return getStatusHistoryDocuments(matchedByDate);
    }

    const entryType = (
      entry?.uploadType ||
      entry?.type ||
      entry?.action ||
      ""
    ).toLowerCase();
    if (entryType) {
      const matchedByType = uploadHistory.find(
        (upload) =>
          (
            upload?.uploadType ||
            upload?.type ||
            upload?.action ||
            ""
          ).toLowerCase() === entryType,
      );
      if (matchedByType) {
        return getStatusHistoryDocuments(matchedByType);
      }
    }

    if ((entry?.status || "").trim() === "Pending") {
      const resubmitUpload = [...uploadHistory]
        .reverse()
        .find(
          (upload) =>
            (upload?.uploadType || upload?.type || upload?.action || "") ===
            "Resubmit",
        );
      if (resubmitUpload && /resubmit/i.test(entry?.notes || "")) {
        return getStatusHistoryDocuments(resubmitUpload);
      }
      const initialUpload = uploadHistory.find(
        (upload) =>
          (upload?.uploadType || upload?.type || upload?.action || "Initial") ===
          "Initial",
      );
      if (initialUpload) {
        return getStatusHistoryDocuments(initialUpload);
      }
    }

    if (/another hospital has been approved/i.test(entry?.notes || "")) {
      return [];
    }

    if ((entry?.status || "").trim() === "Approved") {
      const latestUpload = uploadHistory[uploadHistory.length - 1];
      if (latestUpload) {
        return getStatusHistoryDocuments(latestUpload);
      }
    }

    if ((entry?.status || "").trim() === "Rejected") {
      const initialUpload = uploadHistory.find(
        (upload) =>
          (upload?.uploadType || upload?.type || upload?.action || "Initial") ===
          "Initial",
      );
      if (initialUpload && !/resubmit/i.test(entry?.notes || "")) {
        return getStatusHistoryDocuments(initialUpload);
      }
      const latestUpload = uploadHistory[uploadHistory.length - 1];
      if (latestUpload) {
        return getStatusHistoryDocuments(latestUpload);
      }
    }

    return [];
  };

  const enrichStatusHistoryEntry = (entry, hospital) => {
    if (!entry) return null;
    return {
      ...entry,
      hospitalName: entry.hospitalName || entry.hospital || hospital?.name,
      documents: hospital
        ? attachDocumentsToStatusEntry(entry, hospital)
        : getStatusHistoryDocuments(entry),
    };
  };

  const formatStatusHistoryDate = (entry) => {
    const dateValue =
      entry?.changedAt ||
      entry?.createdAt ||
      entry?.date ||
      entry?.updatedAt;
    if (!dateValue) return "-";
    return new Date(dateValue).toLocaleDateString("en-GB");
  };

  const filterSupersededPendingEntries = (entries) => {
    if (!Array.isArray(entries) || entries.length === 0) return [];

    const getHospitalKey = (entry) =>
      String(
        entry?.hospitalName || entry?.hospital || entry?.hospitalId || "",
      );

    const getEntryTime = (entry) =>
      new Date(
        entry?.changedAt || entry?.createdAt || entry?.updatedAt || 0,
      ).getTime();

    const grouped = entries.reduce((acc, entry) => {
      const key = getHospitalKey(entry);
      if (!acc[key]) acc[key] = [];
      acc[key].push(entry);
      return acc;
    }, {});

    const filtered = [];
    Object.values(grouped).forEach((hospitalEntries) => {
      const sorted = [...hospitalEntries].sort(
        (a, b) => getEntryTime(a) - getEntryTime(b),
      );
      sorted.forEach((entry) => {
        // Keep full CRM flow in history (Awaiting → Received → Approved/Rejected)
        filtered.push(entry);
      });
    });

    return filtered.sort((a, b) => getEntryTime(a) - getEntryTime(b));
  };

  const withCrmStatusLabel = (entry) => {
    if (!entry) return null;
    const crmStatus = getCrmStatusHistoryLabel(entry);
    return {
      ...entry,
      status: crmStatus,
      rawStatus: entry.status,
    };
  };

  /** Filter out default / premature VIL Upload entries before a VIL is actually uploaded */
  const isDefaultVilUploadEntry = (entry, hospital, info) => {
    if (!entry) return false;
    const status = (entry.status || entry.crmStatus || "").trim();
    const notes = (entry.notes || entry.note || "").trim().toLowerCase();

    // Check if entry represents a VIL upload / pending status
    const isVilUploadStatus = /vil\s*(upload|uploaded|pending)/i.test(status);
    if (!isVilUploadStatus) return false;

    // Direct documents on the entry
    const entryDocs = getStatusHistoryDocuments(entry);
    const hasEntryDocs = entryDocs.length > 0;

    // VIL documents on the hospital or treatment plan
    const hospitalVilDocs = [
      ...(Array.isArray(hospital?.vilDocuments) ? hospital.vilDocuments : []),
      ...(hospital?.vilDocument ? [hospital.vilDocument] : []),
      ...(Array.isArray(info?.vilDocuments) ? info.vilDocuments : []),
      ...(info?.vilDocument ? [info.vilDocument] : []),
    ].filter(Boolean);

    // If there are NO VIL documents anywhere at all:
    // It's a default / premature status entry that was created before any VIL was actually uploaded!
    if (!hasEntryDocs && hospitalVilDocs.length === 0) {
      return true;
    }

    // If marked as default in notes without documents
    if (/default/i.test(notes) && !hasEntryDocs) {
      return true;
    }

    return false;
  };

  /** Build CRM-side status history (Awaiting → Received → Approved/Rejected) */
  const getTreatmentPlanStatusHistory = (info) => {
    const hospitals = info?.hospitals || [];
    const findHospitalForEntry = (entry) => {
      if (!entry) return undefined;
      return hospitals.find(
        (hospital) =>
          hospital?.name === entry.hospitalName ||
          hospital?.name === entry.hospital ||
          hospital?.id === entry.hospitalId ||
          hospital?._id === entry.hospitalId,
      );
    };

    const buildSyntheticCrmHistory = () =>
      hospitals.flatMap((hospital) => {
        if (!hospital) return [];
        const entries = [];
        const hasDocs = hasHospitalUploadedPlanDocument(hospital);
        const createdAt =
          hospital.requestedAt ||
          hospital.createdAt ||
          info?.createdAt ||
          hospital.statusUpdatedAt;
        const submittedAt =
          hospital.submittedAt ||
          hospital.resubmittedAt ||
          hospital.treatmentPlanDocuments?.[0]?.uploadedAt ||
          hospital.estimationDocuments?.[0]?.uploadedAt;

        // CRM-initiated: first status is Awaiting for Treatment Plan
        // Hospital-initiated: starts at Treatment Plan Received (skip awaiting)
        const isHospitalInitiated =
          info?.platform === 0 ||
          info?.initiatedFrom === "hospital" ||
          info?.source === "hospital" ||
          (hasDocs && !info?.reports?.length && !createdAt);

        if (!isHospitalInitiated || showAwaitingHospitalPlan(hospital)) {
          entries.push({
            status: CRM_TP_STATUS.AWAITING,
            hospitalName: hospital.name,
            notes: hospital.requestNotes || "Treatment plan requested from hospital",
            documents: [],
            changedAt: createdAt,
          });
        }

        if (hasDocs || hospital.status === "Approved" || hospital.status === "Rejected") {
          entries.push({
            status: CRM_TP_STATUS.RECEIVED,
            hospitalName: hospital.name,
            notes:
              hospital.treatmentPlanNotes ||
              hospital.submissionNotes ||
              "Treatment plan submitted by hospital",
            documents: getHospitalPlanDocs(hospital),
            changedAt: submittedAt || hospital.updatedAt || createdAt,
          });
        }

        if (hospital.status === "Rejected") {
          entries.push({
            status: CRM_TP_STATUS.REJECTED,
            hospitalName: hospital.name,
            notes: hospital.rejectionNotes || hospital.notes || "",
            documents: getHospitalPlanDocs(hospital),
            changedAt:
              hospital.rejectionAt ||
              hospital.statusUpdatedAt ||
              hospital.updatedAt,
          });
        }

        if (hospital.status === "Approved") {
          entries.push({
            status: CRM_TP_STATUS.APPROVED,
            hospitalName: hospital.name,
            notes: hospital.approvalNotes || hospital.notes || "",
            documents: getHospitalPlanDocs(hospital),
            changedAt:
              hospital.approvalAt ||
              hospital.statusUpdatedAt ||
              hospital.updatedAt,
          });
        }

        // After reject + resubmit (Pending again with docs): show Received again
        if (
          hospital.status === "Pending" &&
          hasDocs &&
          (hospital.resubmittedAt || hospital.rejectionAt)
        ) {
          // Received already added above; keep as current CRM state
        }

        return entries;
      });

    let rawEntries = [];

    if (Array.isArray(info?.treatmentHistory) && info.treatmentHistory.length > 0) {
      const treatmentHistoryEntries = info.treatmentHistory
        .flatMap((item) => {
          if (!item) return [];
          const entries = item?.statusHistory || [];
          const hospital =
            findHospitalForEntry(item) ||
            findHospitalForEntry(entries[0]) ||
            (item.hospitalName
              ? hospitals.find((h) => h?.name === item.hospitalName)
              : undefined);
          return entries
            .map((entry) => enrichStatusHistoryEntry(entry, hospital))
            .filter(Boolean);
        });
      if (treatmentHistoryEntries.length > 0) {
        rawEntries = filterSupersededPendingEntries(treatmentHistoryEntries);
      }
    }

    if (rawEntries.length === 0) {
      const planHistory =
        info?.statusHistory || info?.history || info?.hospitalStatusHistory;
      if (Array.isArray(planHistory) && planHistory.length > 0) {
        rawEntries = filterSupersededPendingEntries(
          planHistory
            .map((entry) =>
              enrichStatusHistoryEntry(entry, findHospitalForEntry(entry)),
            )
            .filter(Boolean),
        );
      }
    }

    if (rawEntries.length === 0) {
      const hospitalHistory = hospitals.flatMap((hospital) => {
        if (!hospital) return [];
        const entries = hospital?.statusHistory || hospital?.history || [];
        return entries
          .map((entry) => enrichStatusHistoryEntry(entry, hospital))
          .filter(Boolean);
      });
      if (hospitalHistory.length > 0) {
        rawEntries = filterSupersededPendingEntries(hospitalHistory);
      }
    }

    if (rawEntries.length === 0) {
      const decided = hospitals
        .filter((hospital) => hospital?.status && hospital.status !== "Pending")
        .map((hospital) => ({
          status: hospital.status,
          hospitalName: hospital.name,
          notes:
            hospital.approvalNotes ||
            hospital.rejectionNotes ||
            hospital.notes ||
            hospital.statusNotes ||
            "",
          documents: getHospitalPlanDocs(hospital),
          changedAt:
            hospital.rejectionAt ||
            hospital.approvalAt ||
            hospital.resubmittedAt ||
            hospital.statusUpdatedAt ||
            hospital.updatedAt ||
            hospital.createdAt,
        }));
      rawEntries = filterSupersededPendingEntries(decided);
    }

    // Fallback: synthesize CRM flow when API has no history yet
    if (rawEntries.length === 0) {
      rawEntries = buildSyntheticCrmHistory();
    } else {
      // CRM-initiated: ensure history starts with "Awaiting for Treatment Plan"
      const isCrmInitiated =
        info?.platform === 1 ||
        info?.initiatedFrom === "crm" ||
        info?.source === "crm" ||
        (Array.isArray(info?.reports) && info.reports.length > 0);

      if (isCrmInitiated) {
        const withAwaiting = [];
        const seenHospitals = new Set();
        hospitals.forEach((hospital) => {
          const key = hospital?.name || hospital?.id || hospital?._id;
          if (!key || seenHospitals.has(key)) return;
          seenHospitals.add(key);
          const hospitalEntries = rawEntries.filter(
            (e) =>
              (e.hospitalName || e.hospital) === hospital.name ||
              e.hospitalId === hospital.id ||
              e.hospitalId === hospital._id,
          );
          const hasAwaiting = hospitalEntries.some((e) => {
            const s = (e.status || "").trim();
            return (
              s === CRM_TP_STATUS.AWAITING ||
              s === "Requested" ||
              (/awaiting|requested/i.test(s) &&
                !/received|submitted|approved|rejected/i.test(s))
            );
          });
          if (!hasAwaiting) {
            withAwaiting.push({
              status: CRM_TP_STATUS.AWAITING,
              hospitalName: hospital.name,
              notes: "Treatment plan requested from hospital",
              documents: [],
              changedAt:
                hospital.requestedAt ||
                hospital.createdAt ||
                info?.createdAt,
            });
          }
        });
        rawEntries = [...withAwaiting, ...rawEntries];
      }
    }

    const cleanRawEntries = rawEntries.filter((entry) => {
      const hospital = findHospitalForEntry(entry);
      return !isDefaultVilUploadEntry(entry, hospital, info);
    });

    return cleanRawEntries.map(withCrmStatusLabel).filter(Boolean);
  };

  const getEstimationDocuments = (info) =>
    (info?.hospitals || []).flatMap((hospital) =>
      getHospitalPlanDocs(hospital).map((doc) => ({
        ...doc,
        hospitalName: hospital.name,
        hospitalId: hospital.id || hospital._id,
        notes:
          doc.notes ||
          doc.treatmentPlanNotes ||
          hospital.treatmentPlanNotes ||
          "",
      })),
    );

  const updateHospitalStatusV2 = async (info, hospitalId, payload) => {
    const response = await axios.put(
      `${baseurl}updateHospitalStatus/${info._id}/${hospitalId}?version=v2`,
      { ...payload, version: "v2" },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  };

  const approveHospitalPlan = async (info, hospitalId) => {
    const { value: notes, isConfirmed } = await Swal.fire({
      title: "Approve Treatment Plan",
      input: "textarea",
      inputLabel: "Notes",
      inputPlaceholder: "Enter approval notes...",
      text: "Approval will use treatment plan documents submitted by the hospital.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Approve",
      confirmButtonColor: "#28a745",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "Notes are required for approval";
        }
        return null;
      },
    });

    if (!isConfirmed) return;

    try {
      const response = await updateHospitalStatusV2(info, hospitalId, {
        status: "Approved",
        notes: notes.trim(),
      });

      if (response?.data?.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message || "Treatment plan approved successfully",
          confirmButtonText: "OK",
        });
        getTreatmentPlan();
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      } else {
        await Swal.fire(
          "Error",
          response?.data?.message || "Status update failed",
          "error",
        );
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Server error occurred";

      await Swal.fire("Error", errorMsg, "error");
    }
  };

  const rejectHospitalPlan = async (info, hospitalId) => {
    const { value: notes, isConfirmed } = await Swal.fire({
      title: "Reject Treatment Plan",
      input: "textarea",
      inputLabel: "Notes",
      inputPlaceholder: "Enter rejection reason...",
      showCancelButton: true,
      confirmButtonText: "Reject",
      confirmButtonColor: "#dc3545",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "Notes are required for rejection";
        }
        return null;
      },
    });

    if (!isConfirmed) return;

    try {
      const response = await updateHospitalStatusV2(info, hospitalId, {
        status: "Rejected",
        notes: notes.trim(),
      });

      if (response?.data?.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message || "Treatment plan rejected successfully",
          confirmButtonText: "OK",
        });
        getTreatmentPlan();
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      } else {
        await Swal.fire(
          "Error",
          response?.data?.message || "Status update failed",
          "error",
        );
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Server error occurred";

      await Swal.fire("Error", errorMsg, "error");
    }
  };

  // VIL & Pre-Intimation Workflow Helpers & Handlers
  const getHospitalVilStatus = (item, info) => {
    return item?.vilStatus || info?.vilStatus || "";
  };

  const hasHospitalVilUploaded = (item, info) => {
    const vil = item?.vilStatus || info?.vilStatus || "";
    if (["Pending", "Approved", "Rejected"].includes(vil)) return true;
    const docs = [
      ...(Array.isArray(item?.vilDocuments) ? item.vilDocuments : []),
      ...(item?.vilDocument ? [item.vilDocument] : []),
      ...(Array.isArray(info?.vilDocuments) ? info.vilDocuments : []),
      ...(info?.vilDocument ? [info.vilDocument] : []),
    ].filter(Boolean);
    return docs.length > 0;
  };

  const hasHospitalPreIntimationSent = (item, info) => {
    const vil = item?.vilStatus || info?.vilStatus || "";
    // If VIL document has been uploaded or reviewed, pre-intimation was already completed
    if (["Pending", "Approved", "Rejected"].includes(vil)) {
      return true;
    }
    const docs = Array.isArray(item?.vilDocuments)
      ? item.vilDocuments
      : item?.vilDocument
      ? [item.vilDocument]
      : [];
    if (docs.length > 0) {
      return true;
    }

    // Check if preIntimation object has actual dispatch metadata (not just an empty {} object from Mongoose)
    const pre = item?.preIntimation || info?.preIntimation;
    if (pre && typeof pre === "object") {
      const hasDispatchData = Boolean(
        pre.sentAt ||
        pre.sentBy ||
        (typeof pre.doctorName === "string" && pre.doctorName.trim() !== "") ||
        (typeof pre.doctor_name === "string" && pre.doctor_name.trim() !== "") ||
        pre.appointmentDate ||
        pre.appointment_date ||
        pre.isSent === true ||
        pre.sent === true ||
        pre.status === "Sent"
      );
      if (hasDispatchData) return true;
    }

    return false;
  };

  const isTreatmentCreatedFromPlan = (item, info) => {
    // If explicitly marked false by backend, it is not active/created yet
    const isExplicitlyFalse =
      item?.isTreatmentActive === false ||
      item?.isTreatmentActive === "false" ||
      info?.isTreatmentActive === false ||
      info?.isTreatmentActive === "false" ||
      item?.is_treatment_active === false ||
      item?.is_treatment_active === "false" ||
      info?.is_treatment_active === false ||
      info?.is_treatment_active === "false";

    if (isExplicitlyFalse) {
      return (
        item?.treatmentCreated === true ||
        info?.treatmentCreated === true ||
        Boolean(item?.treatmentId) ||
        Boolean(info?.treatmentId)
      );
    }

    // 1. Direct isTreatmentActive check on hospital item or treatment plan
    const isExplicitlyActive =
      item?.isTreatmentActive === true ||
      item?.isTreatmentActive === "true" ||
      item?.isTreatmentActive === 1 ||
      item?.isTreatmentActive === "1" ||
      info?.isTreatmentActive === true ||
      info?.isTreatmentActive === "true" ||
      info?.isTreatmentActive === 1 ||
      info?.isTreatmentActive === "1" ||
      item?.is_treatment_active === true ||
      item?.is_treatment_active === "true" ||
      info?.is_treatment_active === true ||
      info?.is_treatment_active === "true" ||
      item?.treatmentActive === true ||
      item?.treatmentActive === "true" ||
      info?.treatmentActive === true ||
      info?.treatmentActive === "true";

    if (isExplicitlyActive) {
      return true;
    }

    // 2. Direct treatmentCreated or treatmentId check
    if (
      item?.treatmentCreated === true ||
      item?.treatmentCreated === "true" ||
      info?.treatmentCreated === true ||
      info?.treatmentCreated === "true" ||
      Boolean(item?.treatmentId) ||
      Boolean(info?.treatmentId)
    ) {
      return true;
    }

    // 3. Fallback: check if matching treatment already exists in patient's treatments (tretment / treatmentuser)
    const planName = String(
      info?.treatment_name ||
      info?.treatment?.name ||
      info?.name ||
      ""
    ).trim().toLowerCase();

    const planId = String(info?._id || info?.id || info?.treatment_plan_id || "").trim();

    const existingTreatments = [
      ...(Array.isArray(tretment) ? tretment : []),
      ...(Array.isArray(treatmentuser) ? treatmentuser : []),
    ];

    if (existingTreatments.length > 0) {
      const match = existingTreatments.find((t) => {
        const tPlanId = String(t?.treatment_plan_id || t?.plan_id || t?.treatmentPlanId || "").trim();
        if (planId && tPlanId && planId === tPlanId) return true;
        const tName = String(t?.treatment_name || t?.name || "").trim().toLowerCase();
        if (planName && tName && planName === tName) return true;
        return false;
      });
      if (match) return true;
    }

    return false;
  };

  const getCreatedTreatmentIdFromPlan = (item, info) => {
    if (item?.treatmentId) return item.treatmentId;
    if (info?.treatmentId) return info.treatmentId;

    const planName = String(
      info?.treatment_name ||
      info?.treatment?.name ||
      info?.name ||
      ""
    ).trim().toLowerCase();

    const planId = String(info?._id || info?.id || info?.treatment_plan_id || "").trim();

    const existingTreatments = [
      ...(Array.isArray(tretment) ? tretment : []),
      ...(Array.isArray(treatmentuser) ? treatmentuser : []),
    ];

    const match = existingTreatments.find((t) => {
      const tPlanId = String(t?.treatment_plan_id || t?.plan_id || t?.treatmentPlanId || "").trim();
      if (planId && tPlanId && planId === tPlanId) return true;
      const tName = String(t?.treatment_name || t?.name || "").trim().toLowerCase();
      if (planName && tName && planName === tName) return true;
      return false;
    });

    return match?.treatment_id || match?.id || "";
  };

  const handleOpenPreIntimationModal = (info, item) => {
    setSelectedViewPreIntimation(null);
    setActiveVilPlan(info);
    setActiveVilHospital(item);
    setPreIntimationModalOpen(true);
  };

  const handleOpenDirectPreIntimation = (hospital = null) => {
    setSelectedViewPreIntimation(null);
    setActiveVilPlan(null);
    setActiveVilHospital(hospital);
    setPreIntimationModalOpen(true);
  };

  const handleOpenPreIntimationViewDirect = (item) => {
    setSelectedViewPreIntimation(item);
    setActiveVilPlan(item?.treatmentPlan || null);
    setActiveVilHospital(item?.hospitalItem || null);
    setPreIntimationViewModalOpen(true);
  };

  const handleSavePreIntimationRecord = (record) => {
    if (!record) return;
    setStandalonePreIntimations((prev) => [record, ...prev]);
  };

  const hasActualPreIntimationData = (pre) => {
    if (!pre || typeof pre !== "object") return false;
    return Boolean(
      pre.sentAt ||
      pre.sentBy ||
      pre.appointmentDate ||
      pre.appointment_date ||
      (typeof pre.doctorName === "string" && pre.doctorName.trim() !== "") ||
      (typeof pre.doctor_name === "string" && pre.doctor_name.trim() !== "") ||
      pre.status === "Sent" ||
      pre.isSent === true
    );
  };

  const getAllPatientPreIntimations = () => {
    const list = [];
    const seen = new Set();

    // 1. From treatment plans (strictly verified dispatched pre-intimations)
    (treatemntData1 || []).forEach((plan) => {
      (plan?.hospitals || []).forEach((hosp) => {
        const pre =
          hosp?.preIntimation ||
          (plan?.hospitals?.length === 1 ? plan?.preIntimation : null);
        if (hasActualPreIntimationData(pre)) {
          const hospId = String(hosp.id || hosp._id || hosp.hospitalId || "").trim();
          const apptDate = String(pre.appointmentDate || pre.appointment_date || "").trim();
          const course = String(pre.treatmentCourse || plan?.treatment?.name || "").trim().toLowerCase();
          const key = `${hospId}_${apptDate}_${course}`;

          if (!seen.has(key)) {
            seen.add(key);
            list.push({
              source: "treatmentPlan",
              treatmentPlan: plan,
              hospitalItem: hosp,
              hospitalId: hospId,
              hospitalName:
                hosp.name ||
                hosp.hospital_Name ||
                hosp.hospital?.name ||
                pre.hospitalName ||
                "Hospital",
              hospitalCity:
                hosp.city ||
                hosp.hospital?.city ||
                pre.hospitalCity ||
                "",
              hospitalEmail:
                hosp.email ||
                hosp.hospital?.email ||
                pre.hospitalEmail ||
                "",
              treatmentCourse:
                pre.treatmentCourse ||
                plan?.treatment?.name ||
                "",
              doctorName: pre.doctorName || pre.doctor_name || "",
              appointmentDate: pre.appointmentDate || pre.appointment_date || "",
              sentAt: pre.sentAt || hosp.preIntimationSentAt || null,
              sentBy: pre.sentBy || null,
              notes: pre.notes || "",
              attendants: pre.attendants || [],
              preIntimationData: pre,
            });
          }
        }
      });
    });

    // 2. From standalone pre-intimations (in-memory dispatched in current session)
    (standalonePreIntimations || []).forEach((item) => {
      if (hasActualPreIntimationData(item)) {
        const hospId = String(item.hospitalId || "").trim();
        const apptDate = String(item.appointmentDate || "").trim();
        const course = String(item.treatmentCourse || "").trim().toLowerCase();
        const key = `${hospId}_${apptDate}_${course}`;

        if (!seen.has(key)) {
          seen.add(key);
          list.push({
            source: "direct",
            treatmentPlan: null,
            hospitalItem: {
              id: item.hospitalId,
              name: item.hospitalName,
              city: item.hospitalCity,
              email: item.hospitalEmail,
            },
            hospitalId: item.hospitalId,
            hospitalName: item.hospitalName || "Hospital",
            hospitalCity: item.hospitalCity || "",
            hospitalEmail: item.hospitalEmail || "",
            treatmentCourse: item.treatmentCourse || "",
            doctorName: item.doctorName || "",
            appointmentDate: item.appointmentDate || "",
            sentAt: item.sentAt || null,
            sentBy: item.sentBy || null,
            notes: item.notes || "",
            attendants: item.attendants || [],
            preIntimationData: item,
          });
        }
      }
    });

    return list;
  };

  const handleOpenUploadVil = (info, item, isResubmit = false) => {
    const vilStatus = getHospitalVilStatus(item, info);
    const alreadyUploaded = hasHospitalVilUploaded(item, info);

    // Once VIL is uploaded, block further uploads until it is Rejected (same pattern as Treatment Plan resubmit)
    if (alreadyUploaded && vilStatus !== "Rejected") {
      Swal.fire(
        "Upload Disabled",
        "VIL is already uploaded and under review. You can Resubmit VIL only after it is rejected.",
        "info"
      );
      return;
    }

    setActiveVilPlan(info);
    setActiveVilHospital(item);
    setIsVilResubmit(isResubmit || vilStatus === "Rejected");
    setUploadVilModalOpen(true);
  };

  const handleOpenPreIntimationView = (info, item) => {
    setActiveVilPlan(info);
    setActiveVilHospital(item);
    setPreIntimationViewModalOpen(true);
  };

  const handleViewVil = (info, item) => {
    const docs = Array.isArray(item?.vilDocuments)
      ? item.vilDocuments
      : item?.vilDocument
      ? [item.vilDocument]
      : Array.isArray(info?.vilDocuments)
      ? info.vilDocuments
      : info?.vilDocument
      ? [info.vilDocument]
      : [];
    if (docs.length > 0) {
      const latestDoc = docs[docs.length - 1];
      window.open(getDocFileUrl(latestDoc), "_blank");
    } else {
      Swal.fire("No Document", "No VIL document uploaded yet", "info");
    }
  };

  const handleApproveVil = async (info, item) => {
    const { value: notes, isConfirmed } = await Swal.fire({
      title: "Approve Visa Invitation Letter (VIL)",
      input: "textarea",
      inputLabel: "Approval Notes",
      inputPlaceholder: "Enter optional approval notes...",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Approve VIL",
      confirmButtonColor: "#28a745",
      cancelButtonText: "Cancel",
    });

    if (!isConfirmed) return;

    const hospitalId =
      item?.id || item?._id || item?.hospitalId || item?.hospital?._id || item?.hospital || "";
    try {
      const response = await axios.put(
        `${baseurl}updateVILStatus/${info._id}/${hospitalId}`,
        { status: "Approved", notes: (notes || "").trim() },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          icon: "success",
          title: "VIL Approved!",
          text:
            response.data.message ||
            "Visa Invitation Letter approved successfully. You can now create the treatment.",
        });
        getTreatmentPlan();
      } else {
        Swal.fire("Error", response?.data?.message || "Status update failed", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || error?.message || "Server error occurred",
        "error"
      );
    }
  };

  const handleRejectVil = async (info, item) => {
    const { value: notes, isConfirmed } = await Swal.fire({
      title: "Reject Visa Invitation Letter (VIL)",
      input: "textarea",
      inputLabel: "Rejection Reason",
      inputPlaceholder: "Enter rejection reason...",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Reject VIL",
      confirmButtonColor: "#dc3545",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "Rejection reason is required";
        }
        return null;
      },
    });

    if (!isConfirmed) return;

    const hospitalId =
      item?.id || item?._id || item?.hospitalId || item?.hospital?._id || item?.hospital || "";
    try {
      const response = await axios.put(
        `${baseurl}updateVILStatus/${info._id}/${hospitalId}`,
        { status: "Rejected", notes: notes.trim() },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          icon: "success",
          title: "VIL Rejected",
          text: response.data.message || "Visa Invitation Letter rejected.",
        });
        getTreatmentPlan();
      } else {
        Swal.fire("Error", response?.data?.message || "Status update failed", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || error?.message || "Server error occurred",
        "error"
      );
    }
  };

  const handleCreateTreatmentFromPlan = async (info, item) => {
    const hospitalName = item?.name || "the hospital";
    const patientName = ispatient?.fullname || ispatient?.name || "the patient";

    const result = await Swal.fire({
      title: "Create Treatment?",
      html: `Are you sure you want to create treatment for <b>${patientName}</b> under <b>${hospitalName}</b>?<br/><small class="text-muted">A new Treatment record (Tx-XXXXX) will be generated in Treatment Model.</small>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create Treatment",
      confirmButtonColor: "#16a34a",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    const hospitalId =
      item?.id || item?._id || item?.hospitalId || item?.hospital?._id || item?.hospital || "";
    try {
      const response = await axios.post(
        `${baseurl}createTreatmentFromPlan/${info._id}/${hospitalId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        const newTxId =
          response?.data?.treatmentId ||
          response?.data?.data?.treatment_id ||
          response?.data?.data?.id ||
          "";
        await Swal.fire({
          icon: "success",
          title: "Treatment Created!",
          html: `Treatment <b>${newTxId || ""}</b> has been created successfully!`,
          confirmButtonText: "Go to Treatment",
          showCancelButton: true,
          cancelButtonText: "Stay Here",
        }).then((res) => {
          if (res.isConfirmed) {
            handleMainTabChange("treatment");
          }
        });
        getTreatmentPlan();
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      } else {
        Swal.fire("Error", response?.data?.message || "Failed to create treatment", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.message || error?.message || "Server error occurred",
        "error"
      );
    }
  };

  const handleclickEdAppointment = (a) => {
    navigate("/Admin/Edit-patient-treatment", {
      state: { data: a, patientid: (location?.state?.patientId || effectivePatientDetailId) },
    });
  };
  const EditButtoneditprofile = (id) => {
    setEditPatientProfile(true);
  };
  const EditButtoneditprofileClose = () => {
    setEditPatientProfile(false);
  };
  const handleupdateProfile = async () => {
    if (!imagefile) {
      Swal.fire({
        icon: "warning",
        title: "No Image Selected",
        text: "Please select an image first.",
      });
      return;
    }
    const userId = ispatient?.user_id || location.state?.user_id;
    if (!userId) {
      Swal.fire({
        icon: "warning",
        title: "User ID Missing",
        text: "Patient user ID not found.",
      });
      return;
    }
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("image", imagefile);
    try {
      const response = await axios.post(
        `${AdminBaseUrl}profile/image/update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Profile Updated!",
          text: "Patient profile updated successfully.",
          timer: 2000,
          showConfirmButton: false,
        });
        EditButtoneditprofileClose();
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        setImagefile(null);
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: response?.data?.message || "Something went wrong",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: error?.response?.data?.message || "Something went wrong",
      });
    }
  };
  const handleclickAttandpDetails = async (id) => {
    setAttendId(id);
    // console.log(id);
    try {
      const response = await axios.get(`${baseurl}getAttendeeDetails/${id}`);
      setTreatmentNamePassport(response.data);
      if (response.data.success) {
        setPassportDetails(response.data.data);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const handkekeypreees = (e) => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };
  const handledeedit = (a, b) => {
    console.log(a, b);
    setTreatmentChargeid(a.treatment_id);
    // console.log(a, b);
    setIsEditT(true);
    setHospitalCharge({
      id: b._id,
      service_name: b.service_name,
      price: b.price === 0 || b.price ? b.price : "",
      discount_percentage:
        b.discount_percentage === 0 || b.discount_percentage
          ? b.discount_percentage
          : "",
      final_price:
        b.final_price === 0 || b.final_price ? b.final_price : "",
      date: b.date ? new Date(b.date).toISOString().split("T")[0] : "",
    });
    setOpenmodalCharge(true);
    // setDataImperial(true);
  };
  const handleEditHospitalLumpCharge = (info) => {
    const details = info?.hospital?.details || {};
    setTreatmentIDa(info);
    setNoteHospital2(getPaidAmountInputValue(details.hospital_charge));
    setHospitalLumpDiscount(
      details.discount_percentage === 0 || details.discount_percentage
        ? details.discount_percentage
        : "",
    );
    setHospitalLumpFinalAmount(
      details.final_amount === 0 || details.final_amount
        ? details.final_amount
        : "",
    );
    setDataImperial(true);
  };
  const handleHospitalLumpChargeChange = (field, value) => {
    if (field === "hospital_charge") {
      setNoteHospital2(value);
      if (hospitalLumpDiscount !== "" && hospitalLumpDiscount != null) {
        setHospitalLumpFinalAmount(
          calculateFinalFromDiscount(value, hospitalLumpDiscount),
        );
      } else if (isValidPaidAmount(value) && isValidPaidAmount(hospitalLumpFinalAmount)) {
        setHospitalLumpDiscount(
          calculateDiscountFromFinal(value, hospitalLumpFinalAmount),
        );
      }
      return;
    }
    if (field === "discount_percentage") {
      setHospitalLumpDiscount(value);
      if (isValidPaidAmount(noteHospital2) && value !== "") {
        setHospitalLumpFinalAmount(
          calculateFinalFromDiscount(noteHospital2, value),
        );
      }
      return;
    }
    if (field === "final_amount") {
      setHospitalLumpFinalAmount(value);
      if (isValidPaidAmount(noteHospital2) && isValidPaidAmount(value)) {
        setHospitalLumpDiscount(
          calculateDiscountFromFinal(noteHospital2, value),
        );
      }
    }
  };
  const dataIwemperial = () => {
    setDataImperial(false);
    setNoteHospital2("");
    setHospitalLumpDiscount("");
    setHospitalLumpFinalAmount("");
    setTreatmentIDa(null);
  };
  const handleNothospitalchargeesdata = async () => {
    const hasCharge = isValidPaidAmount(noteHospital2);
    const hasDiscount =
      hospitalLumpDiscount !== "" && hospitalLumpDiscount != null;
    const hasFinal = isValidPaidAmount(hospitalLumpFinalAmount);

    if (!hasCharge && !hasDiscount && !hasFinal) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please enter hospital charge or discount details",
      });
      return;
    }

    const discountError = getDiscountValidationError(
      noteHospital2,
      hospitalLumpDiscount,
      hospitalLumpFinalAmount,
    );
    if (discountError) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: discountError,
      });
      return;
    }

    const payload = {};
    if (hasCharge) payload.hospital_charge = Number(noteHospital2);
    if (hasDiscount) payload.discount_percentage = Number(hospitalLumpDiscount);
    if (hasFinal) payload.final_amount = Number(hospitalLumpFinalAmount);

    try {
      const response = await axios.put(
        `${baseurl}updateHospitalCharge/${treatmentIDa?.treatment_id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        dataIwemperial();
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Hospital charge updated successfully.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response?.data?.message || "Something went wrong!",
      });
    }
  };
  const getSelectedTreatmentInfo = () => {
    if (!selectedTreatmentId) return null;
    return tretment?.find((t) => t.treatment_id === selectedTreatmentId);
  };
  const handleMainTabChange = (tab) => {
    setMainTab(tab);
    localStorage.setItem("patientMainTab", tab);
    setSelectedTreatmentId(null);
    setActiveSubTab("details");
  };
  const handleAction = (e, type, info, d, index) => {
    console.log(e, type, info, d);
    if (index !== undefined && index !== null) {
      setOpenIndex(index);
    }
    const tId = info.treatment_id;
    const hDetails = info.hospital.details;
    setHospitalData({
      hospital_id: info.hospital.details?.hospital_id,
      hospital_Name: info.hospital.details?.hospital_Name,
      hospital_email: info.hospital.details?.hospital_email,
    });
    const status = info.treatment_status;
    const treatmentName = info.treatment_name;
    setSelectedTreatmentId(tId);
    setTreatMentNAem(status);
    setTreatmentNameHeading(d);
    setTreatmentIdFilter(treatmentName);
    setHospitalDetails(hDetails);
    getDataapi3(tId);
    console.log(e, type, info, d);
    if (type === "attendant") {
      setActiveSubTab("attendant");
      handleclickAttandpDetails(tId);
    } else if (type === "payment") {
      setActiveSubTab("payment");
    } else if (type === "reports") {
      setActiveSubTab("reports");
    } else if (type === "hospital") {
      handleClickOpen(e, tId);
    } else if (type === "appointment") {
      setSelectedTreatmentId(tId);
      setActiveSubTab("appointment");
    } else if (type === "notes") {
      setActiveSubTab("notes");
    } else if (type === "services") {
      penModal(info, tId);
    }
  };
  //   const handleAction = (e, type, info, d) => {
  //     console.log(e, type, info, d);
  //     const tId = info.treatment_id;
  //     const hDetails = info.Hospital_details;
  //     const status = info.treatment_status;
  //     const treatmentName = info.treatment_name;
  //     setSelectedTreatmentId(tId);
  //     setTreatMentNAem(status);
  //     setTreatmentNameHeading(d);
  //     setTreatmentIdFilter(treatmentName);
  //     console.log(tId);
  //     getDataapi3(tId);
  //     if (type === "attendant") {
  //       setActiveSubTab("attendant");
  //       handleclickAttandpDetails(tId);
  //     } else if (type === "payment") {
  //       setActiveSubTab("payment");
  //     } else if (type === "reports") {
  //       setActiveSubTab("reports");
  //     } else if (type === "hospital") {
  //       handleClickOpen(e, tId);
  //     } else if (type === "appointment") {
  //       handleClickOpen1(e,tId,hDetails)
  //     } else if (type === "notes") {
  //       handleClickOpenNotes(e, tId, hDetails);
  //     } else if (type === "services") {
  //       penModal(info, tId);
  //     }
  //   };
  const handleclickdeleteplan = async (item) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        const response = await axios.delete(
          `${baseurl}deleteTreatmentPlan/${item._id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Plan deleted successfully.", "success");
          getTreatmentPlan();
        }
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error!", "Something went wrong.", "error");
    }
  };
  const handleStatusChange = async (id, status) => {
    try {
      const response = await axios.post(
        `${baseurl}update_treatment_status/${id}`,
        { status: status },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        Swal.fire("Updated!", "Status changed successfully", "success");
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      }
    } catch (error) {
      Swal.fire("Error!", "Something went wrong", "error");
    }
  };
  const getallPayments = async () => {
    try {
      const patientId = location?.state?.patientId;
      const response = await axios.get(
        `${baseurl}getAllPaymentsByPatientId/${patientId}`,
      );
      // console.log(response.data);
    } catch (error) {
      // console.log(error);
    }
  };
  const handleclickpharmacycharge = (info) => {
    console.log(info);
    setTreatmntidPharmacy(info.treatment_id);
    setPharmacyvalue({
      service_name: "",
      price: "",
      discount_percentage: "",
      final_price: "",
      date: "",
    });
    setOpenPharmacyModal(true);
    setPharmacyadd(false);
  };
  const deletepharmacy = async (info, index) => {
    console.log(info);
    // 🔥 Confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this pharmacy charge!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    // ❌ If user cancels → stop
    if (!result.isConfirmed) return;
    try {
      const response = await axios.delete(
        `${baseurl}deletePharmacyCharge/${info.treatment_id}`,
        {
          data: { index: index },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      // ✅ Success Swal
      Swal.fire({
        title: "Deleted!",
        text: response?.data?.message || "Pharmacy charge deleted successfully",
        icon: "success",
      });
      // 🔄 Optional: refresh data
      // getPharmacyData();
    } catch (error) {
      console.log(error);
      // ❌ Error Swal
      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to delete, please try again",
        icon: "error",
      });
    }
  };
  const getAllPaidTo = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllPaidTo`);
      if (response.data.success) {
        console.log(response.data.data);
        setPaidTo(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleclickpcloseacycharge = () => {
    setOpenPharmacyModal(false);
    setPharmacyadd(false);
    setPharmacyvalue({
      service_name: "",
      price: "",
      discount_percentage: "",
      final_price: "",
      date: "",
    });
  };
  const getDataapi3 = async (tId) => {
    try {
      const response = await axios.get(
        `${baseurl}getAllTreatmentData/${(location?.state?.patientId || effectivePatientDetailId)}/${tId}`,
      );
      const data = response.data.data;
      setDoctorReviewNotes(response.data.data);
      console.log("API DATA:", data);
      const filteredAppointments = (data.appointment || []).filter(
        (item) => item.treatment_id === tId,
      );
      const filteredNotes = (data.notes || []).filter(
        (item) => item.treatment_id === tId,
      );
      const filteredReports = (data.reports || []).filter(
        (item) => item.treatmentId === tId || item.treatment_id === tId,
      );
      const filteredPayments = (data.payment_details || []).filter(
        (item) => item.treatment_id === tId,
      );
      const filteredAttendants = (data.attendants || []).filter(
        (item) => item.treatment_id === tId,
      );
      setAppointmentTabel(filteredAppointments);
      setNotesTable(filteredNotes);
      setReportsFilered1(filteredReports);
      setPaymentsFilered(filteredPayments);
      setAttandantFilered(filteredAttendants);
    } catch (error) {
      console.log(error);
    }
  };
  const handledeltePayment = async (a, b, c) => {
    console.log(a, b, c);
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this payment!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${baseurl}delete_payment/${a.id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        Swal.fire(
          "Deleted!",
          response?.data?.message || "Payment deleted successfully",
          "success",
        );
      } catch (error) {
        console.log(error);
        Swal.fire(
          "Error!",
          error?.response?.data?.message || "Something went wrong",
          "error",
        );
      }
    }
  };

  const handleApprovePayment = async (paymentItem, treatmentInfo) => {
    const treatmentId = treatmentInfo?.treatment_id || paymentItem?.treatment_id || selectedTreatmentId;
    const paymentId = paymentItem?._id || paymentItem?.id;
    if (!treatmentId || !paymentId) {
      return Swal.fire("Error", "Missing treatment ID or payment ID", "error");
    }

    const payAmt = paymentItem?.paid_amount ?? paymentItem?.amount ?? 0;
    const method = paymentItem?.paymentMethod || "GOP";

    const result = await Swal.fire({
      title: "Approve Payment?",
      html: `Are you sure you want to approve this <strong>${method}</strong> payment of <strong>$${payAmt}</strong>?<br/><small class="text-muted">Once approved, this payment will be counted towards total paid and reduce due amount.</small>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Approve",
    });

    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${baseurl}approve_treatment_payment/${treatmentId}/${paymentId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        Swal.fire(
          "Approved!",
          response?.data?.message || "Payment approved successfully!",
          "success"
        );
        dispatch(
          GetPatientTreatments({
            id: (location?.state?.patientId || effectivePatientDetailId),
          })
        );
        if (selectedTreatmentId) {
          getDataapi3(selectedTreatmentId);
        }
      } catch (error) {
        console.error("Approve payment error:", error);
        Swal.fire(
          "Error!",
          error?.response?.data?.message || "Failed to approve payment",
          "error"
        );
      }
    }
  };

  const handleRejectPayment = async (paymentItem, treatmentInfo) => {
    const treatmentId = treatmentInfo?.treatment_id || paymentItem?.treatment_id || selectedTreatmentId;
    const paymentId = paymentItem?._id || paymentItem?.id;
    if (!treatmentId || !paymentId) {
      return Swal.fire("Error", "Missing treatment ID or payment ID", "error");
    }

    const payAmt = paymentItem?.paid_amount ?? paymentItem?.amount ?? 0;
    const method = paymentItem?.paymentMethod || "GOP";

    const { value: notes, isConfirmed } = await Swal.fire({
      title: "Reject Payment",
      text: `Reason for rejecting this ${method} payment of $${payAmt}:`,
      input: "textarea",
      inputPlaceholder: "Enter reason for rejection...",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Reject Payment",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "Please enter a reason for rejection!";
        }
      },
    });

    if (isConfirmed && notes) {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${baseurl}reject_treatment_payment/${treatmentId}/${paymentId}`,
          { notes: notes.trim() },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        Swal.fire(
          "Rejected!",
          response?.data?.message || "Payment has been rejected.",
          "info"
        );
        dispatch(
          GetPatientTreatments({
            id: (location?.state?.patientId || effectivePatientDetailId),
          })
        );
        if (selectedTreatmentId) {
          getDataapi3(selectedTreatmentId);
        }
      } catch (error) {
        console.error("Reject payment error:", error);
        Swal.fire(
          "Error!",
          error?.response?.data?.message || "Failed to reject payment",
          "error"
        );
      }
    }
  };

  const handleclickDeleteTreatment = async (treatment_id) => {
    console.log(treatment_id);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to recover this treatment!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6e7881",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${baseurl}deleteTreatment/${treatment_id}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );
          if (response.data.success) {
            Swal.fire("Deleted!", response.data.message, "success");
            dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
          } else {
            Swal.fire("Error!", response.data.message, "error");
          }
        } catch (error) {
          console.error(error);
          Swal.fire("Error!", "Something went wrong", "error");
        }
      }
    });
  };
  const getAttemdeData = async () => {
    try {
      const response = await axios.get(
        `${baseurl}getAttendeeDetails/${(location?.state?.patientId || effectivePatientDetailId)}`,
      );
      if (response.data.success) {
        setGetAttendeDetails(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleclickopencharge = (info) => {
    setTreatmentIdCharge(info.treatment_id);
    setHospitalCharge({
      service_name: "",
      price: "",
      discount_percentage: "",
      final_price: "",
      date: "",
    });
    setOpenmodalCharge(true);
  };
  const handleclickclosecharge = () => {
    setIsEditT(false);
    setHospitalCharge("");
    setOpenmodalCharge(false);
  };
  const addhospitalChare = (e) => {
    const { name, value } = e.target;
    setHospitalCharge((prev) =>
      updateDiscountedFields(prev, name, value, "price", "final_price"),
    );
  };
  const addchargeapiHedithspital = async () => {
    // Trim service name
    const serviceName = hospitalCharge.service_name?.trim();

    // Convert price to number
    const priceValue = Number(hospitalCharge.price);

    // Service Name Validation
    if (!serviceName) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Service name is required",
        confirmButtonColor: "#d33",
      });
      return;
    }

    // Price Validation
    if (!isValidPaidAmount(hospitalCharge.price)) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please enter a valid price",
        confirmButtonColor: "#d33",
      });
      return;
    }
    const discountError = getDiscountValidationError(
      hospitalCharge.price,
      hospitalCharge.discount_percentage,
      hospitalCharge.final_price,
    );
    if (discountError) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: discountError,
      });
      return;
    }

    const payload = {
      charge_id: hospitalCharge.id,
      service_name: serviceName,
      price: priceValue,
      ...(hospitalCharge.discount_percentage !== "" &&
        hospitalCharge.discount_percentage !== null &&
        hospitalCharge.discount_percentage !== undefined
        ? {
          discount_percentage: Number(
            hospitalCharge.discount_percentage,
          ),
        }
        : {}),
      ...(hospitalCharge.final_price !== "" &&
        hospitalCharge.final_price !== null &&
        hospitalCharge.final_price !== undefined
        ? { final_price: Number(hospitalCharge.final_price) }
        : {}),
      date: hospitalCharge.date,
    };

    try {
      const response = await axios.put(
        `${baseurl}editHospitalServiceCharge/${treatmentChargeid}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      console.log(response.data);

      handleclickclosecharge();
      setTreatmentChargeid("");

      setHospitalCharge({
        service_name: "",
        price: "",
        date: "",
      });

      dispatch(
        GetPatientTreatments({
          id: (location?.state?.patientId || effectivePatientDetailId),
        }),
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Hospital charge edited successfully!",
        confirmButtonColor: "#3085d6",
      });
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong!",
        confirmButtonColor: "#d33",
      });
    }
  };
  const addchargeapiHospital = async () => {
    const serviceName = hospitalCharge.service_name?.trim();
    const priceValue = Number(hospitalCharge.price);
    if (!serviceName) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Service name is required",
        confirmButtonColor: "#d33",
      });
      return;
    }
    if (!isValidPaidAmount(hospitalCharge.price)) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please enter a valid price",
        confirmButtonColor: "#d33",
      });
      return;
    }
    const discountError = getDiscountValidationError(
      hospitalCharge.price,
      hospitalCharge.discount_percentage,
      hospitalCharge.final_price,
    );
    if (discountError) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: discountError,
      });
      return;
    }

    const payload = {
      service_name: serviceName,
      price: priceValue,
      ...(hospitalCharge.discount_percentage !== "" &&
        hospitalCharge.discount_percentage !== null &&
        hospitalCharge.discount_percentage !== undefined
        ? {
          discount_percentage: Number(
            hospitalCharge.discount_percentage,
          ),
        }
        : {}),
      ...(hospitalCharge.final_price !== "" &&
        hospitalCharge.final_price !== null &&
        hospitalCharge.final_price !== undefined
        ? { final_price: Number(hospitalCharge.final_price) }
        : {}),
      date: hospitalCharge.date,
      platform: 1,
    };

    try {
      const response = await axios.post(
        `${baseurl}addHospitalCharge/${treatmentIdCharge}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      console.log(response.data);

      handleclickclosecharge();

      setHospitalCharge({
        service_name: "",
        price: "",
        date: "",
      });

      dispatch(
        GetPatientTreatments({
          id: (location?.state?.patientId || effectivePatientDetailId),
        }),
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Hospital charge added successfully!",
        confirmButtonColor: "#3085d6",
      });
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong!",
        confirmButtonColor: "#d33",
      });
    }
  };
  const handledeedit123222 = async (info, index) => {
    console.log(info, index);
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this hospital charge!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3b3b3b",
      confirmButtonText: "Yes, delete it!",
    });
    if (!result.isConfirmed) return;
    try {
      const response = await axios.delete(
        `${baseurl}deleteHospitalServiceCharge/${info.treatment_id}`,
        {
          data: {
            index: index, // ✅ IMPORTANT
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Hospital charge deleted successfully!",
        });
        // 🔥 refresh
        getDataapi3(info.treatment_id);
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong!",
      });
    }
  };
  // pharmacy
  const addhosppharmacyhare = (e) => {
    const { name, value } = e.target;
    setPharmacyvalue((prev) =>
      updateDiscountedFields(prev, name, value, "price", "final_price"),
    );
  };
  const addchargeapipharmacy = async () => {
    // Convert price to number
    const priceValue = Number(pharmacyvalue.price);
    if (!isValidPaidAmount(pharmacyvalue?.price)) {
      Swal.fire({
        title: "Validation Error!",
        text: "Please enter a valid price",
        icon: "error",
      });
      return;
    }
    const discountError = getDiscountValidationError(
      pharmacyvalue.price,
      pharmacyvalue.discount_percentage,
      pharmacyvalue.final_price,
    );
    if (discountError) {
      Swal.fire({
        title: "Validation Error!",
        text: discountError,
        icon: "error",
      });
      return;
    }
    const payload = {
      service_name: pharmacyvalue.service_name,
      price: priceValue,
      ...(pharmacyvalue.discount_percentage !== "" &&
        pharmacyvalue.discount_percentage !== null &&
        pharmacyvalue.discount_percentage !== undefined
        ? {
          discount_percentage: Number(
            pharmacyvalue.discount_percentage,
          ),
        }
        : {}),
      ...(pharmacyvalue.final_price !== "" &&
        pharmacyvalue.final_price !== null &&
        pharmacyvalue.final_price !== undefined
        ? { final_price: Number(pharmacyvalue.final_price) }
        : {}),
      date: pharmacyvalue.date,
    };
    try {
      const response = await axios.post(
        `${baseurl}addPharmacyCharge/${treatmntidPharmacy}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      getDataapi3(treatmntidPharmacy);
      setPharmacyvalue({
        service_name: "",
        price: "",
        date: "",
      });
      dispatch(
        GetPatientTreatments({
          id: (location?.state?.patientId || effectivePatientDetailId),
        }),
      );
      handleclickpcloseacycharge();
      // Success
      Swal.fire({
        title: "Success!",
        text: response?.data?.message || "Charge added successfully",
        icon: "success",
      });
    } catch (error) {
      console.log(error);
      // Error
      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Something went wrong, please try again",
        icon: "error",
      });
    }
  };

  //  const handleUpdatePayment = async () => {
  //   try {
  //     const formData = new FormData();

  //     formData.append("paid_amount", data.paid_amount);
  //     formData.append("paymentMethod", data.paymentMethod);
  //     formData.append("payment_Date", data.payment_Date);
  //     formData.append("paid_to", data.paid_to);
  //     formData.append("paid_for", data.paid_for);
  //     formData.append("notes", data.notes);

  //     if (selectedFiles && selectedFiles.length > 0) {
  //       selectedFiles.forEach((file) => {
  //         formData.append("attachFile", file);
  //       });
  //     }

  //     const res = await axios.put(`${baseurl}update_treatment_payment/${data.treatment_id}/${data._id}`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }, {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           },
  //         },
  //     );

  //     await Swal.fire({
  //       icon: "success",
  //       title: "Success",
  //       text: "Payment updated successfully.",
  //       timer: 2000,
  //       showConfirmButton: false,
  //     });

  //     setOpenPaymentmodal(false);

  //     console.log(res.data);

  //   } catch (error) {
  //     console.log(error);

  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text:
  //         error?.response?.data?.message ||
  //         "Something went wrong while updating payment.",
  //     });
  //   }
  // };
  const handleUpdatePayment = async () => {
    if (paymentSubmitLockRef.current) return;
    if (!isValidPaidAmount(data.paid_amount)) {
      return Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please enter a valid Paid Amount",
      });
    }
    paymentSubmitLockRef.current = true;
    try {
      const formData = new FormData();

      formData.append("paid_amount", formatPaidAmountForApi(data.paid_amount));
      formData.append("paymentMethod", data.paymentMethod);
      if (data.status) {
        formData.append("status", data.status);
      } else {
        formData.append("status", isGopPayment(data) ? "Pending" : "Approved");
      }
      formData.append("payment_Date", data.payment_Date);
      formData.append("paid_to", data.paid_to);
      formData.append("paid_for", data.paid_for);
      formData.append("notes", data.notes);

      // Attach file only if user selected new file
      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file) => {
          formData.append("attachFile", file);
        });
      }

      // Debug FormData
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const token = localStorage.getItem("token");

      const res = await axios.put(
        `${baseurl}update_treatment_payment/${data.treatment_id}/${data._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("API Response:", res);
      console.log("Response Data:", res.data);
      getDataapi3(data.treatment_id);
      await Swal.fire({
        icon: "success",
        title: "Success",
        text: res?.data?.message || "Payment updated successfully.",
        timer: 2000,
        showConfirmButton: false,
      });

      setOpenPaymentmodal(false);

      // Optional: refresh data
      // getTreatmentDetails();
    } catch (error) {
      console.log("Full Error:", error);
      console.log("Response:", error?.response);
      console.log("Error Data:", error?.response?.data);

      let errorMessage = "Something went wrong";

      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (typeof error?.response?.data === "string") {
        errorMessage = error.response.data;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: `Error ${error?.response?.status || ""}`,
        text: errorMessage,
      });
    } finally {
      paymentSubmitLockRef.current = false;
    }
  };
  const handleDownloadPDF = (index) => {
    const element = hospitalRef.current[index];

    if (!element) return;

    const options = {
      margin: 0.3,
      filename: `hospital-${index + 1}.pdf`,
      image: {
        type: "jpeg",
        quality: 1,
      },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
      },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf().set(options).from(element).save();
  };
  const handleeditpharmacycharge = (item, info) => {
    console.log(item, info);
    setTreatmntidPharmacy(info.treatment_id);
    setOpenPharmacyModal(true);
    setPharmacyadd(true);
    setPharmacyvalue({
      service_name: item.service_name,
      price: item.price === 0 || item.price ? item.price : "",
      discount_percentage:
        item.discount_percentage === 0 || item.discount_percentage
          ? item.discount_percentage
          : "",
      final_price:
        item.final_price === 0 || item.final_price ? item.final_price : "",
      date: item.date ? item.date.split("T")[0] : "",
      _id: item._id,
    });
  };
  const editpaharmacy = async () => {
    if (!isValidPaidAmount(pharmacyvalue?.price)) {
      Swal.fire({
        title: "Validation Error!",
        text: "Please enter a valid price",
        icon: "error",
      });
      return;
    }
    const discountError = getDiscountValidationError(
      pharmacyvalue.price,
      pharmacyvalue.discount_percentage,
      pharmacyvalue.final_price,
    );
    if (discountError) {
      Swal.fire({
        title: "Validation Error!",
        text: discountError,
        icon: "error",
      });
      return;
    }
    const payload = {
      service_name: pharmacyvalue.service_name,
      price: Number(pharmacyvalue.price),
      ...(pharmacyvalue.discount_percentage !== "" &&
        pharmacyvalue.discount_percentage !== null &&
        pharmacyvalue.discount_percentage !== undefined
        ? {
          discount_percentage: Number(
            pharmacyvalue.discount_percentage,
          ),
        }
        : {}),
      ...(pharmacyvalue.final_price !== "" &&
        pharmacyvalue.final_price !== null &&
        pharmacyvalue.final_price !== undefined
        ? { final_price: Number(pharmacyvalue.final_price) }
        : {}),
      date: pharmacyvalue.date,
      charge_id: pharmacyvalue._id,
    };
    try {
      const response = await axios.put(
        `${baseurl}editPharmacyCharge/${treatmntidPharmacy}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setPharmacyvalue("");
      setOpenPharmacyModal(false);
      setPharmacyadd(false);
      dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
      Swal.fire({
        title: "Success!",
        text: response?.data?.message || "Pharmacy updated successfully",
        icon: "success",
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text:
          error?.response?.data?.message ||
          "Failed to update, please try again",
        icon: "error",
      });
    }
  };
  const handlechangeGuesthouse = (e) => {
    const { name, value, type, files } = e.target;

    setFormDataGuestHouse((prev) => {
      if (type === "file") {
        return { ...prev, [name]: Array.from(files) };
      }
      return updateDiscountedFields(
        prev,
        name,
        value,
        "paymentAmount",
        "final_amount",
      );
    });
  };
  const handleClickGuesthuseedit = async () => {
    if (paymentSubmitLockRef.current) return;
    const data = formDataGuestHouse;

    console.log(data);

    // 🔥 Validation
    if (!data.guestHouseName?.trim()) {
      return Swal.fire("Error", "Guest House Name is required", "error");
    }

    if (!data.dateRangeFrom) {
      return Swal.fire("Error", "Date Range From is required", "error");
    }

    if (!data.dateRangeTo) {
      return Swal.fire("Error", "Date Range To is required", "error");
    }

    // ✅ Date logic
    if (new Date(data.dateRangeTo) < new Date(data.dateRangeFrom)) {
      return Swal.fire("Error", "End date must be after start date", "error");
    }

    if (!data.numberOfRooms) {
      return Swal.fire("Error", "Number of Rooms is required", "error");
    }

    if (!isValidPaidAmount(data.paymentAmount)) {
      return Swal.fire("Error", "Please enter a valid Payment Amount", "error");
    }
    const discountError = getDiscountValidationError(
      data.paymentAmount,
      data.discount_percentage,
      data.final_amount,
    );
    if (discountError) {
      return Swal.fire("Error", discountError, "error");
    }

    if (!data.paymentDate) {
      return Swal.fire("Error", "Payment Date is required", "error");
    }

    if (!data.notes?.trim()) {
      return Swal.fire("Error", "Notes is required", "error");
    }

    paymentSubmitLockRef.current = true;
    try {
      const formData = new FormData();

      // ✅ Normal fields
      Object.keys(data).forEach((key) => {
        if (
          key !== "invoiceFile" &&
          !(
            ["discount_percentage", "final_amount"].includes(key) &&
            data[key] === ""
          ) &&
          data[key] !== null &&
          data[key] !== undefined
        ) {
          const value =
            ["paymentAmount", "discount_percentage", "final_amount"].includes(
              key,
            )
              ? formatPaidAmountForApi(data[key])
              : data[key];
          formData.append(key, value);
        }
      });

      // ✅ Multiple files
      if (Array.isArray(data.invoiceFile) && data.invoiceFile.length > 0) {
        data.invoiceFile.forEach((file) => {
          formData.append("invoiceFile", file);
        });
      }

      // ✅ Extra params
      formData.append("treatment_id", treatmentIds1);

      formData.append("patientId", (location?.state?.patientId || effectivePatientDetailId));

      const response = await axios.post(
        `${baseurl}updateGuestHouseCharge/${data.id}`,
        formData,
      );

      if (isApiSuccess(response?.data?.success)) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message || "Data updated successfully",
        });

        patient_guesthouse(data.treatment_id);

        dispatch(
          GetPatientTreatments({
            id: (location?.state?.patientId || effectivePatientDetailId),
          }),
        );

        handleCloseguesthouse();
      } else {
        Swal.fire(
          "Error",
          response?.data?.message || "Something went wrong",
          "error",
        );
      }
    } catch (error) {
      console.error(error);

      Swal.fire(
        "Error",
        error.response?.data?.message || "Server error",
        "error",
      );
    } finally {
      paymentSubmitLockRef.current = false;
    }
  };
  const submitGuestHouseApi = async () => {
    if (paymentSubmitLockRef.current) return;
    const data = formDataGuestHouse;
    // 🔥 Validation
    if (!data.guestHouseName?.trim()) {
      return Swal.fire("Error", "Guest House Name is required", "error");
    }
    if (!data.dateRangeFrom) {
      return Swal.fire("Error", "Date Range From is required", "error");
    }
    if (!data.dateRangeTo) {
      return Swal.fire("Error", "Date Range To is required", "error");
    }
    // ✅ Date logic validation
    if (new Date(data.dateRangeTo) < new Date(data.dateRangeFrom)) {
      return Swal.fire("Error", "End date must be after start date", "error");
    }
    if (!data.numberOfRooms) {
      return Swal.fire("Error", "Number of Rooms is required", "error");
    }
    if (!isValidPaidAmount(data.paymentAmount)) {
      return Swal.fire("Error", "Please enter a valid Payment Amount", "error");
    }
    const discountError = getDiscountValidationError(
      data.paymentAmount,
      data.discount_percentage,
      data.final_amount,
    );
    if (discountError) {
      return Swal.fire("Error", discountError, "error");
    }
    if (!data.paymentDate) {
      return Swal.fire("Error", "Payment Date is required", "error");
    }
    if (!data.notes?.trim()) {
      return Swal.fire("Error", "Notes is required", "error");
    }
    // if (!data.invoiceFile) {
    //   return Swal.fire("Error", "Invoice File is required", "error");
    // }
    paymentSubmitLockRef.current = true;
    try {
      const formData = new FormData();

      Object.keys(data).forEach((key) => {
        // Multiple Files
        if (key === "invoiceFile" && Array.isArray(data[key])) {
          data[key].forEach((file) => {
            formData.append("invoiceFile", file);
          });
        } else if (
          !(
            ["discount_percentage", "final_amount"].includes(key) &&
            data[key] === ""
          ) &&
          data[key] !== null &&
          data[key] !== undefined
        ) {
          const value =
            ["paymentAmount", "discount_percentage", "final_amount"].includes(
              key,
            )
              ? formatPaidAmountForApi(data[key])
              : data[key];
          formData.append(key, value);
        }
      });
      formData.append("treatment_id", treatmentIds1);
      formData.append("patientId", (location?.state?.patientId || effectivePatientDetailId));
      const response = await axios.post(
        `${baseurl}addGuestHouseCharge`,
        formData,
      );
      if (isApiSuccess(response?.data?.success)) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message || "Data submitted successfully",
        });
        patient_guesthouse(treatmentIds1);
        dispatch(GetPatientTreatments({ id: (location?.state?.patientId || effectivePatientDetailId) }));
        handleCloseguesthouse();
      } else {
        Swal.fire(
          "Error",
          response?.data?.message || "Something went wrong",
          "error",
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Server error",
        "error",
      );
    } finally {
      paymentSubmitLockRef.current = false;
    }
  };
  const handleclickopenpopup = () => {
    setPopupopenattande(true);
  };
  const handlecliclosepup = () => {
    setPopupopenattande(false);
  };
  const handleassignAtendent = async () => {
    try {
      // 🔍 Validation
      if (!selectedAttendants || selectedAttendants.length === 0) {
        return Swal.fire({
          icon: "warning",
          title: "No Selection",
          text: "Please select at least one attendant!",
        });
      }
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You want to assign selected attendants?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, assign",
        cancelButtonText: "Cancel",
      });
      if (!result.isConfirmed) return;
      const payload = {
        AttendeeIds: selectedAttendants,
      };
      const response = await axios.post(
        `${baseurl}treatmentAssignAttendee/${selectedTreatmentId}`,
        payload,
      );
      handlecliclosepup();
      getDataapi3(selectedTreatmentId);
      // ✅ Success Swal
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Attendees assigned successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
      // 🔄 Optional Reset
      setSelectedAttendants([]);
    } catch (error) {
      console.error(error);
      // ❌ Error Swal
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong!",
      });
    }
  };
  const handleEdit = (item) => {
    setFilesData(item);
    console.log(item);
    setOpen2(true);
    setAttendedeaisledit(true);
  };
  //     const handleEditPayment = (payment, info) => {

  //   setTreatmentInfo(info);

  //   setData({
  //     _id: payment._id,
  //     paid_to: payment.paid_to?._id || "",
  //     paid_for: payment.paid_for?._id || "",
  //     paid_amount: payment.paid_amount || "",
  //     paymentMethod: payment.paymentMethod || "",
  //     payment_Date: payment.payment_Date?.split("T")[0] || "",
  //     notes: payment.notes || "",
  //   });

  //   setOpenPaymentmodal(true);
  // };
  const handleEditPayment = async (payment, info) => {
    try {
      console.log("Payment:", payment);
      console.log("Info:", info);

      // First populate form
      setData({
        _id: payment._id || "",
        treatment_id: payment.treatment_id || info?.treatment_id || "",
        paid_to: payment?.paid_to?._id || "",
        paid_for: payment?.paid_for?._id || "",
        paid_amount:
          payment?.paid_amount === 0 || payment?.paid_amount
            ? payment.paid_amount
            : "",
        paymentMethod: payment?.paymentMethod || "",
        status: payment?.status || (isGopPayment(payment) ? "Pending" : "Approved"),
        payment_Date: payment?.payment_Date
          ? payment.payment_Date.split("T")[0]
          : "",
        notes: payment?.notes || "",
      });
      setValueofappointmentpaidto(payment?.paid_to?._id || "");
      if (payment?.paid_to?._id) {
        const response = await axios.get(
          `${baseurl}/getPaidForByPaidTo/${payment.paid_to._id}`,
        );
        setDatagetapiPaidto(response.data.data || []);
      }
      setOpenPaymentmodal(true);
    } catch (error) {
      console.log("Edit Payment Error:", error);
    }
  };
  const handleDeletetrtrtrtr = async (item) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this attendee?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete",
        cancelButtonText: "Cancel",
        cancelButtonColor: "#6e7881",
      });
      if (!result.isConfirmed) return;
      await axios.delete(`${baseurl}deleteAttendee/${item?._id}`);
      getattendantnewai();
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Attendee deleted successfully.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong!",
      });
    }
  };
  const patient_guesthouse = async (treatmentId) => {
    try {
      const response = await axios.get(
        `${baseurl}getGuestHouseCharge/${(location?.state?.patientId || effectivePatientDetailId)}/${treatmentId}`,
      );
      console.log(response.data.data);
      setGuestHouseBooking(response.data.data);
      setGuestHouseBookingobj(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreateTreatment = async () => {
    const { value: treatmentName } = await Swal.fire({
      title: "Add Treatment",
      input: "text",
      inputLabel: "Treatment Name",
      inputPlaceholder: "Enter treatment name",
      showCancelButton: true,
      confirmButtonText: "Add",
      customClass: {
        container: "swal-on-top",
        popup: "swal-on-top",
      },
      didOpen: () => {
        const input = Swal.getInput();
        if (input) {
          input.focus();
        }
      },
      inputValidator: (value) => {
        if (!value) {
          return "Treatment name is required";
        }
      },
    });
    if (treatmentName) {
      const payload = { name: treatmentName };
      try {
        const response = await axios.post(
          `${AdminBaseUrl}treatment/add`,
          payload,
        );
        console.log(response.data);
        const data = await response.data;
        console.log(response, data);
        if (response.data.success === "true") {
          dispatch(GetAllTreatment());
          Swal.fire(
            "Success",
            data.message || "Treatment created successfully",
            "success",
          );
        } else {
          Swal.fire(
            "Error",
            data.message || "Failed to create treatment",
            "error",
          );
        }
      } catch (error) {
        console.log(error);
        Swal.fire(
          "Error",
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong",
          "error",
        );
      }
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row gx-3">
            <div className="col-md-12">
              <div className="topmainhd">
                <h6>
                  <i
                    class="fa-solid fa-arrow-left-long me-2"
                    onClick={() => window.history.back()}
                  ></i>
                  Patient Details
                </h6>
              </div>
            </div>
            <div className="col-md-12">
              <div className="main_content">
                <div className="row gx-0 align-items-center">
                  <div className="col-md-5">
                    <div class="profile-sidebar">
                      <div class="top">
                        <form>
                          <div class="image-wrap">
                            <div class="part-img">
                              <img
                                src={
                                  resolveCrmImageUrl(ispatient?.patient_Profile) ||
                                  avtar
                                }
                                className="pro-img"
                                alt=""
                                onError={(event) => {
                                  event.currentTarget.onerror = null;
                                  event.currentTarget.src = avtar;
                                }}
                              />
                            </div>
                            <input
                              type="file"
                              class="form-control d-none"
                              name="profile_pic"
                            />
                            <label
                              htmlFor="profileUpload"
                              className="edit-icon"
                            >
                              <FaPen
                                size={12}
                                onClick={(e) =>
                                  EditButtoneditprofile(
                                    (location?.state?.patientId || effectivePatientDetailId),
                                  )
                                }
                              />
                            </label>
                          </div>
                        </form>
                        <div class="part-txt">
                          <h6>{ispatient?.patient_name}</h6>
                          <p>
                            Patient ID :{" "}
                            {ispatient?.patientNumber
                              ? ispatient?.patientNumber
                              : ispatient?.patientId}
                          </p>
                          {(patientRegistrationDate ||
                            ispatient?.createdAt ||
                            ispatient?.created_at ||
                            ispatient?.registration_date ||
                            ispatient?.registrationDate ||
                            ispatient?.registerDate ||
                            ispatient?.date) && (
                            <p>
                              Date of Registration :{" "}
                              {(() => {
                                const regDate =
                                  patientRegistrationDate ||
                                  ispatient?.createdAt ||
                                  ispatient?.created_at ||
                                  ispatient?.registration_date ||
                                  ispatient?.registrationDate ||
                                  ispatient?.registerDate ||
                                  ispatient?.date;
                                const d = new Date(regDate);
                                return !isNaN(d.getTime())
                                  ? d.toLocaleDateString("en-GB")
                                  : String(regDate);
                              })()}
                            </p>
                          )}
                          {showModal && (
                            <div className="custom-modal">
                              <div className="modal-content">
                                {/* CLOSE BUTTON */}
                                <button
                                  className="close-btn"
                                  onClick={() => setShowModal(false)}
                                >
                                  ✖
                                </button>

                                {/* PREV BUTTON */}
                                <button
                                  onClick={() =>
                                    setCurrentIndex((prev) =>
                                      prev === 0
                                        ? (kys?.[0]?.id_proof?.length || 1) - 1
                                        : prev - 1,
                                    )
                                  }
                                >
                                  ⬅
                                </button>
                                {/* FILE VIEWER */}
                                {(() => {
                                  const currentFile =
                                    kys?.[0]?.id_proof?.[currentIndex];
                                  const fileUrl = currentFile
                                    ? `https://sisccltd.com/omca_crm/${currentFile}`
                                    : "";
                                  const isPdf = currentFile
                                    ?.toLowerCase()
                                    .endsWith(".pdf");
                                  if (!currentFile) {
                                    return <p>No file available</p>;
                                  }
                                  return isPdf ? (
                                    <iframe
                                      src={fileUrl}
                                      title="PDF Viewer"
                                      width="400px"
                                      height="400px"
                                      style={{ border: "none" }}
                                    />
                                  ) : (
                                    <img
                                      src={fileUrl}
                                      alt="Document"
                                      style={{
                                        width: "400px",
                                        height: "400px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  );
                                })()}
                                <button
                                  onClick={() =>
                                    setCurrentIndex((prev) =>
                                      prev ===
                                        (kys?.[0]?.id_proof?.length || 1) - 1
                                        ? 0
                                        : prev + 1,
                                    )
                                  }
                                >
                                  ➡
                                </button>
                                {(() => {
                                  const currentFile =
                                    kys?.[0]?.id_proof?.[currentIndex];
                                  const fileUrl = currentFile
                                    ? `https://sisccltd.com/omca_crm/${currentFile}`
                                    : "";
                                  const isPdf = currentFile
                                    ?.toLowerCase()
                                    .endsWith(".pdf");
                                  return (
                                    isPdf && (
                                      <div style={{ marginTop: "10px" }}>
                                        <a
                                          href={fileUrl}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Open PDF in new tab
                                        </a>
                                      </div>
                                    )
                                  );
                                })()}
                              </div>
                            </div>
                          )}
                          {kys?.[0]?.id_proof && kys[0].id_proof.length > 0 && (
                            <div className="d-flex gap-2">
                              <button
                                type="button"
                                className="viewbtn"
                                onClick={() => {
                                  const files = kys[0]?.id_proof;

                                  if (files && files.length > 0) {
                                    setCurrentIndex(0);
                                    setShowModal(true);
                                  } else {
                                    Swal.fire(
                                      "Error",
                                      "Document not available",
                                      "error",
                                    );
                                  }
                                }}
                              >
                                View Patient ID
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 patinfomain">
                    <div className="user-info-main">
                      {isAdmin && ispatient?.contact_no && (
                        <p>
                          <i className="fa-solid fa-phone"></i>
                          <span>
                            {ispatient.phoneCode} {ispatient.contact_no}
                          </span>
                        </p>
                      )}
                      {isAdmin && ispatient?.emergency_contact_no && (
                        <p>
                          <i className="fa-solid fa-phone"></i>
                          <span>
                            {ispatient.phoneCode}{" "}
                            {ispatient?.emergency_contact_no}
                          </span>
                        </p>
                      )}
                      {isAdmin && ispatient?.email && (
                        <p>
                          <i className="fa-solid fa-envelope"></i>
                          <span>{ispatient?.email}</span>
                        </p>
                      )}
                      <p>
                        Gender:<span>{ispatient?.gender}</span>
                      </p>
                      <p>
                        Age:<span>{ispatient?.age}</span>
                      </p>
                    </div>
                    <div className="user-info-main">
                      <p>
                        <i className="fa-solid fa-house-user"></i>
                        <span>{ispatient?.address}</span>
                      </p>
                      <p>
                        Town:<span>{ispatient?.town}</span>
                      </p>
                      <p>
                        Country:<span>{ispatient?.country}</span>
                      </p>
                      <p>
                        Patient-Status:<span>{ispatient?.patient_status}</span>
                      </p>
                      {isAdmin && ispatient?.passport_num && (
                        <p>
                          Passport Number:<span>{ispatient?.passport_num}</span>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 gy-3">
              <div className="card patient-tabs">
                <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <ul className="nav nav-tabs nav-tabs-bottom mb-0 flex-grow-1">
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "Patient_Enquiry" ? "active" : ""}`}
                        href="#attendecontent"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("Patient_Enquiry")}
                      >
                        <i className="fa-solid fa-circle-question me-2"></i>
                        Enquiries
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "Doctor-Review" ? "active" : ""}`}
                        href="#about-cont126"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("Doctor-Review")}
                      >
                        <i className="fa-solid fa-user-doctor me-2"></i>Doctor
                        Review
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "pre-intimation" ? "active" : ""}`}
                        href="#pre-intimation-content"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("pre-intimation")}
                      >
                        <i className="fa-solid fa-paper-plane me-2"></i>
                        Pre-Intimation Letter
                        {isTreatmentPlanLoading ? (
                          <span
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ width: "11px", height: "11px", borderWidth: "1.5px" }}
                          ></span>
                        ) : getAllPatientPreIntimations().length > 0 ? (
                          <span
                            className="badge bg-primary rounded-pill ms-1"
                            style={{ fontSize: "10px", padding: "2px 6px" }}
                          >
                            {getAllPatientPreIntimations().length}
                          </span>
                        ) : null}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "treatment-plans" ? "active" : ""}`}
                        href="#about-cont123"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("treatment-plans")}
                      >
                        <i className="fa-solid fa-notes-medical me-2"></i>
                        Treatment Plans
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "treatment" ? "active" : ""}`}
                        href="#about-cont"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("treatment")}
                      >
                        <i className="fa-solid fa-kit-medical me-2"></i>
                        Treatment
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "Attende" ? "active" : ""}`}
                        href="#attendecontent"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("Attende")}
                      >
                        <i className="fa-solid fa-users me-2"></i>Attendants
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "my-order" || mainTab === "my-orders" ? "active" : ""}`}
                        href="#myorderscontent"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("my-order")}
                      >
                        <i className="fa-solid fa-cart-shopping me-2"></i>My Order
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${mainTab === "physiotherapy" ? "active" : ""}`}
                        href="#physiotherapycontent"
                        data-toggle="tab"
                        onClick={() => handleMainTabChange("physiotherapy")}
                      >
                        <i className="fa-solid fa-heartbeat me-2 text-danger"></i>Physiotherapy
                      </a>
                    </li>
                  </ul>
                  <div className="card-header-actions d-flex align-items-center gap-2 my-1">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary fw-bold d-flex align-items-center gap-1 shadow-sm"
                      style={{
                        borderRadius: "20px",
                        fontSize: "12.5px",
                        padding: "5px 14px",
                        borderColor: "#0284c7",
                        color: "#0284c7",
                      }}
                      onClick={() => handleOpenDirectPreIntimation()}
                      title="Send Pre-Intimation email anytime directly to any hospital"
                    >
                      <i className="fa-solid fa-paper-plane me-1"></i> Send Pre-Intimation
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="tab-content">
                    <div
                      className={`tab-pane ${mainTab === "Doctor-Review" ? "show active" : ""}`}
                      id="about-cont126"
                    >
                      <div className="row gx-3 gy-3">
                        <div className="col-md-12">
                          {doctorReviewData1?.length === 0 ? (
                            <p className="nodtafond">
                              No Doctor Review for this patients
                            </p>
                          ) : (
                            <>
                              {doctorReviewData1?.map((info, index) => {
                                return (
                                  <div className="card doctor-card" key={index}>
                                    <div className="card-header">
                                      <h6>
                                        Doctor Reviews ({info?.enquiryId})
                                      </h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="row gx-3">
                                        <div className="col-md-2">
                                          <div className="doctorcontent">
                                            <h5>Date</h5>
                                            <p>
                                              {new Date(
                                                info?.createdAt,
                                              ).toLocaleDateString("en-GB")}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="col-md-3">
                                          <div className="doctorcontent">
                                            <h5>Subject</h5>
                                            <p>
                                              {info?.title ||
                                                info?.Title ||
                                                "No Subject Added"}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="col-md-2">
                                          <div className="doctorcontent">
                                            <h5>Notes</h5>
                                            <p>
                                              {info?.review_notes ||
                                                "No Notes Added"}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="col-md-3">
                                          <div className="doctorcontent">
                                            <h5>Recommendations</h5>
                                            <p>{info?.Recommendations}</p>
                                          </div>
                                        </div>

                                        <div className="col-md-2">
                                          <div className="doctorcontent">
                                            <h5>Reports</h5>
                                            {info?.images?.length > 0 ? (
                                              info.images.map(
                                                (report, index) => (
                                                  <div key={index}>
                                                    <a
                                                      href={`${baseu11}/${report}`}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      className="report-link"
                                                    >
                                                      View
                                                    </a>
                                                  </div>
                                                ),
                                              )
                                            ) : (
                                              <p className="nodtafond">
                                                No Report found
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row gx-3 gy-3 mt-0">
                                        {info.comments &&
                                          info.comments.length > 0 && (
                                            <div className="col-md-12">
                                              <div
                                                className="accordion"
                                                id={`commentsAccordion${index}`}
                                              >
                                                <div className="accordion-item border-0">
                                                  <h2
                                                    className="accordion-header"
                                                    id={`commentsHeading${index}`}
                                                  >
                                                    <button
                                                      className="accordion-button customstylecard collapsed"
                                                      type="button"
                                                      data-bs-toggle="collapse"
                                                      data-bs-target={`#commentsCollapse${index}`}
                                                      aria-expanded="false"
                                                      aria-controls={`commentsCollapse${index}`}
                                                    >
                                                      <span>Comments</span>
                                                    </button>
                                                  </h2>
                                                  <div
                                                    id={`commentsCollapse${index}`}
                                                    className="accordion-collapse collapse "
                                                    aria-labelledby={`commentsHeading${index}`}
                                                    data-bs-parent={`#commentsAccordion${index}`}
                                                  >
                                                    <div className="accordion-body p-0 pt-3">
                                                      <div className="row gy-3">
                                                        {info.comments.map(
                                                          (
                                                            comment,
                                                            commentIndex,
                                                          ) => (
                                                            <div
                                                              className="col-md-12"
                                                              key={
                                                                comment._id ||
                                                                commentIndex
                                                              }
                                                            >
                                                              <div className="card customstylecard">
                                                                <div className="card-body">
                                                                  <div className="note-view">
                                                                    <h3 className="card-title">
                                                                      {
                                                                        comment.user_type
                                                                      }{" "}
                                                                      Note
                                                                    </h3>
                                                                  </div>

                                                                  <div className="experience-box">
                                                                    <ul className="experience-list">
                                                                      <li className="mb-0">
                                                                        <div className="experience-user">
                                                                          <div className="before-circle"></div>
                                                                        </div>

                                                                        <div className="experience-content">
                                                                          <div className="timeline-content">
                                                                            <a
                                                                              href="#/"
                                                                              className="name"
                                                                            >
                                                                              {
                                                                                comment.Notes
                                                                              }
                                                                            </a>

                                                                            {/* Images */}
                                                                            {comment.images &&
                                                                              comment
                                                                                .images
                                                                                .length >
                                                                              0 && (
                                                                                <div className="mt-2 mb-2">
                                                                                  {comment.images.map(
                                                                                    (
                                                                                      img,
                                                                                      imgIndex,
                                                                                    ) => {
                                                                                      const fullUrl =
                                                                                        img.startsWith(
                                                                                          "http",
                                                                                        )
                                                                                          ? img
                                                                                          : image +
                                                                                          img;

                                                                                      return (
                                                                                        <button
                                                                                          key={
                                                                                            imgIndex
                                                                                          }
                                                                                          type="button"
                                                                                          className="viewbtn btn-sm me-2"
                                                                                          onClick={() =>
                                                                                            window.open(
                                                                                              fullUrl,
                                                                                              "_blank",
                                                                                            )
                                                                                          }
                                                                                        >
                                                                                          View
                                                                                          Document{" "}
                                                                                          {imgIndex +
                                                                                            1}
                                                                                        </button>
                                                                                      );
                                                                                    },
                                                                                  )}
                                                                                </div>
                                                                              )}

                                                                            <div>
                                                                              Date
                                                                              -{" "}
                                                                              {comment.Date
                                                                                ? new Date(
                                                                                  comment.Date,
                                                                                ).toLocaleDateString(
                                                                                  "en-GB",
                                                                                )
                                                                                : new Date(
                                                                                  comment.createdAt,
                                                                                ).toLocaleDateString(
                                                                                  "en-GB",
                                                                                )}
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ),
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane ${mainTab === "pre-intimation" ? "show active" : ""}`}
                      id="pre-intimation-content"
                    >
                      <div className="row gx-3">
                        <div className="col-md-12 mb-3">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 p-3 bg-light rounded border">
                            <div>
                              <h5 className="mb-1 text-dark fw-bold" style={{ fontSize: "16px" }}>
                                <i className="fa-solid fa-paper-plane text-primary me-2"></i>
                                Pre-Intimation Letters
                              </h5>
                              <p className="text-muted small mb-0">
                                Send tentative intimation letters anytime directly to any hospital separate from the treatment plan flow.
                              </p>
                            </div>
                            <button
                              onClick={() => handleOpenDirectPreIntimation()}
                              className="btn btn-primary btn-sm fw-bold d-flex align-items-center gap-2 shadow-sm"
                              style={{
                                backgroundColor: "#0284c7",
                                borderColor: "#0284c7",
                                borderRadius: "6px",
                                padding: "7px 16px",
                                fontSize: "13px",
                              }}
                            >
                              <i className="fa-solid fa-paper-plane"></i> Send Pre-Intimation Letter
                            </button>
                          </div>
                        </div>

                        <div className="col-md-12">
                          {isTreatmentPlanLoading ? (
                            <div
                              className="text-center p-5 bg-light rounded border"
                              style={{
                                minHeight: "260px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-primary mb-3"
                                role="status"
                                style={{ width: "2.8rem", height: "2.8rem" }}
                              >
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <h6 className="fw-semibold text-secondary mb-1">
                                Loading Pre-Intimation Letters...
                              </h6>
                              <small className="text-muted">
                                Fetching dispatched letters for this patient
                              </small>
                            </div>
                          ) : getAllPatientPreIntimations().length === 0 ? (
                            <div
                              className="text-center p-5 bg-light rounded border"
                              style={{
                                minHeight: "220px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: "56px",
                                  height: "56px",
                                  borderRadius: "50%",
                                  background: "#e0f2fe",
                                  color: "#0284c7",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "24px",
                                  marginBottom: "12px",
                                }}
                              >
                                <i className="fa-solid fa-paper-plane"></i>
                              </div>
                              <h6 className="fw-bold text-dark mb-1">No Pre-Intimation Letter Sent Yet</h6>
                              <p className="text-muted small mb-3" style={{ maxWidth: "440px" }}>
                                Staff can directly dispatch tentative pre-intimation letters anytime to any hospital for this patient without waiting for a treatment plan.
                              </p>
                              <button
                                onClick={() => handleOpenDirectPreIntimation()}
                                className="btn btn-sm btn-primary fw-bold shadow-sm"
                                style={{
                                  backgroundColor: "#0284c7",
                                  borderColor: "#0284c7",
                                  borderRadius: "6px",
                                  padding: "7px 18px",
                                }}
                              >
                                <i className="fa-solid fa-paper-plane me-2"></i> Send First Pre-Intimation
                              </button>
                            </div>
                          ) : (
                            <div className="row g-3">
                              {getAllPatientPreIntimations().map((item, idx) => (
                                <div className="col-md-6 col-lg-4" key={idx}>
                                  <div
                                    className="card h-100 border shadow-sm"
                                    style={{ borderRadius: "10px", overflow: "hidden" }}
                                  >
                                    <div
                                      className="card-header d-flex justify-content-between align-items-center py-2 px-3"
                                      style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}
                                    >
                                      <span className="badge bg-success" style={{ fontSize: "11px", fontWeight: 600 }}>
                                        <i className="fa-solid fa-check-circle me-1"></i> Dispatched
                                      </span>
                                      <small className="text-muted" style={{ fontSize: "11px" }}>
                                        {item.sentAt
                                          ? new Date(item.sentAt).toLocaleDateString("en-GB")
                                          : "Sent"}
                                      </small>
                                    </div>
                                    <div className="card-body p-3">
                                      <h6 className="fw-bold text-dark mb-1 text-truncate" title={item.hospitalName}>
                                        <i className="fa-solid fa-hospital text-primary me-1"></i>
                                        {item.hospitalName}
                                      </h6>
                                      {item.hospitalCity && (
                                        <div className="text-muted small mb-2">
                                          <i className="fa-solid fa-location-dot me-1 text-secondary"></i>
                                          {item.hospitalCity}
                                        </div>
                                      )}
                                      <div className="p-2 bg-light rounded small mb-2 border">
                                        <div className="d-flex justify-content-between mb-1">
                                          <span className="text-muted">Treatment:</span>
                                          <span className="fw-semibold text-truncate ms-2" style={{ maxWidth: "180px" }}>
                                            {item.treatmentCourse || "-"}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-1">
                                          <span className="text-muted">Arrival / Appt:</span>
                                          <span className="fw-semibold">
                                            {item.appointmentDate
                                              ? new Date(item.appointmentDate).toLocaleDateString("en-GB")
                                              : "-"}
                                          </span>
                                        </div>
                                        {item.doctorName && (
                                          <div className="d-flex justify-content-between">
                                            <span className="text-muted">Doctor:</span>
                                            <span className="fw-semibold text-truncate ms-2" style={{ maxWidth: "180px" }}>
                                              {item.doctorName}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      {item.attendants && item.attendants.length > 0 && (
                                        <div className="small text-muted mb-2">
                                          <i className="fa-solid fa-users me-1 text-primary"></i>
                                          {item.attendants.length} Accompanying Attendant{item.attendants.length > 1 ? "s" : ""}
                                        </div>
                                      )}
                                      <div className="d-flex gap-2 mt-3 pt-2 border-top">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-primary flex-fill fw-semibold"
                                          style={{ fontSize: "12px" }}
                                          onClick={() => handleOpenPreIntimationViewDirect(item)}
                                        >
                                          <i className="fa-solid fa-eye me-1"></i> View Letter
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-secondary fw-semibold"
                                          style={{ fontSize: "12px" }}
                                          title="Resend or send another letter to this hospital"
                                          onClick={() => handleOpenDirectPreIntimation(item.hospitalItem || item)}
                                        >
                                          <i className="fa-solid fa-rotate-right me-1"></i> Resend
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane ${mainTab === "treatment-plans" ? "show active" : ""}`}
                      id="about-cont123"
                    >
                      <div className="row gx-3">
                        <div className="col-md-12">
                          <div className="text-end">
                            <button
                              onClick={PlanTreatmentPopUp}
                              className="add-button"
                            >
                              <i className="fa fa-plus me-2"></i>Add Treatment
                              Plan
                            </button>
                          </div>
                        </div>
                        <div className="col-md-12 gy-3">
                          {treatemntData1?.length === 0 ? (
                            <p className="nodtafond">
                              No Treatment Plan Added for this patients
                            </p>
                          ) : (
                            <>
                              {treatemntData1?.map((info, index) => {
                                return (
                                  <div
                                    className={`accordian-main ${openPlanIndex === index ? "active-accordion" : ""}`}
                                    key={index}
                                  >
                                    <div className="treat-card">
                                      <div className="sectabmain">
                                        <div className="treat-id">
                                          <div className="mngetreatment">
                                            <h3 style={{ margin: 0 }}>
                                              {info?.treatment?.name}
                                            </h3>
                                            <div className="action-icon d-flex align-items-center gap-2">
                                              {!isTreatmentPlanApproved(info) && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 py-0.5 px-2 shadow-sm"
                                                  style={{ fontSize: "11px", fontWeight: "600", borderRadius: "4px" }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleOpenAddHospitalToPlan(info);
                                                  }}
                                                  title="Add more hospitals to this treatment plan"
                                                >
                                                  <i className="fa-solid fa-plus"></i> Add Hospital
                                                </button>
                                              )}
                                              {canDeleteAction && (
                                                <i
                                                  onClick={() => {
                                                    handleclickdeleteplan(info);
                                                  }}
                                                  className="fa-solid fa-trash"
                                                ></i>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="accor-icon">
                                          <div
                                            className={`collapse-icon ${openPlanIndex === index ? "rotate" : ""}`}
                                            onClick={() => {
                                              setOpenPlanIndex(
                                                openPlanIndex === index
                                                  ? null
                                                  : index,
                                              );
                                            }}
                                            aria-expanded={
                                              openPlanIndex === index
                                            }
                                          >
                                            <i className="fa-solid fa-chevron-down"></i>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className={`collapse ${openPlanIndex === index ? "show" : ""}`}
                                    >
                                      <div className="card-body">
                                        <div className="forborder pb-3 mb-3 border-bottom">
                                          <div className="row g-3">
                                            {/* Hospitals List - Full Width */}
                                            <div className="col-12">
                                              <div className="d-flex align-items-center justify-content-between mb-2">
                                                <h6 className="d-flex align-items-center gap-2 text-dark fw-bold mb-0" style={{ fontSize: "14px" }}>
                                                  <i className="fa-solid fa-hospital text-primary"></i>
                                                  <span>Hospitals &amp; Estimation Plans</span>
                                                </h6>
                                                <div className="d-flex align-items-center gap-2">
                                                  <span className="badge bg-light text-secondary border px-2 py-1" style={{ fontSize: "11px", fontWeight: "500" }}>
                                                    {info?.hospitals?.length || 0} Hospital{info?.hospitals?.length === 1 ? "" : "s"}
                                                  </span>
                                                  {!isTreatmentPlanApproved(info) && (
                                                    <button
                                                      type="button"
                                                      className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1 py-1 px-2.5 shadow-sm"
                                                      style={{
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                        borderRadius: "6px",
                                                        backgroundColor: "#0284c7",
                                                        borderColor: "#0284c7",
                                                      }}
                                                      onClick={() => handleOpenAddHospitalToPlan(info)}
                                                      title="Add more hospitals to this treatment plan"
                                                    >
                                                      <i className="fa-solid fa-plus"></i> Add Hospital
                                                    </button>
                                                  )}
                                                </div>
                                              </div>

                                              <div className="d-flex flex-column gap-2">
                                                {info?.hospitals?.map((item, i) => (
                                                  <div
                                                    key={i}
                                                    className="hospital-plan-card p-3 rounded-3"
                                                    style={{
                                                      background: "#ffffff",
                                                      border: "1px solid #e2e8f0",
                                                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "space-between",
                                                      flexWrap: "wrap",
                                                      gap: "12px",
                                                    }}
                                                  >
                                                    {/* Left: Hospital Name & Approval/Rejection Notes */}
                                                    <div className="d-flex align-items-center gap-2.5" style={{ minWidth: "220px", flex: "1 1 240px" }}>
                                                      <div
                                                        style={{
                                                          width: "38px",
                                                          height: "38px",
                                                          borderRadius: "8px",
                                                          background: "#f0f9ff",
                                                          color: "#0284c7",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent: "center",
                                                          fontSize: "16px",
                                                          flexShrink: 0,
                                                          border: "1px solid #e0f2fe",
                                                        }}
                                                      >
                                                        <i className="fa-solid fa-hospital"></i>
                                                      </div>
                                                      <div>
                                                        <div className="fw-bold text-dark" style={{ fontSize: "14px", lineHeight: "1.3" }}>
                                                          {item.name}
                                                        </div>
                                                        {item.status === "Approved" && item.approvalNotes && (
                                                          <small className="text-success d-inline-flex align-items-center gap-1 mt-1 fw-medium" style={{ fontSize: "11px" }}>
                                                            <i className="fa-solid fa-circle-check" style={{ fontSize: "10px" }}></i>
                                                            {item.approvalNotes}
                                                          </small>
                                                        )}
                                                        {item.status === "Rejected" && item.rejectionNotes && (
                                                          <small className="text-danger d-inline-flex align-items-center gap-1 mt-1 fw-medium" style={{ fontSize: "11px" }}>
                                                            <i className="fa-solid fa-circle-xmark" style={{ fontSize: "10px" }}></i>
                                                            {item.rejectionNotes}
                                                          </small>
                                                        )}
                                                      </div>
                                                    </div>

                                                    {/* Right: Status Badges & Action Buttons */}
                                                    <div className="d-flex align-items-center flex-wrap justify-content-end" style={{ flex: "2 1 auto", gap: "12px" }}>
                                                      {/* Group 1: All Status Badges */}
                                                      <div className="d-inline-flex align-items-center flex-wrap" style={{ gap: "8px" }}>
                                                        <span
                                                          className={`status-badge m-0 ${getHospitalStatusBadgeClass(
                                                            getCrmHospitalStatusLabel(item)
                                                          )}`}
                                                          style={{ fontSize: "12px", padding: "4px 10px", fontWeight: "500" }}
                                                        >
                                                          {getCrmHospitalStatusLabel(item)}
                                                        </span>

                                                        {(item.status === "Approved" ||
                                                          getCrmHospitalStatusLabel(item) === CRM_TP_STATUS.APPROVED) && (
                                                          <>
                                                            {getHospitalVilStatus(item, info) === "Approved" ? (
                                                              <span className="status-badge vil-approved m-0" style={{ fontSize: "12px", padding: "4px 10px", fontWeight: "500" }}>
                                                                <i className="fa-solid fa-circle-check me-1"></i>
                                                                VIL Approved
                                                              </span>
                                                            ) : getHospitalVilStatus(item, info) === "Pending" ? (
                                                              <span className="status-badge vil-pending m-0" style={{ fontSize: "12px", padding: "4px 10px", fontWeight: "500" }}>
                                                                <i className="fa-solid fa-clock me-1"></i>
                                                                VIL Pending Review
                                                              </span>
                                                            ) : getHospitalVilStatus(item, info) === "Rejected" ? (
                                                              <span className="status-badge vil-rejected m-0" style={{ fontSize: "12px", padding: "4px 10px", fontWeight: "500" }}>
                                                                <i className="fa-solid fa-circle-xmark me-1"></i>
                                                                VIL Rejected
                                                              </span>
                                                            ) : hasHospitalPreIntimationSent(item, info) ? (
                                                              <span className="status-badge pre-intimation m-0" style={{ fontSize: "12px", padding: "4px 10px", fontWeight: "500" }}>
                                                                <i className="fa-solid fa-paper-plane me-1"></i>
                                                                Pre-Intimation Sent
                                                              </span>
                                                            ) : null}
                                                          </>
                                                        )}
                                                      </div>

                                                      {/* Group 2: All Action Buttons */}
                                                      {(item.status === "Approved" ||
                                                        getCrmHospitalStatusLabel(item) === CRM_TP_STATUS.APPROVED) && (
                                                        <div className="d-inline-flex align-items-center flex-wrap" style={{ gap: "8px" }}>
                                                          {/* Foundation & Private PDF Buttons */}
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary py-1 px-2.5 shadow-sm"
                                                            style={{
                                                              fontSize: "12px",
                                                              fontWeight: "600",
                                                              borderRadius: "6px",
                                                              backgroundColor: "#f0f9ff",
                                                              borderColor: "#0284c7",
                                                              color: "#0369a1",
                                                            }}
                                                            onClick={() =>
                                                              handleOpenPdfModal(
                                                                item,
                                                                info,
                                                                "Foundation"
                                                              )
                                                            }
                                                            title="View Foundation Estimation PDF"
                                                          >
                                                            <i className="fa-solid fa-file-pdf text-danger me-1"></i> Foundation
                                                          </button>
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-success py-1 px-2.5 shadow-sm"
                                                            style={{
                                                              fontSize: "12px",
                                                              fontWeight: "600",
                                                              borderRadius: "6px",
                                                              backgroundColor: "#f0fdf4",
                                                              borderColor: "#16a34a",
                                                              color: "#15803d",
                                                            }}
                                                            onClick={() =>
                                                              handleOpenPdfModal(
                                                                item,
                                                                info,
                                                                "Private"
                                                              )
                                                            }
                                                            title="View Private Estimation PDF"
                                                          >
                                                            <i className="fa-solid fa-file-pdf text-danger me-1"></i> Private
                                                          </button>

                                                          {/* Action Buttons */}
                                                          {isTreatmentCreatedFromPlan(item, info) ? (
                                                            <>
                                                              {/* View-only Pre-Intimation button if pre-intimation was sent */}
                                                              {hasHospitalPreIntimationSent(item, info) && (
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-sm btn-outline-info py-1 px-2.5 shadow-sm"
                                                                  style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                  onClick={() => handleOpenPreIntimationView(info, item)}
                                                                  title="View Pre-Intimation Details"
                                                                >
                                                                  <i className="fa-solid fa-circle-info me-1"></i> Pre-Intimation
                                                                </button>
                                                              )}

                                                              {/* View-only VIL button if VIL was uploaded / approved */}
                                                              {hasHospitalVilUploaded(item, info) && (
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-sm btn-outline-secondary py-1 px-2.5 shadow-sm"
                                                                  style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                  onClick={() => handleViewVil(info, item)}
                                                                  title="View Visa Invitation Letter"
                                                                >
                                                                  <i className="fa-solid fa-file-pdf text-danger me-1"></i> View VIL
                                                                </button>
                                                              )}

                                                              <span className="status-badge treatment-created m-0" style={{ fontSize: "12px", padding: "4px 10px", fontWeight: "500" }}>
                                                                <i className="fa-solid fa-circle-check me-1"></i>
                                                                {getCreatedTreatmentIdFromPlan(item, info)
                                                                  ? `Treatment: ${getCreatedTreatmentIdFromPlan(item, info)}`
                                                                  : "Treatment Active"}
                                                              </span>

                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-primary py-1 px-3 shadow-sm fw-semibold"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleMainTabChange("treatment")}
                                                              >
                                                                <i className="fa-solid fa-arrow-right me-1"></i> View Treatment
                                                              </button>
                                                            </>
                                                          ) : getHospitalVilStatus(item, info) === "Approved" ? (
                                                            <>
                                                              {/* Pre-Intimation view-only button (don't hide!) */}
                                                              {hasHospitalPreIntimationSent(item, info) && (
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-sm btn-outline-info py-1 px-2.5 shadow-sm"
                                                                  style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                  onClick={() => handleOpenPreIntimationView(info, item)}
                                                                  title="View Pre-Intimation Details"
                                                                >
                                                                  <i className="fa-solid fa-circle-info me-1"></i> Pre-Intimation
                                                                </button>
                                                              )}

                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleViewVil(info, item)}
                                                                title="View Visa Invitation Letter"
                                                              >
                                                                <i className="fa-solid fa-file-pdf text-danger me-1"></i> View VIL
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-success py-1 px-3 shadow-sm fw-bold"
                                                                style={{ fontSize: "12px", borderRadius: "6px", backgroundColor: "#16a34a", borderColor: "#16a34a" }}
                                                                onClick={() => handleCreateTreatmentFromPlan(info, item)}
                                                              >
                                                                <i className="fa-solid fa-plus-circle me-1"></i> Create Treatment
                                                              </button>
                                                            </>
                                                          ) : getHospitalVilStatus(item, info) === "Pending" ||
                                                            (hasHospitalVilUploaded(item, info) &&
                                                              getHospitalVilStatus(item, info) !== "Approved" &&
                                                              getHospitalVilStatus(item, info) !== "Rejected") ? (
                                                            <>
                                                              {hasHospitalPreIntimationSent(item, info) && (
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-sm btn-outline-info py-1 px-2.5 shadow-sm"
                                                                  style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                  onClick={() => handleOpenPreIntimationView(info, item)}
                                                                  title="View Pre-Intimation Details"
                                                                >
                                                                  <i className="fa-solid fa-circle-info me-1"></i> Pre-Intimation
                                                                </button>
                                                              )}

                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-primary py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleViewVil(info, item)}
                                                              >
                                                                <i className="fa-solid fa-eye me-1"></i> View VIL
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-success py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", fontWeight: "600", borderRadius: "6px", backgroundColor: "#16a34a", borderColor: "#16a34a" }}
                                                                onClick={() => handleApproveVil(info, item)}
                                                              >
                                                                <i className="fa-solid fa-check me-1"></i> Approve VIL
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", fontWeight: "600", borderRadius: "6px", backgroundColor: "#dc3545", borderColor: "#dc3545" }}
                                                                onClick={() => handleRejectVil(info, item)}
                                                              >
                                                                <i className="fa-solid fa-xmark me-1"></i> Reject VIL
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                disabled
                                                                title="Upload is disabled while VIL is under review. Resubmit VIL is available only after rejection."
                                                              >
                                                                <i className="fa-solid fa-ban me-1"></i> Upload Disabled
                                                              </button>
                                                            </>
                                                          ) : getHospitalVilStatus(item, info) === "Rejected" ? (
                                                            <>
                                                              {hasHospitalPreIntimationSent(item, info) && (
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-sm btn-outline-info py-1 px-2.5 shadow-sm"
                                                                  style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                  onClick={() => handleOpenPreIntimationView(info, item)}
                                                                  title="View Pre-Intimation Details"
                                                                >
                                                                  <i className="fa-solid fa-circle-info me-1"></i> Pre-Intimation
                                                                </button>
                                                              )}

                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-warning py-1 px-2.5 shadow-sm text-dark fw-bold"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleOpenUploadVil(info, item, true)}
                                                              >
                                                                <i className="fa-solid fa-upload me-1"></i> Resubmit VIL
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleViewVil(info, item)}
                                                              >
                                                                <i className="fa-solid fa-eye me-1"></i> View Rejected VIL
                                                              </button>
                                                            </>
                                                          ) : hasHospitalPreIntimationSent(item, info) ? (
                                                            <>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-info py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleOpenPreIntimationView(info, item)}
                                                              >
                                                                <i className="fa-solid fa-circle-info me-1"></i> Pre-Intimation
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-primary py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleOpenPreIntimationModal(info, item)}
                                                              >
                                                                <i className="fa-solid fa-paper-plane me-1"></i> Resend
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", fontWeight: "600", borderRadius: "6px", backgroundColor: "#0284c7", borderColor: "#0284c7" }}
                                                                onClick={() => handleOpenUploadVil(info, item, false)}
                                                              >
                                                                <i className="fa-solid fa-upload me-1"></i> Upload VIL
                                                              </button>
                                                            </>
                                                          ) : (
                                                            <>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary py-1 px-3 shadow-sm"
                                                                style={{ fontSize: "12px", fontWeight: "600", borderRadius: "6px", backgroundColor: "#0284c7", borderColor: "#0284c7" }}
                                                                onClick={() => handleOpenPreIntimationModal(info, item)}
                                                              >
                                                                <i className="fa-solid fa-paper-plane me-1"></i> Send Pre-Intimation Letter
                                                              </button>
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary py-1 px-2.5 shadow-sm"
                                                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                                                onClick={() => handleOpenUploadVil(info, item, false)}
                                                              >
                                                                <i className="fa-solid fa-upload me-1"></i> Upload VIL
                                                              </button>
                                                            </>
                                                          )}
                                                        </div>
                                                      )}

                                                      {canReviewHospital(info, item) && (
                                                        <div className="d-inline-flex align-items-center ms-1" style={{ gap: "8px" }}>
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-success py-1 px-3 shadow-sm fw-semibold"
                                                            style={{ fontSize: "12px", borderRadius: "6px" }}
                                                            onClick={() => approveHospitalPlan(info, item.id)}
                                                          >
                                                            <i className="fa-solid fa-check me-1"></i> Approve
                                                          </button>
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger py-1 px-3 shadow-sm fw-semibold"
                                                            style={{ fontSize: "12px", borderRadius: "6px" }}
                                                            onClick={() => rejectHospitalPlan(info, item.id)}
                                                          >
                                                            <i className="fa-solid fa-xmark me-1"></i> Reject
                                                          </button>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>

                                            {/* Notes Card - col-md-6 */}
                                            <div className="col-md-6">
                                              <div
                                                className="p-3 rounded-3 h-100 d-flex flex-column justify-content-between"
                                                style={{
                                                  background: "#f8fafc",
                                                  border: "1px solid #e2e8f0",
                                                }}
                                              >
                                                <div>
                                                  <h6 className="d-flex align-items-center gap-2 mb-2 text-secondary fw-semibold" style={{ fontSize: "13px" }}>
                                                    <i className="fa-regular fa-clipboard text-primary"></i> Notes
                                                  </h6>
                                                  <p className="mb-0 text-dark" style={{ fontSize: "13px", lineHeight: "1.5", wordBreak: "break-word" }}>
                                                    {info?.notes ? (
                                                      info.notes
                                                    ) : (
                                                      <span className="text-muted fst-italic">No Notes Added</span>
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Reports Card - col-md-6 */}
                                            <div className="col-md-6">
                                              <div
                                                className="p-3 rounded-3 h-100 d-flex flex-column justify-content-between"
                                                style={{
                                                  background: "#f8fafc",
                                                  border: "1px solid #e2e8f0",
                                                }}
                                              >
                                                <div>
                                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <h6 className="d-flex align-items-center gap-2 text-secondary fw-semibold mb-0" style={{ fontSize: "13px" }}>
                                                      <i className="fa-regular fa-file-lines text-primary"></i> Reports &amp; Documents
                                                    </h6>
                                                    {info?.reports?.length > 0 && (
                                                      <span className="badge bg-white text-secondary border" style={{ fontSize: "10px" }}>
                                                        {info.reports.length} file{info.reports.length === 1 ? "" : "s"}
                                                      </span>
                                                    )}
                                                  </div>
                                                  <div className="reportviewimg d-flex align-items-center gap-2 flex-wrap mt-2">
                                                    {info?.reports?.length > 0 ? (
                                                      <>
                                                        {/* Images First */}
                                                        {info?.reports
                                                          ?.filter((report) =>
                                                            /\.(jpg|jpeg|png|gif|webp)$/i.test(
                                                              report.fileName,
                                                            ),
                                                          )
                                                          .map((report, index) => {
                                                            const fileUrl = `${image}${report.fileName}`;
                                                            return (
                                                              <div key={`img-${index}`}>
                                                                <a
                                                                  href={fileUrl}
                                                                  data-fancybox="gallery"
                                                                  data-caption={`Report ${index + 1}`}
                                                                >
                                                                  <img
                                                                    src={fileUrl}
                                                                    alt="report"
                                                                    className="viewrepot rounded border"
                                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                                  />
                                                                </a>
                                                              </div>
                                                            );
                                                          })}

                                                        {/* PDF / Other Files */}
                                                        {info?.reports
                                                          ?.filter(
                                                            (report) =>
                                                              !/\.(jpg|jpeg|png|gif|webp)$/i.test(
                                                                report.fileName,
                                                              ),
                                                          )
                                                          .map((report, index) => {
                                                            const fileUrl = `${image}${report.fileName}`;
                                                            return (
                                                              <div key={`doc-${index}`}>
                                                                <a
                                                                  href={fileUrl}
                                                                  target="_blank"
                                                                  rel="noopener noreferrer"
                                                                  className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-2 py-1.5 px-3 shadow-sm"
                                                                  style={{
                                                                    fontSize: "12px",
                                                                    borderRadius: "6px",
                                                                    backgroundColor: "#f0f9ff",
                                                                    borderColor: "#bae6fd",
                                                                    color: "#0369a1",
                                                                    fontWeight: "500",
                                                                  }}
                                                                >
                                                                  <i className="fa-solid fa-file-pdf text-danger"></i>
                                                                  <span>Report ${index + 1}</span>
                                                                  <i className="fa-solid fa-arrow-up-right-from-square ms-1" style={{ fontSize: "10px", opacity: 0.7 }}></i>
                                                                </a>
                                                              </div>
                                                            );
                                                          })}
                                                      </>
                                                    ) : (
                                                      <span className="text-muted fst-italic" style={{ fontSize: "12px" }}>
                                                        No Reports Attached
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        {/* VIL & Pre-Intimation Workflow Section for Approved Hospital(s) (only shown when treatment is NOT already active/created) */}
                                        {info?.hospitals?.filter((h) => (h.status === "Approved" || getCrmHospitalStatusLabel(h) === CRM_TP_STATUS.APPROVED) && !isTreatmentCreatedFromPlan(h, info)).map((approvedHospital, hIdx) => (
                                          <VilWorkflowSection
                                            key={`vil-section-${hIdx}`}
                                            treatmentPlan={info}
                                            hospitalItem={approvedHospital}
                                            onSendPreIntimation={() => handleOpenPreIntimationModal(info, approvedHospital)}
                                            onViewPreIntimation={() => handleOpenPreIntimationView(info, approvedHospital)}
                                            onUploadVil={() => handleOpenUploadVil(info, approvedHospital, getHospitalVilStatus(approvedHospital, info) === "Rejected")}
                                            onApproveVil={() => handleApproveVil(info, approvedHospital)}
                                            onRejectVil={() => handleRejectVil(info, approvedHospital)}
                                            onCreateTreatment={() => handleCreateTreatmentFromPlan(info, approvedHospital)}
                                            onViewTreatment={() => handleMainTabChange("treatment")}
                                          />
                                        ))}

                                        {(() => {
                                          const hospitalPlanDocs =
                                            getEstimationDocuments(info);
                                          if (hospitalPlanDocs.length === 0) {
                                            return null;
                                          }

                                          return (
                                            <div className="forborder">
                                              <div className="row gy-3 gx-3 mt-0">
                                                <div className="col-md-12">
                                                  <div className="paymntdata">
                                                    <h6>
                                                      Treatment Plan Documents
                                                    </h6>
                                                    <div className="table-responsive">
                                                      <table className="table table-no-card mb-0">
                                                        <thead>
                                                          <tr>
                                                            <th>Sr.No.</th>
                                                            <th>Hospital</th>
                                                            <th>Name</th>
                                                            <th>Document</th>
                                                            <th>Notes</th>
                                                            <th>Date</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {(() => {
                                                            const groupedEstimationDocs =
                                                              hospitalPlanDocs.reduce(
                                                                (acc, doc) => {
                                                                  const filePath =
                                                                    doc?.file ||
                                                                    doc?.fileName ||
                                                                    doc?.url ||
                                                                    "";
                                                                  if (!filePath) {
                                                                    return acc;
                                                                  }
                                                                  const key = `${doc.hospitalName || ""}_${doc.documentName || doc.name || ""}_${doc.uploadedAt || ""}`;
                                                                  if (!acc[key]) {
                                                                    acc[key] = {
                                                                      hospitalName:
                                                                        doc.hospitalName,
                                                                      documentName:
                                                                        doc.documentName ||
                                                                        doc.name,
                                                                      uploadedAt:
                                                                        doc.uploadedAt,
                                                                      notes:
                                                                        doc.notes ||
                                                                        "",
                                                                      files: [],
                                                                    };
                                                                  }
                                                                  acc[key].files.push(
                                                                    doc,
                                                                  );
                                                                  return acc;
                                                                },
                                                                {},
                                                              );
                                                            const estimationGroups =
                                                              Object.values(
                                                                groupedEstimationDocs,
                                                              );

                                                            return estimationGroups.map(
                                                              (
                                                                group,
                                                                groupIndex,
                                                              ) => (
                                                                <tr
                                                                  key={
                                                                    group.hospitalName +
                                                                    group.documentName +
                                                                    group.uploadedAt +
                                                                    groupIndex
                                                                  }
                                                                >
                                                                  <td>
                                                                    {groupIndex + 1}
                                                                  </td>
                                                                  <td>
                                                                    {group.hospitalName ||
                                                                      "-"}
                                                                  </td>
                                                                  <td>
                                                                    {group.documentName ||
                                                                      "-"}
                                                                  </td>
                                                                  <td>
                                                                    {group.files.map(
                                                                      (
                                                                        doc,
                                                                        docIndex,
                                                                      ) => {
                                                                        const fullUrl =
                                                                          getDocFileUrl(
                                                                            doc,
                                                                          );
                                                                        return (
                                                                          <button
                                                                            key={
                                                                              doc._id ||
                                                                              docIndex
                                                                            }
                                                                            type="button"
                                                                            className="viewbtn me-2"
                                                                            onClick={() =>
                                                                              window.open(
                                                                                fullUrl,
                                                                                "_blank",
                                                                              )
                                                                            }
                                                                          >
                                                                            View
                                                                          </button>
                                                                        );
                                                                      },
                                                                    )}
                                                                  </td>
                                                                  <td>
                                                                    {group.notes ||
                                                                      "-"}
                                                                  </td>
                                                                  <td>
                                                                    {group.uploadedAt
                                                                      ? new Date(
                                                                        group.uploadedAt,
                                                                      ).toLocaleDateString(
                                                                        "en-GB",
                                                                      )
                                                                      : "-"}
                                                                  </td>
                                                                </tr>
                                                              ),
                                                            );
                                                          })()}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })()}
                                        <div className="forborder">
                                          <div className="row gy-3 gx-3 mt-0">
                                            <div className="col-md-12">
                                              <div className="paymntdata">
                                                <h6>Status History</h6>
                                                {(() => {
                                                  const statusHistory =
                                                    getTreatmentPlanStatusHistory(
                                                      info,
                                                    );
                                                  return statusHistory.length >
                                                    0 ? (
                                                    <div className="table-responsive">
                                                      <table className="table table-no-card mb-0">
                                                        <thead>
                                                          <tr>
                                                            <th>Sr.No.</th>
                                                            <th>Hospital</th>
                                                            <th>Status</th>
                                                            <th>Notes</th>
                                                            <th>Document</th>
                                                            <th>Date</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {statusHistory.map(
                                                            (
                                                              entry,
                                                              historyIndex,
                                                            ) => (
                                                              <tr
                                                                key={
                                                                  entry._id ||
                                                                  `${entry.status}-${historyIndex}`
                                                                }
                                                                className={
                                                                  (
                                                                    entry.status ||
                                                                    ""
                                                                  ).trim() ===
                                                                    "Approved" ||
                                                                    (
                                                                      entry.status ||
                                                                      ""
                                                                    ).trim() ===
                                                                    CRM_TP_STATUS.APPROVED
                                                                    ? "status-history-approved-row"
                                                                    : (
                                                                      entry.status ||
                                                                      ""
                                                                    ).trim() ===
                                                                      "Rejected" ||
                                                                      (
                                                                        entry.status ||
                                                                        ""
                                                                      ).trim() ===
                                                                      CRM_TP_STATUS.REJECTED
                                                                      ? "status-history-rejected-row"
                                                                      : ""
                                                                }
                                                              >
                                                                <td>
                                                                  {historyIndex +
                                                                    1}
                                                                </td>
                                                                <td>
                                                                  {entry.hospitalName ||
                                                                    entry.hospital ||
                                                                    "-"}
                                                                </td>
                                                                <td>
                                                                  <span
                                                                    className={`status-badge ${getHospitalStatusBadgeClass(entry.status)}`}
                                                                  >
                                                                    {entry.status ||
                                                                      "-"}
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  {entry.notes ||
                                                                    entry.note ||
                                                                    entry.approvalNotes ||
                                                                    entry.rejectionNotes ||
                                                                    "-"}
                                                                </td>
                                                                <td>
                                                                  {(
                                                                    entry.documents ||
                                                                    []
                                                                  ).length > 0 ? (
                                                                    (
                                                                      entry.documents ||
                                                                      []
                                                                    ).map(
                                                                      (
                                                                        doc,
                                                                        docIndex,
                                                                      ) => (
                                                                        <button
                                                                          key={
                                                                            doc._id ||
                                                                            docIndex
                                                                          }
                                                                          type="button"
                                                                          className="viewbtn me-2"
                                                                          onClick={() =>
                                                                            window.open(
                                                                              getDocFileUrl(
                                                                                doc,
                                                                              ),
                                                                              "_blank",
                                                                            )
                                                                          }
                                                                        >
                                                                          View
                                                                        </button>
                                                                      ),
                                                                    )
                                                                  ) : (
                                                                    "-"
                                                                  )}
                                                                </td>
                                                                <td>
                                                                  {formatStatusHistoryDate(
                                                                    entry,
                                                                  )}
                                                                </td>
                                                              </tr>
                                                            ),
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  ) : (
                                                    <p className="nodtafond mb-0">
                                                      No status history found
                                                    </p>
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="forborder">
                                        <div className="row gy-3 gx-3 mt-0">
                                          {info?.documents?.length > 0 ? (
                                            <div className="col-md-12">
                                              <div className="paymntdata">
                                                <h6>
                                                  Approved Treatment Plan
                                                  Documents
                                                </h6>
                                                <div className="table-responsive">
                                                  <table className="table table-no-card mb-0">
                                                    <thead>
                                                      <tr>
                                                        <th>Sr.No.</th>
                                                        <th>Name</th>
                                                        <th>Document</th>
                                                        <th>Date</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {(() => {
                                                        const flatDocs = (
                                                          info?.documents || []
                                                        ).filter(
                                                          (doc) => doc?.file,
                                                        );
                                                        const groupedDocs =
                                                          flatDocs.reduce(
                                                            (acc, doc) => {
                                                              const key = `${doc.documentName || ""}_${doc.uploadedAt || ""}`;
                                                              if (!acc[key]) {
                                                                acc[key] = {
                                                                  documentName:
                                                                    doc.documentName,
                                                                  uploadedAt:
                                                                    doc.uploadedAt,
                                                                  files: [],
                                                                };
                                                              }
                                                              acc[
                                                                key
                                                              ].files.push(doc);
                                                              return acc;
                                                            },
                                                            {},
                                                          );
                                                        const treatmentPlanDocs =
                                                          Object.values(
                                                            groupedDocs,
                                                          );
                                                        return treatmentPlanDocs.length >
                                                          0 ? (
                                                          treatmentPlanDocs.map(
                                                            (
                                                              group,
                                                              groupIndex,
                                                            ) => (
                                                              <tr
                                                                key={
                                                                  group.documentName +
                                                                  group.uploadedAt +
                                                                  groupIndex
                                                                }
                                                              >
                                                                <td>
                                                                  {groupIndex +
                                                                    1}
                                                                </td>
                                                                <td>
                                                                  {group.documentName ||
                                                                    "-"}
                                                                </td>
                                                                <td>
                                                                  {group.files.map(
                                                                    (
                                                                      doc,
                                                                      docIndex,
                                                                    ) => {
                                                                      const fullUrl = getDocFileUrl(doc);
                                                                      return (
                                                                        <button
                                                                          key={
                                                                            doc._id ||
                                                                            docIndex
                                                                          }
                                                                          type="button"
                                                                          className="viewbtn me-2"
                                                                          onClick={() =>
                                                                            window.open(
                                                                              fullUrl,
                                                                              "_blank",
                                                                            )
                                                                          }
                                                                        >
                                                                          View
                                                                        </button>
                                                                      );
                                                                    },
                                                                  )}
                                                                </td>
                                                                <td>
                                                                  {group.uploadedAt
                                                                    ? new Date(
                                                                      group.uploadedAt,
                                                                    ).toLocaleDateString(
                                                                      "en-GB",
                                                                    )
                                                                    : "-"}
                                                                </td>
                                                              </tr>
                                                            ),
                                                          )
                                                        ) : (
                                                          <tr>
                                                            <td
                                                              colSpan="4"
                                                              style={{
                                                                textAlign:
                                                                  "center",
                                                              }}
                                                            >
                                                              No Data Found
                                                            </td>
                                                          </tr>
                                                        );
                                                      })()}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="col-md-12 gy-3">
                                              <p className="nodtafond">
                                                No treatment plan found
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      </div> */}
                                        <div className="forborder">
                                          <div className="row gx-3 mt-0">
                                            <div className="col-md-12 gy-3">
                                              <div className="paymntdata">
                                                <h6>Doctor Review</h6>
                                              </div>
                                            </div>
                                            {(() => {
                                              const planDoctorReviews =
                                                Array.isArray(info?.doctorReview)
                                                  ? info.doctorReview.filter(
                                                    Boolean,
                                                  )
                                                  : info?.doctorReview
                                                    ? [info.doctorReview]
                                                    : [];
                                              return planDoctorReviews.length >
                                                0 ? (
                                                planDoctorReviews.map(
                                                  (review, reviewIndex) => (
                                                    <div
                                                      className="col-md-12"
                                                      key={
                                                        review._id || reviewIndex
                                                      }
                                                    >
                                                      <div className="row mb-3">
                                                        <div className="col-md-2">
                                                          <div className="">
                                                            <h6>Date</h6>
                                                            <p>
                                                              {review?.createdAt
                                                                ? new Date(
                                                                  review.createdAt,
                                                                ).toLocaleDateString(
                                                                  "en-GB",
                                                                )
                                                                : "-"}
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                          <div className="">
                                                            <h6>Subject</h6>
                                                            <p>
                                                              {review?.title ||
                                                                review?.Title ||
                                                                "-"}
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                          <div className="">
                                                            <h6>Notes</h6>
                                                            <p>
                                                              {review?.review_notes ||
                                                                "-"}
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                          <div className="">
                                                            <h6>
                                                              Recommendation
                                                            </h6>
                                                            <p>
                                                              {review?.Recommendations ||
                                                                "-"}
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                          <div className="">
                                                            <h6>Documentation</h6>
                                                            {review?.images
                                                              ?.length > 0 ? (
                                                              review.images.map(
                                                                (
                                                                  img,
                                                                  imgIndex,
                                                                ) => {
                                                                  const fullUrl = getDocFileUrl(img);
                                                                  return (
                                                                    <button
                                                                      key={
                                                                        imgIndex
                                                                      }
                                                                      type="button"
                                                                      className="viewbtn me-2"
                                                                      onClick={() =>
                                                                        window.open(
                                                                          fullUrl,
                                                                          "_blank",
                                                                        )
                                                                      }
                                                                    >
                                                                      View{" "}
                                                                      {imgIndex +
                                                                        1}
                                                                    </button>
                                                                  );
                                                                },
                                                              )
                                                            ) : (
                                                              <span>-</span>
                                                            )}
                                                          </div>
                                                        </div>
                                                        {review?.comments
                                                          ?.length > 0 && (
                                                            <div className="col-md-12">
                                                              <div
                                                                className="accordion"
                                                                id={`planDoctorReviewCommentsAccordion${index}_${reviewIndex}`}
                                                              >
                                                                <div className="accordion-item border-0">
                                                                  <h2
                                                                    className="accordion-header"
                                                                    id={`planDoctorReviewCommentsHeading${index}_${reviewIndex}`}
                                                                  >
                                                                    <button
                                                                      className="accordion-button collapsed customstylecard"
                                                                      type="button"
                                                                      data-bs-toggle="collapse"
                                                                      data-bs-target={`#planDoctorReviewCommentsCollapse${index}_${reviewIndex}`}
                                                                      aria-expanded="false"
                                                                      aria-controls={`planDoctorReviewCommentsCollapse${index}_${reviewIndex}`}
                                                                    >
                                                                      <div className="d-flex align-items-center gap-2">
                                                                        <span>
                                                                          Comments
                                                                        </span>
                                                                      </div>
                                                                    </button>
                                                                  </h2>
                                                                  <div
                                                                    id={`planDoctorReviewCommentsCollapse${index}_${reviewIndex}`}
                                                                    className="accordion-collapse collapse"
                                                                    aria-labelledby={`planDoctorReviewCommentsHeading${index}_${reviewIndex}`}
                                                                    data-bs-parent={`#planDoctorReviewCommentsAccordion${index}_${reviewIndex}`}
                                                                  >
                                                                    <div className="accordion-body p-0 pt-3">
                                                                      <div className="row gy-3">
                                                                        {review.comments.map(
                                                                          (
                                                                            comment,
                                                                            commentIndex,
                                                                          ) => (
                                                                            <div
                                                                              className="col-md-12"
                                                                              key={
                                                                                comment._id ||
                                                                                commentIndex
                                                                              }
                                                                            >
                                                                              <div className="card customstylecard">
                                                                                <div className="card-body">
                                                                                  <div className="note-view">
                                                                                    <h3 className="card-title">
                                                                                      {
                                                                                        comment.user_type
                                                                                      }{" "}
                                                                                      Note
                                                                                    </h3>
                                                                                  </div>
                                                                                  <div className="experience-box">
                                                                                    <ul className="experience-list">
                                                                                      <li className="mb-0">
                                                                                        <div className="experience-user">
                                                                                          <div className="before-circle"></div>
                                                                                        </div>
                                                                                        <div className="experience-content">
                                                                                          <div className="timeline-content">
                                                                                            <a
                                                                                              href="#/"
                                                                                              className="name"
                                                                                            >
                                                                                              {
                                                                                                comment.Notes
                                                                                              }
                                                                                            </a>
                                                                                            {comment
                                                                                              .images
                                                                                              ?.length >
                                                                                              0 && (
                                                                                                <div className="mt-2 mb-2">
                                                                                                  {comment.images.map(
                                                                                                    (
                                                                                                      img,
                                                                                                      imgIndex,
                                                                                                    ) => {
                                                                                                      const fullUrl = getDocFileUrl(img);
                                                                                                      return (
                                                                                                        <button
                                                                                                          key={
                                                                                                            imgIndex
                                                                                                          }
                                                                                                          type="button"
                                                                                                          className="viewbtn btn-sm me-2"
                                                                                                          onClick={() =>
                                                                                                            window.open(
                                                                                                              fullUrl,
                                                                                                              "_blank",
                                                                                                            )
                                                                                                          }
                                                                                                        >
                                                                                                          View
                                                                                                          Document{" "}
                                                                                                          {imgIndex +
                                                                                                            1}
                                                                                                        </button>
                                                                                                      );
                                                                                                    },
                                                                                                  )}
                                                                                                </div>
                                                                                              )}
                                                                                            <div>
                                                                                              {comment.Date
                                                                                                ? new Date(
                                                                                                  comment.Date,
                                                                                                ).toLocaleDateString(
                                                                                                  "en-GB",
                                                                                                )
                                                                                                : new Date(
                                                                                                  comment.createdAt,
                                                                                                ).toLocaleDateString(
                                                                                                  "en-GB",
                                                                                                )}
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>
                                                                                      </li>
                                                                                    </ul>
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          ),
                                                                        )}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )}
                                                      </div>
                                                    </div>
                                                  ),
                                                )
                                              ) : (
                                                <div className="col-md-12 gy-3">
                                                  <p className="nodtafond">
                                                    No Data Found
                                                  </p>
                                                </div>
                                              );
                                            })()}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane ${mainTab === "treatment" ? "show active" : ""}`}
                      id="about-cont"
                    >
                      <div className="row gx-3">
                        <div className="col-md-12">
                          <div className="text-end">
                            <button
                              onClick={PatientDetailButton}
                              className="add-button"
                            >
                              <i className="fa fa-plus me-2"></i>Add Treatment
                            </button>
                          </div>
                        </div>
                        <div className="col-md-12 gy-3">
                          {tretment?.length === 0 ? (
                            <p className="nodtafond">
                              No Treatment Added for this patients
                            </p>
                          ) : (
                            <>
                              {tretment?.map((info, index) => {
                                return (
                                  <div
                                    className={`accordian-main ${openIndex === index ? "active-accordion" : ""}`}
                                    id="accordion"
                                  >
                                    <div className="treat-card">
                                      <div className="sectabmain">
                                        <div className="treat-id">
                                          <div className="mngetreatment">
                                            <h3
                                              onClick={() => {
                                                setActiveSubTab("details");
                                                setSelectedTreatmentId(
                                                  info.treatment_id,
                                                );
                                                setOpenIndex(index);
                                              }}
                                              style={{
                                                cursor: "pointer",
                                                margin: 0,
                                              }}
                                            >
                                              {info.treatment_name}{" "}
                                            </h3>
                                            <div className="action-icon">
                                              {canDeleteAction && (
                                                <i
                                                  className="fa-solid fa-trash"
                                                  onClick={() => {
                                                    handleclickDeleteTreatment(
                                                      info.treatment_id,
                                                    );
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                ></i>
                                              )}
                                            </div>
                                          </div>
                                          <select
                                            className="selectstatus"
                                            value={getMappedStatus(
                                              info?.treatment_status,
                                            )}
                                            onChange={(e) =>
                                              handleStatusChange(
                                                info.treatment_id,
                                                e.target.value,
                                              )
                                            }
                                          >
                                            <option value="">
                                              Select Status
                                            </option>
                                            <option value="Assigned to Hospital">
                                              Assigned to Hospital
                                            </option>
                                            <option value="In Process">
                                              In Process
                                            </option>
                                            <option value="Completed">
                                              Completed
                                            </option>
                                            <option value="Cancelled">
                                              Cancelled
                                            </option>
                                            <option disabled>
                                              --- Hospital Status ---
                                            </option>
                                            <option value="Admitted">
                                              Admitted
                                            </option>
                                            <option value="Under Review">
                                              Under Review
                                            </option>
                                            <option value="Under Investigation">
                                              Under Investigation
                                            </option>
                                            <option value="Under Surgery">
                                              Under Surgery
                                            </option>
                                            <option value="Under Recovery">
                                              Under Recovery
                                            </option>
                                            <option value="Discharged">
                                              Discharged
                                            </option>
                                          </select>
                                        </div>
                                        <div className="accor-icon">
                                          <div className="">
                                            <ul className="nav nav-tabs treat-tabs">
                                              <li className="nav-item">
                                                <button
                                                  className={`nav-link ${activeSubTab === "attendant" && selectedTreatmentId === info.treatment_id ? "active" : ""}`}
                                                  onClick={(e) => {
                                                    handleAction(
                                                      e,
                                                      "attendant",
                                                      info,
                                                      info.treatment_name,
                                                      index,
                                                    );
                                                  }}
                                                >
                                                  Assign Attendant
                                                </button>
                                              </li>
                                              <li className="nav-item">
                                                <button
                                                  className={`nav-link ${activeSubTab === "payment" && selectedTreatmentId === info.treatment_id ? "active" : ""}`}
                                                  onClick={(e) => {
                                                    handleAction(
                                                      e,
                                                      "payment",
                                                      info,
                                                      info.treatment_name,
                                                      index,
                                                    );
                                                  }}
                                                >
                                                  Payment Details
                                                </button>
                                              </li>
                                              <li className="nav-item">
                                                <button
                                                  className={`nav-link ${activeSubTab === "reports" && selectedTreatmentId === info.treatment_id ? "active" : ""}`}
                                                  onClick={(e) => {
                                                    handleAction(
                                                      e,
                                                      "reports",
                                                      info,
                                                      info.treatment_name,
                                                      index,
                                                    );
                                                  }}
                                                >
                                                  Reports
                                                </button>
                                              </li>
                                              <li className="nav-item">
                                                <button
                                                  className={`nav-link ${activeSubTab === "appointment" && selectedTreatmentId === info.treatment_id ? "active" : ""}`}
                                                  onClick={(e) =>
                                                    handleAction(
                                                      e,
                                                      "appointment",
                                                      info,
                                                      info.treatment_name,
                                                      index,
                                                    )
                                                  }
                                                >
                                                  Appointment
                                                </button>
                                              </li>
                                              <li className="nav-item">
                                                <button
                                                  className={`nav-link ${activeSubTab === "notes" && selectedTreatmentId === info.treatment_id ? "active" : ""}`}
                                                  onClick={(e) =>
                                                    handleAction(
                                                      e,
                                                      "notes",
                                                      info,
                                                      info.treatment_name,
                                                      index,
                                                    )
                                                  }
                                                >
                                                  Notes
                                                </button>
                                              </li>
                                              {!info?.hospital?.details
                                                ?.hospital_Name && (
                                                  <li className="nav-item">
                                                    <button
                                                      className="nav-link"
                                                      onClick={(e) =>
                                                        handleAction(
                                                          e,
                                                          "hospital",
                                                          info,
                                                          info.treatment_name,
                                                          index,
                                                        )
                                                      }
                                                    >
                                                      + Add Hospital
                                                    </button>
                                                  </li>
                                                )}
                                            </ul>
                                          </div>
                                          <div
                                            className={`collapse-icon ${openIndex === index ? "rotate" : ""}`}
                                            onClick={() => {
                                              const isOpening =
                                                openIndex !== index;
                                              setOpenIndex(
                                                isOpening ? index : null,
                                              );
                                              if (isOpening) {
                                                patient_guesthouse(
                                                  info.treatment_id,
                                                );
                                              }
                                            }}
                                            aria-expanded={openIndex === index}
                                          >
                                            <i className="fa-solid fa-chevron-down"></i>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className={`collapse ${openIndex === index ? "show" : ""}`}
                                    >
                                      {(activeSubTab === "details" || selectedTreatmentId !== info.treatment_id) ? (
                                        <>
                                          <div className="row gx-3 gy-3">
                                            {/* for hospital separate data */}
                                            <div className="col-md-12">
                                              <div
                                                className="card customstylecard"
                                                style={{
                                                  border: "1px solid #0ba6df",
                                                }}
                                              >
                                                <div
                                                  className="card-header d-flex justify-content-between align-items-center"
                                                  style={{
                                                    backgroundColor: "#E8F8FD",
                                                    borderBottom:
                                                      "1px solid #0ba6df",
                                                  }}
                                                >
                                                  <div className="d-flex gap-2 align-items-center">
                                                    <h6>
                                                      Hospital Name:{" "}
                                                      {
                                                        info?.hospital?.details
                                                          ?.hospital_Name
                                                      }
                                                    </h6>
                                                    <div className="action-icon">
                                                      {info?.hospital?.details
                                                        ?.hospital_Name &&
                                                        info?.hospital?.charges
                                                          ?.length === 0 &&
                                                        canDeleteAction && (
                                                          <i
                                                            className="fa-solid fa-trash"
                                                            onClick={() =>
                                                              handledelete(
                                                                info,
                                                                index,
                                                              )
                                                            }
                                                          ></i>
                                                        )}
                                                    </div>
                                                  </div>
                                                  {hospitalStatuses.includes(
                                                    info?.treatment_status,
                                                  ) && (
                                                      <h6>
                                                        Hospital Status:{" "}
                                                        {info?.treatment_status}
                                                      </h6>
                                                    )}
                                                  <div className="">
                                                    <button
                                                      type="button"
                                                      className="border-0 bg-transparent"
                                                      onClick={() => {
                                                        handleDownloadPDF(
                                                          index,
                                                        );
                                                      }}
                                                    >
                                                      <i className="fa-solid fa-download"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="card-body">
                                                  <div
                                                    ref={(el) =>
                                                    (hospitalRef.current[
                                                      index
                                                    ] = el)
                                                    }
                                                  >
                                                    <div className="row gx-3 gy-3">

                                                      <div className="col-md-12">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list">
                                                            <h6>Treatment</h6>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Name
                                                                    </th>
                                                                    <th>
                                                                      Hospital ID
                                                                    </th>
                                                                    <th>
                                                                      Charge
                                                                    </th>
                                                                    <th>
                                                                      Discount
                                                                    </th>
                                                                    <th>
                                                                      Final
                                                                      Charge
                                                                    </th>
                                                                    <th>
                                                                      Date
                                                                    </th>
                                                                    <th>
                                                                      Time
                                                                    </th>
                                                                    <th className="action-col pdf-hide">
                                                                      Action
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  <tr
                                                                    key={index}
                                                                  >
                                                                    <td>
                                                                      {info?.treatment_name ||
                                                                        "-"}
                                                                    </td>
                                                                    <td>
                                                                      {info?.hospital_ID ||
                                                                        "-"}
                                                                    </td>
                                                                    <td>
                                                                      {getMoneyDisplayValue(
                                                                        info?.total_charge ??
                                                                        info?.treatment_course_fee,
                                                                      )}
                                                                    </td>
                                                                    <td>
                                                                      {getDiscountPercentageDisplay(
                                                                        info?.discount_percentage,
                                                                      )}
                                                                    </td>
                                                                    <td>
                                                                      {getFinalChargeDisplay(
                                                                        {
                                                                          ...info,
                                                                          total_charge:
                                                                            info?.total_charge ??
                                                                            info?.treatment_course_fee,
                                                                        },
                                                                        "final_amount",
                                                                        "total_charge",
                                                                      )}
                                                                    </td>
                                                                    <td>
                                                                      {new Date(
                                                                        info.treatment_created_at,
                                                                      ).toLocaleDateString(
                                                                        "en-GB",
                                                                      )}
                                                                    </td>
                                                                    <td>
                                                                      {info.treatment_created_at
                                                                        ? new Date(
                                                                          info.treatment_created_at,
                                                                        ).toLocaleTimeString(
                                                                          "en-US",
                                                                          {
                                                                            hour: "2-digit",
                                                                            minute:
                                                                              "2-digit",
                                                                          },
                                                                        )
                                                                        : "-"}
                                                                    </td>
                                                                    <td className="pdf-hide">
                                                                      <div className="action-icon">
                                                                        <i
                                                                          className="fa-solid fa-pen-to-square"
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                          onClick={() => {
                                                                            handleclickEdAppointment(
                                                                              info,
                                                                            );
                                                                          }}
                                                                        ></i>
                                                                      </div>
                                                                    </td>
                                                                  </tr>
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list d-flex justify-content-between">
                                                            <div>
                                                              <h6>
                                                                Hospital Charges
                                                              </h6>
                                                            </div>
                                                            <div className="pdf-hide">
                                                              <button
                                                                className="add-button approvebtn"
                                                                onClick={() => {
                                                                  handleclickopencharge(
                                                                    info,
                                                                  );
                                                                }}
                                                              >
                                                                Add Charge
                                                              </button>
                                                            </div>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Service
                                                                      Name
                                                                    </th>
                                                                    <th>
                                                                      Price
                                                                    </th>
                                                                    <th>
                                                                      Discount
                                                                    </th>
                                                                    <th>
                                                                      Final
                                                                      Charge
                                                                    </th>
                                                                    <th>
                                                                      Date
                                                                    </th>
                                                                    <th className="action-col pdf-hide">
                                                                      Action
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {info
                                                                    ?.hospital
                                                                    ?.charges
                                                                    ?.length >
                                                                    0 ? (
                                                                    info?.hospital?.charges?.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => {
                                                                        const createdAt =
                                                                          item?.date;

                                                                        return (
                                                                          <tr
                                                                            key={
                                                                              index
                                                                            }
                                                                          >
                                                                            <td>
                                                                              {item?.service_name ||
                                                                                "-"}
                                                                            </td>
                                                                            <td>
                                                                              {getMoneyDisplayValue(
                                                                                item?.price,
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {getDiscountPercentageDisplay(
                                                                                item?.discount_percentage,
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {getFinalChargeDisplay(
                                                                                item,
                                                                                "final_price",
                                                                                "price",
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {createdAt
                                                                                ? new Date(
                                                                                  createdAt,
                                                                                ).toLocaleDateString(
                                                                                  "en-GB",
                                                                                )
                                                                                : "-"}
                                                                            </td>
                                                                            <td className="pdf-hide">
                                                                              <div className="action-icon">
                                                                                <i
                                                                                  className="fa-solid fa-pen-to-square me-2"
                                                                                  style={{
                                                                                    cursor:
                                                                                      "pointer",
                                                                                  }}
                                                                                  onClick={() =>
                                                                                    handledeedit(
                                                                                      info,
                                                                                      item,
                                                                                    )
                                                                                  }
                                                                                ></i>
                                                                                {canDeleteAction && (
                                                                                    <i
                                                                                      className="fa-solid fa-trash"
                                                                                      style={{
                                                                                        cursor:
                                                                                          "pointer",
                                                                                      }}
                                                                                      onClick={() =>
                                                                                        handledeedit123222(
                                                                                          info,
                                                                                          index,
                                                                                        )
                                                                                      }
                                                                                    ></i>
                                                                                  )}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      },
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan="6"
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="total-amount">
                                                          <h6 className="mb-0">
                                                            Total Amount:
                                                          </h6>
                                                          <p>
                                                            $
                                                            {
                                                              info?.hospital
                                                                ?.totalAmount
                                                            }
                                                          </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list">
                                                            <h6>Payment</h6>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Payment
                                                                      Amount
                                                                    </th>
                                                                    <th>
                                                                      Payment
                                                                      Date
                                                                    </th>
                                                                    <th>
                                                                      Payment
                                                                      Method
                                                                    </th>
                                                                    <th>Status</th>
                                                                    <th>
                                                                      Notes
                                                                    </th>
                                                                    <th>
                                                                      Paid To
                                                                    </th>
                                                                    <th>
                                                                      Paid For
                                                                    </th>
                                                                    <th>
                                                                      Document
                                                                    </th>
                                                                    <th>Pdf</th>
                                                                    {canDeleteAction && (
                                                                        <th>
                                                                          Action
                                                                        </th>
                                                                      )}
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {info
                                                                    ?.hospital
                                                                    ?.payments &&
                                                                    info?.hospital
                                                                      ?.payments
                                                                      .length >
                                                                    0 ? (
                                                                    info?.hospital?.payments.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => {
                                                                        return (
                                                                          <tr
                                                                            key={
                                                                              item.id
                                                                            }
                                                                          >
                                                                            <td>
                                                                              $
                                                                              {item?.paid_amount ===
                                                                                0 ||
                                                                                item?.paid_amount
                                                                                ? item.paid_amount
                                                                                : "-"}
                                                                            </td>

                                                                            <td>
                                                                              {new Date(
                                                                                item.payment_Date,
                                                                              ).toLocaleDateString(
                                                                                "en-GB",
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {
                                                                                item.paymentMethod
                                                                              }
                                                                            </td>
                                                                            <td>
                                                                              {renderPaymentStatusBadge(
                                                                                item,
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {item.notes ||
                                                                                "-"}
                                                                            </td>
                                                                            <td>
                                                                              {item
                                                                                .paid_to
                                                                                .name ||
                                                                                "-"}
                                                                            </td>
                                                                            <td>
                                                                              {item
                                                                                .paid_for
                                                                                .name ||
                                                                                "-"}
                                                                            </td>

                                                                            <td>
                                                                              {(() => {
                                                                                const docFiles = getDocFilesList(item?.attachFile);
                                                                                if (docFiles.length === 0) return "No File";
                                                                                return (
                                                                                  <div className="d-flex flex-wrap gap-1 align-items-center">
                                                                                    {docFiles.map((file, fIndex) => (
                                                                                      <button
                                                                                        key={fIndex}
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleOpenDocFile(file)}
                                                                                        title="View Document"
                                                                                      >
                                                                                        View{docFiles.length > 1 ? ` ${fIndex + 1}` : ""}
                                                                                      </button>
                                                                                    ))}
                                                                                  </div>
                                                                                );
                                                                              })()}
                                                                            </td>
                                                                            <td>
                                                                              -
                                                                            </td>
                                                                            <td>
                                                                              <div className="action-icon d-flex align-items-center gap-2">
                                                                                {canDeleteAction && (
                                                                                    <>
                                                                                      {getPaymentStatus(item) === "Pending" && (
                                                                                        <>
                                                                                          <i
                                                                                            className="fa-solid fa-circle-check text-success"
                                                                                            style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                            title="Approve Payment"
                                                                                            onClick={() =>
                                                                                              handleApprovePayment(
                                                                                                item,
                                                                                                info,
                                                                                              )
                                                                                            }
                                                                                          ></i>
                                                                                          <i
                                                                                            className="fa-solid fa-circle-xmark text-danger"
                                                                                            style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                            title="Reject Payment"
                                                                                            onClick={() =>
                                                                                              handleRejectPayment(
                                                                                                item,
                                                                                                info,
                                                                                              )
                                                                                            }
                                                                                          ></i>
                                                                                        </>
                                                                                      )}
                                                                                      {getPaymentStatus(item) === "Rejected" && (
                                                                                        <i
                                                                                          className="fa-solid fa-circle-check text-success"
                                                                                          style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                          title="Re-approve Payment"
                                                                                          onClick={() =>
                                                                                            handleApprovePayment(
                                                                                              item,
                                                                                              info,
                                                                                            )
                                                                                          }
                                                                                        ></i>
                                                                                      )}
                                                                                      <i
                                                                                        className="fa-solid fa-trash"
                                                                                        style={{ cursor: "pointer" }}
                                                                                        title="Delete Payment"
                                                                                        onClick={() => {
                                                                                          handledeltePayment(
                                                                                            item,
                                                                                            info,
                                                                                            index,
                                                                                          );
                                                                                        }}
                                                                                      ></i>
                                                                                    </>
                                                                                  )}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      },
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan="10"
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {(() => {
                                                  const totals = getCategoryPaymentTotals(
                                                    info?.hospital?.payments,
                                                    info?.hospital?.paidAmount,
                                                    info?.hospital?.totalAmount,
                                                  );
                                                  return (
                                                    <>
                                                      <div
                                                        className="card-footer"
                                                        style={{
                                                          borderTop:
                                                            "1px solid #0ba6df",
                                                        }}
                                                      >
                                                        <div className="row justify-content-end">
                                                          <div className="col-md-12">
                                                            <div className="total-amount">
                                                              <h6 className="mb-0">
                                                                Paid
                                                              </h6>
                                                              <p>
                                                                $
                                                                {totals.approvedPaid}
                                                                {totals.pendingAmount > 0 && (
                                                                  <span
                                                                    className="badge bg-warning text-dark ms-2"
                                                                    style={{ fontSize: "11px", fontWeight: 500 }}
                                                                  >
                                                                    Pending: ${totals.pendingAmount}
                                                                  </span>
                                                                )}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="card-footer"
                                                        style={{
                                                          borderTop:
                                                            "1px solid #0ba6df",
                                                        }}
                                                      >
                                                        <div className="row justify-content-end">
                                                          <div className="col-md-12">
                                                            <div className="total-amount">
                                                              <h6 className="mb-0">
                                                                Due Amount:
                                                              </h6>
                                                              <p>
                                                                $
                                                                {totals.dueAmount}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                            {/* for omca services */}
                                            <div className="col-md-12">
                                              <div
                                                className="card customstylecard"
                                                style={{
                                                  border: "1px solid #22c7b8",
                                                }}
                                              >
                                                <div
                                                  className="card-header d-flex align-items-center justify-content-between"
                                                  style={{
                                                    backgroundColor: "#EAFBF9",
                                                    borderBottom:
                                                      "1px solid #22c7b8",
                                                  }}
                                                >
                                                  <div className="d-flex gap-2 align-items-center">
                                                    <h6>OMCA</h6>
                                                    <button
                                                      type="button"
                                                      className="border-0 bg-transparent"
                                                      onClick={() => {
                                                        handleDownloadPDF1(
                                                          omcaRefs,
                                                          index,
                                                          `omca-${index + 1}.pdf`,
                                                        );
                                                      }}
                                                    >
                                                      <i className="fa-solid fa-download"></i>
                                                    </button>
                                                  </div>
                                                  <div className="">
                                                    <button
                                                      className="add-button"
                                                      onClick={(e) =>
                                                        handleAction(
                                                          e,
                                                          "services",
                                                          info,
                                                          info.treatment_name,
                                                        )
                                                      }
                                                    >
                                                      + Add Services
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="card-body">
                                                  <div
                                                    ref={(el) =>
                                                    (omcaRefs.current[index] =
                                                      el)
                                                    }
                                                  >
                                                    <div className="row gx-3 gy-3">
                                                      <div className="col-md-6">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list">
                                                            <h6>
                                                              Extra Services
                                                            </h6>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Service
                                                                      Name
                                                                    </th>
                                                                    <th>
                                                                      Price
                                                                    </th>
                                                                    <th>
                                                                      Discount
                                                                    </th>
                                                                    <th>
                                                                      Final
                                                                      Charge
                                                                    </th>
                                                                    <th>
                                                                      Valid From
                                                                    </th>
                                                                    <th>
                                                                      Valid To
                                                                    </th>
                                                                    <th className="action-col pdf-hide">
                                                                      Action
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {info?.omca
                                                                    ?.extraServices &&
                                                                    info.omca.extraServices.filter(
                                                                      (item) =>
                                                                        item.price ===
                                                                        0 ||
                                                                        item.price,
                                                                    ).length >
                                                                    0 ? (
                                                                    info.omca.extraServices.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => {
                                                                        if (
                                                                          item.price !==
                                                                          0 &&
                                                                          !item.price
                                                                        )
                                                                          return null;
                                                                        return (
                                                                          <tr
                                                                            key={
                                                                              item._id ||
                                                                              item.service_type
                                                                            }
                                                                          >
                                                                            <td>
                                                                              {item.serviceName ||
                                                                                "-"}
                                                                            </td>
                                                                            <td>
                                                                              {getMoneyDisplayValue(
                                                                                item.price,
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {getDiscountPercentageDisplay(
                                                                                item.discount_percentage,
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {getFinalChargeDisplay(
                                                                                item,
                                                                                "final_price",
                                                                                "price",
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {item.startTime
                                                                                ? new Date(
                                                                                  item.startTime,
                                                                                ).toLocaleDateString(
                                                                                  "en-GB",
                                                                                )
                                                                                : "-"}
                                                                            </td>
                                                                            <td>
                                                                              {item.endTime
                                                                                ? new Date(
                                                                                  item.endTime,
                                                                                ).toLocaleDateString(
                                                                                  "en-GB",
                                                                                )
                                                                                : "-"}
                                                                            </td>
                                                                            <td className="pdf-hide">
                                                                              <div className="action-icon">
                                                                                <i
                                                                                  className="fa-solid fa-pen-to-square"
                                                                                  onClick={() => {
                                                                                    hadnlcecEditModal(
                                                                                      item,
                                                                                      info,
                                                                                    );
                                                                                  }}
                                                                                ></i>

                                                                                {canDeleteAction && (
                                                                                    <i
                                                                                      className="fa-solid fa-trash"
                                                                                      onClick={() => {
                                                                                        handledeltePatientserveice(
                                                                                          item,
                                                                                          info,
                                                                                          index,
                                                                                        );
                                                                                      }}
                                                                                    ></i>
                                                                                  )}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      },
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan="7"
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list">
                                                            <h6>
                                                              Free Services
                                                            </h6>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Service
                                                                      Name
                                                                    </th>
                                                                    {/* <th>Price</th> */}
                                                                    <th>
                                                                      Duration
                                                                    </th>
                                                                    {/* <th>Valid To</th>*/}
                                                                    <th className="action-col pdf-hide">
                                                                      Action
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {info?.omca
                                                                    ?.freeServices &&
                                                                    info.omca
                                                                      .freeServices
                                                                      .length >
                                                                    0 ? (
                                                                    info.omca.freeServices.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => {
                                                                        return (
                                                                          <tr
                                                                            key={
                                                                              index
                                                                            }
                                                                          >
                                                                            <td>
                                                                              {item.serviceName ||
                                                                                "-"}
                                                                            </td>
                                                                            <td>
                                                                              {
                                                                                item.duration
                                                                              }
                                                                            </td>
                                                                            <td className="pdf-hide">
                                                                              <div className="action-icon">
                                                                                {/* <i
                                                                            className="fa-solid fa-pen-to-square"
                                                                            onClick={() => {
                                                                              hadnlcecEditModal(
                                                                                item,
                                                                                info,
                                                                              );
                                                                            }}
                                                                          ></i> */}
                                                                                {canDeleteAction && (
                                                                                    <i
                                                                                      className="fa-solid fa-trash"
                                                                                      onClick={() => {
                                                                                        handledeltePatientserveice(
                                                                                          item,
                                                                                          info,
                                                                                          index,
                                                                                        );
                                                                                      }}
                                                                                    ></i>
                                                                                  )}
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      },
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan={
                                                                          3
                                                                        }
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list d-flex justify-content-between">
                                                            <h6>
                                                              Guest House
                                                              Services
                                                            </h6>
                                                            <div className="pdf-hide">
                                                              <button
                                                                className="add-button"
                                                                onClick={() => {
                                                                  handleclickGuestHouse(
                                                                    info,
                                                                  );
                                                                }}
                                                              >
                                                                Add Guest House
                                                              </button>
                                                            </div>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Guest
                                                                      House Name
                                                                    </th>
                                                                    <th>
                                                                      Check In
                                                                    </th>
                                                                    <th>
                                                                      Check Out
                                                                    </th>
                                                                    <th>
                                                                      Total
                                                                      Rooms
                                                                    </th>
                                                                    <th>
                                                                      Amount
                                                                    </th>
                                                                    <th>
                                                                      Discount
                                                                    </th>
                                                                    <th>
                                                                      Final
                                                                      Charge
                                                                    </th>
                                                                    <th>
                                                                      Payment
                                                                      Date
                                                                    </th>
                                                                    <th>
                                                                      Notes
                                                                    </th>
                                                                    <th className="action-col pdf-hide">
                                                                      Document
                                                                    </th>
                                                                    <th className="action-col pdf-hide">
                                                                      Action
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {guestHouseBooking &&
                                                                    guestHouseBooking.length >
                                                                    0 ? (
                                                                    guestHouseBooking.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => {
                                                                        return (
                                                                          <tr
                                                                            key={
                                                                              item.id
                                                                            }
                                                                          >
                                                                            <td>
                                                                              {item.guestHouseName ||
                                                                                "-"}
                                                                            </td>
                                                                            <td>
                                                                              {new Date(
                                                                                item.dateRangeFrom,
                                                                              ).toLocaleDateString(
                                                                                "en-GB",
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {new Date(
                                                                                item.dateRangeTo,
                                                                              ).toLocaleDateString(
                                                                                "en-GB",
                                                                              )}
                                                                            </td>

                                                                            <td>
                                                                              {
                                                                                item.numberOfRooms
                                                                              }
                                                                            </td>
                                                                            <td>
                                                                              {getMoneyDisplayValue(
                                                                                item?.paymentAmount,
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {getDiscountPercentageDisplay(
                                                                                item?.discount_percentage,
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {getFinalChargeDisplay(
                                                                                item,
                                                                                "final_amount",
                                                                                "paymentAmount",
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {new Date(
                                                                                item?.paymentDate,
                                                                              ).toLocaleDateString(
                                                                                "en-GB",
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {
                                                                                item?.notes
                                                                              }
                                                                            </td>
                                                                            <td className="pdf-hide">
                                                                              {Array.isArray(
                                                                                item?.invoiceUrl,
                                                                              ) &&
                                                                                item
                                                                                  .invoiceUrl
                                                                                  .length >
                                                                                0 ? (
                                                                                <div
                                                                                  style={{
                                                                                    display:
                                                                                      "flex",
                                                                                    flexWrap:
                                                                                      "wrap",
                                                                                    gap: "8px",
                                                                                  }}
                                                                                >
                                                                                  {item.invoiceUrl.map(
                                                                                    (
                                                                                      file,
                                                                                      index,
                                                                                    ) => (
                                                                                      <button
                                                                                        key={
                                                                                          index
                                                                                        }
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() =>
                                                                                          window.open(
                                                                                            getDocFileUrl(file),
                                                                                            "_blank",
                                                                                          )
                                                                                        }
                                                                                      >
                                                                                        View
                                                                                      </button>
                                                                                    ),
                                                                                  )}
                                                                                </div>
                                                                              ) : (
                                                                                "No File"
                                                                              )}
                                                                            </td>
                                                                            <td className="pdf-hide">
                                                                              <div className="action-icon">
                                                                                <div className="action-icon">
                                                                                  <i
                                                                                    className="fa-solid fa-pen-to-square"
                                                                                    onClick={() => {
                                                                                      hadnlcecEdopenmodalGuestHouse(
                                                                                        item,
                                                                                        info,
                                                                                      );
                                                                                    }}
                                                                                  ></i>
                                                                                  {canDeleteAction && (
                                                                                      <i
                                                                                        className="fa-solid fa-trash"
                                                                                        onClick={() => {
                                                                                          handledelteguestHouse(
                                                                                            item,
                                                                                            info,
                                                                                            index,
                                                                                          );
                                                                                        }}
                                                                                      ></i>
                                                                                    )}
                                                                                </div>
                                                                              </div>
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      },
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan="11"
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="total-amount">
                                                          <h6 className="mb-0">
                                                            Total Amount:
                                                          </h6>
                                                          <p>
                                                            $
                                                            {
                                                              info?.omca
                                                                ?.totalAmount
                                                            }
                                                          </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list">
                                                            <h6>Payment</h6>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Amount
                                                                    </th>
                                                                    <th>
                                                                      Payment
                                                                      Date
                                                                    </th>
                                                                    <th>
                                                                      Payment Method
                                                                    </th>
                                                                    <th>Status</th>
                                                                    <th>
                                                                      Notes
                                                                    </th>
                                                                    <th>
                                                                      Paid To
                                                                    </th>
                                                                    <th>
                                                                      Paid For
                                                                    </th>
                                                                    <th className="action-col pdf-hide">
                                                                      Document
                                                                    </th>
                                                                    {canDeleteAction && <th>Action</th>}
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {info?.omca
                                                                    ?.payments &&
                                                                    info?.omca
                                                                      ?.payments
                                                                      .length >
                                                                    0 ? (
                                                                    info?.omca?.payments.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => {
                                                                        return (
                                                                          <tr
                                                                            key={
                                                                              item.id
                                                                            }
                                                                          >
                                                                            <td>
                                                                              $
                                                                              {item.paid_amount ===
                                                                                0 ||
                                                                                item.paid_amount
                                                                                ? item.paid_amount
                                                                                : "-"}
                                                                            </td>

                                                                            <td>
                                                                              {new Date(
                                                                                item.payment_Date,
                                                                              ).toLocaleDateString(
                                                                                "en-GB",
                                                                              )}
                                                                            </td>
                                                                            <td>
                                                                              {item.paymentMethod || "-"}
                                                                            </td>
                                                                            <td>
                                                                              {renderPaymentStatusBadge(
                                                                                item,
                                                                              )}
                                                                            </td>
                                                                            <td
                                                                              title={
                                                                                item.notes
                                                                              }
                                                                            >
                                                                              {item.notes
                                                                                ? item
                                                                                  .notes
                                                                                  .length >
                                                                                  30
                                                                                  ? item.notes.slice(
                                                                                    0,
                                                                                    30,
                                                                                  ) +
                                                                                  "..."
                                                                                  : item.notes
                                                                                : "-"}
                                                                            </td>
                                                                            <td>
                                                                              {item
                                                                                .paid_to
                                                                                .name ||
                                                                                "-"}
                                                                            </td>
                                                                            <td>
                                                                              {item
                                                                                .paid_for
                                                                                .name ||
                                                                                "-"}
                                                                            </td>

                                                                            <td className="pdf-hide">
                                                                              {(() => {
                                                                                const docFiles = getDocFilesList(item?.attachFile);
                                                                                if (docFiles.length === 0) return "No File";
                                                                                return (
                                                                                  <div className="d-flex flex-wrap gap-1 align-items-center">
                                                                                    {docFiles.map((file, fIndex) => (
                                                                                      <button
                                                                                        key={fIndex}
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleOpenDocFile(file)}
                                                                                        title="View Document"
                                                                                      >
                                                                                        View{docFiles.length > 1 ? ` ${fIndex + 1}` : ""}
                                                                                      </button>
                                                                                    ))}
                                                                                  </div>
                                                                                );
                                                                              })()}
                                                                            </td>
                                                                            {canDeleteAction && (
                                                                              <td>
                                                                                <div className="action-icon d-flex align-items-center gap-2">
                                                                                  {getPaymentStatus(item) === "Pending" && (
                                                                                    <>
                                                                                      <i
                                                                                        className="fa-solid fa-circle-check text-success"
                                                                                        style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                        title="Approve Payment"
                                                                                        onClick={() =>
                                                                                          handleApprovePayment(
                                                                                            item,
                                                                                            info,
                                                                                          )
                                                                                        }
                                                                                      ></i>
                                                                                      <i
                                                                                        className="fa-solid fa-circle-xmark text-danger"
                                                                                        style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                        title="Reject Payment"
                                                                                        onClick={() =>
                                                                                          handleRejectPayment(
                                                                                            item,
                                                                                            info,
                                                                                          )
                                                                                        }
                                                                                      ></i>
                                                                                    </>
                                                                                  )}
                                                                                  {getPaymentStatus(item) === "Rejected" && (
                                                                                    <i
                                                                                      className="fa-solid fa-circle-check text-success"
                                                                                      style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                      title="Re-approve Payment"
                                                                                      onClick={() =>
                                                                                        handleApprovePayment(
                                                                                          item,
                                                                                          info,
                                                                                        )
                                                                                      }
                                                                                    ></i>
                                                                                  )}
                                                                                  <i
                                                                                    className="fa-solid fa-trash"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    title="Delete Payment"
                                                                                    onClick={() => {
                                                                                      handledeltePayment(
                                                                                        item,
                                                                                        info,
                                                                                        index,
                                                                                      );
                                                                                    }}
                                                                                  ></i>
                                                                                </div>
                                                                              </td>
                                                                            )}
                                                                          </tr>
                                                                        );
                                                                      },
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan={canDeleteAction ? "9" : "8"}
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {(() => {
                                                  const totals = getCategoryPaymentTotals(
                                                    info?.omca?.payments,
                                                    info?.omca?.paidAmount,
                                                    info?.omca?.totalAmount,
                                                  );
                                                  return (
                                                    <>
                                                      <div
                                                        className="card-footer"
                                                        style={{
                                                          borderTop:
                                                            "1px solid #22c7b8",
                                                        }}
                                                      >
                                                        <div className="row justify-content-end">
                                                          <div className="col-md-12">
                                                            <div className="total-amount">
                                                              <h6 className="mb-0">
                                                                Paid
                                                              </h6>
                                                              <p>
                                                                $
                                                                {totals.approvedPaid}
                                                                {totals.pendingAmount > 0 && (
                                                                  <span
                                                                    className="badge bg-warning text-dark ms-2"
                                                                    style={{ fontSize: "11px", fontWeight: 500 }}
                                                                  >
                                                                    Pending: ${totals.pendingAmount}
                                                                  </span>
                                                                )}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="card-footer"
                                                        style={{
                                                          borderTop:
                                                            "1px solid #22c7b8",
                                                        }}
                                                      >
                                                        <div className="row justify-content-end">
                                                          <div className="col-md-12">
                                                            <div className="total-amount">
                                                              <h6 className="mb-0">
                                                                Due Amount:
                                                              </h6>
                                                              <p>
                                                                $
                                                                {totals.dueAmount}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                            {/* for pharmacy data */}
                                            <div className="col-md-12">
                                              <div
                                                className="card customstylecard"
                                                style={{
                                                  border: "1px solid #58C8EC",
                                                }}
                                              >
                                                <div
                                                  className="card-header d-flex justify-content-between"
                                                  style={{
                                                    backgroundColor: "#F2FCFF",
                                                    borderBottom:
                                                      "1px solid #58C8EC",
                                                  }}
                                                >
                                                  <div className="d-flex align-items-center gap-3">
                                                    <h6>Pharmacy</h6>
                                                    <div className="">
                                                      <button
                                                        type="button"
                                                        className="border-0 bg-transparent"
                                                        onClick={() => {
                                                          handleDownloadPDF2(
                                                            pharmacyRefs,
                                                            index,
                                                            `pharmacy-${index + 1}.pdf`,
                                                          );
                                                        }}
                                                      >
                                                        <i className="fa-solid fa-download"></i>
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <button
                                                      className="add-button"
                                                      onClick={() => {
                                                        handleclickpharmacycharge(
                                                          info,
                                                        );
                                                      }}
                                                    >
                                                      Add Charge
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="card-body">
                                                  <div
                                                    ref={(el) =>
                                                    (pharmacyRefs.current[
                                                      index
                                                    ] = el)
                                                    }
                                                  >
                                                    <div className="row gx-3 gy-3">
                                                      <div className="col-md-12">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list">
                                                            <h6>Pharmacy</h6>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Pharmacy
                                                                      Name
                                                                    </th>
                                                                    <th>
                                                                      Price
                                                                    </th>
                                                                    <th>
                                                                      Discount
                                                                    </th>
                                                                    <th>
                                                                      Final
                                                                      Charge
                                                                    </th>
                                                                    <th>
                                                                      Date
                                                                    </th>
                                                                    <th>
                                                                      Action
                                                                    </th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {info
                                                                    ?.pharmacy
                                                                    ?.pharmacyCharges
                                                                    ?.length >
                                                                    0 ? (
                                                                    info.pharmacy?.pharmacyCharges?.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => (
                                                                        <tr
                                                                          key={
                                                                            item._id
                                                                          }
                                                                        >
                                                                          <td>
                                                                            {item?.service_name ||
                                                                              "-"}
                                                                          </td>
                                                                          <td>
                                                                            {getMoneyDisplayValue(
                                                                              item?.price,
                                                                            )}
                                                                          </td>
                                                                          <td>
                                                                            {getDiscountPercentageDisplay(
                                                                              item?.discount_percentage,
                                                                            )}
                                                                          </td>
                                                                          <td>
                                                                            {getFinalChargeDisplay(
                                                                              item,
                                                                              "final_price",
                                                                              "price",
                                                                            )}
                                                                          </td>
                                                                          <td>
                                                                            {new Date(
                                                                              item?.date,
                                                                            ).toLocaleDateString(
                                                                              "en-GB",
                                                                            ) ||
                                                                              "-"}
                                                                          </td>
                                                                          <td>
                                                                            <div className="action-icon">
                                                                              <i
                                                                                className="fa-solid fa-pen-to-square"
                                                                                onClick={() => {
                                                                                  handleeditpharmacycharge(
                                                                                    item,
                                                                                    info,
                                                                                  );
                                                                                }}
                                                                              ></i>
                                                                              {canDeleteAction && (
                                                                                  <i
                                                                                    className="fa-solid fa-trash"
                                                                                    style={{
                                                                                      cursor:
                                                                                        "pointer",
                                                                                    }}
                                                                                    onClick={() =>
                                                                                      deletepharmacy(
                                                                                        info,
                                                                                        index,
                                                                                      )
                                                                                    }
                                                                                  ></i>
                                                                                )}
                                                                            </div>
                                                                          </td>
                                                                        </tr>
                                                                      ),
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan="6"
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="total-amount">
                                                          <h6 className="mb-0">
                                                            Total Amount:
                                                          </h6>
                                                          <p>
                                                            $
                                                            {
                                                              info?.pharmacy
                                                                ?.totalAmount
                                                            }
                                                          </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="card patientreat">
                                                          <div className="card-header service-list">
                                                            <h6>Payment</h6>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="table-responsive table-no-card">
                                                              <table className="table-card w-100">
                                                                <thead>
                                                                  <tr>
                                                                    <th>
                                                                      Paid
                                                                      Amount
                                                                    </th>
                                                                    <th>
                                                                      Date
                                                                    </th>
                                                                    <th>
                                                                      Notes
                                                                    </th>
                                                                    <th>
                                                                      Paid To
                                                                    </th>
                                                                    <th>
                                                                      Paid For
                                                                    </th>
                                                                    <th>
                                                                      Method
                                                                    </th>
                                                                    <th>Status</th>
                                                                    {canDeleteAction && <th>Action</th>}
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {info
                                                                    ?.pharmacy
                                                                    ?.payments
                                                                    ?.length >
                                                                    0 ? (
                                                                    info?.pharmacy?.payments?.map(
                                                                      (
                                                                        item,
                                                                        index,
                                                                      ) => (
                                                                        <tr
                                                                          key={
                                                                            item._id
                                                                          }
                                                                        >
                                                                          <td>
                                                                            $
                                                                            {item?.paid_amount ===
                                                                              0 ||
                                                                              item?.paid_amount
                                                                              ? item.paid_amount
                                                                              : "-"}
                                                                          </td>
                                                                          <td>
                                                                            {new Date(
                                                                              item?.payment_Date,
                                                                            ).toLocaleDateString(
                                                                              "en-GB",
                                                                            ) ||
                                                                              "-"}
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              item.notes
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              item
                                                                                .paid_for
                                                                                .name
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              item
                                                                                .paid_to
                                                                                .name
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              item.paymentMethod
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {renderPaymentStatusBadge(item)}
                                                                          </td>
                                                                          {canDeleteAction && (
                                                                            <td>
                                                                              <div className="action-icon d-flex align-items-center gap-2">
                                                                                {getPaymentStatus(item) === "Pending" && (
                                                                                  <>
                                                                                    <i
                                                                                      className="fa-solid fa-circle-check text-success"
                                                                                      style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                      title="Approve Payment"
                                                                                      onClick={() =>
                                                                                        handleApprovePayment(
                                                                                          item,
                                                                                          info,
                                                                                        )
                                                                                      }
                                                                                    ></i>
                                                                                    <i
                                                                                      className="fa-solid fa-circle-xmark text-danger"
                                                                                      style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                      title="Reject Payment"
                                                                                      onClick={() =>
                                                                                        handleRejectPayment(
                                                                                          item,
                                                                                          info,
                                                                                        )
                                                                                      }
                                                                                    ></i>
                                                                                  </>
                                                                                )}
                                                                                {getPaymentStatus(item) === "Rejected" && (
                                                                                  <i
                                                                                    className="fa-solid fa-circle-check text-success"
                                                                                    style={{ cursor: "pointer", fontSize: "16px" }}
                                                                                    title="Re-approve Payment"
                                                                                    onClick={() =>
                                                                                      handleApprovePayment(
                                                                                        item,
                                                                                        info,
                                                                                      )
                                                                                    }
                                                                                  ></i>
                                                                                )}
                                                                                <i
                                                                                  className="fa-solid fa-trash"
                                                                                  style={{ cursor: "pointer" }}
                                                                                  title="Delete Payment"
                                                                                  onClick={() => {
                                                                                    handledeltePayment(
                                                                                      item,
                                                                                      info,
                                                                                      index,
                                                                                    );
                                                                                  }}
                                                                                ></i>
                                                                              </div>
                                                                            </td>
                                                                          )}
                                                                        </tr>
                                                                      ),
                                                                    )
                                                                  ) : (
                                                                    <tr>
                                                                      <td
                                                                        colSpan={
                                                                          canDeleteAction
                                                                            ? 8
                                                                            : 7
                                                                        }
                                                                        style={{
                                                                          textAlign:
                                                                            "center",
                                                                        }}
                                                                      >
                                                                        No Data
                                                                        Found
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {(() => {
                                                  const totals = getCategoryPaymentTotals(
                                                    info?.pharmacy?.payments,
                                                    info?.pharmacy?.paidAmount,
                                                    info?.pharmacy?.totalAmount,
                                                  );
                                                  return (
                                                    <>
                                                      <div
                                                        className="card-footer"
                                                        style={{
                                                          borderTop:
                                                            "1px solid #58C8EC",
                                                        }}
                                                      >
                                                        <div className="row justify-content-end">
                                                          <div className="col-md-12">
                                                            <div className="total-amount">
                                                              <h6 className="mb-0">
                                                                Paid
                                                              </h6>
                                                              <p>
                                                                $
                                                                {totals.approvedPaid}
                                                                {totals.pendingAmount > 0 && (
                                                                  <span
                                                                    className="badge bg-warning text-dark ms-2"
                                                                    style={{ fontSize: "11px", fontWeight: 500 }}
                                                                  >
                                                                    Pending: ${totals.pendingAmount}
                                                                  </span>
                                                                )}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="card-footer"
                                                        style={{
                                                          borderTop:
                                                            "1px solid #58C8EC",
                                                        }}
                                                      >
                                                        <div className="row justify-content-end">
                                                          <div className="col-md-12">
                                                            <div className="total-amount">
                                                              <h6 className="mb-0">
                                                                Due Amount:
                                                              </h6>
                                                              <p>
                                                                $
                                                                {totals.dueAmount}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {activeSubTab === "attendant" &&
                                        selectedTreatmentId ===
                                        info.treatment_id && (
                                          <>
                                            <div className="row">
                                              <div className="col-md-12">
                                                <div className="experience-box">
                                                  <div className="tbletophd">
                                                    <div className="paymntdata">
                                                      <h6>Attendent</h6>
                                                    </div>
                                                    <div className="treat-buttons">
                                                      <button
                                                        onClick={
                                                          handleclickopenpopup
                                                        }
                                                        className="add-button"
                                                      >
                                                        Assign
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div className="table-responsive">
                                                    <Table
                                                      stickyHeader
                                                      aria-label="attendant table"
                                                      className="table-no-card"
                                                    >
                                                      <TableHead>
                                                        <TableRow>
                                                          <TableCell>
                                                            Name
                                                          </TableCell>
                                                          <TableCell>
                                                            Relation
                                                          </TableCell>
                                                          <TableCell>
                                                            Contact
                                                          </TableCell>
                                                          <TableCell>
                                                            Country
                                                          </TableCell>
                                                          <TableCell>
                                                            Address
                                                          </TableCell>
                                                          <TableCell>
                                                            Attendant ID Proof
                                                          </TableCell>
                                                          {canDeleteAction && (
                                                              <TableCell>
                                                                Action
                                                              </TableCell>
                                                            )}
                                                        </TableRow>
                                                      </TableHead>
                                                      <TableBody>
                                                        {attandantFilered.length ===
                                                          0 ? (
                                                          <TableRow>
                                                            <TableCell
                                                              colSpan={7}
                                                              align="center"
                                                            >
                                                              No attendants
                                                              found
                                                            </TableCell>
                                                          </TableRow>
                                                        ) : (
                                                          attandantFilered.map(
                                                            (item, index) => (
                                                              <TableRow
                                                                key={
                                                                  item._id ||
                                                                  index
                                                                }
                                                              >
                                                                <TableCell>
                                                                  {item
                                                                    ?.AttendeeId
                                                                    ?.attendant_fullname ||
                                                                    "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                  {item
                                                                    ?.AttendeeId
                                                                    ?.attendant_relation ||
                                                                    "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                  {item
                                                                    ?.AttendeeId
                                                                    ?.attendant_contact ||
                                                                    "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                  {item
                                                                    ?.AttendeeId
                                                                    ?.country ||
                                                                    "N/A"}
                                                                </TableCell>
                                                                <TableCell>
                                                                  {item
                                                                    ?.AttendeeId
                                                                    ?.attendant_address ||
                                                                    "N/A"}
                                                                </TableCell>

                                                                <TableCell>
                                                                  <div className="d-flex flex-wrap gap-2">
                                                                    {Array.isArray(
                                                                      item
                                                                        ?.AttendeeId
                                                                        ?.attendant_passport,
                                                                    ) &&
                                                                      item
                                                                        .AttendeeId
                                                                        .attendant_passport
                                                                        .length >
                                                                      0 ? (
                                                                      item.AttendeeId.attendant_passport.map(
                                                                        (
                                                                          file,
                                                                          index,
                                                                        ) => {
                                                                          const filePath =
                                                                            typeof file ===
                                                                              "object"
                                                                              ? file?.path
                                                                              : file;

                                                                          return (
                                                                            <a
                                                                              key={
                                                                                index
                                                                              }
                                                                              href={getDocFileUrl(filePath)}
                                                                              target="_blank"
                                                                              rel="noopener noreferrer"
                                                                              className="btn btn-sm btn-primary"
                                                                            >
                                                                              View{" "}
                                                                            </a>
                                                                          );
                                                                        },
                                                                      )
                                                                    ) : (
                                                                      <span>
                                                                        Not
                                                                        Uploaded
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                </TableCell>
                                                                {canDeleteAction && (
                                                                    <TableCell>
                                                                      <i
                                                                        className="fa-solid fa-trash ms-2 text-danger"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleDelete212(
                                                                            item?._id,
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    </TableCell>
                                                                  )}
                                                              </TableRow>
                                                            ),
                                                          )
                                                        )}
                                                      </TableBody>
                                                    </Table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      {activeSubTab === "payment" &&
                                        selectedTreatmentId ===
                                        info.treatment_id && (
                                          <>
                                            <div className="row">
                                              <div className="col-md-12">
                                                <div className="experience-box">
                                                  <div className="tbletophd">
                                                    <div className="paymntdata">
                                                      <h6>Payment Details</h6>
                                                    </div>
                                                    <div className="treat-buttons">
                                                      <button
                                                        onClick={(e) =>
                                                          handleClickOpen3(
                                                            e,
                                                            info.treatment_id,
                                                          )
                                                        }
                                                        className="add-button"
                                                      >
                                                        <i className="fa fa-plus text-white"></i>
                                                      </button>
                                                      {canExportAction && (
                                                      <button
                                                        onClick={(e) =>
                                                          handleClicexportPayment(
                                                            e,
                                                            info.treatment_id,
                                                          )
                                                        }
                                                        className="add-button ms-2"
                                                        title="Export Payment"
                                                      >
                                                        <i className="fa-solid fa-download text-white"></i>
                                                      </button>
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="table-responsive">
                                                    <table className="table table-no-card">
                                                      <thead>
                                                        <tr>
                                                          <th>Payment Date</th>
                                                          <th>Payment Method</th>
                                                          <th>Payment Amount</th>
                                                          <th>Paid To</th>
                                                          <th>Paid For</th>
                                                          <th>Notes</th>
                                                          <th>Status</th>
                                                          <th>Added By</th>
                                                          <th>Document</th>
                                                          {canDeleteAction ? (
                                                            <>
                                                              <th>PDF</th>
                                                              <th>Action</th>
                                                            </>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {paymentsFilered &&
                                                          paymentsFilered.length > 0 ? (
                                                          paymentsFilered.map((item) => (
                                                            <tr key={item._id}>
                                                              <td>
                                                                {item?.payment_Date
                                                                  ? new Date(
                                                                    item.payment_Date,
                                                                  ).toLocaleDateString("en-GB")
                                                                  : "-"}
                                                              </td>
                                                              <td>{item?.paymentMethod || "-"}</td>
                                                              <td>
                                                                {item?.paid_amount === 0 || item?.paid_amount
                                                                  ? `$${item.paid_amount}`
                                                                  : "-"}
                                                              </td>
                                                              <td>{item?.paid_to?.name || "-"}</td>
                                                              <td>
                                                                {item?.paid_for?.name
                                                                  ? item.paid_for.name
                                                                    .split("_")
                                                                    .map(
                                                                      (word) =>
                                                                        word.charAt(0).toUpperCase() +
                                                                        word.slice(1),
                                                                    )
                                                                    .join(" ")
                                                                  : "-"}
                                                              </td>
                                                              <td>{item?.notes || "-"}</td>
                                                              <td>{renderPaymentStatusBadge(item)}</td>
                                                              <td>{formatAddedBy(item)}</td>
                                                              <td>
                                                                {(() => {
                                                                  const docFiles = getDocFilesList(item?.attachFile);
                                                                  if (docFiles.length === 0) return "-";
                                                                  return (
                                                                    <div className="d-flex flex-wrap gap-1 align-items-center">
                                                                      {docFiles.map((file, fIndex) => (
                                                                        <button
                                                                          key={fIndex}
                                                                          type="button"
                                                                          className="btn btn-sm btn-primary me-1"
                                                                          onClick={() => handleOpenDocFile(file)}
                                                                          title="View Document"
                                                                        >
                                                                          View{docFiles.length > 1 ? ` ${fIndex + 1}` : ""}
                                                                        </button>
                                                                      ))}
                                                                    </div>
                                                                  );
                                                                })()}
                                                              </td>
                                                              {canDeleteAction ? (
                                                                <>
                                                                  <td>
                                                                    <button
                                                                      type="button"
                                                                      className="btn btn-sm btn-primary"
                                                                      onClick={() => {
                                                                        navigate(
                                                                          "/Admin/Patient-Pdfdetails",
                                                                          {
                                                                            state: {
                                                                              data: item?._id,
                                                                            },
                                                                          },
                                                                        );
                                                                      }}
                                                                    >
                                                                      <i className="fa fa-download"></i>
                                                                    </button>
                                                                  </td>
                                                                  <td>
                                                                    <div className="action-icon d-flex align-items-center gap-2">
                                                                      {getPaymentStatus(item) === "Pending" && (
                                                                        <>
                                                                          <i
                                                                            className="fa-solid fa-circle-check text-success"
                                                                            style={{ cursor: "pointer", fontSize: "16px" }}
                                                                            title="Approve Payment"
                                                                            onClick={() =>
                                                                              handleApprovePayment(
                                                                                item,
                                                                                info,
                                                                              )
                                                                            }
                                                                          ></i>
                                                                          <i
                                                                            className="fa-solid fa-circle-xmark text-danger"
                                                                            style={{ cursor: "pointer", fontSize: "16px" }}
                                                                            title="Reject Payment"
                                                                            onClick={() =>
                                                                              handleRejectPayment(
                                                                                item,
                                                                                info,
                                                                              )
                                                                            }
                                                                          ></i>
                                                                        </>
                                                                      )}
                                                                      {getPaymentStatus(item) === "Rejected" && (
                                                                        <i
                                                                          className="fa-solid fa-circle-check text-success"
                                                                          style={{ cursor: "pointer", fontSize: "16px" }}
                                                                          title="Re-approve Payment"
                                                                          onClick={() =>
                                                                            handleApprovePayment(
                                                                              item,
                                                                              info,
                                                                            )
                                                                          }
                                                                        ></i>
                                                                      )}
                                                                      <i
                                                                        className="fa-solid fa-pen-to-square"
                                                                        onClick={() =>
                                                                          handleEditPayment(
                                                                            item,
                                                                            info,
                                                                          )
                                                                        }
                                                                      ></i>
                                                                      <i
                                                                        className="fa-solid fa-trash"
                                                                        onClick={() =>
                                                                          deletePaymentInvoice(
                                                                            item,
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    </div>
                                                                  </td>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                            </tr>
                                                          ))
                                                        ) : (
                                                          <tr>
                                                            <td
                                                              colSpan={
                                                                canDeleteAction
                                                                  ? 11
                                                                  : 9
                                                              }
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              No Data Found
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      {activeSubTab === "reports" &&
                                        selectedTreatmentId ===
                                        info.treatment_id && (
                                          <>
                                            <div className="row">
                                              <div className="col-md-12">
                                                <div className="experience-box">
                                                  <div className="tbletophd">
                                                    <div className="paymntdata">
                                                      <h6>Reports</h6>
                                                    </div>
                                                    <div className="treat-buttons">
                                                      <button
                                                        onClick={(e) =>
                                                          handleClickOpen10(
                                                            e,
                                                            selectedTreatmentId,
                                                          )
                                                        }
                                                        className="add-button"
                                                        title="Add Report"
                                                      >
                                                        <i className="fa fa-plus text-white"></i>
                                                      </button>
                                                      {canExportAction && (
                                                      <button
                                                        onClick={handleExportReportsExcel}
                                                        className="add-button ms-2"
                                                        title="Export to Excel"
                                                        type="button"
                                                      >
                                                        <i className="fa fa-file-excel-o text-white"></i>
                                                      </button>
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="table-responsive">
                                                    <table className="table table-no-card">
                                                      <thead>
                                                        <tr>
                                                          <th>Treatment Name</th>
                                                          <th>Report Title</th>
                                                          <th>Report Date</th>
                                                          <th>Added By</th>
                                                          <th>Reports</th>
                                                          {canDeleteAction ? (
                                                            <th>Action</th>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {reportsFilered1 &&
                                                          reportsFilered1.length > 0 ? (
                                                          reportsFilered1.map(
                                                            (item, itemIndex) => (
                                                              <tr
                                                                key={
                                                                  item._id || itemIndex
                                                                }
                                                              >
                                                                <td>
                                                                  {item?.treatment_course_name ||
                                                                    info?.treatment_name ||
                                                                    "-"}
                                                                </td>
                                                                <td>
                                                                  {item?.reportTitle || "-"}
                                                                </td>
                                                                <td>
                                                                  {item?.treatment_report_date
                                                                    ? new Date(
                                                                      item.treatment_report_date,
                                                                    ).toLocaleDateString(
                                                                      "en-GB",
                                                                    )
                                                                    : "-"}
                                                                </td>
                                                                <td>
                                                                  {formatAddedBy(item)}
                                                                </td>
                                                                <td>
                                                                  {(() => {
                                                                    const reportFiles =
                                                                      Array.isArray(
                                                                        item?.treatmentReport,
                                                                      )
                                                                        ? item.treatmentReport
                                                                        : item?.treatmentReport
                                                                          ? [
                                                                            item.treatmentReport,
                                                                          ]
                                                                          : Array.isArray(
                                                                            item?.documents,
                                                                          )
                                                                            ? item.documents
                                                                            : [];
                                                                    return reportFiles.length >
                                                                      0
                                                                      ? reportFiles.map(
                                                                        (
                                                                          doc,
                                                                          docIndex,
                                                                        ) => {
                                                                          const fullUrl = getDocFileUrl(doc);
                                                                          return (
                                                                            <button
                                                                              key={
                                                                                docIndex
                                                                              }
                                                                              type="button"
                                                                              className="btn btn-sm btn-primary me-1"
                                                                              onClick={() =>
                                                                                window.open(
                                                                                  fullUrl,
                                                                                  "_blank",
                                                                                )
                                                                              }
                                                                            >
                                                                              View{" "}
                                                                              {docIndex + 1}
                                                                            </button>
                                                                          );
                                                                        },
                                                                      )
                                                                      : "-";
                                                                  })()}
                                                                </td>
                                                                {canDeleteAction ? (
                                                                  <td>
                                                                    <div className="action-icon">
                                                                      <i
                                                                        className="fa-solid fa-pen-to-square"
                                                                        onClick={() =>
                                                                          handleEditreport(
                                                                            item,
                                                                            info,
                                                                          )
                                                                        }
                                                                      ></i>
                                                                      <i
                                                                        className="fa-solid fa-trash"
                                                                        onClick={() =>
                                                                          handledeleteReport(
                                                                            item,
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    </div>
                                                                  </td>
                                                                ) : (
                                                                  ""
                                                                )}
                                                              </tr>
                                                            ),
                                                          )
                                                        ) : (
                                                          <tr>
                                                            <td
                                                              colSpan={
                                                                canDeleteAction
                                                                  ? 6
                                                                  : 5
                                                              }
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              No Data Found
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      {activeSubTab === "appointment" &&
                                        selectedTreatmentId ===
                                        info.treatment_id && (
                                          <div className="row">
                                            <div className="col-md-12">
                                              <div className="experience-box">
                                                <div className="tbletophd">
                                                  <div className="paymntdata">
                                                    <h6>Appointment</h6>
                                                  </div>
                                                  <div className="treat-buttons">
                                                    <button
                                                      onClick={(e) =>
                                                        handleClickOpen1(
                                                          e,
                                                          selectedTreatmentId,
                                                          info,
                                                        )
                                                      }
                                                      className="add-button approvebtn"
                                                    >
                                                      <i className="fa fa-plus text-white"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="table-responsive">
                                                  <table className="table table-no-card">
                                                    <thead>
                                                      <tr>
                                                        <th>ID</th>
                                                        <th>Vehicle No</th>
                                                        <th>Driver Name</th>
                                                        <th>Driver Contact</th>
                                                        <th>Pickup Time</th>
                                                        <th>Date & Time</th>
                                                        <th>Notes</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {appointmentTabel.length ===
                                                        0 ? (
                                                        <tr>
                                                          <td
                                                            colSpan="8"
                                                            className="text-center"
                                                          >
                                                            No Appointment Found
                                                          </td>
                                                        </tr>
                                                      ) : (
                                                        appointmentTabel.map(
                                                          (item) => (
                                                            <tr key={item._id}>
                                                              <td>
                                                                {
                                                                  item.appointmentId
                                                                }
                                                              </td>
                                                              <td>
                                                                {item.mode !==
                                                                  "online"
                                                                  ? item.vehicle_no
                                                                  : "-"}
                                                              </td>
                                                              <td>
                                                                {item.mode !==
                                                                  "online"
                                                                  ? item.driver_name
                                                                  : "-"}
                                                              </td>
                                                              <td>
                                                                {item.mode !==
                                                                  "online"
                                                                  ? item.driver_contact
                                                                  : "-"}
                                                              </td>
                                                              <td>
                                                                {item.mode !==
                                                                  "online"
                                                                  ? item.pickup_time
                                                                  : "-"}
                                                              </td>
                                                              <td>
                                                                {formatDisplayDateTime(
                                                                  item.appointment_Date,
                                                                  item.appointment_Time,
                                                                )}
                                                              </td>
                                                              <td>
                                                                {item.note}
                                                              </td>
                                                              <td>
                                                                <span className="badge bg-primary">
                                                                  {item.status}
                                                                </span>
                                                              </td>
                                                              <td>
                                                                <div className="action-icon">
                                                                  <i
                                                                    className="fa-solid fa-pen-to-square"
                                                                    onClick={() =>
                                                                      handleclickeditfunc(
                                                                        item,
                                                                        info,
                                                                      )
                                                                    }
                                                                  ></i>

                                                                  {canDeleteAction && (
                                                                      <i
                                                                        className="fa-solid fa-trash"
                                                                        onClick={() =>
                                                                          handleclickeditdelete(
                                                                            item,
                                                                            info,
                                                                          )
                                                                        }
                                                                      ></i>
                                                                    )}
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          ),
                                                        )
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {activeSubTab === "notes" &&
                                        selectedTreatmentId ===
                                        info.treatment_id && (
                                          <>
                                            <div className="row">
                                              <div className="col-md-12">
                                                <div className="experience-box">
                                                  <div className="tbletophd">
                                                    <div className="paymntdata">
                                                      <h6>Notes</h6>
                                                    </div>
                                                    <div className="treat-buttons">
                                                      <button
                                                        onClick={(e) =>
                                                          handleClickOpenNotes(
                                                            e,
                                                            selectedTreatmentId,
                                                            info,
                                                          )
                                                        }
                                                        className="add-button"
                                                      >
                                                        <i className="fa fa-plus text-white"></i>
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div className="table-responsive">
                                                    <table className="table table-no-card">
                                                      <thead>
                                                        <tr>
                                                          <th>Note</th>
                                                          <th>Date</th>
                                                          <th>Added By</th>
                                                          <th>Images</th>
                                                          <th>Action</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {notesTable &&
                                                          notesTable.length >
                                                          0 ? (
                                                          notesTable.map(
                                                            (item, index) => {
                                                              return (
                                                                <tr
                                                                  key={
                                                                    item._id ||
                                                                    index
                                                                  }
                                                                >
                                                                  <td
                                                                    style={{
                                                                      width:
                                                                        "20%",
                                                                    }}
                                                                  >
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                      <span title={item.note}>
                                                                        {item.note
                                                                          ? item.note.length > 30
                                                                            ? item.note.slice(0, 30) + "..."
                                                                            : item.note
                                                                          : "-"}
                                                                      </span>
                                                                      {item.note && item.note.length > 30 && (
                                                                        <VisibilityIcon
                                                                          style={{
                                                                            fontSize: "18px",
                                                                            color: "#17a2b8",
                                                                            cursor: "pointer",
                                                                            flexShrink: 0,
                                                                          }}
                                                                          titleAccess="View full note"
                                                                          onClick={() => {
                                                                            setViewNoteText(item.note);
                                                                            setViewNoteOpen(true);
                                                                          }}
                                                                        />
                                                                      )}
                                                                    </div>
                                                                  </td>
                                                                  <td>
                                                                    {item?.date
                                                                      ? new Date(
                                                                        item.date,
                                                                      ).toLocaleDateString(
                                                                        "en-GB",
                                                                      )
                                                                      : "-"}
                                                                  </td>
                                                                  <td>
                                                                    {formatAddedBy(
                                                                      item,
                                                                    )}
                                                                  </td>
                                                                  <td>
                                                                    {item
                                                                      ?.treatmentNoteImages
                                                                      ?.length >
                                                                      0
                                                                      ? item.treatmentNoteImages.map(
                                                                        (
                                                                          img,
                                                                          index,
                                                                        ) => (
                                                                          <button
                                                                            key={
                                                                              index
                                                                            }
                                                                            className="btn btn-sm btn-primary me-1"
                                                                            onClick={() =>
                                                                              window.open(
                                                                                `https://sisccltd.com/omca_crm/${img}`,
                                                                                "_blank",
                                                                              )
                                                                            }
                                                                          >
                                                                            View
                                                                          </button>
                                                                        ),
                                                                      )
                                                                      : "-"}
                                                                  </td>

                                                                  <td>
                                                                    <div className="action-icon">
                                                                      <i
                                                                        className="fa-solid fa-pen-to-square"
                                                                        onClick={() =>
                                                                          EditButton(
                                                                            item,
                                                                            info,
                                                                          )
                                                                        }
                                                                      ></i>

                                                                      {canDeleteAction && (
                                                                          <i
                                                                            className="fa-solid fa-trash"
                                                                            onClick={() =>
                                                                              EditDelete(
                                                                                item,
                                                                                info,
                                                                              )
                                                                            }
                                                                          ></i>
                                                                        )}
                                                                    </div>
                                                                  </td>
                                                                </tr>
                                                              );
                                                            },
                                                          )
                                                        ) : (
                                                          <tr>
                                                            <td
                                                              colSpan="5"
                                                              style={{
                                                                textAlign:
                                                                  "center",
                                                              }}
                                                            >
                                                              No Data Found
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}

                                      {/* View Note Dialog */}
                                      <Dialog
                                        open={viewNoteOpen}
                                        onClose={() => setViewNoteOpen(false)}
                                        maxWidth="sm"
                                        fullWidth
                                      >
                                        <DialogTitle
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            background: "#17a2b8",
                                            color: "#fff",
                                            padding: "12px 20px",
                                          }}
                                        >
                                          <span>View Note</span>
                                          <span
                                            style={{ cursor: "pointer", fontSize: "20px" }}
                                            onClick={() => setViewNoteOpen(false)}
                                          >
                                            &times;
                                          </span>
                                        </DialogTitle>
                                        <DialogContent
                                          style={{
                                            padding: "20px",
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            fontSize: "14px",
                                            lineHeight: "1.6",
                                            maxHeight: "400px",
                                            overflowY: "auto",
                                            marginTop: "10px",
                                          }}
                                        >
                                          {viewNoteText || "No notes available."}
                                        </DialogContent>
                                        <DialogActions
                                          style={{ padding: "10px 20px" }}
                                        >
                                          <Button
                                            onClick={() => setViewNoteOpen(false)}
                                            variant="contained"
                                            style={{
                                              background: "#17a2b8",
                                              color: "#fff",
                                            }}
                                          >
                                            Close
                                          </Button>
                                        </DialogActions>
                                      </Dialog>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane ${mainTab === "Attende" ? "show active" : ""}`}
                      id="atten-cont"
                    >
                      <div className="row gx-3">
                        <div className="col-md-12">
                          <div className="text-end">
                            <button
                              onClick={(e) =>
                                handleClickOpen2(e, selectedTreatmentId)
                              }
                              className="add-button"
                            >
                              <i className="fa fa-plus me-2"></i>
                              Add Attendant
                            </button>
                          </div>
                        </div>
                        <div className="col-md-12 gy-3">
                          <div className="table-responsive">
                            <TableContainer
                              component={Paper}
                              style={{
                                overflowX: "auto",
                              }}
                            >
                              <Table
                                stickyHeader
                                aria-label="attendant table"
                                className="table-no-card"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Sr.No.</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Relation</TableCell>
                                    <TableCell>Contact</TableCell>
                                    <TableCell>Country</TableCell>
                                    <TableCell>Attendant Address</TableCell>
                                    <TableCell>Attendant ID Proof</TableCell>
                                    <TableCell>Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {attandantnew.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={8} align="center">
                                        No attendants found
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    attandantnew.map((item, index) => (
                                      <TableRow key={item._id || index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                          {item?.attendant_fullname || "N/A"}
                                        </TableCell>
                                        <TableCell>
                                          {item?.attendant_relation || "N/A"}
                                        </TableCell>
                                        <TableCell>
                                          {item.phoneCode}{" "}
                                          {item?.attendant_contact || "N/A"}
                                        </TableCell>
                                        <TableCell>
                                          {item?.country || "N/A"}
                                        </TableCell>
                                        <TableCell>
                                          {item?.attendant_address}
                                        </TableCell>
                                        <TableCell className="d-flex gap-2">
                                          {item?.attendant_passport?.length > 0
                                            ? item.attendant_passport.map(
                                              (file, fIndex) => {
                                                const filePath =
                                                  typeof file === "object"
                                                    ? file?.path
                                                    : file;
                                                return (
                                                  <div key={fIndex}>
                                                    <a
                                                      href={`https://sisccltd.com/omca_crm/${filePath}`}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      className="viewbtn"
                                                    >
                                                      View{" "}
                                                      {item.attendant_passport
                                                        .length > 1
                                                        ? fIndex + 1
                                                        : ""}
                                                    </a>
                                                  </div>
                                                );
                                              },
                                            )
                                            : "Not Uploaded"}
                                        </TableCell>
                                        <TableCell>
                                          <div className="action-icon">
                                            <i
                                              className="fa-solid fa-pen-to-square"
                                              onClick={() => handleEdit(item)}
                                            ></i>
                                            {canDeleteAction && (
                                              <i
                                                className="fa-solid fa-trash"
                                                onClick={() =>
                                                  handleDeletetrtrtrtr(item)
                                                }
                                              ></i>
                                            )}
                                          </div>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane ${mainTab === "Patient_Enquiry" ? "show active" : ""}`}
                      id="atten-cont"
                    >
                      <div className="row gx-3">
                        <div className="col-md-12">
                          <ul
                            className="nav nav-tabs enqurytab"
                            style={{
                              marginBottom: 20,
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                              border: 0,
                              justifyContent: "center",
                            }}
                          >
                            <li className="nav-item">
                              <button
                                className={`nav-link ${tabValue === 0 ? "active" : ""}`}
                                onClick={() => setTabValue(0)}
                              >
                                Enquiry
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className={`nav-link ${tabValue === 1 ? "active" : ""}`}
                                onClick={() => setTabValue(1)}
                              >
                                Ambulance Services
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className={`nav-link ${tabValue === 2 ? "active" : ""}`}
                                onClick={() => setTabValue(2)}
                              >
                                Air Medical Escort
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className={`nav-link ${tabValue === 3 ? "active" : ""}`}
                                onClick={() => setTabValue(3)}
                              >
                                Treatment Estimate
                              </button>
                            </li>
                          </ul>
                          <div className="table-responsive">
                            {tabValue === 0 && (
                              <div>
                                <TableContainer className="table-responsive">
                                  <Table className="table-no-card">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Sr.No.</TableCell>
                                        <TableCell>Enquiry ID</TableCell>
                                        <TableCell>Country</TableCell>
                                        <TableCell>Treating In</TableCell>
                                        <TableCell>Date/Time</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Action</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {dataForConfirmedEnq
                                        .slice(
                                          page * rowsPerPage,
                                          page * rowsPerPage + rowsPerPage,
                                        )
                                        .map((info, i) => (
                                          <TableRow key={info._id}>
                                            <TableCell>
                                              {page * rowsPerPage + i + 1}
                                            </TableCell>
                                            <TableCell>
                                              {info.enquiryId}
                                            </TableCell>

                                            <TableCell>
                                              {" "}
                                              {info?.country?.length > 10
                                                ? info.country.slice(0, 10) +
                                                "..."
                                                : info.country}
                                            </TableCell>
                                            <TableCell>
                                              {" "}
                                              {info?.treatingIn?.length > 10
                                                ? info.treatingIn.slice(0, 10) +
                                                "..."
                                                : info.treatingIn}
                                            </TableCell>
                                            <TableCell>
                                              {new Date(
                                                info.createdAt,
                                              ).toLocaleDateString("en-GB", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                              })}{" "}
                                              {new Date(
                                                info.createdAt,
                                              ).toLocaleTimeString("en-GB", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                              })}
                                            </TableCell>
                                            <TableCell>
                                              {info.enq_status ===
                                                "Confirmed" ? (
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Confirmed
                                                </span>
                                              ) : (
                                                <FormControl
                                                  sx={{
                                                    m: 1,
                                                    minWidth: 120,
                                                  }}
                                                  size="small"
                                                  className="cont-main"
                                                >
                                                  <Select
                                                    value={
                                                      seekerStatus[
                                                        info.enquiryId
                                                      ]
                                                        ? seekerStatus[
                                                        info.enquiryId
                                                        ]
                                                        : info.enq_status ===
                                                          "Hold"
                                                          ? "2"
                                                          : info.enq_status ===
                                                            "Follow-Up"
                                                            ? "3"
                                                            : info.enq_status ===
                                                              "Dead"
                                                              ? "4"
                                                              : "0"
                                                    }
                                                    onChange={(e) =>
                                                      handleChangeStatusEnquiry(
                                                        e,
                                                        info.enquiryId,
                                                        tabValue,
                                                        info,
                                                      )
                                                    }
                                                    displayEmpty
                                                    className="status-direct"
                                                  >
                                                    <MenuItem value="0">
                                                      Pending
                                                    </MenuItem>
                                                    <MenuItem value="1">
                                                      Confirmed
                                                    </MenuItem>
                                                    <MenuItem value="2">
                                                      Hold
                                                    </MenuItem>
                                                    <MenuItem value="3">
                                                      Follow-up
                                                    </MenuItem>
                                                    <MenuItem value="4">
                                                      Closed
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              )}
                                            </TableCell>
                                            <TableCell className="action-icon">
                                              <i
                                                className="fa-solid fa-notes-medical"
                                                title="Create Notes"
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) =>
                                                  handleOpenEnquiryNotes(
                                                    e,
                                                    info.enquiryId,
                                                  )
                                                }
                                              ></i>
                                              <VisibilityIcon
                                                className="eye-icon"
                                                onClick={(e) =>
                                                  ViewDetail(e, tabValue, info)
                                                }
                                              />
                                              <i
                                                className="fa-solid fa-stethoscope"
                                                onClick={(e) =>
                                                  handleClickOpen4(
                                                    e,
                                                    info.enquiryId,
                                                    info,
                                                  )
                                                }
                                              ></i>
                                              {info?.hasAppointment === true ? (
                                                ""
                                              ) : (
                                                <i
                                                  className="fa-solid fa-calendar-plus"
                                                  title="Add Appointment"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    handleOpenAppointment(info)
                                                  }
                                                ></i>
                                              )}
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <Stack spacing={2}>
                                  <Pagination
                                    className="page-nation"
                                    count={Math.ceil(
                                      dataForConfirmedEnq.length / rowsPerPage,
                                    )}
                                    page={page + 1}
                                    onChange={(event, value) =>
                                      setPage(value - 1)
                                    }
                                    color="primary"
                                  />
                                </Stack>
                              </div>
                            )}
                            {tabValue === 1 && (
                              <div>
                                <TableContainer className="table-responsive">
                                  <Table className="table-no-card">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Sr.No.</TableCell>
                                        <TableCell>Enquiry ID</TableCell>
                                        <TableCell>Country</TableCell>
                                        <TableCell>Treating In</TableCell>
                                        <TableCell>Date/Time</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Action</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {ambulanceData?.length > 0 ? (
                                        ambulanceData
                                          .slice(
                                            ambulancePage * rowsPerPage,
                                            ambulancePage * rowsPerPage +
                                            rowsPerPage,
                                          )
                                          .map((info, i) => (
                                            <TableRow key={info._id}>
                                              <TableCell>
                                                {ambulancePage * rowsPerPage +
                                                  i +
                                                  1}
                                              </TableCell>
                                              <TableCell>
                                                {info.enquiryId}
                                              </TableCell>
                                              <TableCell>
                                                {info?.country?.length > 10
                                                  ? info.country.slice(0, 10) +
                                                  "..."
                                                  : info.country}
                                              </TableCell>

                                              <TableCell>
                                                {info?.treating_in_country
                                                  ?.length > 10
                                                  ? info.treating_in_country.slice(
                                                    0,
                                                    10,
                                                  ) + "..."
                                                  : info.treating_in_country}
                                              </TableCell>

                                              <TableCell>
                                                {new Date(
                                                  info.created_at,
                                                ).toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                })}{" "}
                                                {new Date(
                                                  info.created_at,
                                                ).toLocaleTimeString("en-GB", {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  hour12: true,
                                                })}
                                              </TableCell>
                                              <TableCell>
                                                {info.status === "Confirmed" ? (
                                                  // ✅ Only show text
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Confirmed
                                                  </span>
                                                ) : (
                                                  // ✅ Otherwise show dropdown
                                                  <FormControl
                                                    sx={{
                                                      m: 1,
                                                      minWidth: 120,
                                                    }}
                                                    size="small"
                                                    className="cont-main"
                                                  >
                                                    <Select
                                                      value={
                                                        seekerStatus[
                                                          info.enquiryId
                                                        ]
                                                          ? seekerStatus[
                                                          info.enquiryId
                                                          ]
                                                          : info.status ===
                                                            "Hold"
                                                            ? "2"
                                                            : info.status ===
                                                              "Follow-Up"
                                                              ? "3"
                                                              : info.status ===
                                                                "Dead"
                                                                ? "4"
                                                                : "0"
                                                      }
                                                      onChange={(e) =>
                                                        handleChangtype(e, info)
                                                      }
                                                      displayEmpty
                                                      className="status-direct"
                                                    >
                                                      <MenuItem value="0">
                                                        Pending
                                                      </MenuItem>
                                                      <MenuItem value="1">
                                                        Confirmed
                                                      </MenuItem>
                                                      <MenuItem value="2">
                                                        Hold
                                                      </MenuItem>
                                                      <MenuItem value="3">
                                                        Follow-up
                                                      </MenuItem>
                                                      <MenuItem value="4">
                                                        Closed
                                                      </MenuItem>
                                                    </Select>
                                                  </FormControl>
                                                )}
                                              </TableCell>

                                              <TableCell className="action-icon">
                                                <i
                                                  className="fa-solid fa-notes-medical"
                                                  title="Create Notes"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) =>
                                                    handleOpenEnquiryNotes(
                                                      e,
                                                      info.enquiryId,
                                                    )
                                                  }
                                                ></i>
                                                <VisibilityIcon
                                                  className="eye-icon"
                                                  onClick={(e) =>
                                                    ViewDetail(
                                                      e,
                                                      tabValue,
                                                      info,
                                                    )
                                                  }
                                                />

                                                {info?.hasDoctorReview !==
                                                  true && (
                                                    <i
                                                      className="fa-solid fa-stethoscope"
                                                      onClick={(e) =>
                                                        handleClickOpen4(
                                                          e,
                                                          info.enquiryId,
                                                          info,
                                                        )
                                                      }
                                                    ></i>
                                                  )}

                                                {info?.hasAppointment !==
                                                  true && (
                                                    <i
                                                      className="fa-solid fa-calendar-plus"
                                                      title="Add Appointment"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleOpenAppointment(
                                                          info,
                                                        )
                                                      }
                                                    ></i>
                                                  )}
                                              </TableCell>
                                            </TableRow>
                                          ))
                                      ) : (
                                        <TableRow>
                                          <TableCell colSpan={7} align="center">
                                            No Data Found
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <Stack spacing={2}>
                                  <Pagination
                                    className="page-nation"
                                    count={Math.ceil(
                                      ambulanceData.length / rowsPerPage,
                                    )}
                                    page={ambulancePage + 1}
                                    onChange={(event, value) =>
                                      setAmbulancePage(value - 1)
                                    }
                                    color="primary"
                                  />
                                </Stack>
                              </div>
                            )}
                            {tabValue === 2 && (
                              <div>
                                <TableContainer className="table-responsive">
                                  <Table className="table-no-card">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Sr.No.</TableCell>
                                        <TableCell>Enquiry ID</TableCell>
                                        <TableCell>Country</TableCell>
                                        <TableCell>Treating In</TableCell>
                                        <TableCell>Date/Time</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Action</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {airAmbulanceData?.length > 0 ? (
                                        airAmbulanceData
                                          .slice(
                                            airAmbulancePage * rowsPerPage,
                                            airAmbulancePage * rowsPerPage +
                                            rowsPerPage,
                                          )
                                          .map((info, i) => (
                                            <TableRow key={info._id}>
                                              <TableCell>
                                                {airAmbulancePage *
                                                  rowsPerPage +
                                                  i +
                                                  1}
                                              </TableCell>

                                              <TableCell>
                                                {info.enquiryId}
                                              </TableCell>
                                              <TableCell>
                                                {info?.country?.length > 10
                                                  ? info.country.slice(0, 10) +
                                                  "..."
                                                  : info.country}
                                              </TableCell>
                                              <TableCell>
                                                {info?.treating_in_country
                                                  ?.length > 10
                                                  ? info.treating_in_country.slice(
                                                    0,
                                                    10,
                                                  ) + "..."
                                                  : info.treating_in_country}
                                              </TableCell>
                                              <TableCell>
                                                {new Date(
                                                  info.created_at,
                                                ).toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                })}{" "}
                                                {new Date(
                                                  info.created_at,
                                                ).toLocaleTimeString("en-GB", {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  hour12: true,
                                                })}
                                              </TableCell>
                                              <TableCell>
                                                {info.status === "Confirmed" ? (
                                                  // ✅ Only show text
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Confirmed
                                                  </span>
                                                ) : (
                                                  // ✅ Otherwise show dropdown
                                                  <FormControl
                                                    sx={{
                                                      m: 1,
                                                      minWidth: 120,
                                                    }}
                                                    size="small"
                                                    className="cont-main"
                                                  >
                                                    <Select
                                                      value={
                                                        seekerStatus[
                                                          info.enquiryId
                                                        ]
                                                          ? seekerStatus[
                                                          info.enquiryId
                                                          ]
                                                          : info.status ===
                                                            "Hold"
                                                            ? "2"
                                                            : info.status ===
                                                              "Follow-Up"
                                                              ? "3"
                                                              : info.status ===
                                                                "Dead"
                                                                ? "4"
                                                                : "0"
                                                      }
                                                      onChange={(e) =>
                                                        handleChangtype(e, info)
                                                      }
                                                      displayEmpty
                                                      className="status-direct"
                                                    >
                                                      <MenuItem value="0">
                                                        Pending
                                                      </MenuItem>
                                                      <MenuItem value="1">
                                                        Confirmed
                                                      </MenuItem>
                                                      <MenuItem value="2">
                                                        Hold
                                                      </MenuItem>
                                                      <MenuItem value="3">
                                                        Follow-up
                                                      </MenuItem>
                                                      <MenuItem value="4">
                                                        Closed
                                                      </MenuItem>
                                                    </Select>
                                                  </FormControl>
                                                )}
                                              </TableCell>
                                              <TableCell className="action-icon">
                                                <i
                                                  className="fa-solid fa-notes-medical"
                                                  title="Create Notes"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) =>
                                                    handleOpenEnquiryNotes(
                                                      e,
                                                      info.enquiryId,
                                                    )
                                                  }
                                                ></i>
                                                <VisibilityIcon
                                                  className="eye-icon"
                                                  onClick={(e) =>
                                                    ViewDetail(
                                                      e,
                                                      tabValue,
                                                      info,
                                                    )
                                                  }
                                                />
                                                {info?.hasDoctorReview !==
                                                  true && (
                                                    <i
                                                      className="fa-solid fa-stethoscope"
                                                      onClick={(e) =>
                                                        handleClickOpen4(
                                                          e,
                                                          info.enquiryId,
                                                          info,
                                                        )
                                                      }
                                                    ></i>
                                                  )}
                                                {info?.hasAppointment !==
                                                  true && (
                                                    <i
                                                      className="fa-solid fa-calendar-plus"
                                                      title="Add Appointment"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleOpenAppointment(
                                                          info,
                                                        )
                                                      }
                                                    ></i>
                                                  )}
                                              </TableCell>
                                            </TableRow>
                                          ))
                                      ) : (
                                        <TableRow>
                                          <TableCell colSpan={7} align="center">
                                            No Data Found
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <Stack spacing={2}>
                                  <Pagination
                                    className="page-nation"
                                    count={Math.ceil(
                                      airAmbulanceData.length / rowsPerPage,
                                    )}
                                    page={airAmbulancePage + 1}
                                    onChange={(event, value) =>
                                      setAirAmbulancePage(value - 1)
                                    }
                                    color="primary"
                                  />
                                </Stack>
                              </div>
                            )}
                            {tabValue === 3 && (
                              <div>
                                <TableContainer className="table-responsive">
                                  <Table className="table-no-card">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Sr.No.</TableCell>
                                        <TableCell>Enquiry ID</TableCell>
                                        <TableCell>Country</TableCell>
                                        <TableCell>Treating In</TableCell>
                                        <TableCell>Date/Time</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Action</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {treatmentData1?.length > 0 ? (
                                        treatmentData1
                                          ?.slice(
                                            treatmentPage * rowsPerPage,
                                            treatmentPage * rowsPerPage +
                                            rowsPerPage,
                                          )
                                          .map((info, i) => (
                                            <TableRow key={info._id}>
                                              <TableCell>
                                                {treatmentPage * rowsPerPage +
                                                  i +
                                                  1}
                                              </TableCell>
                                              <TableCell>
                                                {info.enquiryId}
                                              </TableCell>
                                              <TableCell>
                                                {info?.country?.length > 10
                                                  ? info.country.slice(0, 10) +
                                                  "..."
                                                  : info.country}
                                              </TableCell>
                                              <TableCell>
                                                {info?.treating_in_country
                                                  ?.length > 10
                                                  ? info.treating_in_country.slice(
                                                    0,
                                                    10,
                                                  ) + "..."
                                                  : info.treating_in_country}
                                              </TableCell>
                                              <TableCell>
                                                {new Date(
                                                  info.created_at,
                                                ).toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                })}{" "}
                                                {new Date(
                                                  info.created_at,
                                                ).toLocaleTimeString("en-GB", {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  hour12: true,
                                                })}
                                              </TableCell>
                                              <TableCell>
                                                {info.status === "Confirmed" ? (
                                                  // ✅ Only show text
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Confirmed
                                                  </span>
                                                ) : (
                                                  // ✅ Otherwise show dropdown
                                                  <FormControl
                                                    sx={{
                                                      m: 1,
                                                      minWidth: 120,
                                                    }}
                                                    size="small"
                                                    className="cont-main"
                                                  >
                                                    <Select
                                                      value={
                                                        seekerStatus[
                                                          info.enquiryId
                                                        ]
                                                          ? seekerStatus[
                                                          info.enquiryId
                                                          ]
                                                          : info.status ===
                                                            "Hold"
                                                            ? "2"
                                                            : info.status ===
                                                              "Follow-Up"
                                                              ? "3"
                                                              : info.status ===
                                                                "Dead"
                                                                ? "4"
                                                                : "0"
                                                      }
                                                      onChange={(e) =>
                                                        handleChangtype(e, info)
                                                      }
                                                      displayEmpty
                                                      className="status-direct"
                                                    >
                                                      <MenuItem value="0">
                                                        Pending
                                                      </MenuItem>
                                                      <MenuItem value="1">
                                                        Confirmed
                                                      </MenuItem>
                                                      <MenuItem value="2">
                                                        Hold
                                                      </MenuItem>
                                                      <MenuItem value="3">
                                                        Follow-up
                                                      </MenuItem>
                                                      <MenuItem value="4">
                                                        Closed
                                                      </MenuItem>
                                                    </Select>
                                                  </FormControl>
                                                )}
                                              </TableCell>
                                              <TableCell className="action-icon">
                                                <i
                                                  className="fa-solid fa-notes-medical"
                                                  title="Create Notes"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) =>
                                                    handleOpenEnquiryNotes(
                                                      e,
                                                      info.enquiryId,
                                                    )
                                                  }
                                                ></i>
                                                <VisibilityIcon
                                                  className="eye-icon"
                                                  onClick={(e) =>
                                                    ViewDetail(
                                                      e,
                                                      tabValue,
                                                      info,
                                                    )
                                                  }
                                                />
                                                {info?.hasDoctorReview !==
                                                  true && (
                                                    <i
                                                      className="fa-solid fa-stethoscope"
                                                      onClick={(e) =>
                                                        handleClickOpen4(
                                                          e,
                                                          info.enquiryId,
                                                          info,
                                                        )
                                                      }
                                                    ></i>
                                                  )}
                                                {info?.hasAppointment !==
                                                  true && (
                                                    <i
                                                      className="fa-solid fa-calendar-plus"
                                                      title="Add Appointment"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        handleOpenAppointment(
                                                          info,
                                                        )
                                                      }
                                                    ></i>
                                                  )}
                                              </TableCell>
                                            </TableRow>
                                          ))
                                      ) : (
                                        <TableRow>
                                          <TableCell colSpan={7} align="center">
                                            No Data Found
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <Stack spacing={2}>
                                  <Pagination
                                    className="page-nation"
                                    count={Math.ceil(
                                      treatmentData1.length / rowsPerPage,
                                    )}
                                    page={treatmentPage + 1}
                                    onChange={(event, value) =>
                                      setTreatmentPage(value - 1)
                                    }
                                    color="primary"
                                  />
                                </Stack>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`tab-pane ${mainTab === "my-order" || mainTab === "my-orders" ? "show active" : ""}`}
                      id="myorderscontent"
                    >
                      <PatientOrdersTab
                        patient={ispatient}
                        userId={
                          ispatient?.user_id ||
                          ispatient?.userId ||
                          effectiveUserId ||
                          PatientTreatments?.user_id ||
                          PatientTreatments?.userId ||
                          ""
                        }
                      />
                    </div>
                    <div
                      className={`tab-pane ${mainTab === "physiotherapy" ? "show active" : ""}`}
                      id="physiotherapycontent"
                    >
                      <PatientPhysiotherapySection
                        patient={ispatient}
                        patientId={
                          ispatient?.patientId ||
                          ispatient?.patient_id ||
                          location?.state?.patientId ||
                          effectivePatientDetailId ||
                          ""
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <React.Fragment>
        <Dialog
          fullWidth
          maxWidth="sm"
          open={treatmentPlanPopup}
          onClose={PlanTreatmentPopupClose}
          disableEnforceFocus
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Plan Treatment</h6>
            </div>
            <div className="cross-icon" onClick={PlanTreatmentPopupClose}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box view-table-detail">
            <Box noValidate component="form" className="contact-form">
              <div className="row">
                <div className="col-md-12">
                  <div className="field-set">
                    <div className="d-flex justify-content-between align-items-center">
                      <label>
                        Treatment Name<span className="text-danger">*</span>
                      </label>

                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={handleCreateTreatment}
                      >
                        + Add
                      </button>
                    </div>
                    <Autocomplete
                      options={Treatment || []}
                      getOptionLabel={(option) => option.name || ""}
                      onChange={(e, newValue) => {
                        setFieldValue(newValue);
                        handleChangeDetails123(newValue);
                        setErrors((prev) => ({ ...prev, treatment: "" }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Treatment"
                          error={!!errors.treatment}
                          helperText={errors.treatment}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="field-set">
                    <label>
                      Select Hospital<span className="text-danger">*</span>
                    </label>
                    <Autocomplete
                      multiple
                      options={hospitlID || []}
                      value={hospitalId || []}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.name}
                      onChange={(e, values) => {
                        const isSelectAll = values.find(
                          (val) => val._id === "all",
                        );

                        if (isSelectAll) {
                          const allHospitals = hospitlID.filter(
                            (item) => item._id !== "all",
                          );
                          setHospitalId(allHospitals);
                        } else {
                          setHospitalId(values);
                        }

                        setErrors((prev) => ({ ...prev, hospitals: "" }));
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            checked={
                              option._id === "all"
                                ? hospitalId.length === hospitlID.length - 1
                                : selected
                            }
                          />
                          {option.name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Hospital"
                          error={!!errors.hospitals}
                        />
                      )}
                    />
                  </div>
                  {errors.hospitals && (
                    <small className="text-danger">{errors.hospitals}</small>
                  )}
                </div>
                <div className="col-md-12">
                  <div className="field-set">
                    <label>
                      Doctor's Review<span className="text-danger"></span>
                    </label>
                    <Autocomplete
                      options={doctorReviewData1 || []}
                      value={
                        doctorReviewData1?.find(
                          (item) => item._id === drreviewnotes,
                        ) || null
                      }
                      getOptionLabel={(option) => getDoctorReviewLabel(option)}
                      isOptionEqualToValue={(option, value) =>
                        option._id === value._id
                      }
                      onChange={(e, newValue) => {
                        setDrreviewnotes(newValue?._id || "");
                        setErrors((prev) => ({ ...prev, drreviewnotes: "" }));
                      }}
                      ListboxProps={{
                        style: {
                          maxHeight: 250,
                          overflow: "auto",
                        },
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          key={option._id}
                          title={getDoctorReviewFullLabel(option)}
                          style={{
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getDoctorReviewLabel(option, 60)}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select"
                          size="small"
                          error={!!errors.drreviewnotes}
                          inputProps={{
                            ...params.inputProps,
                            title: drreviewnotes
                              ? getDoctorReviewFullLabel(
                                doctorReviewData1?.find(
                                  (item) => item._id === drreviewnotes,
                                ),
                              )
                              : "",
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 38,
                            },
                            "& .MuiInputBase-input": {
                              padding: "6px 12px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            },
                          }}
                        />
                      )}
                    />
                    {errors.drreviewnotes && (
                      <small className="text-danger">
                        {errors.drreviewnotes}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="field-set">
                    <label>
                      Select Reports
                    </label>
                    <input
                      type="file"
                      multiple
                      className="form-control"
                      onChange={(e) => {
                        setImages(Array.from(e.target.files));
                        setErrors((prev) => ({ ...prev, reports: "" }));
                      }}
                    />
                  </div>
                  {errors.reports && (
                    <small className="text-danger">{errors.reports}</small>
                  )}
                </div>
                <div className="col-md-12">
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      onChange={(e) => {
                        setValue1(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <DialogActions className="submit-main">
                <Button
                  type="button"
                  onClick={uploadmultipleRecord}
                  variant="contained"
                >
                  Send
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      {/* Add Hospitals to Treatment Plan Modal */}
      <React.Fragment>
        <Dialog
          fullWidth
          maxWidth="sm"
          open={addHospToPlanModalOpen}
          onClose={() => !isAddingHospToPlan && setAddHospToPlanModalOpen(false)}
          disableEnforceFocus
          PaperProps={{
            style: {
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "16px 20px",
              background: "#f8fafc",
              borderBottom: "1px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="d-flex align-items-center gap-2.5">
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "8px",
                  background: "#e0f2fe",
                  color: "#0284c7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                  flexShrink: 0,
                }}
              >
                <i className="fa-solid fa-hospital" />
              </div>
              <div>
                <h6 style={{ margin: 0, fontWeight: "700", color: "#1e293b", fontSize: "15px" }}>
                  Add Hospitals to Treatment Plan
                </h6>
                <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>
                  Treatment: <span style={{ color: "#0f172a", fontWeight: "600" }}>{targetPlanForAddHosp?.treatment?.name || "Treatment Plan"}</span>
                </div>
              </div>
            </div>
            <button
              type="button"
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "6px",
                border: "none",
                background: "transparent",
                color: "#64748b",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "background 0.15s, color 0.15s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#e2e8f0";
                e.currentTarget.style.color = "#1e293b";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "#64748b";
              }}
              onClick={() => !isAddingHospToPlan && setAddHospToPlanModalOpen(false)}
              title="Close"
            >
              <i className="fa-solid fa-xmark" style={{ fontSize: "16px" }} />
            </button>
          </div>

          <DialogContent style={{ padding: "24px 20px" }}>
            <Box noValidate component="form">
              <div className="row g-3">
                <div className="col-md-12">
                  <label className="form-label fw-bold mb-1.5" style={{ fontSize: "13px", color: "#334155" }}>
                    Select Hospital(s) <span className="text-danger">*</span>
                  </label>
                  <Autocomplete
                    multiple
                    options={availableHospitalsForPlan || []}
                    value={selectedHospitalsForPlan || []}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.name || option.hospital_name || ""}
                    isOptionEqualToValue={(option, val) =>
                      String(option.id || option._id) === String(val.id || val._id)
                    }
                    onChange={(e, values) => {
                      setSelectedHospitalsForPlan(values);
                      if (values.length > 0) setAddHospPlanError("");
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} key={option.id || option._id} style={{ padding: "8px 12px" }}>
                        <Checkbox
                          checked={selected}
                          style={{ marginRight: 8, color: selected ? "#0284c7" : undefined }}
                        />
                        <div>
                          <div style={{ fontWeight: 600, color: "#1e293b", fontSize: "13px" }}>
                            {option.name || option.hospital_name}
                          </div>
                          {option.email && (
                            <small className="text-muted" style={{ fontSize: "11px" }}>
                              {option.email}
                            </small>
                          )}
                        </div>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={
                          selectedHospitalsForPlan.length === 0
                            ? "Select hospitals to add..."
                            : ""
                        }
                        error={Boolean(addHospPlanError && selectedHospitalsForPlan.length === 0)}
                        helperText={
                          selectedHospitalsForPlan.length === 0 && addHospPlanError
                            ? addHospPlanError
                            : ""
                        }
                      />
                    )}
                  />
                  {availableHospitalsForPlan.length === 0 ? (
                    <small className="text-muted fst-italic mt-1.5 d-block" style={{ fontSize: "12px" }}>
                      All available hospitals are already added to this treatment plan.
                    </small>
                  ) : (
                    <small className="text-muted mt-1.5 d-block" style={{ fontSize: "11.5px" }}>
                      Select one or more hospitals to request quotations/estimates.
                    </small>
                  )}
                </div>

                {addHospPlanError && selectedHospitalsForPlan.length > 0 && (
                  <div className="col-12">
                    <div className="alert alert-danger py-2 px-3 mb-0" style={{ fontSize: "12px", borderRadius: "6px" }}>
                      <i className="fa-solid fa-triangle-exclamation me-1"></i> {addHospPlanError}
                    </div>
                  </div>
                )}
              </div>

              {/* Clean Footer Buttons */}
              <div
                className="d-flex align-items-center justify-content-end gap-2.5 pt-3 mt-4"
                style={{ borderTop: "1px solid #e2e8f0" }}
              >
                <button
                  type="button"
                  className="btn fw-semibold"
                  style={{
                    backgroundColor: "#f1f5f9",
                    border: "1px solid #cbd5e1",
                    color: "#475569",
                    borderRadius: "7px",
                    fontSize: "13px",
                    padding: "7px 18px",
                    transition: "all 0.15s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e2e8f0";
                    e.currentTarget.style.color = "#1e293b";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f5f9";
                    e.currentTarget.style.color = "#475569";
                  }}
                  onClick={() => setAddHospToPlanModalOpen(false)}
                  disabled={isAddingHospToPlan}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn fw-bold shadow-sm d-inline-flex align-items-center gap-1.5"
                  style={{
                    backgroundColor: selectedHospitalsForPlan.length === 0 ? "#94a3b8" : "#0284c7",
                    borderColor: selectedHospitalsForPlan.length === 0 ? "#94a3b8" : "#0284c7",
                    color: "#ffffff",
                    borderRadius: "7px",
                    fontSize: "13px",
                    padding: "7px 20px",
                    cursor: selectedHospitalsForPlan.length === 0 || isAddingHospToPlan ? "not-allowed" : "pointer",
                    transition: "all 0.15s ease",
                  }}
                  onClick={handleSubmitAddHospitalsToPlan}
                  disabled={isAddingHospToPlan || selectedHospitalsForPlan.length === 0}
                >
                  {isAddingHospToPlan ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" role="status" />
                      Adding...
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-plus me-1"></i> Add Hospitals ({selectedHospitalsForPlan.length})
                    </>
                  )}
                </button>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth
          maxWidth="sm"
          open={modalEditServiceOpen}
          onClose={hadnlcecEcloseeModal}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Edit Service</h6>
            </div>
            <div className="cross-icon" onClick={hadnlcecEcloseeModal}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                width: "100%",
              }}
              className="contact-form"
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>
                      Service<span className="text-danger"></span>
                    </label>
                    <input
                      className="form-control"
                      onChange={editServiceandlechange}
                      value={data.serviceName}
                      disabled
                      name="serviceId"
                    />
                  </div>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>
                      Enter Price<span className="text-danger">*</span>
                    </label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        className="form-control code-in"
                        value={getPaidAmountInputValue(data.price)}
                        name="price"
                        onChange={editServiceandlechange}
                        placeholder="Enter price"
                      />
                    </div>
                  </div>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>Discount (%)</label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="any"
                      className="form-control"
                      value={getPaidAmountInputValue(
                        data.discount_percentage,
                      )}
                      name="discount_percentage"
                      onChange={editServiceandlechange}
                      placeholder="0-100"
                    />
                  </div>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>Final Price</label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        className="form-control code-in"
                        value={getPaidAmountInputValue(data.final_price)}
                        name="final_price"
                        onChange={editServiceandlechange}
                        placeholder="Final price"
                      />
                    </div>
                  </div>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <div className="field-set mb-0">
                      <label>
                        Start Date<span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="startTime"
                        value={
                          data.startTime ? data.startTime.split("T")[0] : ""
                        }
                        onChange={editServiceandlechange}
                        placeholder="Enter start date"
                      />
                    </div>
                  </div>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>
                      End Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="endTime"
                      value={data.endTime ? data.endTime.split("T")[0] : ""}
                      onChange={editServiceandlechange}
                      placeholder="Enter end date"
                    />
                  </div>
                </Box>
              </Box>

              <DialogActions className="submit-main">
                <Button
                  type="button"
                  onClick={handlesubmitdataserviceEdit}
                  variant="contained"
                  disabled={isServiceSubmitting}
                >
                  {isServiceSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={closeModal}>
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Service</h6>
            </div>
            <div className="cross-icon" onClick={closeModal}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                width: "100%",
              }}
              className="contact-form"
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>
                      Select Service<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      onChange={andlechange}
                      name="serviceId"
                    >
                      <option>Select</option>
                      {undadedservice?.map((item, index) => (
                        <option key={index} value={item.serviceId}>
                          {item.serviceName}
                        </option>
                      ))}
                    </select>
                  </div>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>
                      Enter Price<span className="text-danger">*</span>
                    </label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        className="form-control code-in"
                        value={getPaidAmountInputValue(data.price)}
                        name="price"
                        onChange={andlechange}
                        placeholder="Enter price"
                      />
                    </div>
                  </div>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>Discount (%)</label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="any"
                      className="form-control"
                      value={getPaidAmountInputValue(
                        data.discount_percentage,
                      )}
                      name="discount_percentage"
                      onChange={andlechange}
                      placeholder="0-100"
                    />
                  </div>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>Final Price</label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        className="form-control code-in"
                        value={getPaidAmountInputValue(data.final_price)}
                        name="final_price"
                        onChange={andlechange}
                        placeholder="Final price"
                      />
                    </div>
                  </div>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <div className="field-set mb-0">
                      <label>
                        Start Date<span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="start_date"
                        onChange={andlechangedate}
                        placeholder="Enter start date"
                      />
                    </div>
                  </div>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <div className="field-set mb-0">
                    <label>
                      End Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      onChange={andlechangedate}
                      placeholder="Enter end date"
                    />
                  </div>
                </Box>
              </Box>
              <DialogActions className="submit-main">
                <Button
                  type="button"
                  onClick={handlesubmitdata}
                  variant="contained"
                  disabled={isServiceSubmitting}
                >
                  {isServiceSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open}
          onClose={handleClose}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Hospital</h6>
            </div>
            <div className="cross-icon" onClick={handleClose}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
                minHeight: "350px",
              }}
              className="contact-form"
            >
              <Box>
                <form
                  id="contact-form"
                  className="contact-form"
                  method="post"
                  role="form"
                >
                  <div className="field-set">
                    <label>
                      Hospital Name<span className="text-danger">*</span>
                    </label>
                    <Autocomplete
                      disablePortal
                      options={dataHospital?.map((job) => job.name) || []} // Fallback to empty array
                      onChange={(e, value) => {
                        const selectedCourse = dataHospital?.find(
                          (job) => job.name === value,
                        );
                        const courseId = selectedCourse;
                        setHospitalId(courseId);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Hospital" />
                      )}
                      size="small"
                      style={{
                        backgroundColor:
                          "linear-gradient(181deg, #22c7b8 0%, #0ba6df 72%)",
                        border: "0 !important",
                        borderColor: "transparent",
                      }}
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Treatment Id<span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder="Treatment ID"
                      className="form-control"
                      name="treatmentId"
                      required=""
                      value={treatmentId}
                    />
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      onClick={(e) => handlesubmit(e)}
                      variant="contained"
                      disabled={isSubmitting} //✅ disables button while submitting
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open1}
          onClose={handleClose1}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>{edited === true ? "Edit" : "Add"} Appointment</h6>
            </div>
            <div className="cross-icon" onClick={handleClose1}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box view-table-detail">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form
                  id="contact-form"
                  className="contact-form"
                  method="post"
                  role="form"
                >
                  <div className="field-set">
                    <div>
                      <h6>Appointment will be:</h6>
                      <div className="d-flex gap-3">
                        <div className="radio-on">
                          <label>
                            <input
                              type="radio"
                              name="status"
                              value="online"
                              checked={statuddropdown === "online"}
                              onChange={(e) =>
                                setStatuddropdown(e.target.value)
                              }
                            />
                            Online
                          </label>
                        </div>
                        <div className="radio-on">
                          <label>
                            <input
                              type="radio"
                              name="status"
                              value="offline"
                              checked={statuddropdown === "offline"}
                              onChange={(e) =>
                                setStatuddropdown(e.target.value)
                              }
                            />
                            Offline
                          </label>
                        </div>
                      </div>
                    </div>
                    <label>
                      {" "}
                      Hospital<span className="text-danger">*</span>
                    </label>
                    <FormControl fullWidth size="small">
                      <Select
                        value={(() => {
                          const match = (hospitalList || []).find(
                            (item) =>
                              String(item.id ?? item.hospital_id) ===
                                String(hospitalData.hospital_id) ||
                              String(item.name || item.hospital_Name || "") ===
                                String(hospitalData.hospital_Name || ""),
                          );
                          return match
                            ? match.id ?? match.hospital_id
                            : hospitalData.hospital_id || "";
                        })()}
                        displayEmpty
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const selectedHospital = (hospitalList || []).find(
                            (item) =>
                              String(item.id ?? item.hospital_id) ===
                              String(selectedId),
                          );
                          setHospitalData({
                            hospital_id:
                              selectedHospital?.id ??
                              selectedHospital?.hospital_id ??
                              selectedId,
                            hospital_Name:
                              selectedHospital?.name ||
                              selectedHospital?.hospital_Name ||
                              "",
                            hospital_email:
                              selectedHospital?.email ||
                              selectedHospital?.hospital_email ||
                              "",
                          });
                        }}
                        MenuProps={{
                          PaperProps: { style: { maxHeight: 280 } },
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Hospital
                        </MenuItem>
                        {(hospitalList || []).map((item) => (
                          <MenuItem
                            key={item.id || item.hospital_id}
                            value={item.id ?? item.hospital_id}
                          >
                            {item.name || item.hospital_Name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="w3review"
                      name="discussionNotes"
                      rows="4"
                      cols="50"
                      className="form-control"
                      component="textarea"
                      placeholder="Note"
                      onChange={(e) => setNote(e.target.value)}
                      value={note}
                    />
                    <span style={{ color: "red" }}>
                      {appointErr && !note ? "*Please Enter Your  note" : ""}
                    </span>
                  </div>
                  <div className="field-set">
                    <label>
                      Appointment Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="birthday"
                      name="date"
                      placeholder="Appointment Date"
                      className="form-control"
                      onChange={(e) => setDate(e.target.value)}
                      value={
                        date ? new Date(date).toISOString().split("T")[0] : ""
                      }
                      min={new Date().toISOString().split("T")[0]}
                    />

                    <span style={{ color: "red" }}>
                      {appointErr && !date ? "*Please Enter Your date" : ""}
                    </span>
                  </div>
                  <div className="field-set">
                    <label>
                      Appointment Time<span className="text-danger">*</span>
                    </label>
                    <input
                      type="time"
                      name="appointment_Time"
                      placeholder="Appointment Time"
                      className="form-control"
                      onChange={(e) => setAppointmentTime(e.target.value)}
                      value={appointmentTime}
                    />
                    <span style={{ color: "red" }}>
                      {appointErr && !appointmentTime
                        ? "*Please Select Appointment Time"
                        : ""}
                    </span>
                  </div>
                  {statuddropdown === "offline" ? (
                    <>
                      <div className="field-set">
                        <label>Pickup Time</label>
                        <input
                          type="time"
                          id="birthday"
                          name="pickup_time"
                          placeholder="pickup_time"
                          className="form-control"
                          onChange={(e) => setPickuptime(e.target.value)}
                          value={pickuptime}
                        />
                      </div>
                      <div className="field-set">
                        <label>Driver Name</label>
                        <input
                          type="text"
                          id="birthday"
                          name="driver_name"
                          placeholder="Driver Name"
                          className="form-control"
                          onChange={(e) => setDrivername(e.target.value)}
                          value={drivername}
                        />
                      </div>
                      <div className="field-set">
                        <label>
                          Driver Contact<span className="text-danger"></span>
                        </label>
                        <input
                          type="number"
                          id="birthday"
                          name="driver_contact"
                          placeholder="Driver Contact"
                          className="form-control"
                          onChange={(e) => setDrivercontact(e.target.value)}
                          value={drivercontact}
                        />
                      </div>
                      <div className="field-set">
                        <label>
                          Vehicle Number<span className="text-danger"></span>
                        </label>
                        <input
                          type="type"
                          id="birthday"
                          name="vehicle_no"
                          placeholder="Vehicle Number"
                          className="form-control"
                          onChange={(e) => setVehicalnumber(e.target.value)}
                          value={vehicalnumber}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <DialogActions className="submit-main">
                    {!edited && (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={(e) =>
                          statuddropdown === "offline"
                            ? handlesubmitAppoint(e)
                            : handlesubmitAppoint111(e)
                        }
                      >
                        Submit
                      </Button>
                    )}
                    {edited && (
                      <Button
                        type="button" // 🔥 IMPORTANT
                        variant="contained"
                        color="primary"
                        onClick={handleExtraButton}
                      >
                        Edit Appointment
                      </Button>
                    )}
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open2}
          onClose={handleClose2}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>
                {attendedeaisledit === true ? "Edit" : "Add"} Attendant Details
              </h6>
            </div>
            <div className="cross-icon" onClick={handleClose2}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form" className="contact-form">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="field-set">
                        <label>
                          Name<span className="text-danger">*</span>
                        </label>
                        <div className="upload-input">
                          <input
                            type="text"
                            name="attendant_fullname"
                            className="form-control"
                            value={filesData.attendant_fullname}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="field-set">
                        <label>
                          Attendant Relation
                          <span className="text-danger">*</span>
                        </label>
                        <div className="upload-input">
                          <input
                            type="text"
                            name="attendant_relation"
                            className="form-control"
                            value={filesData.attendant_relation}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="field-set">
                        <label>
                          Country<span className="text-danger">*</span>
                        </label>
                        <Autocomplete
                          options={Countries || []}
                          getOptionLabel={(option) => option?.name || ""}
                          value={
                            Countries?.find(
                              (country) => country.name === filesData.country,
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            setFilesData({
                              ...filesData,
                              country: newValue?.name || "",
                              dial_code: newValue?.dial_code || "",
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Country"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  padding: "0 !important",
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="field-set">
                        <label>
                          Attendant Contact
                          <span className="text-danger">*</span>
                        </label>

                        <div className="country-code">
                          <input
                            type="text"
                            className="form-control code-dial"
                            value={filesData.dial_code}
                            disabled
                          />

                          <input
                            type="text"
                            name="attendant_contact"
                            className="form-control code-in"
                            value={filesData.attendant_contact}
                            onKeyPress={handkekeypreees}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="field-set">
                        <label>
                          Attendant Id Proof
                          <span className="text-danger">
                            {attendedeaisledit === true ? "" : "*"}
                          </span>
                        </label>
                        <div className="upload-input">
                          <input
                            type="file"
                            multiple
                            accept="image/*,application/pdf"
                            className="form-control"
                            onChange={(e) =>
                              handleFileChange(e, "Attende_passport")
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="field-set">
                        <label>
                          Attendant Address
                          <span className="text-danger">*</span>
                        </label>
                        <div className="upload-input">
                          <input
                            type="text"
                            name="attendant_address"
                            className="form-control"
                            value={filesData.attendant_address}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <DialogActions className="submit-main">
                    {attendedeaisledit === true ? (
                      <Button
                        type="submit"
                        onClick={editatednde}
                        variant="contained"
                      >
                        Update
                      </Button>
                    ) : (
                      <Button onClick={handleKysDetail} variant="contained">
                        Submit
                      </Button>
                    )}
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={dataImperial}
          onClose={dataIwemperial}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Edit Hospital Charge</h6>
            </div>
            <div className="cross-icon" onClick={dataIwemperial}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Hospital Charge<span className="text-danger">*</span>
                    </label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        id="w3review"
                        type="number"
                        min="0"
                        step="any"
                        name="hospital_charge"
                        className="form-control code-in"
                        placeholder="Charge"
                        onChange={(e) =>
                          handleHospitalLumpChargeChange(
                            "hospital_charge",
                            e.target.value,
                          )
                        }
                        value={noteHospital2}
                      />
                    </div>
                  </div>
                  <div className="field-set">
                    <label>Discount (%)</label>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="any"
                      name="discount_percentage"
                      className="form-control"
                      placeholder="0-100"
                      onChange={(e) =>
                        handleHospitalLumpChargeChange(
                          "discount_percentage",
                          e.target.value,
                        )
                      }
                      value={hospitalLumpDiscount}
                    />
                  </div>
                  <div className="field-set">
                    <label>Final Amount</label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        name="final_amount"
                        className="form-control code-in"
                        placeholder="Final amount after discount"
                        onChange={(e) =>
                          handleHospitalLumpChargeChange(
                            "final_amount",
                            e.target.value,
                          )
                        }
                        value={hospitalLumpFinalAmount}
                      />
                    </div>
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      variant="contained"
                      onClick={() => {
                        handleNothospitalchargeesdata();
                      }}
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <ToastContainer />
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open5}
          onClose={handleClose5}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Notes</h6>
            </div>
            <div className="cross-icon" onClick={handleClose5}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="w3review"
                      name="discussionNotes"
                      rows="4"
                      cols="50"
                      className="form-control"
                      placeholder="Note"
                      onChange={(e) => setNote2(e.target.value)}
                      value={note2}
                    />
                    <span style={{ color: "red" }}>
                      {noteErr && !note2 ? "Please Enter Your  note" : ""}
                    </span>
                  </div>
                  <div className="field-set">
                    <label>Upload Images</label>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      className="form-control"
                      onChange={(e) => setImages([...e.target.files])}
                    />
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      variant="contained"
                      onClick={handleNotesdata}
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <ToastContainer />
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={editModalNotes}
          onClose={handleCloseEditModal}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Edit Notes</h6>
            </div>
            <div className="cross-icon" onClick={handleCloseEditModal}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              component="form"
              className="contact-form"
              onSubmit={(e) => {
                e.preventDefault();
                editNotes();
              }}
            >
              <div className="field-set">
                <label>
                  Notes<span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Note"
                  onChange={(e) => setNote2(e.target.value)}
                  value={note2}
                />
                <span style={{ color: "red" }}>
                  {noteErr && !note2 ? "Please Enter Your note" : ""}
                </span>
              </div>
              <div className="field-set">
                <label>Upload Images</label>

                <input
                  type="file"
                  multiple
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => setImages([...e.target.files])}
                />
              </div>
              <DialogActions className="submit-main">
                <Button type="submit" variant="contained">
                  Submit
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
        <ToastContainer />
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open32}
          onClose={handleclosePerforma}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Invoice</h6>
            </div>
            <div className="cross-icon" onClick={handleclosePerforma}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Add Performa Invoice<span className="text-danger"></span>
                    </label>
                    <input
                      type="file"
                      id="birthday"
                      name="perfomainvoice"
                      placeholder="Appointment Date"
                      className="form-control"
                      accept=".pdf,image/*"
                      onChange={AddpaymentOnchnage123}
                    />
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      // type="submit"
                      onClick={() => {
                        handleAddTritmentPaymenttestsubmit();
                      }}
                      variant="contained"
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={openPaymentmodal}
          onClose={handleClosepayment3}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Edit Amount</h6>
            </div>
            <div className="cross-icon" onClick={handleClosepayment3}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form
                  id="contact-form"
                  className="contact-form view-table-detail"
                >
                  <div className="field-set">
                    <label>
                      Paid To <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="paid_to"
                      value={data.paid_to}
                      onChange={handlefilechangechangeinput}
                    >
                      <option value="">Select</option>

                      {paidTo?.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="field-set">
                    <label>
                      Paid For <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="paid_for"
                      value={data.paid_for}
                      onChange={AddpaymentOnchnage}
                    >
                      <option value="">Select</option>

                      {datagetapiPaidto?.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="field-set">
                    <label>
                      Attach Invoice <span className="text-danger"></span>
                    </label>
                    <input
                      type="file"
                      multiple
                      className="form-control"
                      name="attachFile"
                      onChange={handleAttachFile11}
                    />
                  </div>

                  <div className="field-set">
                    <label>
                      Paid Amount<span className="text-danger">*</span>
                    </label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        placeholder="paid amount"
                        className="form-control"
                        onKeyPress={handleKeyPress}
                        name="paid_amount"
                        onChange={AddpaymentOnchnage}
                        value={getPaidAmountInputValue(data.paid_amount)}
                      />
                    </div>
                  </div>
                  {/* <div>{info.treatment_due_payment}</div> */}
                  <div className="field-set">
                    <label>
                      Payment Method<span className="text-danger">*</span>
                    </label>
                    <select
                      placeholder="payment Method"
                      className="form-control"
                      name="paymentMethod"
                      required=""
                      onChange={AddpaymentOnchnage}
                      value={data.paymentMethod}
                    >
                      <option>Select</option>
                      <option value="GOP">Guarantee of Payment</option>
                      <option value="Cash">Cash</option>
                      <option value="UPI">Online via UPI</option>
                      <option value="foundation">Foundation</option>
                      <option value="Internet banking">Internet banking</option>
                      <option value="Via Net Banking">Via Net Banking</option>
                      <option value="Credit/Debit Card">
                        Debit Card / Credit Card
                      </option>
                    </select>
                    {isGopPayment(data) && (
                      <small className="d-block mt-1" style={{ color: "#d97706", fontSize: "12px", fontWeight: 500 }}>
                        <i className="fa-solid fa-circle-info me-1"></i>
                        GOP payments are saved as <strong>Pending</strong> and will only reflect in Paid/Due totals once approved.
                      </small>
                    )}
                  </div>
                  <div className="field-set">
                    <label>
                      Payment Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="birthday"
                      name="payment_Date"
                      placeholder="Appointment Date"
                      className="form-control"
                      onChange={AddpaymentOnchnage}
                      value={data.payment_Date}
                      max={new Date().toISOString().split("T")[0]} // Prevent future date
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="notes"
                      className="form-control"
                      name="notes"
                      required=""
                      onChange={AddpaymentOnchnage}
                      value={data.notes}
                    />
                  </div>
                  <DialogActions className="submit-main">
                    <SubmitButton
                      onClick={handleUpdatePayment}
                      busyLabel={
                        <>
                          <i className="fa fa-spinner fa-spin me-1" />{" "}
                          Submitting...
                        </>
                      }
                    >
                      Submit
                    </SubmitButton>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open3}
          onClose={handleClose3}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Amount</h6>
            </div>
            <div className="cross-icon" onClick={handleClose3}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form
                  id="contact-form"
                  className="contact-form view-table-detail"
                >
                  <div className="field-set">
                    <label>
                      Paid To <span className="text-danger">*</span>
                    </label>
                    <select
                      placeholder="payment Method"
                      className="form-control"
                      name="paid_to"
                      required
                      onChange={handlefilechangechangeinput}
                    >
                      <option>Select</option>
                      {paidTo.map((item, index) => {
                        return (
                          <>
                            <option value={item._id}>{item.name}</option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                  <div className="field-set">
                    <label>
                      Paid For <span className="text-danger">*</span>
                    </label>
                    <select
                      placeholder="payment Method"
                      className="form-control"
                      name="paid_for"
                      required
                      onChange={handlefilechange}
                    >
                      <option>Select</option>
                      {datagetapiPaidto.map((item, index) => {
                        return (
                          <>
                            <option value={item._id}>{item.name}</option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                  <div className="field-set">
                    <label>
                      Attach Invoice <span className="text-danger"></span>
                    </label>
                    <input
                      type="file"
                      multiple
                      className="form-control"
                      name="attachFile"
                      onChange={handleAttachFile}
                    />
                  </div>

                  <div className="field-set">
                    <label>
                      Paid Amount<span className="text-danger">*</span>
                    </label>
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        placeholder="paid amount"
                        className="form-control"
                        onKeyPress={handleKeyPress}
                        name="paid_amount"
                        onChange={AddpaymentOnchnage}
                        value={getPaidAmountInputValue(data.paid_amount)}
                      />
                    </div>
                  </div>
                  {/* <div>{info.treatment_due_payment}</div> */}
                  <div className="field-set">
                    <label>
                      Payment Method<span className="text-danger">*</span>
                    </label>
                    <select
                      placeholder="payment Method"
                      className="form-control"
                      name="paymentMethod"
                      required=""
                      onChange={AddpaymentOnchnage}
                      value={data.paymentMethod}
                    >
                      <option>Select</option>
                      <option value="GOP">Guarantee of Payment</option>
                      <option value="Cash">Cash</option>
                      <option value="UPI">Online via UPI</option>
                      <option value="foundation">Foundation</option>
                      <option value="Internet banking">Internet banking</option>
                      <option value="Via Net Banking">Via Net Banking</option>
                      <option value="Credit/Debit Card">
                        Debit Card / Credit Card
                      </option>
                    </select>
                    {isGopPayment(data) && (
                      <small className="d-block mt-1" style={{ color: "#d97706", fontSize: "12px", fontWeight: 500 }}>
                        <i className="fa-solid fa-circle-info me-1"></i>
                        GOP payments are saved as <strong>Pending</strong> and will only reflect in Paid/Due totals once approved.
                      </small>
                    )}
                  </div>
                  <div className="field-set">
                    <label>
                      Payment Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      id="birthday"
                      name="payment_Date"
                      placeholder="Appointment Date"
                      className="form-control"
                      onChange={AddpaymentOnchnage}
                      value={data.payment_Date}
                      max={new Date().toISOString().split("T")[0]} // Prevent future date
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="notes"
                      className="form-control"
                      name="notes"
                      required=""
                      onChange={AddpaymentOnchnage}
                      value={data.notes}
                    />
                  </div>
                  <DialogActions className="submit-main">
                    <SubmitButton
                      onClick={handleAddTritmentPayment}
                      busyLabel={
                        <>
                          <i className="fa fa-spinner fa-spin me-1" />{" "}
                          Submitting...
                        </>
                      }
                    >
                      Submit
                    </SubmitButton>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open10}
          onClose={handleClose10}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>{hAndleReport === true ? "Edit" : "Add"} Reports</h6>
            </div>
            <div className="cross-icon" onClick={handleClose10}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box view-table-detail">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <div id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Reports Title<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Report Title"
                      className="form-control"
                      name="reportTitle"
                      value={iniData.reportTitle}
                      onChange={handlefilechange}
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Reports{" "}
                      <span className="text-danger">
                        {hAndleReport === true ? "" : "*"}
                      </span>
                    </label>
                    <input
                      type="file"
                      multiple
                      className="form-control"
                      name="treatmentReport"
                      onChange={handleFileChange1}
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Treatment Report Date{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={
                        iniData?.treatment_report_date
                          ? iniData.treatment_report_date.split("T")[0]
                          : ""
                      }
                      name="treatment_report_date"
                      required
                      onChange={handlefilechange}
                    />
                  </div>

                  <DialogActions className="submit-main">
                    {hAndleReport === true ? (
                      <Button
                        // type="submit"
                        onClick={handleClickEditReport}
                        variant="contained"
                      >
                        Edit Report
                      </Button>
                    ) : (
                      <Button
                        // type="submit"
                        onClick={handleClickSubmit}
                        variant="contained"
                      >
                        Submit
                      </Button>
                    )}
                  </DialogActions>
                </div>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={openGuesthouse}
          onClose={handleCloseguesthouse}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>{isEditGuesthouse === false ? "Add" : "Edit"} Guest House</h6>
            </div>
            <div className="cross-icon" onClick={handleCloseguesthouse}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box view-table-detail">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <div id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Guest House Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder=" Guest House Name"
                      className="form-control"
                      name="guestHouseName"
                      value={formDataGuestHouse.guestHouseName}
                      onChange={handlechangeGuesthouse}
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Date Range From <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={
                        formDataGuestHouse?.dateRangeFrom
                          ? formDataGuestHouse.dateRangeFrom.split("T")[0]
                          : ""
                      }
                      name="dateRangeFrom"
                      required
                      onChange={handlechangeGuesthouse}
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Date Range To <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={
                        formDataGuestHouse?.dateRangeTo
                          ? formDataGuestHouse.dateRangeTo.split("T")[0]
                          : ""
                      }
                      name="dateRangeTo"
                      required
                      onChange={handlechangeGuesthouse}
                    />
                  </div>

                  <div className="field-set">
                    <label>
                      Number Of Rooms<span className="text-danger">*</span>
                    </label>
                    <div className="upload-input">
                      <input
                        type="text"
                        className="form-control"
                        name="numberOfRooms"
                        value={formDataGuestHouse.numberOfRooms}
                        onKeyPress={handkekeypreees}
                        onChange={handlechangeGuesthouse}
                      />
                    </div>

                    <div className="field-set">
                      <label>
                        Payment Amount<span className="text-danger">*</span>
                      </label>
                      <div className="upload-input">
                        <div className="fixpricee">
                          <p className="code-dial">USD($)</p>
                          <input
                            type="number"
                            min="0"
                            className="form-control code-in"
                            name="paymentAmount"
                            value={getPaidAmountInputValue(
                              formDataGuestHouse.paymentAmount,
                            )}
                            onKeyPress={handkekeypreees}
                            onChange={handlechangeGuesthouse}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="field-set">
                      <label>Discount (%)</label>
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="any"
                        className="form-control"
                        name="discount_percentage"
                        value={getPaidAmountInputValue(
                          formDataGuestHouse.discount_percentage,
                        )}
                        onChange={handlechangeGuesthouse}
                        placeholder="0-100"
                      />
                    </div>
                    <div className="field-set">
                      <label>Final Amount</label>
                      <div className="fixpricee">
                        <p className="code-dial">USD($)</p>
                        <input
                          type="number"
                          min="0"
                          step="any"
                          className="form-control code-in"
                          name="final_amount"
                          value={getPaidAmountInputValue(
                            formDataGuestHouse.final_amount,
                          )}
                          onChange={handlechangeGuesthouse}
                        />
                      </div>
                    </div>
                    <div className="field-set">
                      <label>
                        Payment Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={
                          formDataGuestHouse?.paymentDate
                            ? formDataGuestHouse.paymentDate.split("T")[0]
                            : ""
                        }
                        name="paymentDate"
                        required
                        onChange={handlechangeGuesthouse}
                      />
                    </div>
                    <div className="field-set">
                      <label>
                        Notes <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formDataGuestHouse?.notes}
                        name="notes"
                        required
                        onChange={handlechangeGuesthouse}
                      />
                    </div>

                    <div className="field-set">
                      <label>
                        Invoice File <span className="text-danger"></span>
                      </label>
                      <input
                        type="file"
                        placeholder="payment Method"
                        multiple
                        className="form-control"
                        name="invoiceFile"
                        required
                        onChange={handlechangeGuesthouse}
                      />
                    </div>
                  </div>

                  <DialogActions className="submit-main">
                    {isEditGuesthouse === true ? (
                      <SubmitButton
                        onClick={handleClickGuesthuseedit}
                        busyLabel={
                          <>
                            <i className="fa fa-spinner fa-spin me-1" />{" "}
                            Submitting...
                          </>
                        }
                      >
                        Edit Guest House
                      </SubmitButton>
                    ) : (
                      <SubmitButton
                        onClick={submitGuestHouseApi}
                        busyLabel={
                          <>
                            <i className="fa fa-spinner fa-spin me-1" />{" "}
                            Submitting...
                          </>
                        }
                      >
                        Add Guest House
                      </SubmitButton>
                    )}
                  </DialogActions>
                </div>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={editPatientProfile}
          onClose={EditButtoneditprofileClose}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Upload Profile</h6>
            </div>
            <div className="cross-icon" onClick={EditButtoneditprofileClose}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <div id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Profile <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      placeholder="payment Method"
                      className="form-control"
                      name="patient_Profile"
                      accept="image/*"
                      required
                      onChange={handleFileChange12}
                    />
                  </div>

                  <DialogActions className="submit-main">
                    <Button
                      // type="submit"
                      onClick={() => handleupdateProfile()}
                      variant="contained"
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </div>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={openmodalCharge}
          onClose={handleclickclosecharge}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>{isEditT === true ? "Edit" : "Add"} Hospital Charge</h6>
            </div>
            <div className="cross-icon" onClick={handleclickclosecharge}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <div className="field-set">
                  <label>
                    Service Name<span className="text-danger"></span>
                  </label>
                  <div className="upload-input">
                    <input
                      type="text"
                      className="form-control"
                      name="service_name"
                      value={hospitalCharge.service_name}
                      onChange={addhospitalChare}
                    />
                  </div>
                </div>
                <div className="field-set">
                  <label>
                    Price<span className="text-danger"></span>
                  </label>
                  <div className="upload-input">
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        className="form-control code-in"
                        name="price"
                        value={getPaidAmountInputValue(hospitalCharge.price)}
                        onKeyPress={handkekeypreees}
                        onChange={addhospitalChare}
                      />
                    </div>
                  </div>
                </div>
                <div className="field-set">
                  <label>Discount (%)</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="any"
                    className="form-control"
                    name="discount_percentage"
                    value={getPaidAmountInputValue(
                      hospitalCharge.discount_percentage,
                    )}
                    onChange={addhospitalChare}
                    placeholder="0-100"
                  />
                </div>
                <div className="field-set">
                  <label>Final Price</label>
                  <div className="fixpricee">
                    <p className="code-dial">USD($)</p>
                    <input
                      type="number"
                      min="0"
                      step="any"
                      className="form-control code-in"
                      name="final_price"
                      value={getPaidAmountInputValue(
                        hospitalCharge.final_price,
                      )}
                      onChange={addhospitalChare}
                    />
                  </div>
                </div>
                <div className="field-set">
                  <label>
                    Date<span className="text-danger"></span>
                  </label>
                  <div className="upload-input">
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={hospitalCharge.date || ""}
                      onChange={addhospitalChare}
                    />
                  </div>
                </div>
                <DialogActions className="submit-main">
                  {isEditT === true ? (
                    <Button
                      onClick={addchargeapiHedithspital}
                      variant="contained"
                    >
                      Edit Charge
                    </Button>
                  ) : (
                    <Button onClick={addchargeapiHospital} variant="contained">
                      Submit
                    </Button>
                  )}
                </DialogActions>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={openPharmacyModal}
          onClose={handleclickpcloseacycharge}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>{pharmacyadd === true ? "Edit" : "Add"} Pharmacy Charge</h6>
            </div>
            <div className="cross-icon" onClick={handleclickpcloseacycharge}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <div className="field-set">
                  <label>
                    Pharmacy Name<span className="text-danger"></span>
                  </label>
                  <div className="upload-input">
                    <input
                      type="text"
                      className="form-control"
                      name="service_name"
                      value={pharmacyvalue.service_name}
                      onChange={addhosppharmacyhare}
                    />
                  </div>
                </div>
                <div className="field-set">
                  <label>
                    Price<span className="text-danger"></span>
                  </label>
                  <div className="upload-input">
                    <div className="fixpricee">
                      <p className="code-dial">USD($)</p>
                      <input
                        type="number"
                        min="0"
                        step="any"
                        className="form-control code-in"
                        name="price"
                        value={getPaidAmountInputValue(pharmacyvalue.price)}
                        onKeyPress={handkekeypreees}
                        onChange={addhosppharmacyhare}
                      />
                    </div>
                  </div>
                </div>
                <div className="field-set">
                  <label>Discount (%)</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="any"
                    className="form-control"
                    name="discount_percentage"
                    value={getPaidAmountInputValue(
                      pharmacyvalue.discount_percentage,
                    )}
                    onChange={addhosppharmacyhare}
                    placeholder="0-100"
                  />
                </div>
                <div className="field-set">
                  <label>Final Price</label>
                  <div className="fixpricee">
                    <p className="code-dial">USD($)</p>
                    <input
                      type="number"
                      min="0"
                      step="any"
                      className="form-control code-in"
                      name="final_price"
                      value={getPaidAmountInputValue(
                        pharmacyvalue.final_price,
                      )}
                      onChange={addhosppharmacyhare}
                    />
                  </div>
                </div>
                <div className="field-set">
                  <label>
                    Date<span className="text-danger"></span>
                  </label>
                  <div className="upload-input">
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={pharmacyvalue.date || ""}
                      onChange={addhosppharmacyhare}
                    />
                  </div>
                </div>
                <DialogActions className="submit-main">
                  {pharmacyadd === true ? (
                    <Button onClick={editpaharmacy} variant="contained">
                      Edit Charge
                    </Button>
                  ) : (
                    <Button onClick={addchargeapipharmacy} variant="contained">
                      Submit
                    </Button>
                  )}
                </DialogActions>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={notesModal}
          onClose={handleCloseNotesmodal}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Edit Notes</h6>
            </div>
            <div className="cross-icon" onClick={handleCloseNotesmodal}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <div className="upload-input">
                      <input
                        type="text"
                        className="form-control"
                        name="note"
                        value={nodaestInput.note}
                        onChange={handlechangenotesdata}
                      />
                    </div>
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      onClick={(e) => handleKysDetailnotes(e)}
                      variant="contained"
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={popupopenattande}
          onClose={handlecliclosepup}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Assign Attendant</h6>
            </div>
            <div className="cross-icon" onClick={handlecliclosepup}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form" className="contact-form">
                  <div className="field-set">
                    <label>
                      Select Attendent<span className="text-danger">*</span>
                    </label>
                    <div className="upload-input">
                      <Autocomplete
                        multiple
                        options={attandantnew}
                        disableCloseOnSelect
                        getOptionLabel={(option) =>
                          option.attendant_fullname || ""
                        }
                        onChange={(event, newValue) => {
                          const ids = newValue.map((item) => item._id); // 👈 extract _id
                          setSelectedAttendants(ids); // 👈 sirf IDs store
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              checked={selected}
                              style={{ marginRight: 8 }}
                            />
                            {option.attendant_fullname}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Attendants" />
                        )}
                      />
                    </div>
                  </div>
                  <DialogActions className="submit-main">
                    <Button onClick={handleassignAtendent} variant="contained">
                      Submit
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open4}
          onClose={handleClose4}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Doctor Review</h6>
            </div>
            <div className="cross-icon" onClick={handleClose4}>
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="contact-form">
                  <div className="field-set">
                    <label>
                      Subject<span className="text-danger">*</span>
                    </label>
                    <input
                      id=""
                      name="Title"
                      onChange={handleRecommendTitle}
                      className="form-control"
                      value={Title}
                      placeholder="Subject"
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Review Notes<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="w3review"
                      name="discussionNotes"
                      rows="4"
                      cols="50"
                      className="form-control"
                      placeholder="Review"
                      onChange={handleNoteChange}
                      value={note}
                    />
                    <span style={{ color: "red" }}>
                      {blogErr && !note ? "Please Enter Your  note" : ""}
                    </span>
                  </div>
                  <div className="field-set">
                    <label>Upload Images</label>
                    <input
                      type="file"
                      className="form-control"
                      multiple
                      onChange={handleImageChange}
                      name="upload_image"
                      id=""
                    />
                  </div>
                  <div className="field-set">
                    <label>
                      Recommendations<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id=""
                      name="recommend"
                      rows="4"
                      cols="50"
                      onChange={handleRecommendChange}
                      className="form-control"
                      value={recommend}
                      placeholder="Recommendations"
                    />
                  </div>
                  {/* <div className="field-set">
                    <label>
                      Subject<span className="text-danger">*</span>
                    </label>
                    <input
                      id=""
                      name="Title"
                      rows="4"
                      cols="50"
                      onChange={handleRecommendTitle}
                      className="form-control"
                      value={Title}
                      placeholder="Subject"
                    />
                  </div> */}
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      variant="contained"
                      onClick={handleNotesdataqw}
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <ToastContainer />
      </React.Fragment>
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={openEnquiryNotes}
          onClose={handleCloseEnquiryNotes}
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Create Notes</h6>
            </div>
            <div className="cross-icon" onClick={handleCloseEnquiryNotes}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="main-box">
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "fit-content",
              }}
              className="contact-form"
            >
              <Box>
                <form id="enquiry-notes-form">
                  <div className="field-set">
                    <label>
                      Notes<span className="text-danger">*</span>
                    </label>
                    <textarea
                      name="discussionNotes"
                      rows="4"
                      cols="50"
                      className="form-control"
                      placeholder="Note"
                      onChange={(e) => setNote(e.target.value)}
                      value={note}
                    />
                    <span style={{ color: "red" }}>
                      {blogErr && !note ? "Please Enter Your  note" : ""}
                    </span>
                  </div>
                  <div className="field-set">
                    <label>
                      Date<span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      name="date"
                      placeholder="Date"
                      className="form-control"
                      onChange={(e) => setDate(e.target.value)}
                      value={date || ""}
                      min={new Date().toISOString().split("T")[0]}
                    />
                    <span style={{ color: "red" }}>
                      {blogErr && !date ? "Please Enter Your  date" : ""}
                    </span>
                  </div>
                  <DialogActions className="submit-main">
                    <Button
                      type="submit"
                      variant="contained"
                      onClick={handleEnquiryNotesSubmit}
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </form>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <ToastContainer />
      </React.Fragment>
      <React.Fragment>
        <Dialog
          open={openAppointment}
          onClose={handleCloseAppointment}
          fullWidth
          maxWidth="sm"
        >
          <div className="main-card-header">
            <div className="note-hd">
              <h6>Add Appointment</h6>
            </div>
            <div className="cross-icon" onClick={handleCloseAppointment}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <DialogContent className="view-table-detail">
            <Box className="contact-form">
              <div className="field-set mb-2">
                <FormControl fullWidth size="small">
                  <label>Select Hospital</label>
                  <Select
                    value={appointmentData.hospital_id || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;

                      const selectedHospital = hospitalList.find(
                        (item) => item.id === selectedId,
                      );

                      setAppointmentData((prev) => ({
                        ...prev,
                        hospital_id: selectedId,
                        hospitalName: selectedHospital?.name || "",
                        hospital_email: selectedHospital?.email || "",
                      }));
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250,
                        },
                      },
                    }}
                  >
                    {hospitalList.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="field-set">
                <label>Health Issue</label>
                <input
                  type="text"
                  name="health_issue"
                  className="form-control"
                  value={appointmentData.health_issue}
                  onChange={handleAppointmentChange}
                />
              </div>
              <div className="field-set">
                <label>Date</label>
                <span className="text-danger">*</span>
                <input
                  type="date"
                  name="appointment_Date"
                  className="form-control"
                  value={appointmentData.appointment_Date}
                  onChange={handleAppointmentChange}
                />
              </div>
              <div className="field-set">
                <label>Time</label>
                <span className="text-danger">*</span>
                <input
                  type="time"
                  name="appointment_Time"
                  className="form-control"
                  value={appointmentData.appointment_Time}
                  onChange={handleAppointmentChange}
                />
              </div>
              <div className="field-set">
                <label>Notes</label>
                <span className="text-danger">*</span>
                <textarea
                  name="Notes"
                  className="form-control"
                  value={appointmentData.Notes}
                  onChange={handleAppointmentChange}
                />
              </div>
              <div className="field-set">
                <label>
                  Upload Reports / Documents{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  multiple
                  onChange={(e) => {
                    const files = Array.from(e.target.files);
                    setImages(files);
                  }}
                />
                {images.length > 0 && (
                  <div style={{ marginTop: "10px" }}>
                    {images.map((file, index) => (
                      <div key={index} style={{ fontSize: "12px" }}>
                        📄 {file.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <DialogActions className="submit-main">
                <Button onClick={handleCloseAppointment}>Cancel</Button>
                <Button variant="contained" onClick={handleSubmitAppointment}>
                  Submit
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Dynamic PDF Details & Generation Modal */}
        <Dialog
          open={pdfModalOpen}
          onClose={() => setPdfModalOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            },
          }}
        >
          {/* Header Bar */}
          <div
            style={{
              background: "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
              color: "#ffffff",
              padding: "16px 24px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                }}
              >
                📄
              </div>
              <div>
                <h6
                  style={{
                    margin: 0,
                    fontWeight: "700",
                    fontSize: "16px",
                    color: "#ffffff",
                    letterSpacing: "0.3px",
                  }}
                >
                  Dynamic PDF Details Form — {pdfType}
                </h6>
                <small style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px" }}>
                  Patient: {pdfFormData.patient_name || "N/A"}
                  {pdfTreatmentPlanId ? ` · Plan: ${pdfTreatmentPlanId}` : ""}
                </small>
              </div>
            </div>

            {/* Switcher & Close */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  backgroundColor: "rgba(255,255,255,0.15)",
                  padding: "4px",
                  borderRadius: "20px",
                  display: "flex",
                  gap: "4px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{
                    borderRadius: "16px",
                    padding: "4px 14px",
                    fontSize: "12px",
                    fontWeight: "600",
                    border: "none",
                    backgroundColor: pdfActiveTab === "form" ? "#ffffff" : "transparent",
                    color: pdfActiveTab === "form" ? "#0369a1" : "#ffffff",
                    boxShadow: pdfActiveTab === "form" ? "0 2px 4px rgba(0,0,0,0.1)" : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => setPdfActiveTab("form")}
                >
                  <i className="fa fa-edit me-1"></i> Edit Form
                </button>
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{
                    borderRadius: "16px",
                    padding: "4px 14px",
                    fontSize: "12px",
                    fontWeight: "600",
                    border: "none",
                    backgroundColor: pdfActiveTab === "preview" ? "#ffffff" : "transparent",
                    color: pdfActiveTab === "preview" ? "#0369a1" : "#ffffff",
                    boxShadow: pdfActiveTab === "preview" ? "0 2px 4px rgba(0,0,0,0.1)" : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => setPdfActiveTab("preview")}
                >
                  <i className="fa fa-eye me-1"></i> Live Preview
                </button>
              </div>

              <button
                type="button"
                onClick={() => setPdfModalOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#ffffff",
                  fontSize: "20px",
                  cursor: "pointer",
                  opacity: 0.85,
                  lineHeight: "1",
                }}
                title="Close"
              >
                ✕
              </button>
            </div>
          </div>

          <DialogContent
            style={{
              padding: "24px",
              backgroundColor: "#f8fafc",
              maxHeight: "72vh",
            }}
          >
            {pdfLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading details...</span>
                </div>
                <p className="mt-2 text-muted fw-semibold">Fetching PDF details...</p>
              </div>
            ) : pdfActiveTab === "form" ? (
              <form>
                {/* Card 1: General & Patient Info */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    padding: "18px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "16px",
                      color: "#0284c7",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#e0f2fe",
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                      }}
                    >
                      1
                    </span>
                    General & Patient Info
                  </div>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="date"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.date}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 14-Aug-2026"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Patient Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="patient_name"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.patient_name}
                        onChange={handlePdfInputChange}
                        placeholder="Patient full name"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Patient Age
                      </label>
                      <input
                        type="text"
                        name="patient_age"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.patient_age}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 45"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Hospital Name
                      </label>
                      <input
                        type="text"
                        name="hospital_name"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.hospital_name}
                        onChange={handlePdfInputChange}
                        placeholder="Hospital Name"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Hospital Location
                      </label>
                      <input
                        type="text"
                        name="hospital_location"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.hospital_location}
                        onChange={handlePdfInputChange}
                        placeholder="Location, Country"
                      />
                    </div>
                  </div>
                </div>

                {/* Card 2: Medical Details */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    padding: "18px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "16px",
                      color: "#0284c7",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#e0f2fe",
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                      }}
                    >
                      2
                    </span>
                    Medical Details
                  </div>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Diagnosis
                      </label>
                      <input
                        type="text"
                        name="diagnosis"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.diagnosis}
                        onChange={handlePdfInputChange}
                        placeholder="Patient diagnosis"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Treatment / Surgery
                      </label>
                      <input
                        type="text"
                        name="treatment_surgery"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.treatment_surgery}
                        onChange={handlePdfInputChange}
                        placeholder="Procedure / Treatment"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Treating Doctor
                      </label>
                      <input
                        type="text"
                        name="treating_doctor"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.treating_doctor}
                        onChange={handlePdfInputChange}
                        placeholder="Doctor Name"
                      />
                    </div>
                  </div>
                </div>

                {/* Card 3: Costs & Duration Breakdown */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    padding: "18px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "16px",
                      color: "#0284c7",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#e0f2fe",
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                      }}
                    >
                      3
                    </span>
                    Costs & Duration Breakdown
                  </div>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Treatment Cost
                      </label>
                      <input
                        type="text"
                        name="treatment_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.treatment_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 5000 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Evaluation Cost
                      </label>
                      <input
                        type="text"
                        name="evaluation_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.evaluation_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 500 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Surgery Cost
                      </label>
                      <input
                        type="text"
                        name="surgery_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.surgery_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 4500 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Hospital Stay Duration
                      </label>
                      <input
                        type="text"
                        name="hospital_stay_duration"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.hospital_stay_duration}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 5 Days"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        India Stay Duration
                      </label>
                      <input
                        type="text"
                        name="india_stay_duration"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.india_stay_duration}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 14 Days"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Accommodation Cost
                      </label>
                      <input
                        type="text"
                        name="accommodation_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.accommodation_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 1000 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Guesthouse Cost
                      </label>
                      <input
                        type="text"
                        name="guesthouse_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.guesthouse_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 500 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Stretcher / Fligth ticket
                      </label>
                      <input
                        type="text"
                        name="air_ticket_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.air_ticket_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 800 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Medical Cost
                      </label>
                      <input
                        type="text"
                        name="medical_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.medical_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 200 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Physiotherapy Cost
                      </label>
                      <input
                        type="text"
                        name="physiotherapy_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.physiotherapy_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 300 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Medical Escort
                      </label>
                      <input
                        type="text"
                        name="medical_escort_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.medical_escort_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 300 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Other / Additional Costs
                      </label>
                      <input
                        type="text"
                        name="other_additional_costs"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.other_additional_costs}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 150 USD"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        SIM Card Cost
                      </label>
                      <input
                        type="text"
                        name="sim_card_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.sim_card_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. MUR 600 approx."
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Medif Cost
                      </label>
                      <input
                        type="text"
                        name="medif_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.medif_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. MUR 2,500."
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Transport Cost
                      </label>
                      <input
                        type="text"
                        name="transport_cost"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.transport_cost}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. 150 USD"
                      />
                    </div>
                    <div className="col-12 mt-3 pt-3 border-top d-flex justify-content-between align-items-center">
                      <span className="fw-bold text-secondary" style={{ fontSize: "13px" }}>Dynamic Summary:</span>
                      <span className="fw-bold text-primary mb-0" style={{ fontSize: "14px" }}>
                        The total estimated cost for treatment is {calculateTotalCost(pdfFormData, pdfType)}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Card 3.5: Remarks */}
                {pdfType !== "Foundation" && (
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "16px",
                        color: "#0284c7",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#e0f2fe",
                          width: "26px",
                          height: "26px",
                          borderRadius: "50%",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                        }}
                      >
                        3.5
                      </span>
                      Remarks
                    </div>
                    <div className="row g-3">
                      <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <label className="form-label small fw-semibold text-secondary mb-0">
                            Remarks (To be shown after Total Cost)
                          </label>
                          <span className="text-muted small" style={{ fontSize: "11px" }}>
                            {(pdfFormData.remark || "").length} / 200 characters
                          </span>
                        </div>
                        <textarea
                          name="remark"
                          className="form-control form-control-sm"
                          rows={3}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          maxLength={200}
                          value={pdfFormData.remark}
                          onChange={handlePdfInputChange}
                          placeholder="Enter any remarks to display on the PDF (max 200 characters)..."
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Card 3.6: Letter Paragraphs */}
                {pdfType === "Foundation" ? (
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "16px",
                        color: "#0284c7",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#e0f2fe",
                          width: "26px",
                          height: "26px",
                          borderRadius: "50%",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                        }}
                      >
                        3.6
                      </span>
                      Letter Paragraphs (Foundation PDF)
                    </div>
                    <div className="row g-3">
                      <div className="col-12">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Paragraph 1 (QR Contributions Intro)
                        </label>
                        <textarea
                          name="paragraph_1"
                          className="form-control form-control-sm"
                          rows={2}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          value={pdfFormData.paragraph_1}
                          onChange={handlePdfInputChange}
                          placeholder="All contributions in support of this treatment can be made securely by scanning the QR Code provided:"
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Paragraph 2 (Prayers & Support Note)
                        </label>
                        <textarea
                          name="paragraph_2"
                          className="form-control form-control-sm"
                          rows={2}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          value={pdfFormData.paragraph_2}
                          onChange={handlePdfInputChange}
                          placeholder="We humbly seek your prayers & support to enable..."
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "16px",
                        color: "#0284c7",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#e0f2fe",
                          width: "26px",
                          height: "26px",
                          borderRadius: "50%",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                        }}
                      >
                        3.6
                      </span>
                      Letter Paragraphs & Disclaimers
                    </div>
                    <div className="row g-3">
                      <div className="col-12">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Paragraph 1 (Intro Arrangements)
                        </label>
                        <textarea
                          name="paragraph_1"
                          className="form-control form-control-sm"
                          rows={2}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          value={pdfFormData.paragraph_1}
                          onChange={handlePdfInputChange}
                          placeholder="Overseas Medical Care Assistance Ltd is facilitating all necessary arrangements..."
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Paragraph 2 (Breakdown Intro)
                        </label>
                        <textarea
                          name="paragraph_2"
                          className="form-control form-control-sm"
                          rows={2}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          value={pdfFormData.paragraph_2}
                          onChange={handlePdfInputChange}
                          placeholder="Below is a breakdown of the estimated costs associated with the medical travel:"
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Paragraph 3 (Estimates Notice)
                        </label>
                        <textarea
                          name="paragraph_3"
                          className="form-control form-control-sm"
                          rows={2}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          value={pdfFormData.paragraph_3}
                          onChange={handlePdfInputChange}
                          placeholder="These estimates are subject to change based on further evaluation..."
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Paragraph 4 (Collection of Funds Disclaimer)
                        </label>
                        <textarea
                          name="paragraph_4"
                          className="form-control form-control-sm"
                          rows={2}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          value={pdfFormData.paragraph_4}
                          onChange={handlePdfInputChange}
                          placeholder="Please be advised that this letter is not intended for the collection of funds."
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Paragraph 5 (Inquiries / Contact)
                        </label>
                        <textarea
                          name="paragraph_5"
                          className="form-control form-control-sm"
                          rows={2}
                          style={{
                            borderRadius: "6px",
                            borderColor: "#cbd5e1",
                            padding: "8px 12px",
                            fontSize: "13px",
                          }}
                          value={pdfFormData.paragraph_5}
                          onChange={handlePdfInputChange}
                          placeholder="For any further inquiries, please feel free to contact our office..."
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Card 4: Signatory & Authorization */}
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    padding: "18px 20px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "16px",
                      color: "#0284c7",
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: "#e0f2fe",
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                      }}
                    >
                      4
                    </span>
                    Signatory & Authorization
                  </div>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Signatory Name
                      </label>
                      <input
                        type="text"
                        name="signatory_name"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.signatory_name}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. Zaheerah Peerbacus"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">
                        Designation
                      </label>
                      <input
                        type="text"
                        name="designation"
                        className="form-control form-control-sm"
                        style={{
                          borderRadius: "6px",
                          borderColor: "#cbd5e1",
                          padding: "6px 10px",
                        }}
                        value={pdfFormData.designation}
                        onChange={handlePdfInputChange}
                        placeholder="e.g. Medical Coordinator"
                      />
                    </div>
                  </div>
                </div>

                {/* Card 5: Estimate Cost Details (Foundation and Private each store their own list) */}
                {(pdfType === "Foundation" || pdfType === "Private") && (
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "16px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          color: "#0284c7",
                          fontWeight: "700",
                          fontSize: "14px",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor: "#e0f2fe",
                            width: "26px",
                            height: "26px",
                            borderRadius: "50%",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                          }}
                        >
                          5
                        </span>
                        Estimate Cost Details
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => {
                          setPdfFormData((prev) => ({
                            ...prev,
                            estimate_cost_details: [
                              ...(prev.estimate_cost_details || []),
                              { description: "" }
                            ]
                          }));
                        }}
                        style={{ borderRadius: "6px" }}
                      >
                        + Add Row
                      </button>
                    </div>

                    <div className="row g-2">
                      {(pdfFormData.estimate_cost_details || []).map((detail, index) => (
                        <div className="col-12 d-flex align-items-center gap-2" key={index}>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={detail.description || ""}
                            placeholder="e.g. Cost of immunotherapy: USD 2500 approx."
                            onChange={(e) => {
                              const newDetails = [...(pdfFormData.estimate_cost_details || [])];
                              newDetails[index] = { ...newDetails[index], description: e.target.value };
                              setPdfFormData((prev) => ({
                                ...prev,
                                estimate_cost_details: newDetails
                              }));
                            }}
                            style={{ borderRadius: "6px", borderColor: "#cbd5e1" }}
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => {
                              const newDetails = (pdfFormData.estimate_cost_details || []).filter((_, i) => i !== index);
                              setPdfFormData((prev) => ({
                                ...prev,
                                estimate_cost_details: newDetails
                              }));
                            }}
                            style={{ borderRadius: "6px" }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      ))}
                      {(pdfFormData.estimate_cost_details || []).length === 0 && (
                        <p className="text-muted small text-center my-2">No estimate cost details added. Click "+ Add Row" to add.</p>
                      )}
                    </div>
                  </div>
                )}

                {/* Card 6: QR Code Setup (Visible only when pdfType !== "Private") */}
                {pdfType !== "Private" && (
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e2e8f0",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "16px",
                        color: "#0284c7",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#e0f2fe",
                          width: "26px",
                          height: "26px",
                          borderRadius: "50%",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                        }}
                      >
                        6
                      </span>
                      QR Code Configuration
                    </div>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label small fw-semibold text-secondary mb-1">
                          Upload QR Code Image <span className="text-danger">*</span>
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control form-control-sm"
                          onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                              const file = e.target.files[0];
                              setPdfFormData((prev) => ({
                                ...prev,
                                qr_code: file
                              }));
                            }
                          }}
                          style={{ borderRadius: "6px", borderColor: "#cbd5e1" }}
                        />
                      </div>
                      <div className="col-md-6 text-center">
                        <label className="form-label small fw-semibold text-secondary mb-1 d-block">
                          QR Code Preview
                        </label>
                        {pdfFormData.qr_code ? (
                          <div style={{ display: "inline-block", border: "2px solid #cbd5e1", borderRadius: "8px", padding: "6px", backgroundColor: "#fff" }}>
                            <img
                              src={getQrCodeSrc()}
                              alt="QR Code"
                              style={{ width: "110px", height: "110px", objectFit: "contain" }}
                            />
                          </div>
                        ) : (
                          <span className="text-muted small">No QR Code uploaded yet. Using default placeholder.</span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </form>
            ) : (
              /* Live Preview of formatted PDF template */
              <div
                className="pdf-preview-wrapper p-3 border rounded bg-light"
                style={{ overflowX: "auto" }}
              >
                <div
                  style={{
                    width: "100%",
                    maxWidth: "780px",
                    margin: "0 auto",
                    backgroundColor: "#fff",
                    boxShadow: "0 0 12px rgba(0,0,0,0.15)",
                  }}
                >
                  {/* Foundation Layout - OMCA Foundation Certification */}
                  {pdfType === "Foundation" ? (
                    <div
                      style={{
                        position: "relative",
                        padding: "95px 45px 45px 45px",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "13.5px",
                        color: "#222",
                        lineHeight: "1.45",
                        backgroundColor: "#fff",
                        backgroundImage: `url(${base64FoundationLetterhead || omcaFoundationLetterhead})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center top",
                        backgroundSize: "100% 100%",
                        minHeight: "1100px",
                      }}
                    >
                      {/* Date */}
                      <div style={{ fontWeight: "bold", fontSize: "13.5px", color: "#111", marginBottom: "8px" }}>
                        Date: {pdfFormData.date || "29th September 2025"}
                      </div>

                      {/* Subject Title */}
                      <h4
                        style={{
                          fontWeight: "bold",
                          fontSize: "15px",
                          color: "#000",
                          marginBottom: "10px",
                          display: "inline-block",
                          borderBottom: "2px solid #000",
                          paddingBottom: "4px",
                          textDecoration: "none",
                        }}
                      >
                        Subject: Certification of Medical Treatment Plan – {getPatientHonorific(pdfFormData.gender || ispatient?.gender)}
                        {pdfFormData.patient_name || "Issur Pravesh"}
                      </h4>

                      {/* Opening Paragraph */}
                      <p style={{ marginBottom: "8px", textAlign: "justify", fontSize: "13.5px" }}>
                        This is an urgent appeal for contributions to support{" "}
                        <strong>{getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Issur Pravesh"}</strong>
                        {pdfFormData.patient_age ? `, ${pdfFormData.patient_age} years of age` : ""}
                        , holder of identification number{" "}
                        <strong>I010202001275D</strong>, who is scheduled to travel to{" "}
                        <strong>{pdfFormData.hospital_name || "Signature Hospital"}</strong>
                        {pdfFormData.hospital_location ? `, ${pdfFormData.hospital_location}` : ""} for urgent medical care.
                      </p>

                      <p style={{ marginBottom: "6px", fontSize: "13.5px" }}>
                        Following medical evaluation, the treatment plan for {getPatientHonorific(pdfFormData.gender || ispatient?.gender)}
                        {pdfFormData.patient_name || "Issur Pravesh"} includes:
                      </p>

                      {/* Bulleted List */}
                      <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "10px", fontSize: "13px", lineHeight: "1.5" }}>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Diagnosis :</strong> {pdfFormData.diagnosis || "Case of Bilateral Emphysematous Bullae with Left Pneumothorax"}
                        </li>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Treatment:</strong> {pdfFormData.treatment_surgery || "Evaluation Followed by Thoracotomy + Left Lung Bullectomy +/- Left Upper Lobectomy Surgery"}
                        </li>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Treating Specialist:</strong> {pdfFormData.treating_doctor || "Dr. Harish Verma"}
                        </li>
                        {pdfFormData.treatment_cost && (
                          <li style={{ marginBottom: "4px" }}>
                            <strong>Treatment Cost:</strong> {pdfFormData.treatment_cost}
                          </li>
                        )}
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Estimated Cost of Evaluation:</strong> {pdfFormData.evaluation_cost || "MUR 46,000"}
                        </li>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Estimated Cost of Surgery:</strong> {pdfFormData.surgery_cost || "MUR 253,000"}
                        </li>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Estimated Duration of Stay in India:</strong> {pdfFormData.india_stay_duration || "6-7 weeks"} (Hospital Stay: {pdfFormData.hospital_stay_duration || "5 Days"})
                        </li>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Accommodation Cost (Including Transport & Meal Costs):</strong> {pdfFormData.accommodation_cost || "MUR 135,000"}
                        </li>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Airfare*2:</strong> {pdfFormData.air_ticket_cost || "MUR 80,000"} (Note: Airfare is subject to change based on availability)
                        </li>
                        <li style={{ marginBottom: "4px" }}>
                          <strong>Contingencies:</strong> {pdfFormData.other_additional_costs || "MUR 150,000"}
                        </li>
                        {pdfFormData.medical_escort_cost && (
                          <li style={{ marginBottom: "4px" }}>
                            <strong>Medical Escort Cost:</strong> {pdfFormData.medical_escort_cost}
                          </li>
                        )}
                      </ul>

                      {/* Total Amount Line */}
                      <p style={{ fontWeight: "bold", fontSize: "13.5px", color: "#000", marginBottom: "8px" }}>
                        The Total Amount Required for {getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Pravesh"}’s Medical Treatment & Associated Expenses is {calculateTotalCost(pdfFormData, pdfType) || "MUR 664,000"}
                      </p>
                      {pdfFormData.estimate_cost_details && pdfFormData.estimate_cost_details.length > 0 ? (
                        <>
                          <p style={{ fontWeight: "bold", fontSize: "13.5px", color: "#000", marginBottom: "4px" }}>
                            The total estimated cost for treatment is :
                          </p>
                          <ul style={{ listStyleType: "none", paddingLeft: "0px", marginTop: "4px", marginBottom: "8px", fontWeight: "bold", fontSize: "13.5px" }}>
                            {pdfFormData.estimate_cost_details.map((detail, idx) => (
                              <li key={idx} style={{ marginBottom: "2px" }}>
                                {idx + 1}. {detail.description}
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : (
                        <p style={{ fontWeight: "bold", fontSize: "13.5px", color: "#000", marginBottom: "8px" }}>
                          The total estimated cost for treatment is {calculateTotalCost(pdfFormData, pdfType) || "MUR 664,000"}
                        </p>
                      )}


                      {/* QR Scanner Intro Line */}
                      {pdfFormData.paragraph_1 && pdfFormData.paragraph_1.trim() !== "" && (
                        <p style={{ fontWeight: "bold", fontSize: "13px", color: "#000", marginBottom: "8px" }}>
                          {pdfFormData.paragraph_1}
                        </p>
                      )}
                      {/* Scanner Box & Bank Info Container (Table Layout for visual consistency and parity) */}
                      <table style={{ width: "100%", borderCollapse: "collapse", border: "none", marginBottom: "12px" }}>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: "top", width: "135px", padding: 0 }}>
                              {/* Red Frame Box for Scanner */}
                              <div
                                style={{
                                  border: "3px solid #e50914",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                  width: "135px",
                                  textAlign: "center",
                                  backgroundColor: "#fff",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                }}
                              >
                                <div style={{ padding: "8px" }}>
                                  <img
                                    src={base64QrCode || getQrCodeSrc()}
                                    alt="Scan to Donate"
                                    style={{ width: "105px", height: "105px", display: "block", margin: "0 auto" }}
                                  />
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#e50914",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "11px",
                                    padding: "5px 0",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  Scan to Donate
                                </div>
                              </div>
                            </td>
                            <td style={{ verticalAlign: "top", padding: "0 0 0 25px", fontSize: "13px", lineHeight: "1.6" }}>
                              {/* Bank Details */}
                              <div>
                                <strong>Bank:</strong> Mauritius Commercial Bank (MCB)
                              </div>
                              <div>
                                <strong>Name:</strong> OMCA Foundation
                              </div>
                              <div>
                                <strong>Reference:</strong> {pdfFormData.patient_name || "Pravesh"} - <em>(Eligible for Interest contributions)</em>
                              </div>
                              <div style={{ marginTop: "6px" }}>
                                <strong>Donations can also be made securely through our website :</strong>{" "}
                                <span style={{ color: "#006699", borderBottom: "1px solid #006699", paddingBottom: "1px", textDecoration: "none" }}>www.omcafoundation.org</span>
                              </div>
                              {pdfFormData.paragraph_2 && pdfFormData.paragraph_2.trim() !== "" && (
                                <p style={{ marginTop: "8px", fontStyle: "italic", color: "#444", fontSize: "11.5px", margin: 0 }}>
                                  {pdfFormData.paragraph_2}
                                </p>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Signatory */}
                      <div className="pdf-signatory-section" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <p style={{ marginBottom: "5px", fontSize: "13px" }}>Sincerely,</p>
                        <img
                          src={base64Signature || signatureImg}
                          alt="Signature"
                          style={{ height: "55px", marginBottom: "0px" }}
                        />
                        <div style={{ fontWeight: "bold", fontSize: "14px", color: "#000" }}>
                          {pdfFormData.signatory_name || DEFAULT_PDF_SIGNATORY}
                        </div>
                        <div style={{ borderTop: "1px dashed #666", width: "240px", margin: "4px 0" }}></div>
                        <div style={{ fontWeight: "bold", fontSize: "12px", color: "#333" }}>The Protector</div>
                        <div style={{ fontSize: "12px", color: "#555" }}>Overseas Medical Care Assistance Foundation</div>
                      </div>
                    </div>
                  ) : (
                    /* Test 2 Layout - Overseas Medical Care Assistance Ltd */
                    <div
                      style={{
                        position: "relative",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "13px",
                        color: "#222",
                        lineHeight: "1.4",
                        backgroundColor: "#fff",
                        minHeight: "1100px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={base64PrivateLetterhead || omcaPrivateLetterhead}
                        alt=""
                        style={{
                          position: "absolute",
                          inset: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "fill",
                          pointerEvents: "none",
                          zIndex: 0,
                        }}
                      />
                      <div style={{ position: "relative", zIndex: 1, padding: "130px 50px 30px 50px" }}>
                        {/* Date */}
                        <div style={{ fontWeight: "bold", fontSize: "13px", color: "#111", marginBottom: "6px" }}>
                          Date: {pdfFormData.date || "12/05/2026"}
                        </div>

                        {/* Subject */}
                        <h4 style={{ fontWeight: "bold", fontSize: "14.5px", color: "#000", marginBottom: "8px", display: "inline-block", borderBottom: "2px solid #000", paddingBottom: "3px", textDecoration: "none", letterSpacing: "0.5px" }}>
                          TO WHOM IT MAY CONCERN
                        </h4>

                        {/* Paragraph 1 */}
                        <p style={{ marginBottom: "6px", textAlign: "justify", fontSize: "13px", lineHeight: "1.45" }}>
                          This letter serves to inform you that patient <strong>{getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Hitesh Kinoo"}</strong> is preparing to undergo medical treatment at <strong>{pdfFormData.hospital_name || "BLK Max hospital"}</strong>, <strong>{pdfFormData.hospital_location || "Delhi"}</strong>, and will be accompanied by a family member, as advised by his physician.
                        </p>

                        {pdfFormData.paragraph_1 && pdfFormData.paragraph_1.trim() !== "" && (
                          <p style={{ marginBottom: "6px", textAlign: "justify", fontSize: "13px", lineHeight: "1.45" }}>
                            {pdfFormData.paragraph_1}
                          </p>
                        )}

                        {pdfFormData.paragraph_2 && pdfFormData.paragraph_2.trim() !== "" && (
                          <p style={{ marginBottom: "6px", fontSize: "13px" }}>
                            {pdfFormData.paragraph_2}
                          </p>
                        )}
                        {/* Detailed Breakdown (Table Layout for visual parity and html2canvas stability) */}
                        <table style={{ width: "100%", borderCollapse: "collapse", border: "none", marginBottom: "0px" }}>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", padding: 0, fontSize: "12.5px", lineHeight: "1.45" }}>
                                <div style={{ marginBottom: "6px" }}>
                                  <strong>Patient Diagnosis:</strong> {pdfFormData.diagnosis || "Based on the medical reports, patient needs to undergo for clinical evaluation."}
                                </div>
                                <div style={{ marginBottom: "6px" }}>
                                  <strong>Treatment / Surgery:</strong> {pdfFormData.treatment_surgery || "-"}
                                </div>
                                <div style={{ marginBottom: "8px" }}>
                                  <strong>Treating Doctor:</strong> {pdfFormData.treating_doctor || "Dr. Rajiv Anand (Principal Director – Neurology Department)."}
                                </div>

                                <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "5px", marginBottom: "15px" }}>
                                  {pdfFormData.treatment_cost && (
                                    <li style={{ marginBottom: "4px" }}>
                                      <strong>Treatment Cost:</strong> {pdfFormData.treatment_cost}
                                    </li>
                                  )}
                                  <li style={{ marginBottom: "4px" }}>
                                    <strong>Cost of evaluation:</strong> {pdfFormData.evaluation_cost || "USD 2500 – 3000 approx. (MUR 144,000 approx.)"}
                                    {pdfFormData.estimate_cost_details && pdfFormData.estimate_cost_details.length > 0 && (
                                      <ul style={{ listStyleType: "disc", paddingLeft: "18px", marginTop: "4px", marginBottom: "0" }}>
                                        {pdfFormData.estimate_cost_details.map((detail, idx) =>
                                          detail.description ? (
                                            <li key={idx} style={{ marginBottom: "2px" }}>
                                              {detail.description}
                                            </li>
                                          ) : null
                                        )}
                                      </ul>
                                    )}
                                  </li>
                                  <li style={{ marginBottom: "4px" }}>
                                    <strong>Duration of Stay in hospital:</strong> {pdfFormData.hospital_stay_duration || "OPD basis."}
                                  </li>
                                  <li style={{ marginBottom: "4px" }}>
                                    <strong>Duration of Stay in India:</strong> {pdfFormData.india_stay_duration || "3 weeks."}
                                  </li>

                                  <li style={{ marginBottom: "4px" }}>
                                    <strong>Additional Costs:</strong>
                                    <div style={{ paddingLeft: "15px", marginTop: "4px", fontSize: "12px", lineHeight: "1.6" }}>
                                      {(() => {
                                        const parts = [];
                                        if (pdfFormData.air_ticket_cost) {
                                          parts.push(<span key="air"><strong>Stretcher & Flight Ticket:</strong> {pdfFormData.air_ticket_cost}</span>);
                                        }
                                        if (pdfFormData.medical_escort_cost) {
                                          parts.push(<span key="escort"><strong>Medical Escort:</strong> {pdfFormData.medical_escort_cost}</span>);
                                        }
                                        if (parts.length === 0) return null;
                                        return (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                          </div>
                                        );
                                      })()}
                                      {(() => {
                                        const parts = [];
                                        if (pdfFormData.medif_cost) {
                                          parts.push(<span key="medif"><strong>Medif:</strong> {pdfFormData.medif_cost}</span>);
                                        }
                                        if (pdfFormData.medical_cost) {
                                          parts.push(<span key="medcost"><strong>Medical Cost:</strong> {pdfFormData.medical_cost}</span>);
                                        }
                                        if (pdfFormData.physiotherapy_cost) {
                                          parts.push(<span key="physio"><strong>Physiotherapy:</strong> {pdfFormData.physiotherapy_cost}</span>);
                                        }
                                        if (pdfFormData.surgery_cost) {
                                          parts.push(<span key="surgery"><strong>Surgery Cost:</strong> {pdfFormData.surgery_cost}</span>);
                                        }
                                        if (parts.length === 0) return null;
                                        return (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                          </div>
                                        );
                                      })()}
                                      {(() => {
                                        const parts = [];
                                        if (pdfFormData.accommodation_cost) {
                                          parts.push(<span key="accom"><strong>Accommodation Cost:</strong> {pdfFormData.accommodation_cost}</span>);
                                        }
                                        if (pdfFormData.guesthouse_cost) {
                                          parts.push(<span key="house"><strong>Guesthouse:</strong> {pdfFormData.guesthouse_cost}</span>);
                                        }
                                        if (parts.length === 0) return null;
                                        return (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                          </div>
                                        );
                                      })()}
                                      {(() => {
                                        const parts = [];
                                        if (pdfFormData.sim_card_cost) {
                                          parts.push(<span key="sim"><strong>Sim Card:</strong> {pdfFormData.sim_card_cost}</span>);
                                        }
                                        if (pdfFormData.transport_cost) {
                                          parts.push(<span key="trans"><strong>Transport:</strong> {pdfFormData.transport_cost}</span>);
                                        }
                                        if (pdfFormData.other_additional_costs) {
                                          parts.push(<span key="other"><strong>Other/Additional Cost:</strong> {pdfFormData.other_additional_costs}</span>);
                                        }
                                        if (parts.length === 0) return null;
                                        return (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                          </div>
                                        );
                                      })()}
                                    </div>
                                  </li>
                                </ul>
                              </td>
                              <td style={{ verticalAlign: "top", width: "115px", padding: "145px 0 0 15px" }}>
                                {/* Stamp Image on the Middle Right Side */}
                                <img
                                  src={base64Stamp || "/assets/img/omca_stamp.png"}
                                  alt="OMCA Stamp"
                                  style={{ width: "115px", height: "115px", objectFit: "contain", display: "block", position: "relative", right: "35px" }}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {/* Total Highlight */}
                        <p style={{ fontWeight: "bold", fontSize: "13px", color: "#000", marginBottom: "6px" }}>
                          The total estimated cost for treatment is {calculateTotalCost(pdfFormData, pdfType) || "MUR 505,800 approx."}
                        </p>

                        {/* Notes */}
                        {pdfFormData.paragraph_3 && pdfFormData.paragraph_3.trim() !== "" && (
                          <p style={{ marginBottom: "6px", fontSize: "11px", color: "#333" }}>
                            {pdfFormData.paragraph_3}
                          </p>
                        )}

                        {pdfFormData.remark && (
                          <div style={{ backgroundColor: "#f8fafc", borderLeft: "4px solid #0284c7", padding: "5px 10px", marginBottom: "6px", borderRadius: "0 6px 6px 0", textAlign: "left" }}>
                            <strong style={{ fontSize: "12px", color: "#0f172a" }}>Remarks:</strong>
                            <p style={{ margin: "4px 0 0 0", fontSize: "11.5px", color: "#334155", whiteSpace: "pre-wrap", lineHeight: "1.4" }}>{pdfFormData.remark}</p>
                          </div>
                        )}

                        {pdfFormData.paragraph_4 && pdfFormData.paragraph_4.trim() !== "" && (
                          <p style={{ fontWeight: "bold", marginBottom: "6px", fontSize: "11.5px", color: "#000" }}>
                            {pdfFormData.paragraph_4}
                          </p>
                        )}

                        {pdfFormData.paragraph_5 && pdfFormData.paragraph_5.trim() !== "" && (
                          <p style={{ marginBottom: "5px", fontSize: "11px", color: "#333" }}>
                            {pdfFormData.paragraph_5}
                          </p>
                        )}

                        {/* Signatory */}
                        <div className="pdf-signatory-section" style={{ marginTop: "8px", marginBottom: "5px" }}>
                          <p style={{ marginBottom: "8px", fontSize: "12px" }}>Sincerely,</p>
                          <div style={{ position: "relative", height: "42px", width: "240px", marginTop: "0px", marginBottom: "0px" }}>
                            <div style={{ position: "absolute", bottom: "4px", left: 0, color: "#888", letterSpacing: "2px", zIndex: 1 }}>
                              ……………………………………………
                            </div>
                            <img
                              src={base64Signature || signatureImg}
                              alt="Signature"
                              style={{
                                position: "absolute",
                                bottom: "0px",
                                left: "30px",
                                height: "55px",
                                zIndex: 2,
                              }}
                            />
                          </div>
                          <div style={{ fontWeight: "bold", fontSize: "12.5px", color: "#000" }}>
                            (For) {pdfFormData.signatory_name || DEFAULT_PDF_SIGNATORY}
                          </div>
                          <div style={{ fontSize: "11px", color: "#444" }}>(Certified Medical Travel Professional CMTP)</div>
                          <div style={{ fontSize: "11px", color: "#444" }}>{pdfFormData.designation || "(CEO OMCA)"}</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </DialogContent>
          <DialogActions
            style={{
              padding: "16px 24px",
              borderTop: "1px solid #e2e8f0",
              backgroundColor: "#ffffff",
              gap: "10px",
            }}
          >
            <Button
              onClick={() => setPdfModalOpen(false)}
              style={{
                borderRadius: "6px",
                padding: "6px 18px",
                fontSize: "13px",
                fontWeight: "600",
                color: "#64748b",
                border: "1px solid #cbd5e1",
              }}
              disabled={savingPdf}
            >
              Cancel
            </Button>
            {(pdfFormData.pdf_file || pdfFormData.pdf || pdfFormData.file) && (
              <Button
                variant="outlined"
                style={{
                  borderRadius: "6px",
                  padding: "6px 18px",
                  fontSize: "13px",
                  fontWeight: "600",
                  borderColor: "#7c3aed",
                  color: "#7c3aed",
                }}
                onClick={() =>
                  window.open(
                    getDocFileUrl(
                      pdfFormData.pdf_file || pdfFormData.pdf || pdfFormData.file
                    ),
                    "_blank"
                  )
                }
              >
                <i className="fa fa-eye me-1"></i> View Saved PDF
              </Button>
            )}
            <Button
              variant="outlined"
              style={{
                borderRadius: "6px",
                padding: "6px 18px",
                fontSize: "13px",
                fontWeight: "600",
                borderColor: "#0284c7",
                color: "#0284c7",
              }}
              onClick={() => handleSavePdfDetails(true)}
              disabled={savingPdf}
            >
              {savingPdf ? "Saving..." : "Save Details"}
            </Button>
            <Button
              variant="contained"
              style={{
                borderRadius: "6px",
                padding: "6px 20px",
                fontSize: "13px",
                fontWeight: "600",
                background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
                boxShadow: "0 2px 4px rgba(22, 163, 74, 0.3)",
              }}
              onClick={handleGeneratePdfDownload}
              disabled={savingPdf}
            >
              <i className="fa fa-download me-1"></i> Generate & Download PDF
            </Button>
          </DialogActions>
        </Dialog>

        {/* Off-screen A4 template for html2canvas (must not be display:none) */}
        <div
          style={{
            position: "fixed",
            left: "-10000px",
            top: 0,
            width: "794px",
            height: "1123px",
            overflow: "hidden",
            zIndex: -1,
            pointerEvents: "none",
            backgroundColor: "#fff",
          }}
        >
          <div
            ref={pdfTemplateRef}
            id="pdfTemplateRef"
            className="pdf-print-template"
            style={{
              width: "794px",
              height: "1123px",
              boxSizing: "border-box",
              backgroundColor: "#fff",
              position: "relative",
              overflow: "hidden",
              fontFamily: "Arial, Helvetica, sans-serif",
              fontSize: "13px",
              color: "#111",
              lineHeight: "1.4",
            }}
          >
            {pdfType === "Foundation" ? (
              /* Foundation Layout - OMCA Foundation Certification (Single Page) */
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                  boxSizing: "border-box",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                <img
                  src={base64FoundationLetterhead || omcaFoundationLetterhead}
                  alt=""
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "fill",
                    pointerEvents: "none",
                    zIndex: 0,
                  }}
                />
                {/* Content Container */}
                <div style={{ position: "relative", zIndex: 1, padding: "90px 48px 30px 48px", boxSizing: "border-box", height: "100%" }}>
                  {/* Date */}
                  <div style={{ fontWeight: "bold", fontSize: "13.5px", color: "#000", marginBottom: "8px" }}>
                    Date: {pdfFormData.date || "29th September 2025"}
                  </div>

                  {/* Subject Title */}
                  <h4 style={{ fontWeight: "bold", fontSize: "15px", color: "#000", marginBottom: "8px", display: "inline-block", borderBottom: "2px solid #000", paddingBottom: "4px", textDecoration: "none" }}>
                    Subject: Certification of Medical Treatment Plan – {getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Issur Pravesh"}
                  </h4>

                  {/* Appeal Paragraph */}
                  <p style={{ marginBottom: "8px", textAlign: "justify", fontSize: "13.5px", lineHeight: "1.45" }}>
                    This is an urgent appeal for contributions to support <strong>{getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Issur Pravesh"}</strong>, <strong>{pdfFormData.patient_age || "23"}</strong> years of age, holder of identification number <strong>I010202001275D</strong>, who is scheduled to travel to <strong>{pdfFormData.hospital_name || "Signature Hospital"}</strong>, <strong>{pdfFormData.hospital_location || "Delhi"}</strong> for urgent medical care.
                  </p>

                  <p style={{ marginBottom: "6px", fontStyle: "italic", fontSize: "13.5px" }}>
                    Following medical evaluation, the treatment plan for {getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Issur Pravesh"} includes:
                  </p>

                  {/* Bullet Points */}
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "10px", fontSize: "13px", lineHeight: "1.5" }}>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Diagnosis :</strong> {pdfFormData.diagnosis || "Case of Bilateral Emphysematous Bullae with Left Pneumothorax"}
                    </li>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Treatment:</strong> {pdfFormData.treatment_surgery || "Evaluation Followed by Thoracotomy + Left Lung Bullectomy +/- Left Upper Lobectomy Surgery"}
                    </li>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Treating Specialist:</strong> {pdfFormData.treating_doctor || "Dr. Harish Verma"}
                    </li>
                    {pdfFormData.treatment_cost && (
                      <li style={{ marginBottom: "2px" }}>
                        <strong>Treatment Cost:</strong> {pdfFormData.treatment_cost}
                      </li>
                    )}
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Estimated Cost of Evaluation:</strong> {pdfFormData.evaluation_cost || "MUR 46,000"}
                    </li>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Estimated Cost of Surgery:</strong> {pdfFormData.surgery_cost || "MUR 253,000"}
                    </li>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Estimated Duration of Stay in India:</strong> {pdfFormData.india_stay_duration || "6-7 weeks"}
                    </li>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Accommodation Cost (Including Transport & Meal Costs):</strong> {pdfFormData.accommodation_cost || "MUR 135,000"}
                    </li>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Airfare*2:</strong> {pdfFormData.air_ticket_cost || "MUR 80,000"} <em>(Note: Airfare is subject to change based on availability)</em>
                    </li>
                    <li style={{ marginBottom: "2px" }}>
                      <strong>Contingencies:</strong> {pdfFormData.other_additional_costs || "MUR 150,000"}
                    </li>
                    {pdfFormData.medical_escort_cost && (
                      <li style={{ marginBottom: "2px" }}>
                        <strong>Medical Escort Cost:</strong> {pdfFormData.medical_escort_cost}
                      </li>
                    )}
                  </ul>

                  {/* Total Required */}
                  <p style={{ fontWeight: "bold", fontSize: "13.5px", color: "#000", marginBottom: "6px" }}>
                    The Total Amount Required for {getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Pravesh"}’s Medical Treatment & Associated Expenses is {calculateTotalCost(pdfFormData, pdfType) || "MUR 664,000"}
                  </p>
                  {pdfFormData.estimate_cost_details && pdfFormData.estimate_cost_details.length > 0 ? (
                    <>
                      <p style={{ fontWeight: "bold", fontSize: "13.5px", color: "#000", marginBottom: "3px" }}>
                        The total estimated cost for treatment is :
                      </p>
                      <ul style={{ listStyleType: "none", paddingLeft: "0px", marginTop: "4px", marginBottom: "6px", fontWeight: "bold", fontSize: "13.5px" }}>
                        {pdfFormData.estimate_cost_details.map((detail, idx) => (
                          <li key={idx} style={{ marginBottom: "2px" }}>
                            {idx + 1}. {detail.description}
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <p style={{ fontWeight: "bold", fontSize: "13.5px", color: "#000", marginBottom: "6px" }}>
                      The total estimated cost for treatment is {calculateTotalCost(pdfFormData, pdfType) || "MUR 664,000"}
                    </p>
                  )}


                  {/* QR Scan Intro Line */}
                  {pdfFormData.paragraph_1 && pdfFormData.paragraph_1.trim() !== "" && (
                    <p style={{ fontWeight: "bold", fontSize: "13px", color: "#000", marginBottom: "6px" }}>
                      {pdfFormData.paragraph_1}
                    </p>
                  )}

                  {/* QR Scanner & Bank Grid (Table Layout for html2canvas stability) */}
                  <table style={{ width: "100%", borderCollapse: "collapse", border: "none", marginBottom: "10px" }}>
                    <tbody>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "130px", padding: 0 }}>
                          {/* Red Frame Box */}
                          <div style={{ border: "3px solid #e50914", borderRadius: "10px", overflow: "hidden", width: "130px", textAlign: "center", backgroundColor: "#fff" }}>
                            <div style={{ padding: "6px" }}>
                              <img
                                src={base64QrCode || getQrCodeSrc()}
                                alt="Scan to Donate"
                                style={{ width: "100px", height: "100px", display: "block", margin: "0 auto" }}
                              />
                            </div>
                            <div style={{ backgroundColor: "#e50914", color: "#fff", fontWeight: "bold", fontSize: "10px", padding: "4px 0", textTransform: "uppercase" }}>
                              Scan to Donate
                            </div>
                          </div>
                        </td>
                        <td style={{ verticalAlign: "top", padding: "0 0 0 20px", fontSize: "13px", lineHeight: "1.45" }}>
                          {/* Bank Info */}
                          <div><strong>Bank: Mauritius Commercial Bank (MCB)</strong></div>
                          <div><strong>Name: OMCA Foundation</strong></div>
                          <div><strong>Reference: {pdfFormData.patient_name || "Pravesh"} - <em>(Eligible for Interest contributions)</em></strong></div>
                          <div style={{ marginTop: "5px" }}>
                            <strong>Donations can also be made securely through our website : <span style={{ color: "#006699", borderBottom: "1px solid #006699", paddingBottom: "1px", textDecoration: "none" }}>www.omcafoundation.org</span></strong>
                          </div>
                          {pdfFormData.paragraph_2 && pdfFormData.paragraph_2.trim() !== "" && (
                            <p style={{ marginTop: "6px", fontStyle: "italic", color: "#444", fontSize: "11.5px", margin: 0 }}>
                              {pdfFormData.paragraph_2}
                            </p>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Signatory */}
                  <div className="pdf-signatory-section" style={{ marginTop: "8px" }}>
                    <p style={{ marginBottom: "3px", fontSize: "13px" }}>Sincerely,</p>
                    <img src={base64Signature || signatureImg} alt="Signature" style={{ height: "40px", marginBottom: "3px" }} />
                    <div style={{ fontWeight: "bold", fontSize: "14px", color: "#000" }}>{pdfFormData.signatory_name || DEFAULT_PDF_SIGNATORY}</div>
                    <div style={{ borderTop: "1px dashed #444", width: "230px", margin: "3px 0" }}></div>
                    <div style={{ fontWeight: "bold", fontSize: "12px", color: "#222" }}>The Protector</div>
                    <div style={{ fontSize: "12px", color: "#444" }}>Overseas Medical Care Assistance Foundation</div>
                  </div>
                </div>
              </div>
            ) : (
              /* Test 2 Layout - Overseas Medical Care Assistance Ltd (Single Page) */
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                  boxSizing: "border-box",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                <img
                  src={base64PrivateLetterhead || omcaPrivateLetterhead}
                  alt=""
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "fill",
                    pointerEvents: "none",
                    zIndex: 0,
                  }}
                />
                <div
                  style={{
                    position: "relative",
                    zIndex: 1,
                    padding: "125px 48px 30px 48px",
                    fontSize: "13px",
                    lineHeight: "1.4",
                    boxSizing: "border-box",
                    height: "100%",
                  }}
                >
                  {/* Date */}
                  <div style={{ fontWeight: "bold", fontSize: "13px", color: "#000", marginBottom: "6px" }}>
                    Date: {pdfFormData.date || "12/05/2026"}
                  </div>

                  {/* Subject Header */}
                  <h4 style={{ fontWeight: "bold", fontSize: "14.5px", color: "#000", marginBottom: "8px", display: "inline-block", borderBottom: "2px solid #000", paddingBottom: "3px", textDecoration: "none" }}>
                    TO WHOM IT MAY CONCERN
                  </h4>

                  {/* Paragraphs */}
                  <p style={{ marginBottom: "6px", textAlign: "justify", fontSize: "13px", lineHeight: "1.45" }}>
                    This letter serves to inform you that patient <strong>{getPatientHonorific(pdfFormData.gender || ispatient?.gender)}{pdfFormData.patient_name || "Hitesh Kinoo"}</strong> is preparing to undergo medical treatment at <strong>{pdfFormData.hospital_name || "BLK Max hospital"}</strong>, <strong>{pdfFormData.hospital_location || "Delhi"}</strong>, and will be accompanied by a family member, as advised by his physician.
                  </p>

                  {pdfFormData.paragraph_1 && pdfFormData.paragraph_1.trim() !== "" && (
                    <p style={{ marginBottom: "6px", textAlign: "justify", fontSize: "13px", lineHeight: "1.45" }}>
                      {pdfFormData.paragraph_1}
                    </p>
                  )}

                  {pdfFormData.paragraph_2 && pdfFormData.paragraph_2.trim() !== "" && (
                    <p style={{ marginBottom: "6px", fontSize: "13px" }}>
                      {pdfFormData.paragraph_2}
                    </p>
                  )}

                  {/* Breakdown List (Table Layout for html2canvas stability) */}
                  <table style={{ width: "100%", borderCollapse: "collapse", border: "none", marginBottom: "15px" }}>
                    <tbody>
                      <tr>
                        <td style={{ verticalAlign: "top", padding: 0, fontSize: "12.5px", lineHeight: "1.45" }}>
                          <div style={{ marginBottom: "6px" }}>
                            <strong>Patient Diagnosis:</strong> {pdfFormData.diagnosis || "Based on the medical reports, patient needs to undergo for clinical evaluation."}
                          </div>
                          <div style={{ marginBottom: "6px" }}>
                            <strong>Treatment / Surgery:</strong> {pdfFormData.treatment_surgery || "-"}
                          </div>
                          <div style={{ marginBottom: "8px" }}>
                            <strong>Treating Doctor:</strong> {pdfFormData.treating_doctor || "Dr. Rajiv Anand (Principal Director – Neurology Department)."}
                          </div>

                          <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: "4px 0 10px 0" }}>
                            {pdfFormData.treatment_cost && (
                              <li style={{ marginBottom: "3px" }}>
                                <strong>Treatment Cost:</strong> {pdfFormData.treatment_cost}
                              </li>
                            )}
                            <li style={{ marginBottom: "3px" }}>
                              <strong>Cost of evaluation:</strong> {pdfFormData.evaluation_cost || "USD 2500 – 3000 approx. (MUR 144,000 approx.)"}
                              {pdfFormData.estimate_cost_details && pdfFormData.estimate_cost_details.length > 0 && (
                                <ul style={{ listStyleType: "disc", paddingLeft: "16px", marginTop: "3px", marginBottom: "0" }}>
                                  {pdfFormData.estimate_cost_details.map((detail, idx) =>
                                    detail.description ? (
                                      <li key={idx} style={{ marginBottom: "2px" }}>
                                        {detail.description}
                                      </li>
                                    ) : null
                                  )}
                                </ul>
                              )}
                            </li>
                            <li style={{ marginBottom: "3px" }}>
                              <strong>Duration of Stay in hospital:</strong> {pdfFormData.hospital_stay_duration || "OPD basis."}
                            </li>
                            <li style={{ marginBottom: "3px" }}>
                              <strong>Duration of Stay in India:</strong> {pdfFormData.india_stay_duration || "3 weeks."}
                            </li>

                            <li style={{ marginBottom: "4px" }}>
                              <strong>Additional Costs:</strong>
                              <div style={{ paddingLeft: "15px", marginTop: "4px", fontSize: "12px", lineHeight: "1.6" }}>
                                {(() => {
                                  const parts = [];
                                  if (pdfFormData.air_ticket_cost) {
                                    parts.push(<span key="air"><strong>Stretcher & Flight Ticket:</strong> {pdfFormData.air_ticket_cost}</span>);
                                  }
                                  if (pdfFormData.medical_escort_cost) {
                                    parts.push(<span key="escort"><strong>Medical Escort:</strong> {pdfFormData.medical_escort_cost}</span>);
                                  }
                                  if (parts.length === 0) return null;
                                  return (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                    </div>
                                  );
                                })()}
                                {(() => {
                                  const parts = [];
                                  if (pdfFormData.medif_cost) {
                                    parts.push(<span key="medif"><strong>Medif:</strong> {pdfFormData.medif_cost}</span>);
                                  }
                                  if (pdfFormData.medical_cost) {
                                    parts.push(<span key="medcost"><strong>Medical Cost:</strong> {pdfFormData.medical_cost}</span>);
                                  }
                                  if (pdfFormData.physiotherapy_cost) {
                                    parts.push(<span key="physio"><strong>Physiotherapy:</strong> {pdfFormData.physiotherapy_cost}</span>);
                                  }
                                  if (pdfFormData.surgery_cost) {
                                    parts.push(<span key="surgery"><strong>Surgery Cost:</strong> {pdfFormData.surgery_cost}</span>);
                                  }
                                  if (parts.length === 0) return null;
                                  return (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                    </div>
                                  );
                                })()}
                                {(() => {
                                  const parts = [];
                                  if (pdfFormData.accommodation_cost) {
                                    parts.push(<span key="accom"><strong>Accommodation Cost:</strong> {pdfFormData.accommodation_cost}</span>);
                                  }
                                  if (pdfFormData.guesthouse_cost) {
                                    parts.push(<span key="house"><strong>Guesthouse:</strong> {pdfFormData.guesthouse_cost}</span>);
                                  }
                                  if (parts.length === 0) return null;
                                  return (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                    </div>
                                  );
                                })()}
                                {(() => {
                                  const parts = [];
                                  if (pdfFormData.sim_card_cost) {
                                    parts.push(<span key="sim"><strong>Sim Card:</strong> {pdfFormData.sim_card_cost}</span>);
                                  }
                                  if (pdfFormData.transport_cost) {
                                    parts.push(<span key="trans"><strong>Transport:</strong> {pdfFormData.transport_cost}</span>);
                                  }
                                  if (pdfFormData.other_additional_costs) {
                                    parts.push(<span key="other"><strong>Other/Additional Cost:</strong> {pdfFormData.other_additional_costs}</span>);
                                  }
                                  if (parts.length === 0) return null;
                                  return (
                                    <div style={{ whiteSpace: "nowrap" }}>
                                      {parts.reduce((acc, x, i) => i === 0 ? [x] : [...acc, <span key={`sep-${i}`}> | </span>, x], [])}
                                    </div>
                                  );
                                })()}
                              </div>
                            </li>
                          </ul>
                        </td>
                        <td style={{ verticalAlign: "top", width: "110px", padding: "135px 0 0 10px" }}>
                          {/* Stamp Image on the Middle Right Side */}
                          <img
                            src={base64Stamp || "/assets/img/omca_stamp.png"}
                            alt="OMCA Stamp"
                            style={{ width: "110px", height: "110px", objectFit: "contain", display: "block", position: "relative", right: "35px" }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Total Estimated Cost */}
                  <p style={{ fontWeight: "bold", fontSize: "13px", color: "#000", marginBottom: "6px" }}>
                    The total estimated cost for treatment is {calculateTotalCost(pdfFormData, pdfType) || "MUR 505,800 approx."}
                  </p>
                  {pdfFormData.remark && (
                    <div style={{ backgroundColor: "#f8fafc", borderLeft: "4px solid #0284c7", padding: "8px 12px", marginBottom: "10px", borderRadius: "0 4px 4px 0", textAlign: "left" }}>
                      <strong style={{ fontSize: "12px", color: "#0f172a" }}>Remarks:</strong>
                      <p style={{ margin: "2px 0 0 0", fontSize: "11.5px", color: "#334155", whiteSpace: "pre-wrap", lineHeight: "1.4" }}>{pdfFormData.remark}</p>
                    </div>
                  )}

                  {/* Notes & Disclaimers */}
                  {pdfFormData.paragraph_3 && pdfFormData.paragraph_3.trim() !== "" && (
                    <p style={{ marginBottom: "4px", fontSize: "11px", color: "#333" }}>
                      {pdfFormData.paragraph_3}
                    </p>
                  )}

                  {pdfFormData.paragraph_4 && pdfFormData.paragraph_4.trim() !== "" && (
                    <p style={{ fontWeight: "bold", marginBottom: "4px", fontSize: "11.5px", color: "#000" }}>
                      {pdfFormData.paragraph_4}
                    </p>
                  )}

                  {pdfFormData.paragraph_5 && pdfFormData.paragraph_5.trim() !== "" && (
                    <p style={{ marginBottom: "8px", fontSize: "11px", color: "#333" }}>
                      {pdfFormData.paragraph_5}
                    </p>
                  )}

                  {/* Signatory */}
                  <div className="pdf-signatory-section" style={{ marginTop: "8px" }}>
                    <p style={{ marginBottom: "2px", fontSize: "12px" }}>Sincerely,</p>
                    <div style={{ position: "relative", height: "38px", width: "230px", marginTop: "10px", marginBottom: "4px" }}>
                      <div style={{ position: "absolute", bottom: "4px", left: 0, color: "#888", letterSpacing: "2px", zIndex: 1 }}>
                        ……………………………………………
                      </div>
                      <img
                        src={base64Signature || signatureImg}
                        alt="Signature"
                        style={{
                          position: "absolute",
                          bottom: "0px",
                          left: "25px",
                          height: "38px",
                          zIndex: 2,
                        }}
                      />
                    </div>
                    <div style={{ fontWeight: "bold", fontSize: "12.5px", color: "#000" }}>(For) {pdfFormData.signatory_name || DEFAULT_PDF_SIGNATORY}</div>
                    <div style={{ fontSize: "11px", color: "#444" }}>(Certified Medical Travel Professional CMTP)</div>
                    <div style={{ fontSize: "11px", color: "#444" }}>{pdfFormData.designation || "(CEO OMCA)"}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Pre-Intimation Letter Modal */}
        <PreIntimationModal
          open={preIntimationModalOpen}
          onClose={() => {
            setPreIntimationModalOpen(false);
            setActiveVilPlan(null);
            setActiveVilHospital(null);
          }}
          onSuccess={(dispatchedRecord) => {
            getTreatmentPlan();
            if (dispatchedRecord) {
              handleSavePreIntimationRecord(dispatchedRecord);
            }
          }}
          treatmentPlan={activeVilPlan}
          hospitalItem={activeVilHospital}
          patient={ispatient}
          existingAttendants={attandantnew || []}
          hospitalsList={hospitalList || []}
          treatmentsList={Treatment || []}
        />

        {/* Upload VIL Document Modal */}
        <UploadVilModal
          open={uploadVilModalOpen}
          onClose={() => setUploadVilModalOpen(false)}
          onSuccess={() => {
            getTreatmentPlan();
          }}
          treatmentPlan={activeVilPlan}
          hospitalItem={activeVilHospital}
          isResubmit={isVilResubmit}
        />

        {/* Pre-Intimation Details View Modal */}
        <PreIntimationViewModal
          open={preIntimationViewModalOpen}
          onClose={() => {
            setPreIntimationViewModalOpen(false);
            setSelectedViewPreIntimation(null);
          }}
          onResend={() => {
            const plan = selectedViewPreIntimation?.treatmentPlan || activeVilPlan;
            const hosp = selectedViewPreIntimation?.hospitalItem || activeVilHospital;
            setPreIntimationViewModalOpen(false);
            setActiveVilPlan(plan);
            setActiveVilHospital(hosp);
            setPreIntimationModalOpen(true);
          }}
          preIntimationData={
            selectedViewPreIntimation?.preIntimationData ||
            selectedViewPreIntimation ||
            activeVilHospital?.preIntimation ||
            activeVilPlan?.preIntimation
          }
          hospitalItem={selectedViewPreIntimation?.hospitalItem || activeVilHospital}
          treatmentPlan={selectedViewPreIntimation?.treatmentPlan || activeVilPlan}
        />
      </React.Fragment>
    </>
  );
}
export default PatientDetail;
